export const PRICE_LIST = [
  { name: "Any", value: "Any" },
  { name: "$700,000", value: "700000" },
  { name: "$800,000", value: "800000" },
  { name: "$900,000", value: "900000" },
  { name: "$1,000,000", value: "1000000" },
  { name: "$1,250,000", value: "1250000" },
  { name: "$1,500,000", value: "1500000" },
  { name: "$1,750,000", value: "1750000" },
  { name: "$2,000,000", value: "2000000" },
  { name: "$2,500,000", value: "2500000" },
  { name: "$3,000,000", value: "3000000" },
  { name: "$4,000,000", value: "4000000" },
  { name: "$5,000,000", value: "5000000" },
  { name: "$6,000,000", value: "6000000" },
  { name: "$8,000,000", value: "8000000" },
  { name: "$10,000,000", value: "10000000" },
  { name: "$15,000,000", value: "15000000" },
  { name: "$20,000,000", value: "20000000" },
];

export const TENURE_LIST = [
  { name: "Any", value: "Any" },
  { name: "Freehold", value: "Freehold" },
  { name: "999-yr", value: "999" },
  { name: "99-yr", value: "99" },
];

export const PROPERTY_TYPE_LIST = [
  { name: "Any", value: "Any" },
  { name: "Studio", value: "Studio" },
  { name: "1 Bedroom", value: "1 Bedroom" },
  { name: "2 Bedroom", value: "2 Bedroom" },
  { name: "3 Bedroom", value: "3 Bedroom" },
  { name: "4 Bedroom", value: "4 Bedroom" },
  { name: "5 Bedroom", value: "5 Bedroom" },
  { name: "6 Bedroom", value: "6 Bedroom" },
  { name: "Panthouse", value: "Penthouses" },
  { name: "Commercial", value: "Commercial" },
  { name: "Industrial", value: "Industrial" },
];

export const TOP_LIST = [
  { name: "Any", value: "Any" },
  { name: "Move In", value: "Ready" },
  // { name: "Uncompleted", value: "Uncompleted" },
  { name: "2025", value: "2025" },
  { name: "2026", value: "2026" },
  { name: "2027", value: "2027" },
  { name: "2028", value: "2028" },
  { name: "2029", value: "2029" },
  { name: "2030", value: "2030" },
  { name: "2031", value: "2031" },
  { name: "2032", value: "2032" },
];

export const DISTRICT_LIST = [
  { name: "Any", value: "Any", label: "" },
  { name: "D1", value: "D1", label: "Boat Quay / Raffles Place / Marina" },
  { name: "D2", value: "D2", label: "Chinatown / Tanjong Pagar" },
  { name: "D3", value: "D3", label: "Alexandra / Commonwealth" },
  { name: "D4", value: "D4", label: "Sentosa / HarbourFront" },
  {
    name: "D5",
    value: "D5",
    label: "Buona Vista / West Coast / Clementi New Town",
  },
  { name: "D6", value: "D6", label: "City Hall / Clarke Quay" },
  { name: "D7", value: "D7", label: "Beach Road / Bugis / Rochor" },
  { name: "D8", value: "D8", label: "Farrer Park / Serangoon Road" },
  { name: "D9", value: "D9", label: "Orchard / River Valley" },
  { name: "D10", value: "D10", label: "Tanglin / Holland / Bukit Timah" },
  { name: "D11", value: "D11", label: "Newton / Novena" },
  { name: "D12", value: "D12", label: "Balestier / Toa Payoh" },
  { name: "D13", value: "D13", label: "MacPherson / Potong Pasir" },
  { name: "D14", value: "D14", label: "Eunos / Geylang / Paya Lebar" },
  { name: "D15", value: "D15", label: "East Coast / Marine Parade" },
  { name: "D16", value: "D16", label: "Bedok / Upper East Coast" },
  { name: "D17", value: "D17", label: "Changi Airport / Changi Village" },
  { name: "D18", value: "D18", label: "Pasir Ris / Tampines" },
  { name: "D19", value: "D19", label: "Hougang / Punggol / Sengkang" },
  { name: "D20", value: "D20", label: "Ang Mo Kio / Bishan / Thomson" },
  { name: "D21", value: "D21", label: "Clementi Park / Upper Bukit Timah" },
  { name: "D22", value: "D22", label: "Boon Lay / Jurong / Tuas" },
  {
    name: "D23",
    value: "D23",
    label: "Dairy Farm / Bukit Panjang / Choa Chu Kang",
  },
  { name: "D24", value: "D24", label: "Lim Chu Kang / Tengah" },
  { name: "D25", value: "D25", label: "Admiralty / Woodlands" },
  { name: "D26", value: "D26", label: "Mandai / Upper Thomson" },
  { name: "D27", value: "D27", label: "Sembawang / Yishun" },
  { name: "D28", value: "D28", label: "Seletar / Yio Chu Kang" },
];


// export const SCHOOLS = [
//     {
//         "school_name": "ADMIRALTY PRIMARY SCHOOL",
//         "url_address": "https://admiraltypri.moe.edu.sg/",
//         "address": "11 WOODLANDS CIRCLE",
//         "postal_code": 738907,
//         "telephone_no": 63620598,
//         "telephone_no_2": "na",
//         "fax_no": 63627512,
//         "fax_no_2": "na",
//         "email_address": "ADMIRALTY_PS@MOE.EDU.SG",
//         "mrt_desc": "Admiralty Station",
//         "bus_desc": "TIBS 965, 964, 913",
//         "principal_name": "MR CHEN ZHONGYI",
//         "first_vp_name": "MADAM CHUA MUI LING",
//         "second_vp_name": "MR HAMRI BIN A JALIL",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ADMIRALTY SECONDARY SCHOOL",
//         "url_address": "http://www.admiraltysec.moe.edu.sg",
//         "address": "31 WOODLANDS CRESCENT",
//         "postal_code": 737916,
//         "telephone_no": 63651733,
//         "telephone_no_2": 63654596,
//         "fax_no": 63652774,
//         "fax_no_2": "na",
//         "email_address": "Admiralty_SS@moe.edu.sg",
//         "mrt_desc": "ADMIRALTY MRT",
//         "bus_desc": 904,
//         "principal_name": "MR TAN KELLY",
//         "first_vp_name": "MR CHAN YEW REN EUGENE",
//         "second_vp_name": "MR TAN HOCK CHUAN MICHAEL",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "AHMAD IBRAHIM PRIMARY SCHOOL",
//         "url_address": "http://www.ahmadibrahimpri.moe.edu.sg",
//         "address": "10 YISHUN STREET 11",
//         "postal_code": 768643,
//         "telephone_no": 67592906,
//         "telephone_no_2": "na",
//         "fax_no": 67592927,
//         "fax_no_2": "na",
//         "email_address": "AIPS@MOE.EDU.SG",
//         "mrt_desc": "Yishun",
//         "bus_desc": "Yishun Ring Road - 812 (white plate); Yishun Ave 2 - 169, 804, 965, 117, 883",
//         "principal_name": "MS BAEY EE-LYN",
//         "first_vp_name": "MADAM YEO SIAU YEN",
//         "second_vp_name": "MADAM ZHANG JUNLI",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "AHMAD IBRAHIM SECONDARY SCHOOL",
//         "url_address": "http://www.ahmadibrahimsec.moe.edu.sg",
//         "address": "751 YISHUN AVENUE 7",
//         "postal_code": 768928,
//         "telephone_no": 67585384,
//         "telephone_no_2": "na",
//         "fax_no": 67557778,
//         "fax_no_2": "na",
//         "email_address": "AISS@MOE.EDU.SG",
//         "mrt_desc": "CANBERRA MRT, YISHUN MRT",
//         "bus_desc": "117, 167, 169, 800, 811, 812, 883, 856, 858, 859, 965, 969, 980",
//         "principal_name": "MR GOH SOON HOE",
//         "first_vp_name": "MISS LEA SHU HUI",
//         "second_vp_name": "MR QUEK CHOON HSIONG",
//         "third_vp_name": "MISS LATIFAH BTE ABDUL LATIFF",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "AI TONG SCHOOL",
//         "url_address": "http://www.aitong.moe.edu.sg",
//         "address": "100 Bright Hill Drive",
//         "postal_code": 579646,
//         "telephone_no": 64547672,
//         "telephone_no_2": "na",
//         "fax_no": 64532726,
//         "fax_no_2": "na",
//         "email_address": "AITONG_SCH@MOE.EDU.SG",
//         "mrt_desc": "Bishan MRT",
//         "bus_desc": "410, 162, 52",
//         "principal_name": "MR WONG JIA WANG",
//         "first_vp_name": "MR YAK BENG WEI",
//         "second_vp_name": "MR CHIU SHEK MAN PHILIP",
//         "third_vp_name": "MR KHOO THIAM HUAT",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BISHAN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "ALEXANDRA PRIMARY SCHOOL",
//         "url_address": "http://alexandrapri.moe.edu.sg",
//         "address": "2A Prince Charles Crescent",
//         "postal_code": 159016,
//         "telephone_no": 62485400,
//         "telephone_no_2": "na",
//         "fax_no": 62485409,
//         "fax_no_2": "na",
//         "email_address": "alexandra_ps@moe.edu.sg",
//         "mrt_desc": "Redhill Station; Tiong Bahru Station",
//         "bus_desc": "51, 122, 139, 186, 970.",
//         "principal_name": "MADAM TEO CHING LING",
//         "first_vp_name": "MADAM RAPS AZRINAH",
//         "second_vp_name": "MR LOH KAH HONG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANCHOR GREEN PRIMARY SCHOOL",
//         "url_address": "http://www.anchorgreenpri.moe.edu.sg",
//         "address": "31 Anchorvale Drive",
//         "postal_code": 544969,
//         "telephone_no": 68861356,
//         "telephone_no_2": "na",
//         "fax_no": 63159825,
//         "fax_no_2": "na",
//         "email_address": "anchorgreen_ps@moe.edu.sg",
//         "mrt_desc": "MRT : NE16-Sengkang; LRT : SW7-TongKang",
//         "bus_desc": "Bus 372, 110, 50",
//         "principal_name": "MR CHEONG LIT SERN WESLEY",
//         "first_vp_name": "MDM MUMTAAS BINTE MOHAMED KASSIM",
//         "second_vp_name": "MADAM NEO LAY PIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANDERSON PRIMARY SCHOOL",
//         "url_address": "http://www.andersonpri.moe.edu.sg",
//         "address": "19 ANG MO KIO AVE 9",
//         "postal_code": 569785,
//         "telephone_no": 64560340,
//         "telephone_no_2": "na",
//         "fax_no": 65522310,
//         "fax_no_2": "na",
//         "email_address": "ANDERSON_PS@MOE.EDU.SG",
//         "mrt_desc": "Yio Chu Kang MRT Station (NS 15); Lentor MRT Station (TE5)",
//         "bus_desc": "Ang Mo Kio Ave 9 - Bus 76, 265, 268",
//         "principal_name": "MS SHIRLEY LEOW",
//         "first_vp_name": "MR BOH CHEK KEOW",
//         "second_vp_name": "MADAM TAN AI CHOO",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANDERSON SECONDARY SCHOOL",
//         "url_address": "http://www.andersonsec.moe.edu.sg",
//         "address": "10 ANG MO KIO STREET 53",
//         "postal_code": 569206,
//         "telephone_no": 64598303,
//         "telephone_no_2": "na",
//         "fax_no": 64586104,
//         "fax_no_2": "na",
//         "email_address": "ANDERSON_SS@MOE.EDU.SG",
//         "mrt_desc": "ANG MO KIO MRT, YIO CHU KANG MRT",
//         "bus_desc": "265, 45, 50, 72, 159",
//         "principal_name": "MISS TAN PO CHIN",
//         "first_vp_name": "MR JONAH LIM TUCK HWAY (LIN DAHUI)",
//         "second_vp_name": "MR LEE CHUN YANG EUGENE",
//         "third_vp_name": "MR SHAHREEN BIN AMAN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANDERSON SERANGOON JUNIOR COLLEGE",
//         "url_address": "www.asrjc.moe.edu.sg",
//         "address": "1033 Upper Serangoon Road",
//         "postal_code": 534768,
//         "telephone_no": 64596822,
//         "telephone_no_2": "na",
//         "fax_no": 64598734,
//         "fax_no_2": "na",
//         "email_address": "asrjc@moe.edu.sg",
//         "mrt_desc": "Kovan MRT Station",
//         "bus_desc": "25, 55, 62, 80, 81, 82, 101, 107, 107M, 112, 113, 115, 119, 132, 136, 153, 325, 854",
//         "principal_name": "MR HENG YEW SENG",
//         "first_vp_name": "MR GURUSHARAN SINGH S/O M SINGH",
//         "second_vp_name": "MADAM TEY LI SHUN",
//         "third_vp_name": "MR MOHAMAD AMRAN SHAH BIN ABDUL RAHIM",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANG MO KIO PRIMARY SCHOOL",
//         "url_address": "http://www.angmokiopri.moe.edu.sg",
//         "address": "20 ANG MO KIO AVENUE 3",
//         "postal_code": 569920,
//         "telephone_no": 64520794,
//         "telephone_no_2": "na",
//         "fax_no": 64588121,
//         "fax_no_2": "na",
//         "email_address": "AMKPS@MOE.EDU.SG",
//         "mrt_desc": "Ang Mo Kio MRT Station; Mayflower MRT Station",
//         "bus_desc": "76, 132, 165, 166, 169, 265, 268, 269",
//         "principal_name": "MR MUHAMMAD FARIZAL BIN UMAR EFFE",
//         "first_vp_name": "MADAM TAN SIEW KHIM (CHEN XIUQIN)",
//         "second_vp_name": "MISS CHEN YANTING NATHALIE",
//         "third_vp_name": "MADAM LIEW KAH CHANG ALETHEA",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANG MO KIO SECONDARY SCHOOL",
//         "url_address": "http://www.angmokiosec.moe.edu.sg",
//         "address": "6 ANG MO KIO STREET 22",
//         "postal_code": 569362,
//         "telephone_no": 64548605,
//         "telephone_no_2": "na",
//         "fax_no": 64582425,
//         "fax_no_2": "na",
//         "email_address": "AMKSS@MOE.EDU.SG",
//         "mrt_desc": "ANG MO KIO MRT",
//         "bus_desc": "13, 74, 76, 88, 130, 132, 133, 136, 165, 169, 265, 268, 269, 851, 852",
//         "principal_name": "MR ASHRAF HYDER YUSOFF MANIAM",
//         "first_vp_name": "MR CHAN WENG ONN MARTIN",
//         "second_vp_name": "MADAM LEE KEE CHIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANGLICAN HIGH SCHOOL",
//         "url_address": "http://www.anglicanhigh.moe.edu.sg",
//         "address": "600 UPPER CHANGI ROAD",
//         "postal_code": 487012,
//         "telephone_no": 62414866,
//         "telephone_no_2": "na",
//         "fax_no": 64414690,
//         "fax_no_2": "na",
//         "email_address": "AHS@MOE.EDU.SG",
//         "mrt_desc": "TANAH MERAH MRT",
//         "bus_desc": "2, 9, 12, 14, 24, 31, 35, 38, 45, 46, 47, 48, 222",
//         "principal_name": "MR LIM HOCK CHUAN ALVIN",
//         "first_vp_name": "MR CHIN LIH KEONG",
//         "second_vp_name": "MISS WONG HSIEN HUI",
//         "third_vp_name": "MR SEAH THIAM SIONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "ANGLO-CHINESE JUNIOR COLLEGE",
//         "url_address": "https://acjc.moe.edu.sg",
//         "address": "25 DOVER CLOSE EAST",
//         "postal_code": 139745,
//         "telephone_no": 67750511,
//         "telephone_no_2": "na",
//         "fax_no": 67775479,
//         "fax_no_2": "na",
//         "email_address": "ACJC@MOE.EDU.SG",
//         "mrt_desc": "Buona Vista",
//         "bus_desc": "74,95,100,105,106,111,145,147,191,196,198,602",
//         "principal_name": "DR. CHEE YAN HOON SHIRLEEN",
//         "first_vp_name": "MR ANG YUAN PENG",
//         "second_vp_name": "MISS AUDREY LIM",
//         "third_vp_name": "MS QUEK SI MIN",
//         "fourth_vp_name": "MADAM LIM SING THOE",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "QUEENSTOWN",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANGLO-CHINESE SCHOOL (BARKER ROAD)",
//         "url_address": "http://www.acsbr.moe.edu.sg",
//         "address": "60 BARKER ROAD",
//         "postal_code": 309919,
//         "telephone_no": 62561633,
//         "telephone_no_2": "na",
//         "fax_no": 62561366,
//         "fax_no_2": "na",
//         "email_address": "ACBRS@MOE.EDU.SG",
//         "mrt_desc": "NEWTON MRT, STEVENS MRT",
//         "bus_desc": "48, 66, 67, 170, 960, 972",
//         "principal_name": "MR KHOO TSE HORNG",
//         "first_vp_name": "MR TAN WHYE WEE JEFFREY",
//         "second_vp_name": "MR CHEN HONG MING",
//         "third_vp_name": "MADAM MARIE LOH MEI LING",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "NOVENA",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANGLO-CHINESE SCHOOL (INDEPENDENT)",
//         "url_address": "http://www.acsindep.moe.edu.sg",
//         "address": "121 DOVER ROAD",
//         "postal_code": 139650,
//         "telephone_no": 67731633,
//         "telephone_no_2": "na",
//         "fax_no": 67731433,
//         "fax_no_2": "na",
//         "email_address": "ACIS@MOE.EDU.SG",
//         "mrt_desc": "DOVER MRT, BUONA VISTA MRT, ONE-NORTH MRT",
//         "bus_desc": "33, 74, 166, 196",
//         "principal_name": "MR KOH SUNG- YI ARENE",
//         "first_vp_name": "MR CHIEW TECK TZER TERENCE",
//         "second_vp_name": "MR SOO MUN KEONG PATRICK",
//         "third_vp_name": "MRS TEO LAI CHENG JUDY-HO",
//         "fourth_vp_name": "DR YONG YUN LEONG ANDREW",
//         "fifth_vp_name": "MS ALICE TAN SHIH SHIN",
//         "sixth_vp_name": "na",
//         "dgp_code": "QUEENSTOWN",
//         "zone_code": "SOUTH",
//         "type_code": "INDEPENDENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANGLO-CHINESE SCHOOL (JUNIOR)",
//         "url_address": "www.acsj.moe.edu.sg",
//         "address": "16 WINSTEDT ROAD",
//         "postal_code": 227988,
//         "telephone_no": 67337911,
//         "telephone_no_2": 67337912,
//         "fax_no": 67346518,
//         "fax_no_2": "na",
//         "email_address": "ACJS@MOE.EDU.SG",
//         "mrt_desc": "Newton MRT Station",
//         "bus_desc": "5, 54, 124, 143, 162, 162M, 167, 167e, 518, 518A, 972M",
//         "principal_name": "MISS CHEE CHUERN HWEI CHERYL",
//         "first_vp_name": "MADAM ANG CHAI TING",
//         "second_vp_name": "MR GOH SHEOW EN",
//         "third_vp_name": "MR AARON CHUA BEE HOCK",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CENTRAL",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANGLO-CHINESE SCHOOL (PRIMARY)",
//         "url_address": "http://www.acspri.moe.edu.sg/",
//         "address": "50 BARKER ROAD",
//         "postal_code": 309918,
//         "telephone_no": 62501633,
//         "telephone_no_2": "na",
//         "fax_no": 63531366,
//         "fax_no_2": "na",
//         "email_address": "ACPS@MOE.EDU.SG",
//         "mrt_desc": "Newton MRT Station",
//         "bus_desc": "Bus 48, 66, 67, 170, 960, 972M",
//         "principal_name": "MRS LEONG-HO HIL MAY",
//         "first_vp_name": "MR CHUA THIAN KEONG",
//         "second_vp_name": "MADAM TEH HSIAO CHUIN",
//         "third_vp_name": "MADAM SEOW LAY YEN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "NOVENA",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ANGSANA PRIMARY SCHOOL",
//         "url_address": "https://angsanapri.moe.edu.sg/",
//         "address": "51 Tampines Street 61",
//         "postal_code": 528565,
//         "telephone_no": 67830427,
//         "telephone_no_2": "na",
//         "fax_no": 67845293,
//         "fax_no_2": "na",
//         "email_address": "angsana_pri@moe.edu.sg",
//         "mrt_desc": "Tampines",
//         "bus_desc": "Bus Service 68, 68A",
//         "principal_name": "MR WONG WOEN LONG",
//         "first_vp_name": "MADAM SULASNI BINTE ABDUL RAHMAN",
//         "second_vp_name": "MADAM LEE HUAY MENG CAROL",
//         "third_vp_name": "MR KONG CHEE CHIEW",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ASSUMPTION ENGLISH SCHOOL",
//         "url_address": "http://www.assumptionenglish.moe.edu.sg",
//         "address": "622 UPPER BUKIT TIMAH ROAD",
//         "postal_code": 678117,
//         "telephone_no": 65729100,
//         "telephone_no_2": "na",
//         "fax_no": 67636560,
//         "fax_no_2": "na",
//         "email_address": "AES@MOE.EDU.SG",
//         "mrt_desc": "CASHEW MRT",
//         "bus_desc": "67, 75, 170, 176, 178, 184, 961, 963, 970",
//         "principal_name": "MR TOH KIM YONG VINCENT",
//         "first_vp_name": "MR TAN WEIMING BRIAN",
//         "second_vp_name": "MISS WONG KER SIN",
//         "third_vp_name": "MR QUEK SER HIANG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ASSUMPTION PATHWAY SCHOOL",
//         "url_address": "http://www.aps.edu.sg",
//         "address": "30 Cashew Road",
//         "postal_code": 679697,
//         "telephone_no": 62793000,
//         "telephone_no_2": "na",
//         "fax_no": 67622857,
//         "fax_no_2": "na",
//         "email_address": "aps@schools.gov.sg",
//         "mrt_desc": "DOWNTOWN LINE 2, CASHEW MRT",
//         "bus_desc": "SBS Transit No 170; SMRT No 67, 75, 171, 176, 178, 184, 961, 963 & 970",
//         "principal_name": "MR STEPHEN CHIN",
//         "first_vp_name": "MADAM SHABNAM LENA",
//         "second_vp_name": "DR WEE SIEW FONG",
//         "third_vp_name": "MRS TANG HUAY JIUAN NEE CHONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "SPECIALISED SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BARTLEY SECONDARY SCHOOL",
//         "url_address": "http://www.bartleysec.moe.edu.sg",
//         "address": "10 JALAN BUNGA RAMPAI",
//         "postal_code": 538403,
//         "telephone_no": 62889013,
//         "telephone_no_2": "na",
//         "fax_no": 62805595,
//         "fax_no_2": "na",
//         "email_address": "BARTLEY_SS@MOE.EDU.SG",
//         "mrt_desc": "BARTLEY MRT, TAI SENG MRT",
//         "bus_desc": "22, 24, 28, 43, 58, 62, 70, 70M, 76, 80, 80A, 93, 158",
//         "principal_name": "MISS SEET YING LING BRITTA",
//         "first_vp_name": "MR NG CHOR YAM",
//         "second_vp_name": "MR TING POH LEONG ALOYSIUS",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BEACON PRIMARY SCHOOL",
//         "url_address": "https://beaconpri.moe.edu.sg/",
//         "address": "36 Bukit Panjang Ring Road",
//         "postal_code": 679944,
//         "telephone_no": 67697255,
//         "telephone_no_2": "na",
//         "fax_no": 67697244,
//         "fax_no_2": "na",
//         "email_address": "beaconprisch@moe.edu.sg",
//         "mrt_desc": "Bangkit LRT, Fajar LRT Station, Bukit Panjang MRT",
//         "bus_desc": "920, 922, 971, 972, 972A, 972M, 976",
//         "principal_name": "MISS PANG WEE MIAN",
//         "first_vp_name": "MADAM LELA BTE SHAMSUHADI",
//         "second_vp_name": "MISS MELISSA CHANG SUET MUN",
//         "third_vp_name": "MR CHEN WEI NGIAP",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BEATTY SECONDARY SCHOOL",
//         "url_address": "http://www.beattysec.moe.edu.sg",
//         "address": "1 TOA PAYOH NORTH",
//         "postal_code": 318990,
//         "telephone_no": 62569108,
//         "telephone_no_2": "na",
//         "fax_no": 62542284,
//         "fax_no_2": "na",
//         "email_address": "BEATTY_SS@MOE.EDU.SG",
//         "mrt_desc": "BRADDELL MRT, TOA PAYOH MRT",
//         "bus_desc": "13, 28, 56, 57, 59, 73, 88, 93, 105, 129, 153, 155, 157, 159, 163, 231, 232",
//         "principal_name": "MR HARMAN AUGUSTUS JOHLL",
//         "first_vp_name": "MR YEO KOK SAN WILLIAM",
//         "second_vp_name": "MADAM LIM SOK NGIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BEDOK GREEN PRIMARY SCHOOL",
//         "url_address": "http://www.bedokgreenpri.moe.edu.sg",
//         "address": "1 BEDOK SOUTH AVE 2",
//         "postal_code": 469317,
//         "telephone_no": 64425416,
//         "telephone_no_2": "na",
//         "fax_no": 64491491,
//         "fax_no_2": "na",
//         "email_address": "bgps@moe.edu.sg",
//         "mrt_desc": "Bedok MRT Station, Tanah Merah MRT Station",
//         "bus_desc": "Bus No. 2, 9, 12, 24, 31, 34 & 38",
//         "principal_name": "MR YONG YIK YEN BENJAMIN",
//         "first_vp_name": "MR YEO SHO HOR",
//         "second_vp_name": "CHUA KOK SENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BEDOK GREEN SECONDARY SCHOOL",
//         "url_address": "http://www.bedokgreensec.moe.edu.sg",
//         "address": "360 BEDOK NORTH AVE 3",
//         "postal_code": 469722,
//         "telephone_no": 64463301,
//         "telephone_no_2": "na",
//         "fax_no": 64465969,
//         "fax_no_2": "na",
//         "email_address": "BGSS@MOE.EDU.SG",
//         "mrt_desc": "BEDOK MRT, BEDOK RESERVOIR MRT",
//         "bus_desc": "14, 17, 18, 28, 46, 66, 67, 69, 168, 222, 228, 506",
//         "principal_name": "MR SHAW SWEE TAT",
//         "first_vp_name": "MISS SAKINAH BINTE MOHAMED SARIP",
//         "second_vp_name": "MR CHEONG HUEI LEONARD",
//         "third_vp_name": "MR LEE CHEE CHONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BEDOK SOUTH SECONDARY SCHOOL",
//         "url_address": "https://bedoksouthsec.moe.edu.sg/",
//         "address": "1 JALAN LANGGAR BEDOK",
//         "postal_code": 468585,
//         "telephone_no": 64414479,
//         "telephone_no_2": "na",
//         "fax_no": 64491314,
//         "fax_no_2": "na",
//         "email_address": "BSSS@MOE.EDU.SG",
//         "mrt_desc": "TANAH MERAH MRT",
//         "bus_desc": "10, 14, 45",
//         "principal_name": "MR KOH YONG HWEE DARYL (XU RONGHUI)",
//         "first_vp_name": "MISS AZLINDA BTE SAMSUDIN",
//         "second_vp_name": "MR CHEN JINGYUAN ALVIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BEDOK VIEW SECONDARY SCHOOL",
//         "url_address": "http://www.bedokviewsec.moe.edu.sg",
//         "address": "6 BEDOK SOUTH AVENUE 3",
//         "postal_code": 469293,
//         "telephone_no": 64430563,
//         "telephone_no_2": "na",
//         "fax_no": 64494286,
//         "fax_no_2": "na",
//         "email_address": "BEDOKVIEW_SS@MOE.EDU.SG",
//         "mrt_desc": "TANAH MERAH MRT",
//         "bus_desc": "2, 9, 12, 14, 24, 25, 31, 35, 38, 45, 46, 47, 48",
//         "principal_name": "MADAM CHENG HWEE YEANG",
//         "first_vp_name": "MR TYEBALLY AZIZ",
//         "second_vp_name": "MR NEO WEI CHUNG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BENDEMEER PRIMARY SCHOOL",
//         "url_address": "http://www.bendemeerpri.moe.edu.sg/",
//         "address": "91 BENDEMEER ROAD",
//         "postal_code": 339948,
//         "telephone_no": 62982911,
//         "telephone_no_2": "na",
//         "fax_no": 62995735,
//         "fax_no_2": "na",
//         "email_address": "BENDEMEER_PS@MOE.EDU.SG",
//         "mrt_desc": "Boon Keng, Kallang",
//         "bus_desc": "13 23 31 61 64 65 65M 66 125, 125X ,133,140,147,853,857,985",
//         "principal_name": "MADAM LIM KIM GEK",
//         "first_vp_name": "MRS LINDA TAN",
//         "second_vp_name": "MR TOH KIM SING (ZHUO JINSHENG)",
//         "third_vp_name": "MR TOO MENG NGEE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "KALLANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BENDEMEER SECONDARY SCHOOL",
//         "url_address": "http://www.bendemeersec.moe.edu.sg",
//         "address": "1 ST WILFRED ROAD",
//         "postal_code": 327919,
//         "telephone_no": 62927616,
//         "telephone_no_2": "na",
//         "fax_no": 62932594,
//         "fax_no_2": "na",
//         "email_address": "BENDEMEER_SS@MOE.EDU.SG",
//         "mrt_desc": "BOON KENG MRT",
//         "bus_desc": "13,  23,  31,  64,  65,  66, 125, 133, 140, 147, 857, 985",
//         "principal_name": "MS FOO SHEUE FENG",
//         "first_vp_name": "MR HO CHI CHENG",
//         "second_vp_name": "MR MOHD AZMAN B MOHD SIDEK",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "KALLANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BLANGAH RISE PRIMARY SCHOOL",
//         "url_address": "http://www.blangahrisepri.moe.edu.sg/",
//         "address": "91 TELOK BLANGAH HEIGHTS",
//         "postal_code": 109100,
//         "telephone_no": 62717387,
//         "telephone_no_2": "na",
//         "fax_no": 62763037,
//         "fax_no_2": "na",
//         "email_address": "BRPS@MOE.EDU.SG",
//         "mrt_desc": "Telok Blangah, Tiong Bahru & Redhill",
//         "bus_desc": "SBS 273 & 124",
//         "principal_name": "MISS NG POR JOO PEARLY",
//         "first_vp_name": "MISS NARAYANASAMY UMA RANI",
//         "second_vp_name": "MR CHIONH BOON SOO",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BOON LAY GARDEN PRIMARY SCHOOL",
//         "url_address": "www.boonlaygardenpri.moe.edu.sg",
//         "address": "20 BOON LAY DRIVE",
//         "postal_code": 649930,
//         "telephone_no": 63160998,
//         "telephone_no_2": "na",
//         "fax_no": 63160209,
//         "fax_no_2": "na",
//         "email_address": "BLGPS@MOE.EDU.SG",
//         "mrt_desc": "Lakeside & Boon Lay",
//         "bus_desc": "30,99,154,178,180,187,240,246",
//         "principal_name": "MADAM CHRISTINE LIM MIN HUI",
//         "first_vp_name": "MADAM NG BOON IN",
//         "second_vp_name": "MRS AVINASH MURUGESUVARI",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BOON LAY SECONDARY SCHOOL",
//         "url_address": "https://www.boonlaysec.moe.edu.sg",
//         "address": "11 JURONG WEST STREET 65",
//         "postal_code": 648354,
//         "telephone_no": 67940161,
//         "telephone_no_2": "na",
//         "fax_no": 67941324,
//         "fax_no_2": "na",
//         "email_address": "BLSS@MOE.EDU.SG",
//         "mrt_desc": "Boon Lay",
//         "bus_desc": "30, 79, 99, 154, 157, 172, 174, 178, 179, 180, 181, 181M, 187, 192, 193, 194, 198, 199, 240, 241, 242, 243G/W, 246, 249, 251, 252, 258, 405, 502, 974",
//         "principal_name": "MR CHAN ZHENG MING",
//         "first_vp_name": "MR KOH CHON KIAT",
//         "second_vp_name": "MR TAN HWEE SIANG",
//         "third_vp_name": "",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BOWEN SECONDARY SCHOOL",
//         "url_address": "http://www.bowensec.moe.edu.sg",
//         "address": "2 LORONG NAPIRI",
//         "postal_code": 547529,
//         "telephone_no": 63859466,
//         "telephone_no_2": "na",
//         "fax_no": 63856559,
//         "fax_no_2": "na",
//         "email_address": "BOWEN_SS@MOE.EDU.SG",
//         "mrt_desc": "HOUGANG MRT, SERANGOON MRT, SENGKANG MRT",
//         "bus_desc": "43, 70, 73, 103, 109, 156, 854, 25, 74, 74E, 76, 112, 132, 147, 165, 55",
//         "principal_name": "MR LOH CHIH HUI",
//         "first_vp_name": "MR CHEN ZHAOKAI BENJAMIN",
//         "second_vp_name": "MR GOH KEE YONG @ GOH CHONG HENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BROADRICK SECONDARY SCHOOL",
//         "url_address": "http://www.broadricksec.moe.edu.sg",
//         "address": "61 DAKOTA CRESCENT",
//         "postal_code": 399935,
//         "telephone_no": 63445025,
//         "telephone_no_2": "na",
//         "fax_no": 64471427,
//         "fax_no_2": "na",
//         "email_address": "BROADRICK_SS@MOE.EDU.SG",
//         "mrt_desc": "DAKOTA MRT",
//         "bus_desc": "10, 16, 30, 31, 32, 33",
//         "principal_name": "MR NG TIONG NAM",
//         "first_vp_name": "MR BAMBANG PURNAMA PUTRA SHAKNI",
//         "second_vp_name": "MS NG FOONG MENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "GEYLANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BUKIT BATOK SECONDARY SCHOOL",
//         "url_address": "http://www.bukitbatoksec.moe.edu.sg",
//         "address": "50 BUKIT BATOK WEST AVE 8",
//         "postal_code": 658962,
//         "telephone_no": 63799413,
//         "telephone_no_2": "na",
//         "fax_no": 65607006,
//         "fax_no_2": "na",
//         "email_address": "BBSS@MOE.EDU.SG",
//         "mrt_desc": "BUKIT BATOK MRT",
//         "bus_desc": "66, 66C, 157, 174, 174E, 178, 506, 941, 991",
//         "principal_name": "MISS WONG KAH WAI SHIRLEY",
//         "first_vp_name": "MR CHENG POH HUAT, ALAN",
//         "second_vp_name": "MADAM CHIA BEE KHIM MABEL",
//         "third_vp_name": "MR CHAN TECK HONG DAVID",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BUKIT MERAH SECONDARY SCHOOL",
//         "url_address": "http://www.bukitmerahsec.moe.edu.sg",
//         "address": "10 LENGKOK BAHRU",
//         "postal_code": 159050,
//         "telephone_no": 64748934,
//         "telephone_no_2": "na",
//         "fax_no": 64744122,
//         "fax_no_2": "na",
//         "email_address": "BMSS@MOE.EDU.SG",
//         "mrt_desc": "REDHILL MRT",
//         "bus_desc": "14, 32, 33, 63, 64, 120, 132, 139, 145, 147, 196, 197, 855, 961",
//         "principal_name": "MR DARREN CHONG WAI KI",
//         "first_vp_name": "MR KOH SIEW BOON",
//         "second_vp_name": "MS CHAN LAI YING",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BUKIT PANJANG GOVT. HIGH SCHOOL",
//         "url_address": "http://www.bpghs.moe.edu.sg",
//         "address": "7 CHOA CHU KANG AVE 4",
//         "postal_code": 689809,
//         "telephone_no": 67691031,
//         "telephone_no_2": "na",
//         "fax_no": 67626576,
//         "fax_no_2": "na",
//         "email_address": "BPGHS@MOE.EDU.SG",
//         "mrt_desc": "CHOA CHU KANG MRT",
//         "bus_desc": "300, 983",
//         "principal_name": "MR SEET TIAT HEE",
//         "first_vp_name": "MDM TEO TING TING",
//         "second_vp_name": "MR TAN FONG WEI",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BUKIT PANJANG PRIMARY SCHOOL",
//         "url_address": "http://www.bukitpanjangpri.moe.edu.sg",
//         "address": "109 CASHEW ROAD",
//         "postal_code": 679676,
//         "telephone_no": 67691912,
//         "telephone_no_2": "na",
//         "fax_no": 67637462,
//         "fax_no_2": "na",
//         "email_address": "BPPS@MOE.EDU.SG",
//         "mrt_desc": "From Pending LRT station to Choa Chu Kang MRT station",
//         "bus_desc": "75, 184",
//         "principal_name": "MADAM LEN LENG LENG TERESA KELLY",
//         "first_vp_name": "MR CHAN WENG KIT MARK",
//         "second_vp_name": "MADAM KAY HWEE GEAK",
//         "third_vp_name": "MR CHAN KEN YAN MICHAEL",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BUKIT TIMAH PRIMARY SCHOOL",
//         "url_address": "http://www.bukittimahpri.moe.edu.sg",
//         "address": "111 Lorong Kismis",
//         "postal_code": 598112,
//         "telephone_no": 64662863,
//         "telephone_no_2": "na",
//         "fax_no": 64692179,
//         "fax_no_2": "na",
//         "email_address": "bukittimahps@moe.edu.sg",
//         "mrt_desc": "Beauty World, Bukit Batok and Clementi Stations",
//         "bus_desc": 173,
//         "principal_name": "MISS LAU WAN SZE",
//         "first_vp_name": "MDM JAN LIN",
//         "second_vp_name": "MADAM KOH LEE KUN, SHIRLYN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BUKIT VIEW PRIMARY SCHOOL",
//         "url_address": "http://www.bukitviewpri.moe.edu.sg",
//         "address": "18 BUKIT BATOK STREET 21",
//         "postal_code": 659634,
//         "telephone_no": 65661980,
//         "telephone_no_2": "na",
//         "fax_no": 65635015,
//         "fax_no_2": "na",
//         "email_address": "BUKITVIEW_PS@MOE.EDU.SG",
//         "mrt_desc": "Bukit Batok MRT Station",
//         "bus_desc": "173,157,178,852,66,106,61,506,963,77",
//         "principal_name": "MADAM TEO ENG HUI",
//         "first_vp_name": "MADAM LAI SEOW POH",
//         "second_vp_name": "MRS LEE JUN WEN",
//         "third_vp_name": "MR GOH GIN HOWE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "BUKIT VIEW SECONDARY SCHOOL",
//         "url_address": "https://www.bukitviewsec.moe.edu.sg",
//         "address": "16 BUKIT BATOK STREET 21",
//         "postal_code": 659633,
//         "telephone_no": 65661990,
//         "telephone_no_2": "na",
//         "fax_no": 65630945,
//         "fax_no_2": "na",
//         "email_address": "BUKITVIEW_SS@MOE.EDU.SG",
//         "mrt_desc": "BUKIT BATOK MRT",
//         "bus_desc": "61, 66, 77, 106, 157, 173, 174, 178, 189, 506, 653, 852, 963, 990",
//         "principal_name": "na",
//         "first_vp_name": "MR MAK YEW CHONG",
//         "second_vp_name": "MISS MRS ANNA LING",
//         "third_vp_name": "MR NEO KIM HANG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CANBERRA PRIMARY SCHOOL",
//         "url_address": "http://www.canberrapri.moe.edu.sg",
//         "address": "21 ADMIRALTY DRIVE",
//         "postal_code": 757714,
//         "telephone_no": 67597433,
//         "telephone_no_2": "na",
//         "fax_no": 67587312,
//         "fax_no_2": "na",
//         "email_address": "CANBERRA_PS@MOE.EDU.SG",
//         "mrt_desc": "Sembawang MRT Station",
//         "bus_desc": "Bus No. 859",
//         "principal_name": "MR TAN SIAN YEOW TERENCE",
//         "first_vp_name": "MADAM ONG LIXIANG JOYCE",
//         "second_vp_name": "MR SHAH JAHAN B MOHAMED IQBAL",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SEMBAWANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CANBERRA SECONDARY SCHOOL",
//         "url_address": "https://canberrasec.moe.edu.sg",
//         "address": "51 SEMBAWANG DRIVE",
//         "postal_code": 757699,
//         "telephone_no": 67585070,
//         "telephone_no_2": "na",
//         "fax_no": 67583110,
//         "fax_no_2": "na",
//         "email_address": "CANBERRA_SS@MOE.EDU.SG",
//         "mrt_desc": "SEMBAWANG MRT",
//         "bus_desc": "859, 962",
//         "principal_name": "MR LEONG KOK KEE",
//         "first_vp_name": "MADAM ONG LAY YEN",
//         "second_vp_name": "MR SYED FAISAL BIN SYED ISMAIL",
//         "third_vp_name": "MRS AMANDA TAN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SEMBAWANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CANOSSA CATHOLIC PRIMARY SCHOOL",
//         "url_address": "https://canossacatholicpri.moe.edu.sg/",
//         "address": "1 Sallim Road",
//         "postal_code": 387621,
//         "telephone_no": 68441418,
//         "telephone_no_2": "na",
//         "fax_no": 68441417,
//         "fax_no_2": "na",
//         "email_address": "ccps@moe.edu.sg",
//         "mrt_desc": "Nearest MRT station: Mattar Station (about 3-minute walk)",
//         "bus_desc": "Aljunied Road (same side as CCPS): 62, 64, 100; Aljunied Road (opposite CCPS): 61, 62, 64, 66, 100, 135, 154, 155; Merpati Rd (after Jln Anggerek): 40, 61, 63, 65, 66, 135,",
//         "principal_name": "MADAM SIA LU-MING EUGENIE",
//         "first_vp_name": "MR LEE KOK MENG CLEMENT",
//         "second_vp_name": "MR LIM TIAN SIONG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "GEYLANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CANTONMENT PRIMARY SCHOOL",
//         "url_address": "http://www.cantonmentpri.moe.edu.sg",
//         "address": "1 CANTONMENT CLOSE",
//         "postal_code": 88256,
//         "telephone_no": 65119555,
//         "telephone_no_2": "na",
//         "fax_no": 65119556,
//         "fax_no_2": "na",
//         "email_address": "cantonment_ps@moe.edu.sg",
//         "mrt_desc": "Tanjong Pagar; Outram Park",
//         "bus_desc": "121, 167, 196",
//         "principal_name": "MADAM FOO YIN PING GRACE",
//         "first_vp_name": "MISS CHENG SHIN MIIN",
//         "second_vp_name": "MRS JANE CHEAH",
//         "third_vp_name": "MR LOH SIANG KIANG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CASUARINA PRIMARY SCHOOL",
//         "url_address": "http://www.casuarinapri.moe.edu.sg/",
//         "address": "30 PASIR RIS ST 41",
//         "postal_code": 518935,
//         "telephone_no": 65837132,
//         "telephone_no_2": "na",
//         "fax_no": 65836227,
//         "fax_no_2": "na",
//         "email_address": "CASUARINA_PS@MOE.EDU.SG",
//         "mrt_desc": "Pasir Ris MRT Station",
//         "bus_desc": "Nos. 12, 21 & 358",
//         "principal_name": "MR POH CHEE YANG",
//         "first_vp_name": "MR TAYEB B RAJIB",
//         "second_vp_name": "MADAM HAFSAH BINTE ABDULLAH",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CATHOLIC HIGH SCHOOL",
//         "url_address": "http://www.catholichigh.moe.edu.sg",
//         "address": "9 BISHAN STREET 22",
//         "postal_code": 579767,
//         "telephone_no": "64582177 (Secondary)",
//         "telephone_no_2": "64589869 (Primary)",
//         "fax_no": "64561322 (Secondary)",
//         "fax_no_2": "64593938 (Primary)",
//         "email_address": "CHS@MOE.EDU.SG",
//         "mrt_desc": "BISHAN MRT",
//         "bus_desc": "13, 52, 54, 88, 156, 162, 162M, 410",
//         "principal_name": "MADAM TEO YVONNE",
//         "first_vp_name": "MR TAN CHER HUI PHILIP",
//         "second_vp_name": "MADAM WONG WAI SEE KELLIE",
//         "third_vp_name": "MISS LOW PEI LIN BEVERLY",
//         "fourth_vp_name": "MR FONG KOK WAI",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BISHAN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (P1-S4)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "Yes",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "CATHOLIC JUNIOR COLLEGE",
//         "url_address": "https://cjc.moe.edu.sg/",
//         "address": "129 WHITLEY ROAD",
//         "postal_code": 297822,
//         "telephone_no": 62524083,
//         "telephone_no_2": "na",
//         "fax_no": 62537267,
//         "fax_no_2": "na",
//         "email_address": "CATHOLIC_JC@MOE.EDU.SG",
//         "mrt_desc": "Toa Payoh (NS Line), Novena (NS Line), Stevens (DT Line), Caldecott (CC Line,TE Line)",
//         "bus_desc": "105, 132, 151, 153, 154, 156, 186, 966, 985",
//         "principal_name": "MRS WOO SOO MIN",
//         "first_vp_name": "MADAM KAM WAI CHIN",
//         "second_vp_name": "MR TAN JEK SUAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "NOVENA",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CEDAR GIRLS' SECONDARY SCHOOL",
//         "url_address": "http://www.cedargirlssec.moe.edu.sg",
//         "address": "1 CEDAR AVENUE",
//         "postal_code": 349692,
//         "telephone_no": 62884909,
//         "telephone_no_2": "na",
//         "fax_no": 62820244,
//         "fax_no_2": "na",
//         "email_address": "CEDARGIRLSSS@MOE.EDU.SG",
//         "mrt_desc": "WOODLEIGH MRT, POTONG PASIR MRT, MATTAR MRT",
//         "bus_desc": "8, 13, 61, 64, 65, 66, 90, 100, 107, 133, 135, 142, 147, 151, 154, 155, 853",
//         "principal_name": "MADAM THONG MAY TENG",
//         "first_vp_name": "MADAM TAN GEOK LAN",
//         "second_vp_name": "MISS ONG SHU HUI",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CEDAR PRIMARY SCHOOL",
//         "url_address": "Http://www.cedarpri.moe.edu.sg",
//         "address": "15 CEDAR AVENUE",
//         "postal_code": 349700,
//         "telephone_no": 62885633,
//         "telephone_no_2": "na",
//         "fax_no": 62830113,
//         "fax_no_2": "na",
//         "email_address": "CEDAR_PS@MOE.EDU.SG",
//         "mrt_desc": "Potong Pasir MRT Station",
//         "bus_desc": "8, 61, 64, 65, 66, 66A, 90, 90A, 100, 135, 151, 154, 155",
//         "principal_name": "MR CHRIS CHUA",
//         "first_vp_name": "MS CHOONG PEI CHIN",
//         "second_vp_name": "MR NG CHU SIU",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHANGKAT CHANGI SECONDARY SCHOOL",
//         "url_address": "http://www.changkatchangisec.moe.edu.sg",
//         "address": "23 SIMEI ST 3",
//         "postal_code": 529894,
//         "telephone_no": 67859790,
//         "telephone_no_2": "na",
//         "fax_no": 67868481,
//         "fax_no_2": "na",
//         "email_address": "CHANGKATCHGI@MOE.EDU.SG",
//         "mrt_desc": "SIMEI MRT",
//         "bus_desc": "5, 9, 20, 38",
//         "principal_name": "MR HO MING DA",
//         "first_vp_name": "MS SUBASHINI D/O SIVARAM",
//         "second_vp_name": "na",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHANGKAT PRIMARY SCHOOL",
//         "url_address": "http://www.changkatpri.moe.edu.sg/",
//         "address": "11 SIMEI ST 3",
//         "postal_code": 529896,
//         "telephone_no": 67830923,
//         "telephone_no_2": "na",
//         "fax_no": 67844740,
//         "fax_no_2": "na",
//         "email_address": "CHANGKAT_PS@MOE.EDU.SG",
//         "mrt_desc": "Simei MRT Station",
//         "bus_desc": "9,38,5",
//         "principal_name": "MADAM CHENG HUEY TENG",
//         "first_vp_name": "MRS LEE LI THENG",
//         "second_vp_name": "MADAM SITI NAZRAH BTE ABDUL RAHMAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ (KATONG) PRIMARY",
//         "url_address": "http://chijkcp.moe.edu.sg/",
//         "address": "17 MARTIA ROAD",
//         "postal_code": 424821,
//         "telephone_no": 63443072,
//         "telephone_no_2": "na",
//         "fax_no": 63459007,
//         "fax_no_2": "na",
//         "email_address": "CHIJKTPS@MOE.EDU.SG",
//         "mrt_desc": "MARINE PARADE; EUNOS; PAYA LEBAR",
//         "bus_desc": "15, 55, 36, 16, 135, 197, 196, 31, 13, 76, 12, 10, 14, 32, 40",
//         "principal_name": "MADAM MISCHA LEIGH PEREIRA",
//         "first_vp_name": "MADAM TAN POH KUAN JOYCELYN",
//         "second_vp_name": "MISS SHARON NG YE CHIN",
//         "third_vp_name": "MR ONG HENG KIONG (KONG QINGQIANG)",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "VALOUR PRIMARY SCHOOL",
//         "url_address": "valourpri.moe.edu.sg",
//         "address": "49 Punggol Central",
//         "postal_code": 828728,
//         "telephone_no": 62426390,
//         "telephone_no_2": "na",
//         "fax_no": "na",
//         "fax_no_2": "na",
//         "email_address": "valour_ps@moe.edu.sg",
//         "mrt_desc": "na",
//         "bus_desc": "na",
//         "principal_name": "MRS CHARIS WONG",
//         "first_vp_name": "MADAM TAN PIN PIN",
//         "second_vp_name": "MR LEE WEI TE",
//         "third_vp_name": "MR BOH HONG JIK",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ (KELLOCK)",
//         "url_address": "http://www.chijkellock.moe.edu.sg/",
//         "address": "1 Bukit Teresa Road",
//         "postal_code": 99757,
//         "telephone_no": 62730096,
//         "telephone_no_2": "na",
//         "fax_no": 62731710,
//         "fax_no_2": "na",
//         "email_address": "CHIJKS@MOE.EDU.SG",
//         "mrt_desc": "Outram Park Station",
//         "bus_desc": "61, 124, 143, 166",
//         "principal_name": "MRS SHANTHI SURAJ NAIR",
//         "first_vp_name": "MS NG CHIOU HIEN, HELEN MRS HELEN TAN",
//         "second_vp_name": "MADAM YUE  SHARON",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ KATONG CONVENT",
//         "url_address": "http://www.chijkatongconvent.moe.edu.sg",
//         "address": "346 MARINE TERRACE",
//         "postal_code": 449150,
//         "telephone_no": 64486433,
//         "telephone_no_2": "na",
//         "fax_no": 64494405,
//         "fax_no_2": "na",
//         "email_address": "CHIJKTCS@MOE.EDU.SG",
//         "mrt_desc": "BEDOK MRT, KEMBANGAN MRT, EUNOS MRT, PAYA LEBAR MRT, MARINE TERRACE MRT",
//         "bus_desc": "4N, 13, 16, 31, 36, 36A, 36B, 43, 47, 48, 55, 134, 135, 135A, 150, 196, 196E, 197, 853C, 763",
//         "principal_name": "MISS CHEN MEI CHUEN",
//         "first_vp_name": "MISS CHIA SIEW HUI",
//         "second_vp_name": "MISS LIM AI HUI ANNIE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "MARINE PARADE",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ OUR LADY OF GOOD COUNSEL",
//         "url_address": "http://www.chijourladyofgoodcounsel.moe.edu.sg",
//         "address": "2C Burghley Drive",
//         "postal_code": 558979,
//         "telephone_no": 62886930,
//         "telephone_no_2": "na",
//         "fax_no": 62814132,
//         "fax_no_2": "na",
//         "email_address": "CHIJOLGCS@MOE.EDU.SG",
//         "mrt_desc": "Ang Mo Kio MRT, Bishan MRT, Serangoon MRT station.",
//         "bus_desc": "317 Feeder Bus Service from Serangoon Interchange. 135,136 from Ang Mo Kio Interchange.",
//         "principal_name": "MISS TAN LEE YIN GRACE",
//         "first_vp_name": "MISS LIAT MEI KUEN GERALDINE SHARON",
//         "second_vp_name": "MRS WONG- LIM ENG LING ANGELINA",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ OUR LADY OF THE NATIVITY",
//         "url_address": "http://www.chijourladyofthenativity.moe.edu.sg/",
//         "address": "1257 UPPER SERANGOON ROAD",
//         "postal_code": 534793,
//         "telephone_no": 63852455,
//         "telephone_no_2": "na",
//         "fax_no": 63852012,
//         "fax_no_2": "na",
//         "email_address": "CHIJPS@MOE.EDU.SG",
//         "mrt_desc": "Hougang MRT",
//         "bus_desc": "74, 102, 112, 113, 119, 136, 147, 324, 672",
//         "principal_name": "MS ALBUQUERQUE KAREN ANNE",
//         "first_vp_name": "MADAM LOH AH LAH CATHERINE MICHELLE",
//         "second_vp_name": "MADAM WONG YEN LING",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ OUR LADY QUEEN OF PEACE",
//         "url_address": "http://www.chijourladyqueenofpeace.moe.edu.sg/",
//         "address": "4 Chestnut Drive",
//         "postal_code": 679287,
//         "telephone_no": 67691529,
//         "telephone_no_2": "na",
//         "fax_no": 67653551,
//         "fax_no_2": "na",
//         "email_address": "CHIJBTS@MOE.EDU.SG",
//         "mrt_desc": "Cashew and Hillview",
//         "bus_desc": "180, 67, 171, 176, 177, 178, 184, 961, 963, 970",
//         "principal_name": "MS PHAM HONG LIEN PHYLLIS G.",
//         "first_vp_name": "MADAM ADELINE CHONG NGOR YIM",
//         "second_vp_name": "MADAM SNG POH GEOK",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ PRIMARY (TOA PAYOH)",
//         "url_address": "http://www.chijpritoapayoh.moe.edu.sg",
//         "address": "628 Lorong 1 Toa Payoh",
//         "postal_code": 319765,
//         "telephone_no": 63532164,
//         "telephone_no_2": "na",
//         "fax_no": 63536362,
//         "fax_no_2": "na",
//         "email_address": "CHIJTPPS@MOE.EDU.SG",
//         "mrt_desc": "Toa Payoh",
//         "bus_desc": "59, 231, 141",
//         "principal_name": "MADAM CHUA SOOK LIAN JUDINA",
//         "first_vp_name": "MRS SNG CHARMAINE",
//         "second_vp_name": "MRS MELISSA YAP",
//         "third_vp_name": "MADAM YVONNE LIM BUAY HUANG (LIN MEIFANG)",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ SECONDARY (TOA PAYOH)",
//         "url_address": "http://www.chijsec.edu.sg",
//         "address": "626 LORONG 1 TOA PAYOH",
//         "postal_code": 319764,
//         "telephone_no": 63534972,
//         "telephone_no_2": "na",
//         "fax_no": 63544573,
//         "fax_no_2": "na",
//         "email_address": "CHIJTPSS@MOE.EDU.SG",
//         "mrt_desc": "TOA PAYOH MRT",
//         "bus_desc": "59, 141, 231",
//         "principal_name": "MADAM RACHEL ANG LAY KOON",
//         "first_vp_name": "MADAM CHRIS KOH",
//         "second_vp_name": "MADAM LIM LAY HOON",
//         "third_vp_name": "MISS KESAVAN PAULA ANNE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ ST. JOSEPH'S CONVENT",
//         "url_address": "http://www.chijstjosephsconvent.moe.edu.sg",
//         "address": "62 SENGKANG EAST WAY",
//         "postal_code": 548595,
//         "telephone_no": 64897580,
//         "telephone_no_2": "na",
//         "fax_no": 64897589,
//         "fax_no_2": "na",
//         "email_address": "CHIJSJCS@MOE.EDU.SG",
//         "mrt_desc": "SENGKANG MRT",
//         "bus_desc": "50, 82, 86, 88, 119, 136",
//         "principal_name": "MRS VALERIE PINTO",
//         "first_vp_name": "MISS HO WEI LING",
//         "second_vp_name": "MISS TAN LAI YEE MICHELLE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHIJ ST. NICHOLAS GIRLS' SCHOOL",
//         "url_address": "http://www.chijstnicholasgirls.moe.edu.sg",
//         "address": "501 ANG MO KIO STREET 13",
//         "postal_code": 569405,
//         "telephone_no": "63541839 (Secondary)",
//         "telephone_no_2": "64549698 (Primary)",
//         "fax_no": "64511335 (Secondary)",
//         "fax_no_2": "64566169 (Primary)",
//         "email_address": "CHIJSNG@MOE.EDU.SG",
//         "mrt_desc": "ANG MO KIO MRT, YIO CHU KANG MRT, MAYFLOWER MRT",
//         "bus_desc": "76, 265, 268, 269",
//         "principal_name": "MISS TAN SIN WEI WINNIE",
//         "first_vp_name": "MADAM LOW CHIA YEE",
//         "second_vp_name": "MR NG WAI KIT KELVIN",
//         "third_vp_name": "MISS YEO TECK WOON",
//         "fourth_vp_name": "MADAM TAN LIH LIN (CHEN LILIN)",
//         "fifth_vp_name": "MR LIM KAY WAH BENEDICT",
//         "sixth_vp_name": "MR THAM WAI KONG",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (P1-S4)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "CHIJ ST. THERESA'S CONVENT",
//         "url_address": "http://www.chijsttheresasconvent.moe.edu.sg",
//         "address": "160 LOWER DELTA ROAD",
//         "postal_code": 99138,
//         "telephone_no": 64775777,
//         "telephone_no_2": "na",
//         "fax_no": 64775700,
//         "fax_no_2": "na",
//         "email_address": "CHIJSTCS@MOE.EDU.SG",
//         "mrt_desc": "HARBOURFRONT MRT, TIONG BAHRU MRT",
//         "bus_desc": "65, 121, 123, 123M, 124, 131, 131M, 195, 195A, 272, 855",
//         "principal_name": "MADAM TAN MEI MEI JENNY",
//         "first_vp_name": "MISS WEE MEI YEN JANICE",
//         "second_vp_name": "MR YEO NGEE YANG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHONGFU SCHOOL",
//         "url_address": "http://www.chongfu.moe.edu.sg/",
//         "address": "170 YISHUN AVENUE 6",
//         "postal_code": 768959,
//         "telephone_no": 67585527,
//         "telephone_no_2": "na",
//         "fax_no": 62579571,
//         "fax_no_2": "na",
//         "email_address": "CFPS@MOE.EDU.SG",
//         "mrt_desc": "Yishun MRT station",
//         "bus_desc": "Feeder Service 811",
//         "principal_name": "MR TAN KING MING",
//         "first_vp_name": "MISS LIM HWEE MIEN ANGELYNNA",
//         "second_vp_name": "MR SOON WOO SIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHONGZHENG PRIMARY SCHOOL",
//         "url_address": "http://www.chongzhengpri.moe.edu.sg",
//         "address": "1 TAMPINES STREET 21",
//         "postal_code": 529392,
//         "telephone_no": 67819002,
//         "telephone_no_2": "na",
//         "fax_no": 67845054,
//         "fax_no_2": "na",
//         "email_address": "CZPS@MOE.EDU.SG",
//         "mrt_desc": "Tampines MRT Station; Tampines East MRT Station",
//         "bus_desc": "3,3A, 8, 17, 18, 20, 28, 34, 39, 59, 518",
//         "principal_name": "MR LIM WEE JAMES",
//         "first_vp_name": "MADAM RANJIT KAUR D/O MUKHTAR SINGH",
//         "second_vp_name": "MISS SHERRY OH SWEE LYN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHRIST CHURCH SECONDARY SCHOOL",
//         "url_address": "http://www.christchurchsec.moe.edu.sg",
//         "address": "20 WOODLANDS DRIVE 17",
//         "postal_code": 737924,
//         "telephone_no": 68933297,
//         "telephone_no_2": "na",
//         "fax_no": 68932789,
//         "fax_no_2": "na",
//         "email_address": "CCSS@MOE.EDU.SG",
//         "mrt_desc": "WOODLANDS MRT, WOODLANDS SOUTH MRT",
//         "bus_desc": "901, 901M, 665",
//         "principal_name": "MR TAY JUNCHENG ADRIAN",
//         "first_vp_name": "MADAM HENG EU LIN",
//         "second_vp_name": "MR ONG KAH HUI VICTOR",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHUA CHU KANG PRIMARY SCHOOL",
//         "url_address": "http://www.chuachukangpri.moe.edu.sg",
//         "address": "20 CHOA CHU KANG AVENUE 2",
//         "postal_code": 689905,
//         "telephone_no": 67661574,
//         "telephone_no_2": "na",
//         "fax_no": 67661583,
//         "fax_no_2": "na",
//         "email_address": "CCKPS@MOE.EDU.SG",
//         "mrt_desc": "Choa Chu Kang MRT Station and Southview LRT Station",
//         "bus_desc": "Bus Service 300, 301 and NR3 along Chua Chu Kang Ave 2; Bus Service 172, 301, 991 along Chua Chu Kang Ave 1",
//         "principal_name": "MADAM KUEK YEN YEN SHEREE",
//         "first_vp_name": "MADAM CHEW BOON HWEE",
//         "second_vp_name": "MS LIM CHWEE ENG MRS ONG PI HOCK",
//         "third_vp_name": "MADAM PUSPHAALATHA D/O AYAVOO",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHUA CHU KANG SECONDARY SCHOOL",
//         "url_address": "http://www.chuachukangsec.moe.edu.sg",
//         "address": "31 TECK WHYE CRESCENT",
//         "postal_code": 688848,
//         "telephone_no": 67655228,
//         "telephone_no_2": 67664425,
//         "fax_no": 67636807,
//         "fax_no_2": "na",
//         "email_address": "CCKSS@MOE.EDU.SG",
//         "mrt_desc": "CHOA CHU KANG MRT, PHOENIX LRT",
//         "bus_desc": "190, 190A, 307, 975, 982E, 985",
//         "principal_name": "MR CHENG GHEE HOCK TIMOTHY",
//         "first_vp_name": "MADAM HARTATI BTE OSMAN",
//         "second_vp_name": "MADAM LEE EE LEI JANE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CHUNG CHENG HIGH SCHOOL (MAIN)",
//         "url_address": "http://www.chungchenghighmain.moe.edu.sg",
//         "address": "50 GOODMAN ROAD",
//         "postal_code": 439012,
//         "telephone_no": 63441393,
//         "telephone_no_2": "na",
//         "fax_no": 63449686,
//         "fax_no_2": "na",
//         "email_address": "CCHMS@MOE.EDU.SG",
//         "mrt_desc": "DAKOTA MRT",
//         "bus_desc": "10, 12, 14, 14A, 14E 16, 16M, 30, 31, 32, 33, 40, 43, 43E 135, 134, 196, 196A 197, 401, 853M",
//         "principal_name": "MR YAO ZHIXUAN TERENCE",
//         "first_vp_name": "MR CHONG TENG YUAN",
//         "second_vp_name": "MADAM NG BEE LING",
//         "third_vp_name": "MADAM ONG LEE FONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "MARINE PARADE",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "CHUNG CHENG HIGH SCHOOL (YISHUN)",
//         "url_address": "http://www.chungchenghighyishun.moe.edu.sg",
//         "address": "11 YISHUN STREET 61",
//         "postal_code": 768547,
//         "telephone_no": 67583912,
//         "telephone_no_2": "na",
//         "fax_no": 67587397,
//         "fax_no_2": "na",
//         "email_address": "CCHBS@MOE.EDU.SG",
//         "mrt_desc": "KHATIB MRT",
//         "bus_desc": "Yishun Street 61 (opposite school) - 812; Yishun Ave 2 - 39, 85, 117, 851, 852, 853, 854, 855, 857, 858, 860, 965, 969",
//         "principal_name": "MR CHIA GUO HAO",
//         "first_vp_name": "MR WOO LEE YEN",
//         "second_vp_name": "MR CHEONG WING FOOK MELVIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CLEMENTI PRIMARY SCHOOL",
//         "url_address": "http://www.clementipri.moe.edu.sg",
//         "address": "8 CLEMENTI AVE 3",
//         "postal_code": 129903,
//         "telephone_no": 67797449,
//         "telephone_no_2": "na",
//         "fax_no": 67732898,
//         "fax_no_2": "na",
//         "email_address": "CLEMENTI_PS@MOE.EDU.SG",
//         "mrt_desc": "Clementi MRT Station",
//         "bus_desc": "We are just beside Clementi Bus Interchange.",
//         "principal_name": "MR VIMALENTHIRAN S/O VIJAYASINGAM",
//         "first_vp_name": "MADAM KHOO HENG OI CATHERINE",
//         "second_vp_name": "MADAM LEE SWEE MEI CHERYL",
//         "third_vp_name": "MADAM LOW TAN YING",
//         "fourth_vp_name": "MS TUNG AI JUI",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CLEMENTI",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CLEMENTI TOWN SECONDARY SCHOOL",
//         "url_address": "http://www.clementitownsec.moe.edu.sg",
//         "address": "10 CLEMENTI AVE 3",
//         "postal_code": 129904,
//         "telephone_no": 67777362,
//         "telephone_no_2": "na",
//         "fax_no": 67789543,
//         "fax_no_2": "na",
//         "email_address": "CTSS@MOE.EDU.SG",
//         "mrt_desc": "CLEMENTI MRT",
//         "bus_desc": "14, 105, 106, 147, 156, 165, 166, 173, 175, 184, 196, 282, 284, 285, 7, 96, 99",
//         "principal_name": "MADAM RASIDAH BTE RAHIM",
//         "first_vp_name": "MISS HUANG KEXIN",
//         "second_vp_name": "MR NG PING HWEE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CLEMENTI",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "COMMONWEALTH SECONDARY SCHOOL",
//         "url_address": "http://www.commonwealthsec.moe.edu.sg",
//         "address": "698 WEST COAST ROAD",
//         "postal_code": 608784,
//         "telephone_no": 65606866,
//         "telephone_no_2": "na",
//         "fax_no": 65645204,
//         "fax_no_2": "na",
//         "email_address": "CWSS@MOE.EDU.SG",
//         "mrt_desc": "JURONG EAST MRT, CLEMENTI MRT",
//         "bus_desc": "30, 51, 78, 79, 143, 143M, 176, 201",
//         "principal_name": "MR ANG KAY YONG JEREMY",
//         "first_vp_name": "MRS CLAIRE TAN SHI YING",
//         "second_vp_name": "MR DANIEL ONG POH SOON",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG EAST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "COMPASSVALE PRIMARY SCHOOL",
//         "url_address": "https://www.compassvalepri.moe.edu.sg",
//         "address": "21 COMPASSVALE ST",
//         "postal_code": 545091,
//         "telephone_no": 63882819,
//         "telephone_no_2": "na",
//         "fax_no": 63882798,
//         "fax_no_2": "na",
//         "email_address": "CVPS@MOE.EDU.SG",
//         "mrt_desc": "Sengkang",
//         "bus_desc": "83 (along Compassvale Street); 27, 89, 89E & 965 (along Compassvale Road).",
//         "principal_name": "MR VINCENT LEE WEI YEE",
//         "first_vp_name": "MRS MARIA KOH",
//         "second_vp_name": "MR CHIN WENG KIT KELVIN",
//         "third_vp_name": "MR KHOU BENG CHEW",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "COMPASSVALE SECONDARY SCHOOL",
//         "url_address": "http://www.compassvalesec.moe.edu.sg",
//         "address": "51 COMPASSVALE CRESCENT",
//         "postal_code": 545083,
//         "telephone_no": 68815047,
//         "telephone_no_2": "na",
//         "fax_no": 68815998,
//         "fax_no_2": "na",
//         "email_address": "CVSS@MOE.EDU.SG",
//         "mrt_desc": "SENGKANG MRT, COMPASSVALE LRT",
//         "bus_desc": "27, 27A, 82,  83,  86,  88,  89, 89E, 136, 161, 371, 965",
//         "principal_name": "MR CHUA TUNG KIAN",
//         "first_vp_name": "MADAM LEE WUI LIN JACQUELINE",
//         "second_vp_name": "MR SUKHDEV SINGH S/O GURDEEP SINGH",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CONCORD PRIMARY SCHOOL",
//         "url_address": "http://www.concordpri.moe.edu.sg/",
//         "address": "3 CHOA CHU KANG AVE 4",
//         "postal_code": 689814,
//         "telephone_no": 67632139,
//         "telephone_no_2": "na",
//         "fax_no": 67632452,
//         "fax_no_2": "na",
//         "email_address": "CONCORD_PS@MOE.EDU.SG",
//         "mrt_desc": "Choa Chu Kang MRT Station",
//         "bus_desc": "Bus 300 and 983",
//         "principal_name": "MDM CHUA LENG YIN",
//         "first_vp_name": "MADAM GOH PUAY HOON JENNY",
//         "second_vp_name": "MADAM SALBIAH BTE ABAS",
//         "third_vp_name": "MR LEE ENG LOO",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CORPORATION PRIMARY SCHOOL",
//         "url_address": "http://www.corporationpri.moe.edu.sg",
//         "address": "31 JURONG WEST STREET 24",
//         "postal_code": 648347,
//         "telephone_no": 67957381,
//         "telephone_no_2": "na",
//         "fax_no": 67957098,
//         "fax_no_2": "na",
//         "email_address": "CPS@MOE.EDU.SG",
//         "mrt_desc": "BOON LAY STATION; LAKESIDE STATION",
//         "bus_desc": "157 (from Boon Lay Interchange), or 185",
//         "principal_name": "MR MUHAMMAD FADYLLA B RASHIMAN",
//         "first_vp_name": "MDM GOH MUI EE",
//         "second_vp_name": "MADAM NG SEOW WEI JOSEPHINE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CRESCENT GIRLS' SCHOOL",
//         "url_address": "http://www.crescent.edu.sg",
//         "address": "357 TANGLIN ROAD",
//         "postal_code": 247961,
//         "telephone_no": 64758711,
//         "telephone_no_2": "na",
//         "fax_no": 64741248,
//         "fax_no_2": "na",
//         "email_address": "CRESCENTGIRL@MOE.EDU.SG",
//         "mrt_desc": "REDHILL MRT",
//         "bus_desc": "32, 111, 122, 132, 51, 139, 186, 970",
//         "principal_name": "MISS LOW SHIOK CHENG CINDY",
//         "first_vp_name": "MRS TAY PO LIN",
//         "second_vp_name": "MISS USHA JEYARAJAH",
//         "third_vp_name": "MR LIM HAN CHEE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "CREST SECONDARY SCHOOL",
//         "url_address": "http://www.crestsec.edu.sg",
//         "address": "561 JURONG EAST STREET 24",
//         "postal_code": 609561,
//         "telephone_no": 68992779,
//         "telephone_no_2": "na",
//         "fax_no": 68992668,
//         "fax_no_2": "na",
//         "email_address": "info@crestsec.edu.sg",
//         "mrt_desc": "BUKIT BATOK MRT, JURONG EAST MRT",
//         "bus_desc": "41, 52, 98, 98M, 105, 176, 183, 187, 188, 188R, 333, 502, 868, 990",
//         "principal_name": "MR KWOK CHIN POH BENJAMIN",
//         "first_vp_name": "MR TEH TUAN ANN",
//         "second_vp_name": "MADAM LEE KEE MENG",
//         "third_vp_name": "MR OTHMAN ARSAN BIN MOHD ABUBAKAR",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG EAST",
//         "zone_code": "WEST",
//         "type_code": "SPECIALISED SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "DAMAI PRIMARY SCHOOL",
//         "url_address": "http://www.damaipri.moe.edu.sg",
//         "address": "52 BEDOK RESERVOIR CRESCENT",
//         "postal_code": 479226,
//         "telephone_no": 64456483,
//         "telephone_no_2": "na",
//         "fax_no": 64499681,
//         "fax_no_2": "na",
//         "email_address": "DAMAI_PS@MOE.EDU.SG",
//         "mrt_desc": "Bedok North MRT Station",
//         "bus_desc": "Bus 228,66,65,22,21,5 and 506",
//         "principal_name": "MRS LEONG- TAN LING LING JENNY",
//         "first_vp_name": "MADAM LIM PECK CHIN YENLYN",
//         "second_vp_name": "MR MOHAMED JURAIMI BIN ABDUL MUHIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "DAMAI SECONDARY SCHOOL",
//         "url_address": "http://www.damaisec.moe.edu.sg",
//         "address": "4800 BEDOK RESERVOIR ROAD",
//         "postal_code": 479229,
//         "telephone_no": 64436848,
//         "telephone_no_2": "na",
//         "fax_no": 64425629,
//         "fax_no_2": "na",
//         "email_address": "DAMAI_SS@MOE.EDU.SG",
//         "mrt_desc": "BEDOK RESERVOIR MRT, BEDOK MRT, TAMPINES MRT",
//         "bus_desc": "5, 21, 22, 59, 65, 66, 228, 506, CT18",
//         "principal_name": "MADAM CHAN WAN SIONG",
//         "first_vp_name": "MR NG CHENG KEONG",
//         "second_vp_name": "MADAM PREMLATHA D/O SELVARAJ",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "DAZHONG PRIMARY SCHOOL",
//         "url_address": "http://www.dazhongpri.moe.edu.sg",
//         "address": "35 BUKIT BATOK STREET 31",
//         "postal_code": 659441,
//         "telephone_no": 65658002,
//         "telephone_no_2": "na",
//         "fax_no": 65636421,
//         "fax_no_2": "na",
//         "email_address": "DAZHONG_PS@MOE.EDU.SG",
//         "mrt_desc": "Bukit Gombak",
//         "bus_desc": "187, 188",
//         "principal_name": "MR CHRIS LOH KAI MUN",
//         "first_vp_name": "MR KOH KAH HOCK",
//         "second_vp_name": "MRS LIM SEOW KHIM MRS BOEY- LIM SEOW KHIM",
//         "third_vp_name": "MISS TAN HUI YAH",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "DE LA SALLE SCHOOL",
//         "url_address": "http://www.delasalle.moe.edu.sg",
//         "address": "11 Choa Chu Kang St 52",
//         "postal_code": 689285,
//         "telephone_no": 67667675,
//         "telephone_no_2": "na",
//         "fax_no": 67622075,
//         "fax_no_2": "na",
//         "email_address": "DLSS@MOE.EDU.SG",
//         "mrt_desc": "YEW TEE MRT",
//         "bus_desc": "TIBS 302, 979",
//         "principal_name": "MADAM CHERYL CHOO SHUEH-LI",
//         "first_vp_name": "MISS CECILIA TAN LI HUA",
//         "second_vp_name": "MISS LIU JIAZHEN ADELINE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "DEYI SECONDARY SCHOOL",
//         "url_address": "http://www.deyisec.moe.edu.sg",
//         "address": "1 ANG MO KIO STREET 42",
//         "postal_code": 569277,
//         "telephone_no": 64561565,
//         "telephone_no_2": "na",
//         "fax_no": 64583364,
//         "fax_no_2": "na",
//         "email_address": "DEYI_SS@MOE.EDU.SG",
//         "mrt_desc": "ANG MO KIO MRT",
//         "bus_desc": "22, 24, 25, 45, 50, 55, 73, 74, 76, 88, 132, 135, 159, 162, 165, 261, 262, 268, 652, 853",
//         "principal_name": "MR CHOW WEISI",
//         "first_vp_name": "MR APOLLOS INDUCHOODAN PILLAI",
//         "second_vp_name": "MISS CHIANG HUIMIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "DUNEARN SECONDARY SCHOOL",
//         "url_address": "http://www.dunearnsec.moe.edu.sg",
//         "address": "21 BUKIT BATOK WEST AVENUE 2",
//         "postal_code": 659204,
//         "telephone_no": 65653692,
//         "telephone_no_2": "na",
//         "fax_no": 65668650,
//         "fax_no_2": "na",
//         "email_address": "DUNEARN_SS@MOE.EDU.SG",
//         "mrt_desc": "BUKIT BATOK MRT, BUKIT GOMBAK MRT",
//         "bus_desc": "160, 180, 187, 188, 945, 947, 985",
//         "principal_name": "MADAM SOH BENG MUI",
//         "first_vp_name": "MR LEE KAH SIONG JIMMY",
//         "second_vp_name": "YAP KWEE CHYE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "DUNMAN HIGH SCHOOL",
//         "url_address": "http://www.dunmanhigh.moe.edu.sg",
//         "address": "10 TANJONG RHU ROAD",
//         "postal_code": 436895,
//         "telephone_no": 63450533,
//         "telephone_no_2": "na",
//         "fax_no": 63442316,
//         "fax_no_2": "na",
//         "email_address": "DHS@MOE.EDU.SG",
//         "mrt_desc": "KATONG PARK MRT,ALJUNIED MRT, KALLANG MRT, MOUNTBATTEN MRT,",
//         "bus_desc": "12, 14, 30, 158, 196",
//         "principal_name": "MR CHAN YING YIN",
//         "first_vp_name": "MADAM LEONG SOOK HING",
//         "second_vp_name": "MR MELVIN NG YONG HUI",
//         "third_vp_name": "MR PUAH YOU KAI",
//         "fourth_vp_name": "MR ONG QIU JIE",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "KALLANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "Yes",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "DUNMAN SECONDARY SCHOOL",
//         "url_address": "http://www.dunmansec.moe.edu.sg",
//         "address": "21 TAMPINES STREET 45",
//         "postal_code": 529093,
//         "telephone_no": 67862668,
//         "telephone_no_2": "na",
//         "fax_no": 67842164,
//         "fax_no_2": "na",
//         "email_address": "DUNMAN_SS@MOE.EDU.SG",
//         "mrt_desc": "TAMPINES EAST MRT",
//         "bus_desc": "28, 29, 293",
//         "principal_name": "MR TOH THIAM CHYE",
//         "first_vp_name": "MR FATHUL RAHMAN BIN KAMSANI",
//         "second_vp_name": "MISS PRIYA PRASAD",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "EAST SPRING PRIMARY SCHOOL",
//         "url_address": "http://www.eastspringpri.moe.edu.sg",
//         "address": "31 TAMPINES ST 33",
//         "postal_code": 529258,
//         "telephone_no": 67866192,
//         "telephone_no_2": "na",
//         "fax_no": 67866649,
//         "fax_no_2": "na",
//         "email_address": "ESPS@MOE.EDU.SG",
//         "mrt_desc": "Tampines",
//         "bus_desc": "291, 28,18",
//         "principal_name": "MADAM NEO LAY WAH",
//         "first_vp_name": "MADAM FAZILAH MARICAR D/O MD ALI M",
//         "second_vp_name": "MS NG HUI ENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "EAST SPRING SECONDARY SCHOOL",
//         "url_address": "http://www.eastspringsec.moe.edu.sg",
//         "address": "30 TAMPINES STREET 34",
//         "postal_code": 529231,
//         "telephone_no": 65873805,
//         "telephone_no_2": "na",
//         "fax_no": 65873804,
//         "fax_no_2": "na",
//         "email_address": "ESSS@MOE.EDU.SG",
//         "mrt_desc": "TAMPINES MRT, TAMPINES EAST MRT",
//         "bus_desc": "3, 4, 9, 12, 17, 18, 19, 21, 28, 29, 34, 37, 39, 59, 81, 291, 518",
//         "principal_name": "MISS HO SUSIE",
//         "first_vp_name": "MR LIM PIA LEONG",
//         "second_vp_name": "MR KOH CHEE HUI",
//         "third_vp_name": "MR PHAY CHYE HOCK ADRIAN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "EDGEFIELD PRIMARY SCHOOL",
//         "url_address": "http://www.edgefieldpri.moe.edu.sg",
//         "address": "41 EDGEFIELD PLAINS",
//         "postal_code": 828869,
//         "telephone_no": 63126091,
//         "telephone_no_2": "na",
//         "fax_no": 63126093,
//         "fax_no_2": "na",
//         "email_address": "edgefield_ps@moe.edu.sg",
//         "mrt_desc": "Punggol MRT",
//         "bus_desc": "3, 34, 62, 82, 83, 136",
//         "principal_name": "MADAM RABIATHUL BAZRIYA D/O ABU BAKAR",
//         "first_vp_name": "MR YAP LIH MIN SAMUEL",
//         "second_vp_name": "MS TAN PEY SAN",
//         "third_vp_name": "TEH CHONG ANN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "EDGEFIELD SECONDARY SCHOOL",
//         "url_address": "http://www.edgefieldsec.moe.edu.sg",
//         "address": "36 PUNGGOL FIELD",
//         "postal_code": 828814,
//         "telephone_no": 68839511,
//         "telephone_no_2": "na",
//         "fax_no": 63153120,
//         "fax_no_2": "na",
//         "email_address": "edgefield_ss@moe.edu.sg",
//         "mrt_desc": "PUNGGOL MRT",
//         "bus_desc": "3, 34, 62, 82, 83, 119, 136, 381, 382G",
//         "principal_name": "MR FOO JUNG HIN SIMON",
//         "first_vp_name": "MR BENSON TEO HONG GUAN (ZHANG HONGYUAN)",
//         "second_vp_name": "MR HOW PUI SENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ELIAS PARK PRIMARY SCHOOL",
//         "url_address": "http://www.eliasparkpri.moe.edu.sg",
//         "address": "11 PASIR RIS STREET 52",
//         "postal_code": 518866,
//         "telephone_no": 65844393,
//         "telephone_no_2": "na",
//         "fax_no": 65844392,
//         "fax_no_2": "na",
//         "email_address": "EPPS@MOE.EDU.SG",
//         "mrt_desc": "Pasir Ris MRT",
//         "bus_desc": "3, 15, 39, 53, 81, 88, 89, 357, 403, 518",
//         "principal_name": "MADAM CHUA PEI PEI",
//         "first_vp_name": "MR HO FU CHEW",
//         "second_vp_name": "PEH BEE KUAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ENDEAVOUR PRIMARY SCHOOL",
//         "url_address": "https://endeavourpri.moe.edu.sg/",
//         "address": "10 Admiralty Link",
//         "postal_code": 757521,
//         "telephone_no": 64824650,
//         "telephone_no_2": 64824835,
//         "fax_no": 64824670,
//         "fax_no_2": "na",
//         "email_address": "endeavour_ps@moe.edu.sg",
//         "mrt_desc": "Sembawang MRT Station",
//         "bus_desc": "859, 962",
//         "principal_name": "MR KOH KIAN SENG THOMAS",
//         "first_vp_name": "MADAM CHUA HUI PIN",
//         "second_vp_name": "MISS FAUZIAH DAUD",
//         "third_vp_name": "MISS CELESTE LOH SHI MIN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SEMBAWANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "EUNOIA JUNIOR COLLEGE",
//         "url_address": "http://www.eunoiajc.moe.edu.sg",
//         "address": "2 Sin Ming Place",
//         "postal_code": 573838,
//         "telephone_no": 63518388,
//         "telephone_no_2": "na",
//         "fax_no": 63518399,
//         "fax_no_2": "na",
//         "email_address": "eunoiajc@moe.edu.sg",
//         "mrt_desc": "Bishan MRT Station, Marymount MRT Station, Ang Mo Kio MRT Station, Bright Hill MRT Station",
//         "bus_desc": "13, 52, 74, 88, 130, 410G, 410W, 851, 852",
//         "principal_name": "MR TAN ENG HIAN ANDREW",
//         "first_vp_name": "MDM NEW YI CHEEN",
//         "second_vp_name": "MADAM PHUA KIA LING",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BISHAN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "EVERGREEN PRIMARY SCHOOL",
//         "url_address": "http://www.evergreenpri.moe.edu.sg/",
//         "address": "31 WOODLANDS CIRCLE",
//         "postal_code": 738908,
//         "telephone_no": 63687705,
//         "telephone_no_2": "na",
//         "fax_no": 63688084,
//         "fax_no_2": "na",
//         "email_address": "EVERGREEN_PS@MOE.EDU.SG",
//         "mrt_desc": "Admiralty",
//         "bus_desc": "913(front), 911 & 858(back)",
//         "principal_name": "MR JEFFREY AW",
//         "first_vp_name": "MR BOH CHUAN XIANG",
//         "second_vp_name": "MADAM ONG HWEE LENG",
//         "third_vp_name": "MR CHENG YOU NENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "EVERGREEN SECONDARY SCHOOL",
//         "url_address": "http://www.evergreensec.moe.edu.sg",
//         "address": "11 WOODLANDS STREET 83",
//         "postal_code": 738489,
//         "telephone_no": 63656392,
//         "telephone_no_2": "na",
//         "fax_no": 63658083,
//         "fax_no_2": "na",
//         "email_address": "EVERGREEN_SS@MOE.EDU.SG",
//         "mrt_desc": "WOODLANDS MRT",
//         "bus_desc": 911,
//         "principal_name": "MS BIAN YU WEI",
//         "first_vp_name": "MR LIM KANGYU",
//         "second_vp_name": "MADAM TAY CHOR HWEE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FAIRFIELD METHODIST SCHOOL (PRIMARY)",
//         "url_address": "http://www.fmsp.moe.edu.sg/",
//         "address": "100 DOVER ROAD",
//         "postal_code": 139648,
//         "telephone_no": 67788431,
//         "telephone_no_2": "na",
//         "fax_no": 67762948,
//         "fax_no_2": "na",
//         "email_address": "FMPS@MOE.EDU.SG",
//         "mrt_desc": "One-North MRT, Buona Vista MRT & Dover MRT",
//         "bus_desc": "SBS Bus 14,33,74,166 & 196",
//         "principal_name": "MADAM WONG MEI FOONG",
//         "first_vp_name": "MR HO KOK SOON",
//         "second_vp_name": "MADAM QUEK TSUI LAN PRISCA",
//         "third_vp_name": "MR KNG WEE BENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "QUEENSTOWN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FAIRFIELD METHODIST SCHOOL (SECONDARY)",
//         "url_address": "http://www.fairfieldmethodistsec.moe.edu.sg",
//         "address": "102 DOVER ROAD",
//         "postal_code": 139649,
//         "telephone_no": 67788702,
//         "telephone_no_2": "na",
//         "fax_no": 67797482,
//         "fax_no_2": "na",
//         "email_address": "FMSS@MOE.EDU.SG",
//         "mrt_desc": "BUONA VISTA MRT, ONE-NORTH MRT",
//         "bus_desc": "33, 74, 166, 196",
//         "principal_name": "MR WEE TAT CHUEN",
//         "first_vp_name": "MR JEROMY NGIAN KUN CHUAN",
//         "second_vp_name": "MISS STELLA KOH LI HUI",
//         "third_vp_name": "MADAM CHUA JIAYIN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "QUEENSTOWN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FARRER PARK PRIMARY SCHOOL",
//         "url_address": "http://www.farrerparkpri.moe.edu.sg",
//         "address": "2 FARRER PARK ROAD",
//         "postal_code": 217567,
//         "telephone_no": 62952272,
//         "telephone_no_2": "na",
//         "fax_no": 62942272,
//         "fax_no_2": "na",
//         "email_address": "FPPS@MOE.EDU.SG",
//         "mrt_desc": "Farrer Park MRT Station",
//         "bus_desc": 131,
//         "principal_name": "MR YAP SWEE BENG, DENNIS",
//         "first_vp_name": "MADAM RAHIMA BTE ABDUL RAHMAN",
//         "second_vp_name": "MR YONG WEI LEONG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "KALLANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FENGSHAN PRIMARY SCHOOL",
//         "url_address": "http://www.fengshanpri.moe.edu.sg",
//         "address": "307 BEDOK NORTH ROAD",
//         "postal_code": 469680,
//         "telephone_no": 65860123,
//         "telephone_no_2": "na",
//         "fax_no": 65860122,
//         "fax_no_2": "na",
//         "email_address": "FSPS@MOE.EDU.SG",
//         "mrt_desc": "Bedok MRT",
//         "bus_desc": "18, 228, 222, 17, 69, 66, 67, 168, 28, 506, 14, 45",
//         "principal_name": "MISS WONG LIANG- JI TABITHA",
//         "first_vp_name": "MADAM LAI KAI CHING",
//         "second_vp_name": "MS SIEW GEOK LING (SHAO YULING)",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FERN GREEN PRIMARY SCHOOL",
//         "url_address": "www.ferngreenpri.moe.edu.sg",
//         "address": "70 Fernvale Link   Fern Green Primary School",
//         "postal_code": 797538,
//         "telephone_no": 68343100,
//         "telephone_no_2": "na",
//         "fax_no": 68343116,
//         "fax_no_2": "na",
//         "email_address": "ferngreen_ps@moe.edu.sg",
//         "mrt_desc": "Kupang LRT Station (SW3)",
//         "bus_desc": "85, 102",
//         "principal_name": "na",
//         "first_vp_name": "MADAM KYLICIA SOO GEOK LING",
//         "second_vp_name": "MISS CHOW CHIA MIN AGNES",
//         "third_vp_name": "MADAM QUEK HWEE PENG, ANDREA (GUO HUIPING, ANDREA)",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FERNVALE PRIMARY SCHOOL",
//         "url_address": "www.fernvalepri.moe.edu.sg",
//         "address": "1 Fernvale Lane",
//         "postal_code": 797701,
//         "telephone_no": 63153051,
//         "telephone_no_2": "na",
//         "fax_no": 63153067,
//         "fax_no_2": "na",
//         "email_address": "fernvale_ps@moe.edu.sg",
//         "mrt_desc": "Fernvale LRT (Sengkang West Loop)",
//         "bus_desc": "Along Sengkang West Ave - Bus Services 50, 163; Along Yio Chu Kang Road - Bus Services 70, 86, 103 and 854.",
//         "principal_name": "MR LAU ENOCH",
//         "first_vp_name": "MISS YAP AI LI",
//         "second_vp_name": "MR RAMESH MUKUNDHAN",
//         "third_vp_name": "MR KEVIN PATT",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FIRST TOA PAYOH PRIMARY SCHOOL",
//         "url_address": "http://www.firsttoapayohpri.moe.edu.sg",
//         "address": "7 LORONG 8 TOA PAYOH",
//         "postal_code": 319252,
//         "telephone_no": 62567822,
//         "telephone_no_2": "na",
//         "fax_no": 62561102,
//         "fax_no_2": "na",
//         "email_address": "FTPPS@MOE.EDU.SG",
//         "mrt_desc": "Braddell & Toa Payoh Stations",
//         "bus_desc": "157,153,105,159,88,FS238",
//         "principal_name": "MADAM JENNIFER HAN ENG JUAN",
//         "first_vp_name": "MR KOH PENG YEOW",
//         "second_vp_name": "MS TAY YAM ENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FRONTIER PRIMARY SCHOOL",
//         "url_address": "http://www.frontierpri.moe.edu.sg",
//         "address": "20 Jurong West Street 61",
//         "postal_code": 648200,
//         "telephone_no": 65789555,
//         "telephone_no_2": "na",
//         "fax_no": 67908596,
//         "fax_no_2": "na",
//         "email_address": "frontier_ps@moe.edu.sg",
//         "mrt_desc": "Pioneer MRT Station (EW28)",
//         "bus_desc": "241, 974, 179",
//         "principal_name": "MADAM LEE YEW KOON TONNINE",
//         "first_vp_name": "MADAM CHAN YEE CHIN WILNA",
//         "second_vp_name": "MADAM WONG SHI-LEI",
//         "third_vp_name": "MR ANG BOON CHIN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FUCHUN PRIMARY SCHOOL",
//         "url_address": "http://www.fuchunpri.moe.edu.sg",
//         "address": "23 WOODLANDS AVENUE 1",
//         "postal_code": 739063,
//         "telephone_no": 63683925,
//         "telephone_no_2": "na",
//         "fax_no": 63670117,
//         "fax_no_2": "na",
//         "email_address": "FCPS@MOE.EDU.SG",
//         "mrt_desc": "Marsiling",
//         "bus_desc": "187,856,912,925,950,960,961,963,963E,963R,966",
//         "principal_name": "MADAM EUNICE LIM",
//         "first_vp_name": "MR SUDHESH VASU DASH",
//         "second_vp_name": "MR TAN CHIN KEE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FUHUA PRIMARY SCHOOL",
//         "url_address": "http://www.fuhuapri.moe.edu.sg",
//         "address": "65 JURONG EAST STREET 13",
//         "postal_code": 609647,
//         "telephone_no": 65624370,
//         "telephone_no_2": "na",
//         "fax_no": 65639542,
//         "fax_no_2": "na",
//         "email_address": "FHPS@MOE.EDU.SG",
//         "mrt_desc": "JURONG EAST MRT STATION",
//         "bus_desc": "JURONG EAST CENTRAL (BS28441): 41,49,52,105,160,160A,160M,176,183,334,506; JURONG EAST CENTRAL (BS28431):51,66,78,79,143, 143M, 176, 335",
//         "principal_name": "MR GANESAN S/O RAMAN",
//         "first_vp_name": "MADAM SEOW SWEE NEO CHRISTINA",
//         "second_vp_name": "MS SAIMA HANIF D/O MOHAMED HANIF",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG EAST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "FUHUA SECONDARY SCHOOL",
//         "url_address": "http://www.fuhuasec.moe.edu.sg",
//         "address": "5 JURONG WEST STREET 41",
//         "postal_code": 649410,
//         "telephone_no": 65633067,
//         "telephone_no_2": "na",
//         "fax_no": 65634379,
//         "fax_no_2": "na",
//         "email_address": "FHSS@MOE.EDU.SG",
//         "mrt_desc": "CHINESE GARDEN MRT, LAKESIDE MRT",
//         "bus_desc": "49, 98, 99, 157, 180, 185, 187, 198, 334, 335, 502, 657",
//         "principal_name": "MRS LIM CAROL",
//         "first_vp_name": "MR CHNG PUAY KEONG",
//         "second_vp_name": "MISS PEH LEE CHIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GAN ENG SENG PRIMARY SCHOOL",
//         "url_address": "http://www.ganengsengpri.moe.edu.sg",
//         "address": "100 REDHILL CLOSE",
//         "postal_code": 158901,
//         "telephone_no": 64717451,
//         "telephone_no_2": "na",
//         "fax_no": 64794152,
//         "fax_no_2": "na",
//         "email_address": "GESPS@MOE.EDU.SG",
//         "mrt_desc": "Redhill",
//         "bus_desc": "14, 63, 147, 196, 197, 855, 961",
//         "principal_name": "MR LEE WEI YAP, ROY",
//         "first_vp_name": "MR KYAW SAW LYNN",
//         "second_vp_name": "MADAM WONG SEOK GHEE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GAN ENG SENG SCHOOL",
//         "url_address": "http://www.ganengsengsch.moe.edu.sg",
//         "address": "1 HENDERSON ROAD",
//         "postal_code": 159561,
//         "telephone_no": 64745594,
//         "telephone_no_2": "na",
//         "fax_no": 64732479,
//         "fax_no_2": "na",
//         "email_address": "GESS@MOE.EDU.SG",
//         "mrt_desc": "REDHILL MRT, TIONG BAHRU MRT",
//         "bus_desc": "14, 16, 32, 33, 51, 63, 64, 120, 122, 145, 139, 186, 851, 970",
//         "principal_name": "MISS TAN HWEE PIN",
//         "first_vp_name": "MADAM SARAWATHY D/O VARADARAJU",
//         "second_vp_name": "MR TAN TZE JWEE GLYNN",
//         "third_vp_name": "MR GOH THYE HENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GEYLANG METHODIST SCHOOL (PRIMARY)",
//         "url_address": "www.geylangmethodistpri.moe.edu.sg",
//         "address": "4 Geylang East Central",
//         "postal_code": 389706,
//         "telephone_no": 67486746,
//         "telephone_no_2": "na",
//         "fax_no": 67488980,
//         "fax_no_2": "na",
//         "email_address": "GMPS@MOE.EDU.SG",
//         "mrt_desc": "Aljunied",
//         "bus_desc": "80, 134, 155",
//         "principal_name": "MADAM LEONG BENG YUET DAPHNE",
//         "first_vp_name": "MR LUA EE PING",
//         "second_vp_name": "MADAM SHARON CHANTALE KOK YENG LING",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "GEYLANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GEYLANG METHODIST SCHOOL (SECONDARY)",
//         "url_address": "http://www.geylangmethodistsec.moe.edu.sg",
//         "address": "2 GEYLANG EAST CENTRAL",
//         "postal_code": 389705,
//         "telephone_no": 67466503,
//         "telephone_no_2": "na",
//         "fax_no": 67477317,
//         "fax_no_2": "na",
//         "email_address": "GMSS@MOE.EDU.SG",
//         "mrt_desc": "ALJUNIED MRT",
//         "bus_desc": "40, 62, 63, 80, 100, 125, 134, 155, 158",
//         "principal_name": "MR OWYONG TUCK SING VICTOR",
//         "first_vp_name": "MR JOHN WU YIFAN",
//         "second_vp_name": "MISS TAY HUI CHENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "GEYLANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GONGSHANG PRIMARY SCHOOL",
//         "url_address": "http://www.gongshangpri.moe.edu.sg",
//         "address": "1 TAMPINES STREET 42",
//         "postal_code": 529176,
//         "telephone_no": 67831191,
//         "telephone_no_2": "na",
//         "fax_no": 67880004,
//         "fax_no_2": "na",
//         "email_address": "GSPS@MOE.EDU.SG",
//         "mrt_desc": "Tampines (Downtown Line and East West Line) and Tampines East (Downtown Line)",
//         "bus_desc": "4, 8, 18, 19, 21, 37, 38, 81, 293",
//         "principal_name": "MRS STELLA KWAN",
//         "first_vp_name": "MDM NORA BTE OSMAN",
//         "second_vp_name": "MRS YIO YEN LING SELINA",
//         "third_vp_name": "MR FONG WAI KHIN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GREENDALE PRIMARY SCHOOL",
//         "url_address": "http://www.greendalepri.moe.edu.sg",
//         "address": "50 Edgedale Plains",
//         "postal_code": 828848,
//         "telephone_no": 68861413,
//         "telephone_no_2": "na",
//         "fax_no": 68861419,
//         "fax_no_2": "na",
//         "email_address": "greendale_ps@moe.edu.sg",
//         "mrt_desc": "Punggol LRT:  Coral Edge",
//         "bus_desc": "3,62, 83, 85, 386",
//         "principal_name": "MADAM NOORISMAWATY BTE ISMAIL",
//         "first_vp_name": "MR SIM CHIN BENG WILSON",
//         "second_vp_name": "MR CHING KIN HIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GREENDALE SECONDARY SCHOOL",
//         "url_address": "http://www.greendalesec.moe.edu.sg",
//         "address": "51 EDGEDALE PLAINS",
//         "postal_code": 828866,
//         "telephone_no": 63158616,
//         "telephone_no_2": "na",
//         "fax_no": 63158420,
//         "fax_no_2": "na",
//         "email_address": "greendale_ss@moe.edu.sg",
//         "mrt_desc": "PUNGGOL MRT, MERIDIAN LRT",
//         "bus_desc": "3, 62, 83, 85, 136, 386",
//         "principal_name": "MR SULAIMAN B MOHAMAD YUSOF",
//         "first_vp_name": "MRS YU WEN YEN ANNE MRS ANNE CHAN",
//         "second_vp_name": "MR CHIA KENG HWEE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GREENRIDGE PRIMARY SCHOOL",
//         "url_address": "http://www.greenridgepri.moe.edu.sg",
//         "address": "11 JELAPANG ROAD",
//         "postal_code": 677744,
//         "telephone_no": 67604265,
//         "telephone_no_2": "na",
//         "fax_no": 67620189,
//         "fax_no_2": "na",
//         "email_address": "GRPS@MOE.EDU.SG",
//         "mrt_desc": "Senja LRT station, Jelapang LRT Station",
//         "bus_desc": "Bus 920, 922, 972",
//         "principal_name": "MADAM ONG FEI MIN",
//         "first_vp_name": "MR WONG SUNG LAI",
//         "second_vp_name": "MR ANG KONG BENG ANDY",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GREENRIDGE SECONDARY SCHOOL",
//         "url_address": "http://www.greenridgesec.moe.edu.sg",
//         "address": "31 Gangsa Road",
//         "postal_code": 678972,
//         "telephone_no": 67691491,
//         "telephone_no_2": "na",
//         "fax_no": "na",
//         "fax_no_2": "na",
//         "email_address": "GRSS@MOE.EDU.SG",
//         "mrt_desc": "Bukit Panjang MRT, Bukit Panjang LRT, Petir LRT",
//         "bus_desc": "65, 75, 170, 170A, 171, 176, 177, 178, 180, 180A, 920, 922, 960, 961, 963, 963E, 963R, 970, 972, 972A, 972, 972A, 972M, 973, 973A, 974, 975, 976, 979, 983",
//         "principal_name": "MR NG BOON KIAT",
//         "first_vp_name": "MRS DALINA BTE ABDULLAH",
//         "second_vp_name": "MR NGOH SING KIEN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GREENWOOD PRIMARY SCHOOL",
//         "url_address": "http://www.greenwoodpri.moe.edu.sg",
//         "address": "11 WOODLANDS  DR  62",
//         "postal_code": 737942,
//         "telephone_no": 63666158,
//         "telephone_no_2": "na",
//         "fax_no": 63666159,
//         "fax_no_2": "na",
//         "email_address": "GREENWOOD_PS@MOE.EDU.SG",
//         "mrt_desc": "Admiralty MRT Station",
//         "bus_desc": "912, 913, 962",
//         "principal_name": "MADAM TANG PEI LU TRICILIA",
//         "first_vp_name": "MR KIRUPANANTHA KUMAR S/O PALAIYAN",
//         "second_vp_name": "MR LEE HUAN SIAK",
//         "third_vp_name": "MR TAN KAR WEE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "GUANGYANG SECONDARY SCHOOL",
//         "url_address": "http://guangyangsec.moe.edu.sg",
//         "address": "8 BISHAN STREET 12",
//         "postal_code": 579807,
//         "telephone_no": 62589781,
//         "telephone_no_2": "na",
//         "fax_no": 63543108,
//         "fax_no_2": "na",
//         "email_address": "GYSS@MOE.EDU.SG",
//         "mrt_desc": "BISHAN MRT",
//         "bus_desc": "13, 56, 57, 59, 71, 88, 93, 157, 163, 410",
//         "principal_name": "MISS TAN KE XIN",
//         "first_vp_name": "MR HAN WEE FONG (HAN WEIFENG)",
//         "second_vp_name": "MISS WU XINPING JENNIFER",
//         "third_vp_name": "MR ANBALAGAN S/O THANGARAJAH",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BISHAN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HAI SING CATHOLIC SCHOOL",
//         "url_address": "http://www.haisingcatholic.moe.edu.sg",
//         "address": "15 PASIR RIS STREET 21",
//         "postal_code": 518969,
//         "telephone_no": 65827864,
//         "telephone_no_2": "na",
//         "fax_no": 65822543,
//         "fax_no_2": "na",
//         "email_address": "HSHS@MOE.EDU.SG",
//         "mrt_desc": "PASIR RIS MRT",
//         "bus_desc": "3, 5, 6, 89, 109",
//         "principal_name": "MISS LIM MUI MUI ADELINE",
//         "first_vp_name": "MISS SHEREEN WONG MINGRUI",
//         "second_vp_name": "MADAM TAN PHUAY BOON, GWEN",
//         "third_vp_name": "MR KONG WEI FOONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HAIG GIRLS' SCHOOL",
//         "url_address": "http://www.haiggirls.moe.edu.sg",
//         "address": "51 Koon Seng Road",
//         "postal_code": 427072,
//         "telephone_no": 63440293,
//         "telephone_no_2": "na",
//         "fax_no": 64474169,
//         "fax_no_2": "na",
//         "email_address": "HAIGGIRLSSCH@MOE.EDU.SG",
//         "mrt_desc": "Eunos, Dakota",
//         "bus_desc": "16,33",
//         "principal_name": "MS MARION DONNE TAY SZE LENG (ZHENG SHILING)",
//         "first_vp_name": "MADAM GOH SWEE LIN EVELYN",
//         "second_vp_name": "MISS SEAH XIAO YUN SHERLYN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "GEYLANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HENRY PARK PRIMARY SCHOOL",
//         "url_address": "http://www.henryparkpri.moe.edu.sg",
//         "address": "1 HOLLAND GROVE ROAD",
//         "postal_code": 278790,
//         "telephone_no": 64663600,
//         "telephone_no_2": "na",
//         "fax_no": 64691840,
//         "fax_no_2": "na",
//         "email_address": "HPPS@MOE.EDU.SG",
//         "mrt_desc": "Buona Vista MRT, Clementi MRT",
//         "bus_desc": "7, 61, 75, 156, 157, 165, 92",
//         "principal_name": "MR CHAN GEOK ANN CHARLES",
//         "first_vp_name": "MR CHUA CHYE HOCK",
//         "second_vp_name": "MRS JEAN TOH",
//         "third_vp_name": "MISS REGINA KIM LEE HOON",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HILLGROVE SECONDARY SCHOOL",
//         "url_address": "http://www.hillgrovesec.moe.edu.sg",
//         "address": "10 BUKIT BATOK STREET 52",
//         "postal_code": 659250,
//         "telephone_no": 65603726,
//         "telephone_no_2": "na",
//         "fax_no": 65630920,
//         "fax_no_2": "na",
//         "email_address": "HILLGROVE_SS@MOE.EDU.SG",
//         "mrt_desc": "BUKIT BATOK MRT, BUKIT GOMBAK MRT",
//         "bus_desc": "176, 985, 945",
//         "principal_name": "MADAM LEE CHING GUAN HELEN",
//         "first_vp_name": "MR ADAM BIN AHMAD",
//         "second_vp_name": "CHIANG HOCK YEE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HOLY INNOCENTS' HIGH SCHOOL",
//         "url_address": "http://www.holyinnocentshigh.moe.edu.sg",
//         "address": "1191 UPPER SERANGOON ROAD",
//         "postal_code": 534786,
//         "telephone_no": 62833381,
//         "telephone_no_2": "na",
//         "fax_no": 62831737,
//         "fax_no_2": "na",
//         "email_address": "HIHS@MOE.EDU.SG",
//         "mrt_desc": "HOUGANG MRT",
//         "bus_desc": "27, 72, 74, 80, 87, 89, 101, 107, 113, 116, 119, 132, 136, 147, 153, 161, 165, 324, 325",
//         "principal_name": "MRS REBECCA CHEW",
//         "first_vp_name": "MISS CAROL ANN MARTIN",
//         "second_vp_name": "MR TEO HAN WOON, DENNIS",
//         "third_vp_name": "MADAM ONG LEE LEE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HOLY INNOCENTS' PRIMARY SCHOOL",
//         "url_address": "http://www.holyinnocentspri.moe.edu.sg/",
//         "address": "5 Lorong Low Koon",
//         "postal_code": 536451,
//         "telephone_no": 62886516,
//         "telephone_no_2": "na",
//         "fax_no": 62876393,
//         "fax_no_2": "na",
//         "email_address": "HOLYINNOCENT@MOE.EDU.SG",
//         "mrt_desc": "2km walk to Hougang MRT",
//         "bus_desc": "51,72,80,101,119,132,136,153.",
//         "principal_name": "MISS SEET ENG GEOK LENA",
//         "first_vp_name": "MADAM TOO SIEW HAN JOYCE",
//         "second_vp_name": "MADAM GOH HUI CHENG",
//         "third_vp_name": "MR NG CHEONG ANN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "HONG WEN SCHOOL",
//         "url_address": "http://www.hongwen.moe.edu.sg",
//         "address": "30 TOWNER ROAD",
//         "postal_code": 327829,
//         "telephone_no": 62943340,
//         "telephone_no_2": "na",
//         "fax_no": 62937625,
//         "fax_no_2": "na",
//         "email_address": "HWS@MOE.EDU.SG",
//         "mrt_desc": "Boon Keng MRT",
//         "bus_desc": "Serangoon Road: 13, 23, 31, 64, 65, 66, 125, 133, 147, 857, 985; Balestier Road: 21, 125, 130, 139, 145",
//         "principal_name": "MRS THERESA HONG-NG",
//         "first_vp_name": "MR ONG SZE CHONG",
//         "second_vp_name": "MISS TEO AI LIN",
//         "third_vp_name": "MADAM CHRISTINE POON TZE MEI",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "KALLANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "HORIZON PRIMARY SCHOOL",
//         "url_address": "http://www.horizonpri.moe.edu.sg",
//         "address": "61 Edgedale Plains",
//         "postal_code": 828819,
//         "telephone_no": 67535411,
//         "telephone_no_2": "na",
//         "fax_no": 67523971,
//         "fax_no_2": "na",
//         "email_address": "horizon_ps@moe.edu.sg",
//         "mrt_desc": "Punggol MRT Station (NE17); (LRT: Kadaloor [PE5] or Oasis [PE6])",
//         "bus_desc": "3, 50, 83, 85, 569",
//         "principal_name": "MADAM CHIA HUI KHIM",
//         "first_vp_name": "MISS SEET SIEW LIN, PAMELA",
//         "second_vp_name": "MADAM SENTHIL POONKODI D/O R K",
//         "third_vp_name": "MR PHANG CHEE KHENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HOUGANG PRIMARY SCHOOL",
//         "url_address": "http://www.hougangpri.moe.edu.sg/",
//         "address": "1 HOUGANG ST 93",
//         "postal_code": 534238,
//         "telephone_no": 64897445,
//         "telephone_no_2": "na",
//         "fax_no": 64897446,
//         "fax_no_2": "na",
//         "email_address": "HOUGANG_PS@MOE.EDU.SG",
//         "mrt_desc": "Ang Mo Kio, Buangkok, Hougang, Sengkang, Yio Chu Kang",
//         "bus_desc": "SBS 43, 72, 88, 101, 109, 116, 156, 159, 325, 329",
//         "principal_name": "MR GOH WAI MIN, JASON",
//         "first_vp_name": "MISS LIEW PANG HAI",
//         "second_vp_name": "MADAM SHARIFAH FAIRUZ BTE S Y A",
//         "third_vp_name": "MADAM LIM SIEW GIM",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HOUGANG SECONDARY SCHOOL",
//         "url_address": "http://www.hougangsec.moe.edu.sg",
//         "address": "2 HOUGANG STREET 93",
//         "postal_code": 534256,
//         "telephone_no": 63851990,
//         "telephone_no_2": "na",
//         "fax_no": 63852015,
//         "fax_no_2": "na",
//         "email_address": "HOUGANG_SS@MOE.EDU.SG",
//         "mrt_desc": "HOUGANG MRT, BUANGKOK MRT",
//         "bus_desc": "43, 88, 101, 109, 156, 159, 161, 325, 329",
//         "principal_name": "MR LEE THUAN SIM",
//         "first_vp_name": "MR LIM SOON WAI",
//         "second_vp_name": "MR TAY YUAN ZHUANG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HUA YI SECONDARY SCHOOL",
//         "url_address": "http://www.huayisec.moe.edu.sg",
//         "address": "60 JURONG WEST ST 42",
//         "postal_code": 649371,
//         "telephone_no": 65634568,
//         "telephone_no_2": "na",
//         "fax_no": 65634505,
//         "fax_no_2": "na",
//         "email_address": "HYSS@MOE.EDU.SG",
//         "mrt_desc": "LAKESIDE MRT, CHINESE GARDEN MRT",
//         "bus_desc": "49, 98, 98B, 98M, 99, 157, 185, 187, 198, 198A, 334, 335, 502",
//         "principal_name": "DR. LIM SIEW YEE",
//         "first_vp_name": "MADAM TAN KAY BIN",
//         "second_vp_name": "MR NG JOO KOON",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HUAMIN PRIMARY SCHOOL",
//         "url_address": "http://www.huaminpri.moe.edu.sg",
//         "address": "21 YISHUN AVENUE 11",
//         "postal_code": 768857,
//         "telephone_no": 67529004,
//         "telephone_no_2": "na",
//         "fax_no": 67552455,
//         "fax_no_2": "na",
//         "email_address": "HUAMIN_PS@MOE.EDU.SG",
//         "mrt_desc": "Yishun MRT Station",
//         "bus_desc": "806, 804",
//         "principal_name": "MADAM LOE LAI PINK",
//         "first_vp_name": "MADAM BALAKRISHNAN CORINNE ANNE",
//         "second_vp_name": "MR HONG CHIN KEAT",
//         "third_vp_name": "MR LEE LIN CHIEH",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "HWA CHONG INSTITUTION",
//         "url_address": "http://www.hwachong.edu.sg",
//         "address": "661 BUKIT TIMAH ROAD",
//         "postal_code": 269734,
//         "telephone_no": 64683955,
//         "telephone_no_2": 65786644,
//         "fax_no": 67695857,
//         "fax_no_2": "na",
//         "email_address": "admin@hci.edu.sg",
//         "mrt_desc": "TAN KAH KEE MRT",
//         "bus_desc": "66, 67, 74, 151, 154, 156, 157, 170, 170A, 174, 852, 961, 961M",
//         "principal_name": "MR LEE PECK PING",
//         "first_vp_name": "MR CHAN KWOK LEONG",
//         "second_vp_name": "MRS CHIN-LEOW BEE KUAN",
//         "third_vp_name": "MISS HO PING PING",
//         "fourth_vp_name": "DR LIM HONG SENG MELVYN",
//         "fifth_vp_name": "MISS HOW LAI YIN DEBORAH",
//         "sixth_vp_name": "MDM LIM MIAU TENG CHERYL",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "WEST",
//         "type_code": "INDEPENDENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "INNOVA PRIMARY SCHOOL",
//         "url_address": "http://www.innovapri.moe.edu.sg/",
//         "address": "80 Woodlands Drive 17",
//         "postal_code": 737888,
//         "telephone_no": 68944693,
//         "telephone_no_2": "na",
//         "fax_no": 68942573,
//         "fax_no_2": "na",
//         "email_address": "innova_pri@moe.edu.sg",
//         "mrt_desc": "Woodlands",
//         "bus_desc": "900A (weekdays only - 7.00 am to 8.30 am & 4.30 pm to 6.30 pm), 901",
//         "principal_name": "MR YEE YEW LOONG",
//         "first_vp_name": "MR LAU YEAN HUI",
//         "second_vp_name": "na",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JIEMIN PRIMARY SCHOOL",
//         "url_address": "http://www.jieminpri.moe.edu.sg",
//         "address": "2 YISHUN STREET 71",
//         "postal_code": 768515,
//         "telephone_no": 67586472,
//         "telephone_no_2": "na",
//         "fax_no": 67559958,
//         "fax_no_2": "na",
//         "email_address": "JIEMIN_PS@MOE.EDU.SG",
//         "mrt_desc": "Yishun MRT Station",
//         "bus_desc": "167, 169, 171, 800, 811, 812, 856, 858, 859, 969, 980",
//         "principal_name": "MR ANDY MICKEY CHOONG TEK CHOY",
//         "first_vp_name": "MRS NUR FATIMAH BTE ABDUL MALIK MRS NUR FATIMAH FRAUDER",
//         "second_vp_name": "MISS WONG KAH WAN JOY",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JING SHAN PRIMARY SCHOOL",
//         "url_address": "http://www.jingshanpri.moe.edu.sg",
//         "address": "5 ANG MO KIO ST 52",
//         "postal_code": 569228,
//         "telephone_no": 64566305,
//         "telephone_no_2": "na",
//         "fax_no": 64581619,
//         "fax_no_2": "na",
//         "email_address": "JSPS@MOE.EDU.SG",
//         "mrt_desc": "Ang Mo Kio MRT",
//         "bus_desc": "Bus 265",
//         "principal_name": "MADAM BOEY HUEY PENG SHARON",
//         "first_vp_name": "MISS NG SUAT THENG ANGELA",
//         "second_vp_name": "MR JONATHON LOH",
//         "third_vp_name": "MISS LIM EE LENG ELLEN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JUNYUAN PRIMARY SCHOOL",
//         "url_address": "https://junyuanpri.moe.edu.sg",
//         "address": "2 Tampines Street 91",
//         "postal_code": 528906,
//         "telephone_no": 67830375,
//         "telephone_no_2": "na",
//         "fax_no": 67887395,
//         "fax_no_2": "na",
//         "email_address": "JUNYUAN_PS@MOE.EDU.SG",
//         "mrt_desc": "Tampines West (Downtown Line); Tampines (East-West Line)",
//         "bus_desc": "76281: 46, 65, 129; 76061: 10, 15, 20, 21, 23, 27, 31, 34, 39, 67, 168, 292; 75051: 5, 8, 15, 18, 21, 23, 28, 59, 67, 118, 168, 513, 518",
//         "principal_name": "MR CHAN WENG CHEONG",
//         "first_vp_name": "MRS CHEANG MENG TSING",
//         "second_vp_name": "MADAM CHUT SHI LIN",
//         "third_vp_name": "MR WILLIAM CHUE WAI LEONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JUNYUAN SECONDARY SCHOOL",
//         "url_address": "https://junyuansec.moe.edu.sg/",
//         "address": "11 TAMPINES STREET 84",
//         "postal_code": 528933,
//         "telephone_no": 65873683,
//         "telephone_no_2": "na",
//         "fax_no": "na",
//         "fax_no_2": "na",
//         "email_address": "JUNYUAN_SS@MOE.EDU.SG",
//         "mrt_desc": "TAMPINES MRT, TAMPINES WEST MRT",
//         "bus_desc": "69, 291, 293, 46",
//         "principal_name": "MR TAY MENG KIAT",
//         "first_vp_name": "MR LIN PEI",
//         "second_vp_name": "MR GAN THIAM SOON ALLAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JURONG PIONEER JUNIOR COLLEGE",
//         "url_address": "http://jpjc.moe.edu.sg",
//         "address": "21 Teck Whye Walk",
//         "postal_code": 688258,
//         "telephone_no": 65646878,
//         "telephone_no_2": "na",
//         "fax_no": 67651861,
//         "fax_no_2": "na",
//         "email_address": "jpjc@moe.edu.sg",
//         "mrt_desc": "Choa Chu Kang / Bt Panjang / Phoenix Station (LRT)",
//         "bus_desc": "975, 190, 985",
//         "principal_name": "MR KEVIN ANG",
//         "first_vp_name": "MRS LEE BEE CHEOW",
//         "second_vp_name": "MR NAH HONG LEONG",
//         "third_vp_name": "MR POW TIEN MIN JARON",
//         "fourth_vp_name": "MR PHUA YONG SWEE",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JURONG PRIMARY SCHOOL",
//         "url_address": "http://www.jurongpri.moe.edu.sg",
//         "address": "320 JURONG EAST Street 32",
//         "postal_code": 609476,
//         "telephone_no": 65618837,
//         "telephone_no_2": "na",
//         "fax_no": 65641964,
//         "fax_no_2": "na",
//         "email_address": "JPS@MOE.EDU.SG",
//         "mrt_desc": "Lakeside MRT Station, Jurong East MRT Station",
//         "bus_desc": 333,
//         "principal_name": "MR LEONARD CHUA",
//         "first_vp_name": "MISS TAN PEIRU",
//         "second_vp_name": "MR TAN YUAN SHIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG EAST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JURONG SECONDARY SCHOOL",
//         "url_address": "http://www.jurongsec.moe.edu.sg",
//         "address": "31 YUAN CHING ROAD",
//         "postal_code": 618652,
//         "telephone_no": 62655980,
//         "telephone_no_2": "na",
//         "fax_no": 62686414,
//         "fax_no_2": "na",
//         "email_address": "JURONG_SS@MOE.EDU.SG",
//         "mrt_desc": "LAKESIDE MRT",
//         "bus_desc": "30, 49, 98, 154, 240, 246",
//         "principal_name": "MISS YEO SIOK EE",
//         "first_vp_name": "MADAM LER SIAH WOON JULIA",
//         "second_vp_name": "MR LU YEOW CHOR",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JURONG WEST PRIMARY SCHOOL",
//         "url_address": "http://www.jurongwestpri.moe.edu.sg",
//         "address": "30 JURONG WEST ST 61",
//         "postal_code": 648368,
//         "telephone_no": 67933419,
//         "telephone_no_2": "na",
//         "fax_no": 67936593,
//         "fax_no_2": "na",
//         "email_address": "JWPS@MOE.EDU.SG",
//         "mrt_desc": "Pioneer MRT Station",
//         "bus_desc": 192,
//         "principal_name": "MRS CHRISTINA LIM LAY LENG",
//         "first_vp_name": "MADAM SIM EE KOON PATRICIA",
//         "second_vp_name": "MISS TAN WAN KHENG",
//         "third_vp_name": "MR LIM CHIN GUAN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JURONG WEST SECONDARY SCHOOL",
//         "url_address": "https://www.jurongwestsec.moe.edu.sg",
//         "address": "61 JURONG WEST STREET 65",
//         "postal_code": 648348,
//         "telephone_no": 62623593,
//         "telephone_no_2": "na",
//         "fax_no": 62623587,
//         "fax_no_2": "na",
//         "email_address": "JWSS@MOE.EDU.SG",
//         "mrt_desc": "BOON LAY MRT, PIONEER MRT",
//         "bus_desc": "30, 154, 157, 180, 187, 198, 242",
//         "principal_name": "MISS TAN MING MING",
//         "first_vp_name": "MS TAN JIING SHYUAN",
//         "second_vp_name": "MDM ZARINA BINTE AMIR",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JURONGVILLE SECONDARY SCHOOL",
//         "url_address": "http://www.jurongvillesec.moe.edu.sg",
//         "address": "202 JURONG EAST AVENUE 1",
//         "postal_code": 609790,
//         "telephone_no": 65638704,
//         "telephone_no_2": "na",
//         "fax_no": 65662137,
//         "fax_no_2": "na",
//         "email_address": "JURONGVILLE@MOE.EDU.SG",
//         "mrt_desc": "JURONG EAST MRT, LAKESIDE MRT",
//         "bus_desc": "98, 98M, 99, 157, 185, 187, 198, 334, 502",
//         "principal_name": "MR LEOW ZHI WEN PHILIBERT",
//         "first_vp_name": "MR YONG KEK SHOONG",
//         "second_vp_name": "MISS IBAIDAH BINTE IBRAHIM",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG EAST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "JUYING SECONDARY SCHOOL",
//         "url_address": "http://juyingsec.moe.edu.sg",
//         "address": "33 JURONG WEST STREET 91",
//         "postal_code": 649038,
//         "telephone_no": 63089898,
//         "telephone_no_2": "na",
//         "fax_no": 67932835,
//         "fax_no_2": "na",
//         "email_address": "JUYING_SS@MOE.EDU.SG",
//         "mrt_desc": "BOON LAY MRT, PIONEER MRT, JOO KOON MRT",
//         "bus_desc": "99, 241",
//         "principal_name": "MR ANG CHERN KWANG",
//         "first_vp_name": "MR NG HAN MING",
//         "second_vp_name": "MR CHUA YEW WEI",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MEE TOH SCHOOL",
//         "url_address": "http://www.meetoh.moe.edu.sg/",
//         "address": "21 EDGEDALE PLAINS",
//         "postal_code": 828867,
//         "telephone_no": 64893326,
//         "telephone_no_2": "na",
//         "fax_no": 64893243,
//         "fax_no_2": "na",
//         "email_address": "MEETOH_SCH@MOE.EDU.SG",
//         "mrt_desc": "Punggol Station",
//         "bus_desc": "3,62,83,381",
//         "principal_name": "MR TAY HSIEN CHUAN KELVIN",
//         "first_vp_name": "MISS HUANG YILAN LYNNE",
//         "second_vp_name": "MR LEE CHONG TART RONALD",
//         "third_vp_name": "MR NG KOK HENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "KEMING PRIMARY SCHOOL",
//         "url_address": "http://www.kemingpri.moe.edu.sg",
//         "address": "90 BUKIT BATOK EAST AVENUE 6",
//         "postal_code": 659762,
//         "telephone_no": 68962054,
//         "telephone_no_2": "na",
//         "fax_no": 65632356,
//         "fax_no_2": "na",
//         "email_address": "KMPS@MOE.EDU.SG",
//         "mrt_desc": "Bukit Batok",
//         "bus_desc": "61,66,77,106,157,174,178,963",
//         "principal_name": "MRS MRS YAP DAI JEE",
//         "first_vp_name": "MS LEOW MEI LENG (LIU MEICEN)",
//         "second_vp_name": "MISS NG MEI YUN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "KENT RIDGE SECONDARY SCHOOL",
//         "url_address": "http://www.kentridgesec.moe.edu.sg",
//         "address": "147 WEST COAST ROAD",
//         "postal_code": 127368,
//         "telephone_no": 67731127,
//         "telephone_no_2": "na",
//         "fax_no": 67735119,
//         "fax_no_2": "na",
//         "email_address": "KRSS@MOE.EDU.SG",
//         "mrt_desc": "CLEMENTI MRT, HAW PAR VILLA MRT",
//         "bus_desc": "30, 51, 143, 175, 176, 201, 282",
//         "principal_name": "MADAM GOH MIEN HUI VALERIE",
//         "first_vp_name": "MADAM YAP SHARON",
//         "second_vp_name": "MR POH LEONG BERG, ALBERT",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CLEMENTI",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "KHENG CHENG SCHOOL",
//         "url_address": "http://www.khengcheng.moe.edu.sg/",
//         "address": "15 LORONG 3 TOA PAYOH",
//         "postal_code": 319580,
//         "telephone_no": 62552502,
//         "telephone_no_2": "na",
//         "fax_no": 62556569,
//         "fax_no_2": "na",
//         "email_address": "KCS@MOE.EDU.SG",
//         "mrt_desc": "Braddell",
//         "bus_desc": "SBS 235,56,73,88,157,159,163,231,",
//         "principal_name": "MADAM TAN HUILING CHERYL",
//         "first_vp_name": "MR KHOO GHEE HAN",
//         "second_vp_name": "MR PUN KIAN PENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "KONG HWA SCHOOL",
//         "url_address": "http://www.konghwa.moe.edu.sg",
//         "address": "350 GUILLEMARD ROAD",
//         "postal_code": 399772,
//         "telephone_no": 63421195,
//         "telephone_no_2": "na",
//         "fax_no": 63421120,
//         "fax_no_2": "na",
//         "email_address": "KONGHWA_SCH@MOE.EDU.SG",
//         "mrt_desc": "Dakota",
//         "bus_desc": "Service 7,70,70M,197(to Guillemard Road)",
//         "principal_name": "MR POON SIOW LENG RAYMOND",
//         "first_vp_name": "MADAM UE TAY SZE YIN",
//         "second_vp_name": "MADAM TEO SIEW KHIM",
//         "third_vp_name": "MADAM NG BEE HOON",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "GEYLANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "KRANJI PRIMARY SCHOOL",
//         "url_address": "http://kranjipri.moe.edu.sg",
//         "address": "11 CHOA CHU KANG STREET 54",
//         "postal_code": 689189,
//         "telephone_no": 67634812,
//         "telephone_no_2": "na",
//         "fax_no": 67634568,
//         "fax_no_2": "na",
//         "email_address": "KRANJI_PS@MOE.EDU.SG",
//         "mrt_desc": "Yew Tee MRT",
//         "bus_desc": "Bus No 307, 302",
//         "principal_name": "MADAM GOH MEEI YUNN",
//         "first_vp_name": "MR SATHYA PRASAD S/O G",
//         "second_vp_name": "MADAM WONG SEOW LING",
//         "third_vp_name": "MADAM LEE LENG HUI (LI LINGHUI)",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "KRANJI SECONDARY SCHOOL",
//         "url_address": "http://www.kranjisec.moe.edu.sg",
//         "address": "61 CHOA CHU KANG STREET 51",
//         "postal_code": 689333,
//         "telephone_no": 67662464,
//         "telephone_no_2": "na",
//         "fax_no": 67662095,
//         "fax_no_2": "na",
//         "email_address": "KRANJI_SS@MOE.EDU.SG",
//         "mrt_desc": "CHOA CHU KANG MRT, YEW TEE MRT",
//         "bus_desc": "302, 974, 979",
//         "principal_name": "MR CHUA LEK HONG",
//         "first_vp_name": "MR KOO TIANNUO",
//         "second_vp_name": "MADAM ONG LAY LING",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "KUO CHUAN PRESBYTERIAN PRIMARY SCHOOL",
//         "url_address": "http://www.kuochuanpresbyterianpri.moe.edu.sg",
//         "address": "8 BISHAN STREET 13",
//         "postal_code": 579793,
//         "telephone_no": 62595396,
//         "telephone_no_2": "na",
//         "fax_no": 62588012,
//         "fax_no_2": "na",
//         "email_address": "KCPPS@MOE.EDU.SG",
//         "mrt_desc": "Bishan MRT Station",
//         "bus_desc": "54, 56, 410, 410G",
//         "principal_name": "MADAM YEE-TOH GEK KHIAW",
//         "first_vp_name": "MISS LIN HUIXIN SHARON",
//         "second_vp_name": "MR TAN CHIN HENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BISHAN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "KUO CHUAN PRESBYTERIAN SECONDARY SCHOOL",
//         "url_address": "http://www.kuochuanpresbyteriansec.moe.edu.sg",
//         "address": "10 BISHAN STREET 13",
//         "postal_code": 579795,
//         "telephone_no": 62593811,
//         "telephone_no_2": "na",
//         "fax_no": 63536535,
//         "fax_no_2": "na",
//         "email_address": "KCPSS@MOE.EDU.SG",
//         "mrt_desc": "BISHAN MRT",
//         "bus_desc": "54, 56, 410G, 410W",
//         "principal_name": "MR JUSTIN TAN",
//         "first_vp_name": "MADAM LEE CHUI ENG",
//         "second_vp_name": "MR EKA TANU",
//         "third_vp_name": "MR PHANG TECK KING",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BISHAN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "LAKESIDE PRIMARY SCHOOL",
//         "url_address": "http://www.lakesidepri.moe.edu.sg/",
//         "address": "161 Corporation Walk",
//         "postal_code": 618310,
//         "telephone_no": 62620918,
//         "telephone_no_2": "na",
//         "fax_no": 62621021,
//         "fax_no_2": "na",
//         "email_address": "lakeside_ps@moe.edu.sg",
//         "mrt_desc": "Lakeside MRT",
//         "bus_desc": "30, 49, 98, 98M",
//         "principal_name": "MADAM YAP SIU LIN",
//         "first_vp_name": "MISS HAN MINGFANG CHARMAIN",
//         "second_vp_name": "MISS TAN HUI PING",
//         "third_vp_name": "MADAM CHUA LENG LENG (CAI LINGLING)",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "LIANHUA PRIMARY SCHOOL",
//         "url_address": "http://www.lianhuapri.moe.edu.sg/",
//         "address": "2 BUKIT BATOK STREET 52",
//         "postal_code": 659243,
//         "telephone_no": 65639502,
//         "telephone_no_2": "na",
//         "fax_no": 65639591,
//         "fax_no_2": "na",
//         "email_address": "LIANHUA_PS@MOE.EDU.SG",
//         "mrt_desc": "Bukit Gombak/Bukit Batok",
//         "bus_desc": 945,
//         "principal_name": "MISS KIEW HUI LI PAMELA",
//         "first_vp_name": "MADAM MAVIS SIEW SOOK LING",
//         "second_vp_name": "MADAM TAN WAN PHING JANICE",
//         "third_vp_name": "MR LEE TZE WEI, JEFFREY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "LOYANG VIEW SECONDARY SCHOOL",
//         "url_address": "http://www.loyangviewsec.moe.edu.sg",
//         "address": "12 PASIR RIS STREET 11",
//         "postal_code": 519073,
//         "telephone_no": 65821727,
//         "telephone_no_2": "na",
//         "fax_no": 65810557,
//         "fax_no_2": "na",
//         "email_address": "loyangview_ss@moe.edu.sg",
//         "mrt_desc": "PASIR RIS MRT",
//         "bus_desc": "12, 21, 39, 53, 81, 109, 359, 518",
//         "principal_name": "MR LIN YUCHENG EUGENE",
//         "first_vp_name": "MS SAADIAH SAADON WYLDE",
//         "second_vp_name": "MADAM TAN SHAO MAY",
//         "third_vp_name": "MISS LIEW XUE TING ADELINE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MAHA BODHI SCHOOL",
//         "url_address": "http://www.mahabodhi.moe.edu.sg/",
//         "address": "10 UBI AVENUE 1",
//         "postal_code": 408931,
//         "telephone_no": 67442115,
//         "telephone_no_2": "na",
//         "fax_no": 67443752,
//         "fax_no_2": "na",
//         "email_address": "MBS@MOE.EDU.SG",
//         "mrt_desc": "Eunos Station (Transfer Bus No.63, 63M); Ubi Station (Transfer Bus No. 137)",
//         "bus_desc": "5,8,15,22,25,45,51,55,59,61,63,63M,65,66,93,94,137,854",
//         "principal_name": "MADAM TENG LAI KWAN",
//         "first_vp_name": "MR WEE HOCK MENG VICTOR",
//         "second_vp_name": "MR YE JIAMING AARON",
//         "third_vp_name": "MADAM LENG BING LING (LIANG BINGLING)",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "GEYLANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "MANJUSRI SECONDARY SCHOOL",
//         "url_address": "http://www.manjusrisec.moe.edu.sg",
//         "address": "20 UBI AVENUE 1",
//         "postal_code": 408940,
//         "telephone_no": 68424558,
//         "telephone_no_2": "na",
//         "fax_no": 67454492,
//         "fax_no_2": "na",
//         "email_address": "MANJUSRI_SS@MOE.EDU.SG",
//         "mrt_desc": "UBI MRT, MACPHERSON MRT",
//         "bus_desc": "5, 8, 15, 22, 25, 45, 51, 55, 59, 61, 63, 63M, 65, 66, 93, 94, 137, 854",
//         "principal_name": "MR SIM CHONG BOON",
//         "first_vp_name": "MR LIN JUNKAI",
//         "second_vp_name": "MR GOH PAI SHEN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "GEYLANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "MARIS STELLA HIGH SCHOOL",
//         "url_address": "http://www.marisstellahigh.moe.edu.sg",
//         "address": "25 MOUNT VERNON ROAD",
//         "postal_code": 368051,
//         "telephone_no": "62803880 (Sec)",
//         "telephone_no_2": "62827743 (Pri)",
//         "fax_no": "62886905 (Sec)",
//         "fax_no_2": "62827905 (Pri)",
//         "email_address": "MSH@MOE.EDU.SG",
//         "mrt_desc": "BARTLEY MRT",
//         "bus_desc": "28, 93, 129, 158",
//         "principal_name": "MR BOY ENG SENG",
//         "first_vp_name": "MRS LIM QING YI",
//         "second_vp_name": "MR PAN JINGLIU",
//         "third_vp_name": "MR TAN CHING HUAT",
//         "fourth_vp_name": "MDM ANG CHWEE YING PEARLY",
//         "fifth_vp_name": "MR LEE KO YONG",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (P1-S4)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "MARSILING PRIMARY SCHOOL",
//         "url_address": "http://www.marsilingpri.moe.edu.sg",
//         "address": "31 WOODLANDS CENTRE ROAD",
//         "postal_code": 738927,
//         "telephone_no": 62696193,
//         "telephone_no_2": "na",
//         "fax_no": 62699050,
//         "fax_no_2": "na",
//         "email_address": "MARSILING_PS@MOE.EDU.SG",
//         "mrt_desc": "Marsiling MRT Station",
//         "bus_desc": "856, 911, 912",
//         "principal_name": "MADAM HEATHER SIM SIAW CHENG",
//         "first_vp_name": "MR JACKSON KEK",
//         "second_vp_name": "na",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MARSILING SECONDARY SCHOOL",
//         "url_address": "http://www.marsilingsec.moe.edu.sg",
//         "address": "12 MARSILING ROAD",
//         "postal_code": 739110,
//         "telephone_no": 68941413,
//         "telephone_no_2": "na",
//         "fax_no": 68946156,
//         "fax_no_2": "na",
//         "email_address": "MARSILING_SS@MOE.EDU.SG",
//         "mrt_desc": "MARSILING MRT",
//         "bus_desc": "913, 911",
//         "principal_name": "MR KOH YIAK KHENG",
//         "first_vp_name": "MR MOHAMED NASIM S/O ABDUL RAHIM",
//         "second_vp_name": "MR TAN TONG AIK",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MARYMOUNT CONVENT SCHOOL",
//         "url_address": "HTTP://WWW.MARYMOUNTCONVENT.MOE.EDU.SG",
//         "address": "20 Marymount Road",
//         "postal_code": 297754,
//         "telephone_no": "6256 6701",
//         "telephone_no_2": "6256 6532",
//         "fax_no": "6254 3080",
//         "fax_no_2": "na",
//         "email_address": "MMCS@MOE.EDU.SG",
//         "mrt_desc": "Braddell MRT Station or Caldecott MRT Station",
//         "bus_desc": "141, 235",
//         "principal_name": "MISS CHEONG HWEE KHIM",
//         "first_vp_name": "MRS HING SZE MEING DEBBIE (XING SIMIN DEBBIE)",
//         "second_vp_name": "MADAM TAN MEI MEI ANNA",
//         "third_vp_name": "MR LOH YEH CHANG HENRY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MAYFLOWER PRIMARY SCHOOL",
//         "url_address": "http://www.mayflowerpri.moe.edu.sg",
//         "address": "200 Ang Mo Kio Avenue 5",
//         "postal_code": 569878,
//         "telephone_no": 64520849,
//         "telephone_no_2": "na",
//         "fax_no": 64534116,
//         "fax_no_2": "na",
//         "email_address": "MAYFLOWER_PS@MOE.EDU.SG",
//         "mrt_desc": "Yio Chu Kang MRT Station.",
//         "bus_desc": "13,86,138,162,269,851,852,853.",
//         "principal_name": "MISS CECILIA LIM SEOK CHENG",
//         "first_vp_name": "MADAM CHNG HWUI LIN WINEFREDE",
//         "second_vp_name": "MRS SANTHI D/O K RAMACHANDRAN",
//         "third_vp_name": "MR KWOK KENG LIAN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MAYFLOWER SECONDARY SCHOOL",
//         "url_address": "http://www.mayflowersec.moe.edu.sg",
//         "address": "2 ANG MO KIO STREET 21",
//         "postal_code": 569384,
//         "telephone_no": 64577783,
//         "telephone_no_2": "na",
//         "fax_no": 64583284,
//         "fax_no_2": "na",
//         "email_address": "MAYFLOWER_SS@MOE.EDU.SG",
//         "mrt_desc": "ANG MO KIO MRT, MAYFLOWER MRT",
//         "bus_desc": "71, 76, 132, 165, 166, 169, 262, 265, 268, 269",
//         "principal_name": "MR LIM YU KEE",
//         "first_vp_name": "MR GOH KENG TENG",
//         "second_vp_name": "MR PRASHANT S/O JAYAPRAGAS",
//         "third_vp_name": "MADAM NUR HIDAYANI IBRAHIM",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MERIDIAN PRIMARY SCHOOL",
//         "url_address": "http://www.meridianpri.moe.edu.sg/",
//         "address": "20 PASIR RIS ST 71",
//         "postal_code": 518798,
//         "telephone_no": 65832125,
//         "telephone_no_2": "na",
//         "fax_no": 65834993,
//         "fax_no_2": "na",
//         "email_address": "MERIDIAN_PS@MOE.EDU.SG",
//         "mrt_desc": "Pasir Ris MRT Station",
//         "bus_desc": "3,359",
//         "principal_name": "MDM CHEW SIANG JIUN",
//         "first_vp_name": "MR LIM KIM MIN (LIN JINMIN)",
//         "second_vp_name": "MR WANG TAI WEE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MERIDIAN SECONDARY SCHOOL",
//         "url_address": "http://www.meridiansec.moe.edu.sg",
//         "address": "31 PASIR RIS STREET 51",
//         "postal_code": 518901,
//         "telephone_no": 65831387,
//         "telephone_no_2": "na",
//         "fax_no": 65836467,
//         "fax_no_2": "na",
//         "email_address": "meridian_sec@moe.edu.sg",
//         "mrt_desc": "PASIR RIS MRT",
//         "bus_desc": "39, 53, 81, 89, 109, 359, 403, 518",
//         "principal_name": "MR MOHAMED RAZALI B ABDUL HAMED",
//         "first_vp_name": "MISS TAN LI PING",
//         "second_vp_name": "MRS TAY NGEE SEEW",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "METHODIST GIRLS' SCHOOL (PRIMARY)",
//         "url_address": "https://www.mgs.moe.edu.sg/",
//         "address": "11 Blackmore Drive",
//         "postal_code": 599986,
//         "telephone_no": 64694800,
//         "telephone_no_2": "na",
//         "fax_no": 64624166,
//         "fax_no_2": "na",
//         "email_address": "MGPS@MOE.EDU.SG",
//         "mrt_desc": "King Albert Park MRT",
//         "bus_desc": "66, 67, 74, 77, 151, 154, 157, 170, 171, 174, 852, 961, 970",
//         "principal_name": "KOH MING-LI VALARIE",
//         "first_vp_name": "MADAM YEOW CHERN EE",
//         "second_vp_name": "MR TENG TAT MENG, CHARLES",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "METHODIST GIRLS' SCHOOL (SECONDARY)",
//         "url_address": "http://www.mgs.moe.edu.sg",
//         "address": "11 BLACKMORE DRIVE",
//         "postal_code": 599986,
//         "telephone_no": 64694800,
//         "telephone_no_2": "na",
//         "fax_no": 64698717,
//         "fax_no_2": "na",
//         "email_address": "MGSS@MOE.EDU.SG",
//         "mrt_desc": "KING ALBERT PARK MRT",
//         "bus_desc": "66, 67, 74, 77, 151, 154, 157, 170, 174, 852, 961, 970",
//         "principal_name": "MADAM KOH MING- LI VALARIE",
//         "first_vp_name": "MADAM CHNG YI NA @MRS WRIGHT YI NA",
//         "second_vp_name": "MDM TAN P'ENG DIANA",
//         "third_vp_name": "MR YIP WAI CHOONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "WEST",
//         "type_code": "INDEPENDENT SCHOOL",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MILLENNIA INSTITUTE",
//         "url_address": "http://www.millenniainstitute.moe.edu.sg",
//         "address": "60 Bukit Batok West Avenue 8",
//         "postal_code": 658965,
//         "telephone_no": 63023700,
//         "telephone_no_2": "na",
//         "fax_no": 63023767,
//         "fax_no_2": "na",
//         "email_address": "millennia_inst@moe.edu.sg",
//         "mrt_desc": "Bukit Batok (NS 2)",
//         "bus_desc": "157, 174, 174e, 178, 506, 870, 941, 991, 993",
//         "principal_name": "MR LOO MING YAW",
//         "first_vp_name": "MR LIN GUOJING",
//         "second_vp_name": "MR TAN KENG CHEONG",
//         "third_vp_name": "MR DAVID ALLAN D'SOUZA",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "CENTRALISED INSTITUTE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MONTFORT JUNIOR SCHOOL",
//         "url_address": "http://www.montfortjunior.moe.edu.sg/",
//         "address": "52 HOUGANG AVENUE 8",
//         "postal_code": 538786,
//         "telephone_no": 65101588,
//         "telephone_no_2": "na",
//         "fax_no": 65101599,
//         "fax_no_2": "na",
//         "email_address": "MONTFORT_JS@MOE.EDU.SG",
//         "mrt_desc": "Hougang MRT & Bus Interchange",
//         "bus_desc": "74,88,101,147,161,",
//         "principal_name": "MR TAN BOON HONG VICTOR",
//         "first_vp_name": "MADAM POH LEE SIEW",
//         "second_vp_name": "MR TAN WEE BOON",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "MONTFORT SECONDARY SCHOOL",
//         "url_address": "https://montfortsec.moe.edu.sg/",
//         "address": "50 HOUGANG AVENUE 8",
//         "postal_code": 538785,
//         "telephone_no": 65107070,
//         "telephone_no_2": "na",
//         "fax_no": 63862804,
//         "fax_no_2": "na",
//         "email_address": "MONTFORT_SS@MOE.EDU.SG",
//         "mrt_desc": "HOUGANG MRT",
//         "bus_desc": "74, 74e, 88, 88A, 101, 147, 147A, 161",
//         "principal_name": "MADAM HENG SUE LIN, JANICE",
//         "first_vp_name": "MR WILSON TAY SWEE KIAT",
//         "second_vp_name": "MISS TAN MEI LING AUDREY",
//         "third_vp_name": "MADAM TAN LAY YEN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NAN CHIAU HIGH SCHOOL",
//         "url_address": "http://www.nanchiauhigh.moe.edu.sg",
//         "address": "20 ANCHORVALE LINK",
//         "postal_code": 545079,
//         "telephone_no": 64897971,
//         "telephone_no_2": "na",
//         "fax_no": 64897970,
//         "fax_no_2": "na",
//         "email_address": "NCHS@MOE.EDU.SG",
//         "mrt_desc": "SENGKANG MRT, RENJONG LRT, TONGKANG LRT",
//         "bus_desc": "43, 83, 85, 109, 156, 159, 161, 163, 372",
//         "principal_name": "MADAM LER JIA LUEN",
//         "first_vp_name": "MADAM CHOW NYET YOON",
//         "second_vp_name": "DR. OH BEE LENG HESTER",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "NAN CHIAU PRIMARY SCHOOL",
//         "url_address": "http://www.ncps.moe.edu.sg",
//         "address": "50 ANCHORVALE LINK",
//         "postal_code": 545080,
//         "telephone_no": 64897905,
//         "telephone_no_2": "na",
//         "fax_no": 64897906,
//         "fax_no_2": "na",
//         "email_address": "NCPS@MOE.EDU.SG",
//         "mrt_desc": "Sengkang Station",
//         "bus_desc": "156, 159, 161, 371, 372",
//         "principal_name": "MRS ONG LOH JIA MIIN",
//         "first_vp_name": "MDM HOE QUEE HIANG, BELINDA",
//         "second_vp_name": "MADAM LIM SHEUE TYUG",
//         "third_vp_name": "MR WINSTON TAN WEE SING",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NAN HUA HIGH SCHOOL",
//         "url_address": "http://www.nanhuahigh.moe.edu.sg",
//         "address": "41 CLEMENTI AVENUE 1",
//         "postal_code": 129956,
//         "telephone_no": 67788303,
//         "telephone_no_2": "na",
//         "fax_no": 67751956,
//         "fax_no_2": "na",
//         "email_address": "NHSS@MOE.EDU.SG",
//         "mrt_desc": "CLEMENTI MRT",
//         "bus_desc": "14, 33, 52, 78, 96, 97, 105, 106, 147, 151, 154, 165, 166, 183, 185, 188, 189, 196, 197, 198, 282, 285, 963",
//         "principal_name": "MR CHIEW JING WEN",
//         "first_vp_name": "MISS TAY JIA MING JASMINE",
//         "second_vp_name": "MR LOO JIAMING",
//         "third_vp_name": "MR LEE KOK BOON",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CLEMENTI",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "NAN HUA PRIMARY SCHOOL",
//         "url_address": "http://www.nanhuapri.moe.edu.sg",
//         "address": "30 Jalan Lempeng",
//         "postal_code": 128806,
//         "telephone_no": 67788050,
//         "telephone_no_2": "na",
//         "fax_no": 67784127,
//         "fax_no_2": "na",
//         "email_address": "NHPS@MOE.EDU.SG",
//         "mrt_desc": "Clementi MRT Station",
//         "bus_desc": "30, 51, 143, 175, 201, 533, 655, 727, 762",
//         "principal_name": "MADAM PHUA YIN LIN GRACE",
//         "first_vp_name": "MISS TEH LAY CHOO ANNE",
//         "second_vp_name": "MR LIM PENG YUAN, ANDY",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CLEMENTI",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "NANYANG GIRLS' HIGH SCHOOL",
//         "url_address": "https://www.nygh.edu.sg",
//         "address": "2 LINDEN DRIVE",
//         "postal_code": 288683,
//         "telephone_no": 64663275,
//         "telephone_no_2": "na",
//         "fax_no": 64667564,
//         "fax_no_2": "na",
//         "email_address": "NYGHS@MOE.EDU.SG",
//         "mrt_desc": "SIXTH AVENUE MRT, TAN KAH KEE MRT",
//         "bus_desc": "67, 74, 151, 154, 156, 157, 170, 174, 852, 961",
//         "principal_name": "MISS SIAU FONG FUI",
//         "first_vp_name": "MS NG MIEN MIEN AGNES",
//         "second_vp_name": "MISS GAYNOR TEH",
//         "third_vp_name": "MS TAN MEEI YEE MAE PAULINE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "WEST",
//         "type_code": "INDEPENDENT SCHOOL",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "NANYANG JUNIOR COLLEGE",
//         "url_address": "http://www.nanyangjc.moe.edu.sg/",
//         "address": "128 SERANGOON AVENUE 3",
//         "postal_code": 556111,
//         "telephone_no": 62842281,
//         "telephone_no_2": "na",
//         "fax_no": 62855147,
//         "fax_no_2": "na",
//         "email_address": "NYJC@MOE.EDU.SG",
//         "mrt_desc": "Lorong Chuan (Circle Line/CC14); 3-minute walk via sheltered walkway",
//         "bus_desc": "22, 24, 45, 53, 58, 73, 105, 109, 133, 135, 136, 156, 853",
//         "principal_name": "MR PANG CHOON HOW",
//         "first_vp_name": "MISS JASMINE ONG PEISHAN",
//         "second_vp_name": "MRS OH-YOW SIHUA KEN",
//         "third_vp_name": "MADAM CHAN MEI FUNG JOYCE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NANYANG PRIMARY SCHOOL",
//         "url_address": "http://www.nyps.moe.edu.sg",
//         "address": "52 KING'S ROAD",
//         "postal_code": 268097,
//         "telephone_no": 64672677,
//         "telephone_no_2": "na",
//         "fax_no": 64686913,
//         "fax_no_2": "na",
//         "email_address": "NYPS@MOE.EDU.SG",
//         "mrt_desc": "Farrer Rd MRT Station",
//         "bus_desc": "66, 67, 74, 93, 151, 153, 154, 156, 157, 165, 170, 171, 174, 186, 852, 855, 961",
//         "principal_name": "MADAM WONG LI PENG",
//         "first_vp_name": "MS LIM KAR WAE FIONA",
//         "second_vp_name": "MISS SHARLENE CHYE HUI TING",
//         "third_vp_name": "MR JAMES CHONG KOK CHIANG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "NATIONAL JUNIOR COLLEGE",
//         "url_address": "http://www.nationaljc.moe.edu.sg",
//         "address": "37 HILLCREST ROAD",
//         "postal_code": 288913,
//         "telephone_no": 64661144,
//         "telephone_no_2": "na",
//         "fax_no": 64684535,
//         "fax_no_2": "na",
//         "email_address": "NJC@MOE.EDU.SG",
//         "mrt_desc": "BOTANIC GARDENS MRT, TAN KAH KEE MRT, SIXTH AVENUE MRT",
//         "bus_desc": "67, 74, 151, 154, 156, 157, 170, 174, 852, 961",
//         "principal_name": "MRS TOH LUCY",
//         "first_vp_name": "MR HARESH S/O SIVARAM",
//         "second_vp_name": "MISS SIM SOO LENG AILEEN",
//         "third_vp_name": "MR CHONG CHEE KEONG ALVIN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NAVAL BASE PRIMARY SCHOOL",
//         "url_address": "http://www.navalbasepri.moe.edu.sg/",
//         "address": "7 YISHUN AVE 4",
//         "postal_code": 769028,
//         "telephone_no": 67537114,
//         "telephone_no_2": "na",
//         "fax_no": 67555355,
//         "fax_no_2": "na",
//         "email_address": "NBPS@MOE.EDU.SG",
//         "mrt_desc": "Yishun MRT Station",
//         "bus_desc": "Feeder bus No. 811 from Yishun Interchange.",
//         "principal_name": "MR CHIA CHEE WENG RICHARD CHRIS",
//         "first_vp_name": "MADAM LIM WAI CHOO MRS GOH WAI CHOO",
//         "second_vp_name": "MADAM WANG MING HWEE",
//         "third_vp_name": "MADAM THAM LAI PENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NAVAL BASE SECONDARY SCHOOL",
//         "url_address": "http://www.navalbasesec.moe.edu.sg",
//         "address": "901 YISHUN RING ROAD",
//         "postal_code": 768689,
//         "telephone_no": 62571996,
//         "telephone_no_2": "na",
//         "fax_no": 67557706,
//         "fax_no_2": "na",
//         "email_address": "NBSS@MOE.EDU.SG",
//         "mrt_desc": "KHATIB MRT",
//         "bus_desc": "39, 85, 117, 670, 807, 811, 812, 851, 852, 853, 854, 855, 857, 858, 861, 965, 969",
//         "principal_name": "MADAM LINDA YEO SOCK KHOON",
//         "first_vp_name": "MR LIM SEOW KUAN",
//         "second_vp_name": "MR MUHAMMAD SHAHARI B ABU BAKAR",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NEW TOWN PRIMARY SCHOOL",
//         "url_address": "http://www.newtownpri.moe.edu.sg/",
//         "address": "300 Tanglin Halt Road",
//         "postal_code": 148812,
//         "telephone_no": 64748805,
//         "telephone_no_2": "na",
//         "fax_no": 64741249,
//         "fax_no_2": "na",
//         "email_address": "NTPS@MOE.EDU.SG",
//         "mrt_desc": "Commonwealth MRT Station",
//         "bus_desc": "SBS Numbers 32, 100, 105, 111, 145, 147, 195, 196, 198, 855",
//         "principal_name": "MISS HANNAH CHIA CUI'E",
//         "first_vp_name": "MRS CHIN WEY LING LYNNE",
//         "second_vp_name": "MADAM FOO HUEY YING (FU HUIYING)",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "QUEENSTOWN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NEW TOWN SECONDARY SCHOOL",
//         "url_address": "http://www.newtownsec.moe.edu.sg",
//         "address": "1020 DOVER ROAD",
//         "postal_code": 139657,
//         "telephone_no": 67754140,
//         "telephone_no_2": "na",
//         "fax_no": 67752310,
//         "fax_no_2": "na",
//         "email_address": "NTSS@MOE.EDU.SG",
//         "mrt_desc": "DOVER MRT, CLEMENTI MRT",
//         "bus_desc": "33, 96, 96A, 151, 196, 183",
//         "principal_name": "MR ARIVAZHAGAN MANICKAM",
//         "first_vp_name": "MISS GOH YI LING ELISSA",
//         "second_vp_name": "MR LEONARD TAN SOON TECK",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "QUEENSTOWN",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NGEE ANN PRIMARY SCHOOL",
//         "url_address": "http://www.ngeeannpri.moe.edu.sg",
//         "address": "344 MARINE TERRACE",
//         "postal_code": 449149,
//         "telephone_no": 64418677,
//         "telephone_no_2": "na",
//         "fax_no": 64417411,
//         "fax_no_2": "na",
//         "email_address": "NAPS@MOE.EDU.SG",
//         "mrt_desc": "Nil",
//         "bus_desc": "13, 16, 16M, 31,36, 43, 47, 48, 55, 135, 196, 196E, 197, 853M (at Marine Parade road); 13, 16, 16M, 196 and 196E(at Marine Terrace)",
//         "principal_name": "MADAM PANG SIU SAN",
//         "first_vp_name": "MADAM LEE LI LI",
//         "second_vp_name": "MADAM LOW LEE CHERN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "MARINE PARADE",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NGEE ANN SECONDARY SCHOOL",
//         "url_address": "http://www.ngeeannsec.moe.edu.sg",
//         "address": "1 TAMPINES STREET 32",
//         "postal_code": 529283,
//         "telephone_no": 67844583,
//         "telephone_no_2": "na",
//         "fax_no": 67840453,
//         "fax_no_2": "na",
//         "email_address": "NASS@MOE.EDU.SG",
//         "mrt_desc": "TAMPINES MRT, SIMEI MRT, TAMPINES EAST MRT",
//         "bus_desc": "3, 4, 8, 9, 12, 17, 18, 19, 21, 28, 29, 34, 37, 38, 39, 59, 81, 291, 293, 518, 552",
//         "principal_name": "MISS POH SHI HUI",
//         "first_vp_name": "MR GOH CHIN WEI",
//         "second_vp_name": "MADAM TAN LAY GIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTH SPRING PRIMARY SCHOOL",
//         "url_address": "http://www.northspringpri.moe.edu.sg",
//         "address": "1 RIVERVALE STREET",
//         "postal_code": 545088,
//         "telephone_no": 68816887,
//         "telephone_no_2": 63888764,
//         "fax_no": 63851044,
//         "fax_no_2": "na",
//         "email_address": "NSPS@MOE.EDU.SG",
//         "mrt_desc": "NEL - Sengkang Station; LRT - Bakau Station",
//         "bus_desc": "SBS Transit Services 82, 85, 86, 88, 119, 136, 163, 372",
//         "principal_name": "MADAM PHAN SWEE LIN SHERIN JACINTA",
//         "first_vp_name": "MR TAN YEW LEE",
//         "second_vp_name": "MADAM SALIEMA BINTE MOHAMED IQBAL",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTH VIEW PRIMARY SCHOOL",
//         "url_address": "http://www.northviewpri.moe.edu.sg",
//         "address": "210 YISHUN AVENUE 6",
//         "postal_code": 768960,
//         "telephone_no": 67593235,
//         "telephone_no_2": "na",
//         "fax_no": 67593237,
//         "fax_no_2": "na",
//         "email_address": "NVPS@MOE.EDU.SG",
//         "mrt_desc": "Yishun; Khatib",
//         "bus_desc": "Feeder Service 804, 806, 807, 860",
//         "principal_name": "MRS GRACE CHUA",
//         "first_vp_name": "MR RAJINDER SINGH S/O PIARA SINGH",
//         "second_vp_name": "MADAM LING SOOK LENG",
//         "third_vp_name": "MR CHAN SOON HUA",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTH VISTA PRIMARY SCHOOL",
//         "url_address": "http://www.northvistapri.moe.edu.sg",
//         "address": "20 Compassvale Link",
//         "postal_code": 544974,
//         "telephone_no": 64843566,
//         "telephone_no_2": "na",
//         "fax_no": 64843568,
//         "fax_no_2": "na",
//         "email_address": "nvtps@moe.edu.sg",
//         "mrt_desc": "Buangkok MRT (NE15), Ranggung LRT (SE5)",
//         "bus_desc": "na",
//         "principal_name": "MR ONG LYE WHATT",
//         "first_vp_name": "MR AMRAN B TASRIF",
//         "second_vp_name": "MISS GOH AI LING",
//         "third_vp_name": "MADAM KANG SIEW LENG AUDREY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTH VISTA SECONDARY SCHOOL",
//         "url_address": "http://www.northvistasec.moe.edu.sg",
//         "address": "11 RIVERVALE LINK",
//         "postal_code": 545081,
//         "telephone_no": 68793930,
//         "telephone_no_2": "na",
//         "fax_no": 68793931,
//         "fax_no_2": "na",
//         "email_address": "NORTHVISTASS@MOE.EDU.SG",
//         "mrt_desc": "SENGKANG MRT, BUANGKOK MRT, RANGGUNG LRT",
//         "bus_desc": "80, 82, 87, 88, 89, 119",
//         "principal_name": "MR YAP THIAM CHUAN",
//         "first_vp_name": "MR PILLAY P KRISHNAN",
//         "second_vp_name": "MISS WU XIAOYUAN",
//         "third_vp_name": "MR KWEK CHIN LEONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTHBROOKS SECONDARY SCHOOL",
//         "url_address": "http://www.northbrookssec.moe.edu.sg",
//         "address": "585 YISHUN RING ROAD",
//         "postal_code": 768692,
//         "telephone_no": 67524311,
//         "telephone_no_2": "na",
//         "fax_no": 67566110,
//         "fax_no_2": "na",
//         "email_address": "NORTHBROOKS@MOE.EDU.SG",
//         "mrt_desc": "YISHUN MRT, KHATIB MRT",
//         "bus_desc": "804, 806, 807, 860, 103",
//         "principal_name": "MR CHEN XUANTING EDMUND",
//         "first_vp_name": "MISS GOH PEISHI",
//         "second_vp_name": "MR YIP KOK HOONG (YE GUOXIONG)",
//         "third_vp_name": "MR LIM YANG CHERNG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTHLAND PRIMARY SCHOOL",
//         "url_address": "http://www.northlandpri.moe.edu.sg",
//         "address": "15 YISHUN AVENUE 4",
//         "postal_code": 769026,
//         "telephone_no": 67598884,
//         "telephone_no_2": "na",
//         "fax_no": 67559196,
//         "fax_no_2": "na",
//         "email_address": "NORTHLAND_PS@MOE.EDU.SG",
//         "mrt_desc": "Yishun MRT Station",
//         "bus_desc": "812 (next to bus service number 171) at Yishun Interchange",
//         "principal_name": "MR JAY WESTLY MAHARDALE",
//         "first_vp_name": "MR CHONG CHOONG HIAN",
//         "second_vp_name": "MISS LEE QUEE CHOO GINA",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTHLAND SECONDARY SCHOOL",
//         "url_address": "http://www.northlandsec.moe.edu.sg",
//         "address": "3 YISHUN STREET 22",
//         "postal_code": 768578,
//         "telephone_no": 62576781,
//         "telephone_no_2": "na",
//         "fax_no": 62573634,
//         "fax_no_2": "na",
//         "email_address": "NORTHLAND_SS@MOE.EDU.SG",
//         "mrt_desc": "YISHUN MRT",
//         "bus_desc": "811, 804, 800",
//         "principal_name": "MR LIM KOK HWA",
//         "first_vp_name": "MR PETERSON JOSEPH STANLEY",
//         "second_vp_name": "MR LOW CHEE WAI",
//         "third_vp_name": "MR CHEEN HSIEN HONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTHLIGHT SCHOOL",
//         "url_address": "https://www.nls.edu.sg",
//         "address": "151 Towner Road",
//         "postal_code": 327830,
//         "telephone_no": 69296290,
//         "telephone_no_2": "na",
//         "fax_no": 62912423,
//         "fax_no_2": "na",
//         "email_address": "nls@moe.edu.sg",
//         "mrt_desc": "BOON KENG (NE9)",
//         "bus_desc": "21, 125, 130, 139, 145, 13, 23, 31, 64, 65, 133, 147, 857, 985",
//         "principal_name": "MADAM SUNG MEE HAR",
//         "first_vp_name": "MR GAN KOK SOON SIMON",
//         "second_vp_name": "MR HSU YU CHIH TOMMY",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "KALLANG",
//         "zone_code": "SOUTH",
//         "type_code": "SPECIALISED SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTHOAKS PRIMARY SCHOOL",
//         "url_address": "http://www.northoakspri.moe.edu.sg",
//         "address": "61 Sembawang Drive",
//         "postal_code": 757622,
//         "telephone_no": "6753 8835",
//         "telephone_no_2": "na",
//         "fax_no": "6753 8864",
//         "fax_no_2": "na",
//         "email_address": "northoaks_ps@moe.edu.sg",
//         "mrt_desc": "Sembawang MRT",
//         "bus_desc": "Bus number 962",
//         "principal_name": "MR CHER TECK YIANG, LUKE MELVIN",
//         "first_vp_name": "MADAM KOMATHI D/O GOVINDASAMY",
//         "second_vp_name": "MR OW EU GENE JOHN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SEMBAWANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NORTHSHORE PRIMARY SCHOOL",
//         "url_address": "https://northshorepri.moe.edu.sg/",
//         "address": "30 Northshore Drive",
//         "postal_code": 828671,
//         "telephone_no": 62026490,
//         "telephone_no_2": "na",
//         "fax_no": 62026491,
//         "fax_no_2": "na",
//         "email_address": "northhshore_ps@moe.edu.sg",
//         "mrt_desc": "Puggol Point LRT Station",
//         "bus_desc": "84, 384",
//         "principal_name": "MADAM LEE YEN PING CHRISTINE",
//         "first_vp_name": "MADAM GAN SER MIN",
//         "second_vp_name": "MADAM ONG YIN PENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "NUS HIGH SCHOOL OF MATHEMATICS AND SCIENCE",
//         "url_address": "www.nushigh.edu.sg",
//         "address": "20 Clementi Avenue 1",
//         "postal_code": 129957,
//         "telephone_no": 65161709,
//         "telephone_no_2": "na",
//         "fax_no": 67756910,
//         "fax_no_2": "na",
//         "email_address": "einstein@highsch.nus.edu.sg",
//         "mrt_desc": "Nearest MRT Stations - Clementi and Dover",
//         "bus_desc": "96, 97, 151, 183, 188, 189, 196, 197, 198",
//         "principal_name": "MADAM SOH LAI LENG MAGDALEN",
//         "first_vp_name": "MR GOH HOCK LEONG",
//         "second_vp_name": "MS KHOO LEE YONG, SHARON",
//         "third_vp_name": "MRS LAI SOO HONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CLEMENTI",
//         "zone_code": "WEST",
//         "type_code": "SPECIALISED INDEPENDENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "OASIS PRIMARY SCHOOL",
//         "url_address": "http://www.oasispri.moe.edu.sg/",
//         "address": "71 Edgefield Plains",
//         "postal_code": 828716,
//         "telephone_no": "6320 9855",
//         "telephone_no_2": "na",
//         "fax_no": "6320 9856",
//         "fax_no_2": "na",
//         "email_address": "oasis_ps@moe.edu.sg",
//         "mrt_desc": "Damai LRT Station",
//         "bus_desc": "50, 386",
//         "principal_name": "MR POH LEONG KIAT DANNY",
//         "first_vp_name": "MADAM HO JUN- LYNN",
//         "second_vp_name": "MR MOHAMED IMRAN B MOHAMED IHSAN",
//         "third_vp_name": "MISS CHUA MAY CHING",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "OPERA ESTATE PRIMARY SCHOOL",
//         "url_address": "http://www.operaestatepri.moe.edu.sg",
//         "address": "48 FIDELIO STREET",
//         "postal_code": 458436,
//         "telephone_no": 62410417,
//         "telephone_no_2": "na",
//         "fax_no": 64493042,
//         "fax_no_2": "na",
//         "email_address": "OEPS@MOE.EDU.SG",
//         "mrt_desc": "Bedok, Kembangan",
//         "bus_desc": 42,
//         "principal_name": "MADAM HOO WAI LING",
//         "first_vp_name": "MR KENNY RAPHAEL REYES",
//         "second_vp_name": "MR RAYMOND TAY KOON MING",
//         "third_vp_name": "MR GOH LENG SENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ORCHID PARK SECONDARY SCHOOL",
//         "url_address": "http://www.orchidparksec.moe.edu.sg",
//         "address": "10 YISHUN STREET 81",
//         "postal_code": 768454,
//         "telephone_no": 67598547,
//         "telephone_no_2": "na",
//         "fax_no": 67588770,
//         "fax_no_2": "na",
//         "email_address": "OPSS@MOE.EDU.SG",
//         "mrt_desc": "KHATIB MRT",
//         "bus_desc": 811,
//         "principal_name": "MR CHUNG KWOK LEONG DANIEL",
//         "first_vp_name": "MADAM TEO MEI LIN YVONNE",
//         "second_vp_name": "MR NG KOK WING",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "OUTRAM SECONDARY SCHOOL",
//         "url_address": "http://www.outramsec.moe.edu.sg",
//         "address": "3 YORK HILL",
//         "postal_code": 168622,
//         "telephone_no": 67334077,
//         "telephone_no_2": "na",
//         "fax_no": 62352337,
//         "fax_no_2": "na",
//         "email_address": "OSS@MOE.EDU.SG",
//         "mrt_desc": "OUTRAM PARK MRT, CHINATOWN MRT",
//         "bus_desc": "174 , 123, 16, 175, 195, 33, 5, 63, 75, 851, 970, 123, 186, 51, 64",
//         "principal_name": "MR TAN KOK HONG",
//         "first_vp_name": "MISS TAN YEE LIN ELAINE",
//         "second_vp_name": "na",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CENTRAL",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PALM VIEW PRIMARY SCHOOL",
//         "url_address": "http://www.palmviewpri.moe.edu.sg",
//         "address": "150 Compassvale Bow",
//         "postal_code": 544822,
//         "telephone_no": 65087300,
//         "telephone_no_2": "na",
//         "fax_no": 68754150,
//         "fax_no_2": "na",
//         "email_address": "palmview_ps@moe.edu.sg",
//         "mrt_desc": "Buangkok",
//         "bus_desc": "27,43,109,156,159,161,163,163M,550",
//         "principal_name": "MRS MING KUM",
//         "first_vp_name": "MR ANG WEI TECK",
//         "second_vp_name": "MISS KHAIRIAH BTE HAIROMAN",
//         "third_vp_name": "MISS CHUA CHEW HIANG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PARK VIEW PRIMARY SCHOOL",
//         "url_address": "http://www.parkviewpri.moe.edu.sg",
//         "address": "60 PASIR RIS DRIVE 1",
//         "postal_code": 519524,
//         "telephone_no": 65851421,
//         "telephone_no_2": "na",
//         "fax_no": 65851401,
//         "fax_no_2": "na",
//         "email_address": "PVPS@MOE.EDU.SG",
//         "mrt_desc": "Pasir Ris MRT Station",
//         "bus_desc": "358,39,53,81,89",
//         "principal_name": "MISS LIE SUYIN JAMIE",
//         "first_vp_name": "MADAM HO FUI FONG",
//         "second_vp_name": "MADAM LIM CHIU EE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PASIR RIS CREST SECONDARY SCHOOL",
//         "url_address": "http://www.prcss.moe.edu.sg",
//         "address": "11 PASIR RIS STREET 41",
//         "postal_code": 518934,
//         "telephone_no": 65811655,
//         "telephone_no_2": "na",
//         "fax_no": 65813226,
//         "fax_no_2": "na",
//         "email_address": "PRCSS@MOE.EDU.SG",
//         "mrt_desc": "PASIR RIS MRT",
//         "bus_desc": "358, 17, 81, 12, 3",
//         "principal_name": "MRS KOH CAIYU",
//         "first_vp_name": "MR HANSEL LIN DAOYANG",
//         "second_vp_name": "MR LEE SENG LEE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PASIR RIS PRIMARY SCHOOL",
//         "url_address": "http://www.pasirrispri.moe.edu.sg",
//         "address": "5 PASIR RIS STREET 21",
//         "postal_code": 518968,
//         "telephone_no": 65822606,
//         "telephone_no_2": "na",
//         "fax_no": 65828492,
//         "fax_no_2": "na",
//         "email_address": "PRPS@MOE.EDU.SG",
//         "mrt_desc": "Pasir Ris MRT",
//         "bus_desc": "3,5,6,89",
//         "principal_name": "MS LIZA BTE RAHMAT",
//         "first_vp_name": "MADAM HENG WEI SHAN",
//         "second_vp_name": "MADAM THILAGAMANI D/O T SIVANANDAM",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PASIR RIS SECONDARY SCHOOL",
//         "url_address": "https://pasirrissec.moe.edu.sg",
//         "address": "390 TAMPINES STREET 21",
//         "postal_code": 529400,
//         "telephone_no": 65010800,
//         "telephone_no_2": 65010855,
//         "fax_no": 65010900,
//         "fax_no_2": "na",
//         "email_address": "PRSS@MOE.EDU.SG",
//         "mrt_desc": "TAMPINES MRT, TAMPINES EAST MRT,  TAMPINES WEST MRT",
//         "bus_desc": "3, 4, 8, 10, 15, 18, 19, 20, 21, 22, 23, 27, 28, 29, 31, 37, 38, 39, 46, 65, 67, 68, 69, 72, 81, 127, 129, 168, 291, 292, 293, 298, 969",
//         "principal_name": "MADAM GRACE TAN BEE SIM",
//         "first_vp_name": "MS S SANTHA D/O SUKUMARAN",
//         "second_vp_name": "MADAM LEE BENG CHOO",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PAYA LEBAR METHODIST GIRLS' SCHOOL (PRIMARY)",
//         "url_address": "http://www.payalebarmethodistgirlspri.moe.edu.sg/",
//         "address": "298 LORONG AH SOO",
//         "postal_code": 536741,
//         "telephone_no": 62862795,
//         "telephone_no_2": "na",
//         "fax_no": 62803915,
//         "fax_no_2": "na",
//         "email_address": "PLMGPS@MOE.EDU.SG",
//         "mrt_desc": "Kovan (NE13), Serangoon(NE12/CC13)",
//         "bus_desc": "45, 53, 53M, 62, 113",
//         "principal_name": "MRS MRS JOYCE ANG",
//         "first_vp_name": "MADAM TANG WAI YUE",
//         "second_vp_name": "MRS ESTHER SEE-LING SZENGEN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PAYA LEBAR METHODIST GIRLS' SCHOOL (SECONDARY)",
//         "url_address": "http://www.plmgss.moe.edu.sg",
//         "address": "296 LOR AH SOO",
//         "postal_code": 536742,
//         "telephone_no": 62816606,
//         "telephone_no_2": "na",
//         "fax_no": 63820558,
//         "fax_no_2": "na",
//         "email_address": "PLMGSS@MOE.EDU.SG",
//         "mrt_desc": "KOVAN MRT, SERANGOON MRT",
//         "bus_desc": "45, 53, 53M, 62, 113",
//         "principal_name": "MISS NG AMY",
//         "first_vp_name": "MADAM TAN MAY LIN SELINA",
//         "second_vp_name": "MS TOH SUSAN",
//         "third_vp_name": "MR NING TAU YEE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PEI CHUN PUBLIC SCHOOL",
//         "url_address": "http://www.peichunpublic.moe.edu.sg",
//         "address": "16 LORONG 7 TOA PAYOH",
//         "postal_code": 319320,
//         "telephone_no": 63539450,
//         "telephone_no_2": "na",
//         "fax_no": 63538418,
//         "fax_no_2": "na",
//         "email_address": "PCPS@MOE.EDU.SG",
//         "mrt_desc": "Toa Payoh MRT Station and Braddell MRT Station",
//         "bus_desc": "Bus Service 232, 57",
//         "principal_name": "MISS ONG LEE CHOO",
//         "first_vp_name": "MR LIM JIT HIN",
//         "second_vp_name": "MISS YANG JINGYU",
//         "third_vp_name": "MR REEVE SIM (SHEN GUANZE)",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "PEI HWA PRESBYTERIAN PRIMARY SCHOOL",
//         "url_address": "http://www.peihwapresbyterianpri.moe.edu.sg/",
//         "address": "7 PEI WAH AVENUE",
//         "postal_code": 597610,
//         "telephone_no": 64663787,
//         "telephone_no_2": 64663797,
//         "fax_no": 64621944,
//         "fax_no_2": "na",
//         "email_address": "PHPPS@MOE.EDU.SG",
//         "mrt_desc": "Beauty World",
//         "bus_desc": "970, 852, 174, 173, 157, 77, 61",
//         "principal_name": "MRS ALLISON LIM",
//         "first_vp_name": "MR LEONG WEI MING CALEB",
//         "second_vp_name": "MADAM YONG MING WOEI CHLOE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "PEI HWA SECONDARY SCHOOL",
//         "url_address": "http://www.peihwasec.moe.edu.sg",
//         "address": "21 FERNVALE LINK",
//         "postal_code": 797702,
//         "telephone_no": 65009580,
//         "telephone_no_2": "na",
//         "fax_no": 63438326,
//         "fax_no_2": "na",
//         "email_address": "peihwasec@moe.edu.sg",
//         "mrt_desc": "SENGKANG MRT, LAYAR LRT",
//         "bus_desc": "50, 70, 86, 103, 163, 854",
//         "principal_name": "MR MOHD AZHAR B TERIMO",
//         "first_vp_name": "MRS MICHELLE RAJARATHNAM",
//         "second_vp_name": "MR OW WENG KEONG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PEI TONG PRIMARY SCHOOL",
//         "url_address": "http://www.peitongpri.moe.edu.sg/",
//         "address": "15 CLEMENTI AVENUE 5",
//         "postal_code": 129857,
//         "telephone_no": 67775458,
//         "telephone_no_2": "na",
//         "fax_no": 67789784,
//         "fax_no_2": "na",
//         "email_address": "PTPS@MOE.EDU.SG",
//         "mrt_desc": "Clementi",
//         "bus_desc": "7, 184, 282",
//         "principal_name": "MRS ONG-CHEW LU SEE",
//         "first_vp_name": "MR JASON WONG QI HUA",
//         "second_vp_name": "MR MOHAMED YAZEED BIN MOHAMED SAID",
//         "third_vp_name": "MR KOH SEE CHOON",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CLEMENTI",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PEICAI SECONDARY SCHOOL",
//         "url_address": "http://www.peicaisec.moe.edu.sg",
//         "address": "10 SERANGOON AVENUE 4",
//         "postal_code": 556094,
//         "telephone_no": 62021260,
//         "telephone_no_2": "na",
//         "fax_no": "na",
//         "fax_no_2": "na",
//         "email_address": "PEICAI_SS@MOE.EDU.SG",
//         "mrt_desc": "SERANGOON MRT",
//         "bus_desc": "22, 24, 43, 53, 70, 76, 103, 109, 116, 147, 156, 315, 317, 853",
//         "principal_name": "MR MICHAEL MUHUNTHAN S/O SUBRAMANIAM",
//         "first_vp_name": "MADAM JESMINE CHUNG KAH MIN",
//         "second_vp_name": "MR SHUE PEI YAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PEIRCE SECONDARY SCHOOL",
//         "url_address": "http://www.peircesec.moe.edu.sg",
//         "address": "10 SIN MING WALK",
//         "postal_code": 575566,
//         "telephone_no": 64576454,
//         "telephone_no_2": "na",
//         "fax_no": 64576448,
//         "fax_no_2": "na",
//         "email_address": "PEIRCE_SS@MOE.EDU.SG",
//         "mrt_desc": "ANG MO KIO MRT, BISHAN MRT, MARYMOUNT MRT, BRIGHT HILL MRT",
//         "bus_desc": "52, 132, 162, 163, 165, 166, 167, 410, 855, 980",
//         "principal_name": "MR KEH CHIN CHUAN BENEDICT",
//         "first_vp_name": "MR JIN SEBASTIAN",
//         "second_vp_name": "MS NG BOON MIN",
//         "third_vp_name": "MADAM PEH TZU FENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BISHAN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PEIYING PRIMARY SCHOOL",
//         "url_address": "http://www.peiyingpri.moe.edu.sg",
//         "address": "651 YISHUN RING ROAD",
//         "postal_code": 768687,
//         "telephone_no": 62575684,
//         "telephone_no_2": "na",
//         "fax_no": 67558802,
//         "fax_no_2": "na",
//         "email_address": "PYPS@MOE.EDU.SG",
//         "mrt_desc": "Khatib",
//         "bus_desc": "851, 852, 853, 854, 855",
//         "principal_name": "MADAM WONG WEI YONG",
//         "first_vp_name": "MR ABDUL RANI BIN IDRIS",
//         "second_vp_name": "MISS NG PEI SUN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PIONEER PRIMARY SCHOOL",
//         "url_address": "http://www.pioneerpri.moe.edu.sg",
//         "address": "80 TENGAH GARDEN AVENUE",
//         "postal_code": 699915,
//         "telephone_no": 67932039,
//         "telephone_no_2": "na",
//         "fax_no": 67932040,
//         "fax_no_2": "na",
//         "email_address": "PIONEER_PS@MOE.EDU.SG",
//         "mrt_desc": "Boon Lay Station",
//         "bus_desc": "219, 241",
//         "principal_name": "MADAM LOKE WAI LING",
//         "first_vp_name": "MR TAN HOCK CHYE CHARLES",
//         "second_vp_name": "MADAM WONG WEI YI",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TENGAH",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "POI CHING SCHOOL",
//         "url_address": "http://www.poiching.moe.edu.sg",
//         "address": "21 TAMPINES STREET 71",
//         "postal_code": 529067,
//         "telephone_no": 67856420,
//         "telephone_no_2": "na",
//         "fax_no": 67857198,
//         "fax_no_2": "na",
//         "email_address": "POICHING_SCH@MOE.EDU.SG",
//         "mrt_desc": "Tampines MRT",
//         "bus_desc": "Bus 293, 72, 27 and 168",
//         "principal_name": "MADAM LIM TZYY SHIUAN",
//         "first_vp_name": "MISS CHAN JING JING",
//         "second_vp_name": "MRS TAN MEI LING IRENE MRS IRENE GOH HOCK NGUAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "PRESBYTERIAN HIGH SCHOOL",
//         "url_address": "http://www.presbyterian.moe.edu.sg",
//         "address": "5209 ANG MO KIO AVENUE 6",
//         "postal_code": 569845,
//         "telephone_no": 64543722,
//         "telephone_no_2": "na",
//         "fax_no": 64543430,
//         "fax_no_2": "na",
//         "email_address": "PRESBYTERIAN@MOE.EDU.SG",
//         "mrt_desc": "YIO CHU KANG MRT",
//         "bus_desc": "45, 70, 70M, 71, 76, 86, 668, 825, 851, 851e, 852, 853, 853M",
//         "principal_name": "MADAM ONG HUI MIIN ANGELINE",
//         "first_vp_name": "MR CHENG CHI EN",
//         "second_vp_name": "MR TAY SOON INN TIMOTHY",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PRINCESS ELIZABETH PRIMARY SCHOOL",
//         "url_address": "http://www.princesselizabethpri.moe.edu.sg",
//         "address": "30 BUKIT BATOK WEST AVENUE 3",
//         "postal_code": 659163,
//         "telephone_no": 65655111,
//         "telephone_no_2": "na",
//         "fax_no": 65637859,
//         "fax_no_2": "na",
//         "email_address": "PEPS@MOE.EDU.SG",
//         "mrt_desc": "Bukit Batok MRT Station",
//         "bus_desc": "Bus 174, 157, 178, 66, 941",
//         "principal_name": "MR BUCKTHA SEELAN",
//         "first_vp_name": "MADAM CHU SING EE",
//         "second_vp_name": "MISS NGIAM WEE HENG",
//         "third_vp_name": "MISS TOH CUI LIN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PUNGGOL COVE PRIMARY SCHOOL",
//         "url_address": "https://punggolcovepri.moe.edu.sg/",
//         "address": "52 Sumang Walk",
//         "postal_code": 828674,
//         "telephone_no": 63857339,
//         "telephone_no_2": "na",
//         "fax_no": 63857261,
//         "fax_no_2": "na",
//         "email_address": "punggolcove_ps@moe.edu.sg",
//         "mrt_desc": "Nibong LRT Station",
//         "bus_desc": "382W, 84",
//         "principal_name": "MADAM SEAH WHYE CHOO",
//         "first_vp_name": "MR ANDREW CHONG WENYI",
//         "second_vp_name": "MADAM CAI XIRUI",
//         "third_vp_name": "MISS CHNG SHI HUA",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PUNGGOL GREEN PRIMARY SCHOOL",
//         "url_address": "http://www.punggolgreenpri.moe.edu.sg",
//         "address": "98 Punggol Walk",
//         "postal_code": 828772,
//         "telephone_no": 65383011,
//         "telephone_no_2": "na",
//         "fax_no": 65383210,
//         "fax_no_2": "na",
//         "email_address": "admin_punggolgreen_ps@moe.edu.sg",
//         "mrt_desc": "Punggol MRT Station",
//         "bus_desc": "117, 117M, 119, 381, 382G, 666",
//         "principal_name": "MR HANAFI B ASMORE",
//         "first_vp_name": "MRS TAY CHAI HONG",
//         "second_vp_name": "MR JASBIR SINGH",
//         "third_vp_name": "MADAM CHRISTINA TEE SIEW PING",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PUNGGOL PRIMARY SCHOOL",
//         "url_address": "http://www.punggolpri.moe.edu.sg/",
//         "address": "61 HOUGANG AVENUE 8",
//         "postal_code": 538787,
//         "telephone_no": 63850762,
//         "telephone_no_2": "na",
//         "fax_no": 63877793,
//         "fax_no_2": "na",
//         "email_address": "PUNGGOL_PS@MOE.EDU.SG",
//         "mrt_desc": "Hougang, Buangkok",
//         "bus_desc": "62 74 88 113 147 325",
//         "principal_name": "MADAM NORLIZA BTE A RAHIM",
//         "first_vp_name": "MR GOH CHANG CHUEN",
//         "second_vp_name": "MADAM LIM HUI MEOW ANNIE",
//         "third_vp_name": "MISS USHA RANI HENRY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PUNGGOL SECONDARY SCHOOL",
//         "url_address": "http://www.punggolsec.moe.edu.sg",
//         "address": "51 EDGEFIELD PLAINS",
//         "postal_code": 828870,
//         "telephone_no": 64897851,
//         "telephone_no_2": "na",
//         "fax_no": 64897859,
//         "fax_no_2": "na",
//         "email_address": "PUNGGOL_SS@MOE.EDU.SG",
//         "mrt_desc": "PUNGGOL MRT, COVE LRT",
//         "bus_desc": "3, 34, 62, 82, 83, 85, 136, 965, 386",
//         "principal_name": "MS TNG YA WEN VALERIE",
//         "first_vp_name": "MR ANITH KUMAR S/O NADESAN",
//         "second_vp_name": "MADAM GOH YEONG JING",
//         "third_vp_name": "MR NG CHEE KIANG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "PUNGGOL VIEW PRIMARY SCHOOL",
//         "url_address": "http://www.punggolviewpri.moe.edu.sg",
//         "address": "9 Punggol Place",
//         "postal_code": 828845,
//         "telephone_no": "6570 1588",
//         "telephone_no_2": "na",
//         "fax_no": "6570 3680",
//         "fax_no_2": "na",
//         "email_address": "punggolview_ps@moe.edu.sg",
//         "mrt_desc": "Punggol MRT Station",
//         "bus_desc": "50; 382",
//         "principal_name": "MR WONG KIN MUN",
//         "first_vp_name": "MDM DE SOUZA SANDRA ANNE",
//         "second_vp_name": "MADAM SHARIFAH SAMIRAH BTE SYED MOHAMAD",
//         "third_vp_name": "MR CHONG WEE MING",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "QIFA PRIMARY SCHOOL",
//         "url_address": "http://www.qifapri.moe.edu.sg",
//         "address": "50 WEST COAST AVENUE",
//         "postal_code": 128104,
//         "telephone_no": 67783085,
//         "telephone_no_2": "na",
//         "fax_no": 67761485,
//         "fax_no_2": "na",
//         "email_address": "QIFA_PS@MOE.EDU.SG",
//         "mrt_desc": "Clementi MRT Station",
//         "bus_desc": "30,51,78,143,285,655",
//         "principal_name": "MRS CATHERINE CHIANG",
//         "first_vp_name": "MADAM CHOO SIEW HONG",
//         "second_vp_name": "MADAM NORAINI BTE MANSOOR",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CLEMENTI",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "QIHUA PRIMARY SCHOOL",
//         "url_address": "http://www.qihuapri.moe.edu.sg",
//         "address": "5 WOODLANDS STREET 81",
//         "postal_code": 738525,
//         "telephone_no": 62696250,
//         "telephone_no_2": "na",
//         "fax_no": 62693114,
//         "fax_no_2": "na",
//         "email_address": "QIHUA_PS@MOE.EDU.SG",
//         "mrt_desc": "Woodlands MRT Station",
//         "bus_desc": "911, 900",
//         "principal_name": "MRS LEE HUI FENG",
//         "first_vp_name": "MR FOO CHUAN KAI",
//         "second_vp_name": "MISS NURUL SUHANA BINTE SULAIMAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "QUEENSTOWN PRIMARY SCHOOL",
//         "url_address": "http://www.queenstownpri.moe.edu.sg",
//         "address": "310 MARGARET DR",
//         "postal_code": 149303,
//         "telephone_no": 64741044,
//         "telephone_no_2": "na",
//         "fax_no": 64713640,
//         "fax_no_2": "na",
//         "email_address": "QTPS@MOE.EDU.SG",
//         "mrt_desc": "Queenstown MRT",
//         "bus_desc": "32, 111, 145, 195",
//         "principal_name": "MADAM LIM PEI LIN OLIVIA MRS OLIVIA CHEONG",
//         "first_vp_name": "MISS CHEW MAY",
//         "second_vp_name": "MR LOW KAY KIAT",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "QUEENSTOWN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "QUEENSTOWN SECONDARY SCHOOL",
//         "url_address": "http://www.queenstownsec.moe.edu.sg",
//         "address": "1 STRATHMORE ROAD",
//         "postal_code": 148800,
//         "telephone_no": 64741055,
//         "telephone_no_2": "na",
//         "fax_no": 64741295,
//         "fax_no_2": "na",
//         "email_address": "QTSS@MOE.EDU.SG",
//         "mrt_desc": "REDHILL MRT, QUEENSTOWN MRT",
//         "bus_desc": "33, 51, 64, 111, 120, 139, 145, 186, 970",
//         "principal_name": "MR SIM HOW CHONG",
//         "first_vp_name": "MRS CHANG TECK HUI",
//         "second_vp_name": "MR TAN TAI HUAT",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "QUEENSTOWN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "QUEENSWAY SECONDARY SCHOOL",
//         "url_address": "http://www.queenswaysec.moe.edu.sg",
//         "address": "2A MARGARET DRIVE",
//         "postal_code": 149295,
//         "telephone_no": 64741421,
//         "telephone_no_2": "na",
//         "fax_no": 64741302,
//         "fax_no_2": "na",
//         "email_address": "QWSS@MOE.EDU.SG",
//         "mrt_desc": "COMMONWEALTH MRT, QUEENSTOWN MRT",
//         "bus_desc": "32, 51, 93, 100, 105, 111, 122, 123, 145, 147, 153, 186, 195, 196, 198, 855, 961, 970",
//         "principal_name": "MS CHEN LI YING AUDREY",
//         "first_vp_name": "MR TEO WEIHONG",
//         "second_vp_name": "MADAM V PRIYA RAJAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "QUEENSTOWN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RADIN MAS PRIMARY SCHOOL",
//         "url_address": "http://www.radinmasps.moe.edu.sg",
//         "address": "1 BUKIT PURMEI AVENUE",
//         "postal_code": 99840,
//         "telephone_no": 62733937,
//         "telephone_no_2": "na",
//         "fax_no": 62763083,
//         "fax_no_2": "na",
//         "email_address": "RMPS@MOE.EDU.SG",
//         "mrt_desc": "Tiong Bahru MRT; HarbourFront MRT",
//         "bus_desc": "SBS 123, 123M, 131, 131M; SBS 65, 121, 195, 855",
//         "principal_name": "MADAM TAN SUN SUN",
//         "first_vp_name": "MADAM NG LI YI",
//         "second_vp_name": "MS GOH CHIU KENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RAFFLES GIRLS' PRIMARY SCHOOL",
//         "url_address": "http://www.rafflesgirlspri.moe.edu.sg",
//         "address": "21 Hillcrest Road",
//         "postal_code": 289072,
//         "telephone_no": 64684377,
//         "telephone_no_2": "na",
//         "fax_no": 64692024,
//         "fax_no_2": "na",
//         "email_address": "RGPS@MOE.EDU.SG",
//         "mrt_desc": "TAN KAH KEE MRT STATION",
//         "bus_desc": "66, 67, 74, 151, 154, 156, 157, 170, 171, 174, 852, 961",
//         "principal_name": "MADAM ELAINE QUEK-LIM HWEE BIN",
//         "first_vp_name": "MISS KONG SU MAY",
//         "second_vp_name": "MISS SUJATHA PARAMATHAYALAN",
//         "third_vp_name": "MR LOH YUH POR",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RAFFLES GIRLS' SCHOOL (SECONDARY)",
//         "url_address": "http://www.rgs.edu.sg",
//         "address": "2 BRADDELL RISE",
//         "postal_code": 318871,
//         "telephone_no": 67371845,
//         "telephone_no_2": "na",
//         "fax_no": 62353731,
//         "fax_no_2": "na",
//         "email_address": "RGSS@MOE.EDU.SG",
//         "mrt_desc": "BRADDELL MRT, CALDECOTT MRT",
//         "bus_desc": "59, 93, 129, 156, 157, 163, 231, 232, 235",
//         "principal_name": "MADAM LIM HONG PENG",
//         "first_vp_name": "MS TAN HWEE MIAN MAY",
//         "second_vp_name": "MS YEO XIUTING VALERIE",
//         "third_vp_name": "MISS MAGDALENE SUEY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "INDEPENDENT SCHOOL",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RAFFLES INSTITUTION",
//         "url_address": "http://www.ri.edu.sg",
//         "address": "1 RAFFLES INSTITUTION LANE",
//         "postal_code": 575954,
//         "telephone_no": 64199242,
//         "telephone_no_2": "na",
//         "fax_no": 64199238,
//         "fax_no_2": "na",
//         "email_address": "RAFFLES_INST@MOE.EDU.SG",
//         "mrt_desc": "BISHAN MRT, MARYMOUNT MRT",
//         "bus_desc": "410,13,50,52,53,54,55,56,57,58,59,71,74,88,93,128,130,132,156,157,162,163,165,166,167,851,852,855,980",
//         "principal_name": "MR LOH HONG OON, AARON",
//         "first_vp_name": "MR ANG PENG SIONG BRIAN LAGMAN",
//         "second_vp_name": "MR EDWARD NG",
//         "third_vp_name": "MS MELISSA LIM AI LIN",
//         "fourth_vp_name": "MS NG MEI SZE",
//         "fifth_vp_name": "TAN MENG FONG DESMOND",
//         "sixth_vp_name": "MISS SEE PEI LOO",
//         "dgp_code": "BISHAN",
//         "zone_code": "SOUTH",
//         "type_code": "INDEPENDENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RED SWASTIKA SCHOOL",
//         "url_address": "http://www.redswastika.moe.edu.sg",
//         "address": "350 BEDOK NORTH AVENUE 3",
//         "postal_code": 469719,
//         "telephone_no": 64430380,
//         "telephone_no_2": "na",
//         "fax_no": 62448391,
//         "fax_no_2": "na",
//         "email_address": "REDSWASTIKA@MOE.EDU.SG",
//         "mrt_desc": "Bedok Reservoir MRT",
//         "bus_desc": "Bus 14, 17, 28, 46, 66, 67, 69, 222, 228",
//         "principal_name": "MR LIM MENG WEI",
//         "first_vp_name": "MS ANGELA GOH BEE LIAN",
//         "second_vp_name": "MADAM ESTHER E TZY KWEI",
//         "third_vp_name": "MR TAN MENG KHIANG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "REGENT SECONDARY SCHOOL",
//         "url_address": "http://regentsec.moe.edu.sg",
//         "address": "50 CHOA CHU KANG NORTH 5",
//         "postal_code": 689621,
//         "telephone_no": 67653828,
//         "telephone_no_2": "na",
//         "fax_no": 67653413,
//         "fax_no_2": "na",
//         "email_address": "REGENT_SS@MOE.EDU.SG",
//         "mrt_desc": "YEW TEE MRT, CHOA CHU KANG MRT",
//         "bus_desc": "307, 160, 170, 178, 925, 927, 960, 961, 979",
//         "principal_name": "MADAM TAN SIEW HONG (MRS SNG)",
//         "first_vp_name": "MISS NG TZE FANG",
//         "second_vp_name": "MR THANGARASU PUBALAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RIVER VALLEY HIGH SCHOOL",
//         "url_address": "https://rivervalleyhigh.moe.edu.sg/",
//         "address": "6 BOON LAY AVENUE",
//         "postal_code": 649961,
//         "telephone_no": 65678115,
//         "telephone_no_2": "na",
//         "fax_no": 65677351,
//         "fax_no_2": "na",
//         "email_address": "RVHS@MOE.EDU.SG",
//         "mrt_desc": "BOON LAY MRT, LAKESIDE MRT",
//         "bus_desc": "99, 157, 172, 174, 174E, 198, 240, 502, 974",
//         "principal_name": "na",
//         "first_vp_name": "MS CHUA SHI QIAN",
//         "second_vp_name": "MR LAU WAI CHI ALVIN",
//         "third_vp_name": "MR NG HONG PENG",
//         "fourth_vp_name": "MR MICHAEL JOHN PETER LAU CHONG LUM",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "Yes",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "RIVER VALLEY PRIMARY SCHOOL",
//         "url_address": "http://www.rivervalleypri.moe.edu.sg",
//         "address": "2 RIVER VALLEY GREEN",
//         "postal_code": 237993,
//         "telephone_no": 67371785,
//         "telephone_no_2": "na",
//         "fax_no": 67321951,
//         "fax_no_2": "na",
//         "email_address": "RVPS@MOE.EDU.SG",
//         "mrt_desc": "Somerset MRT",
//         "bus_desc": "5, 16, 32, 54, 65, 75, 175, 970",
//         "principal_name": "MRS JENNIFER PANG CHEE CHYN",
//         "first_vp_name": "MRS LOH SOK HIANG JACQUELINE",
//         "second_vp_name": "MADAM NUR RASHIDAH BTE ABDUL RASHID",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CENTRAL",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RIVERSIDE PRIMARY SCHOOL",
//         "url_address": "http://www.riversidepri.moe.edu.sg",
//         "address": "110 Woodlands Crescent",
//         "postal_code": 737803,
//         "telephone_no": 63654490,
//         "telephone_no_2": "na",
//         "fax_no": 63654460,
//         "fax_no_2": "na",
//         "email_address": "riverside_ps@moe.edu.sg",
//         "mrt_desc": "Admiralty MRT Station",
//         "bus_desc": "Bus No 913 and Bus No 964",
//         "principal_name": "MR TAN CHOON KHENG",
//         "first_vp_name": "MADAM KHOO PHAIK HOON REGINA",
//         "second_vp_name": "MRS RANUKA PALANIVELU",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RIVERSIDE SECONDARY SCHOOL",
//         "url_address": "http://www.riversidesec.moe.edu.sg",
//         "address": "3 WOODLANDS STREET 81",
//         "postal_code": 738524,
//         "telephone_no": 62699631,
//         "telephone_no_2": "na",
//         "fax_no": 63683677,
//         "fax_no_2": "na",
//         "email_address": "RIVERSIDE_SS@MOE.EDU.SG",
//         "mrt_desc": "WOODLANDS MRT",
//         "bus_desc": "169, 858, 900, 900A, 903, 904, 911, 913, 964, 965, 969",
//         "principal_name": "MISS THAM YOKE CHUN",
//         "first_vp_name": "MR CHAN KOK TUNG TOM",
//         "second_vp_name": "MISS HUI AI LIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "UNITY PRIMARY SCHOOL",
//         "url_address": "http://www.unitypri.moe.edu.sg",
//         "address": "21 CHOA CHU KANG CRESCENT",
//         "postal_code": 688268,
//         "telephone_no": 67676750,
//         "telephone_no_2": "na",
//         "fax_no": 67676751,
//         "fax_no_2": "na",
//         "email_address": "UNITY_PS@MOE.EDU.SG",
//         "mrt_desc": "Yew Tee MRT",
//         "bus_desc": "TIBs 302",
//         "principal_name": "MRS LEE-KOH SIEW CHENG",
//         "first_vp_name": "MR SYAMSUL ANWAR BIN AWANG",
//         "second_vp_name": "MRS JASMINE TAN RODRIGO",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RIVERVALE PRIMARY SCHOOL",
//         "url_address": "http://www.rivervalepri.moe.edu.sg/",
//         "address": "80 RIVERVALE DRIVE",
//         "postal_code": 545092,
//         "telephone_no": 63887450,
//         "telephone_no_2": "na",
//         "fax_no": 63887449,
//         "fax_no_2": "na",
//         "email_address": "RIVERVALE_PS@MOE.EDU.SG",
//         "mrt_desc": "Nearest LRT Station : Rumbia",
//         "bus_desc": "Bus Service 86, 371.",
//         "principal_name": "MISS RADHA D/O G SUBRAMANIAM",
//         "first_vp_name": "MRS GOH SIEW LING MARIA",
//         "second_vp_name": "MR CHIA SENG CHIANG AARON",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ROSYTH SCHOOL",
//         "url_address": "https://www.rosyth.moe.edu.sg",
//         "address": "21 Serangoon North Avenue 4",
//         "postal_code": 555855,
//         "telephone_no": 64812273,
//         "telephone_no_2": "na",
//         "fax_no": 64831102,
//         "fax_no_2": "na",
//         "email_address": "ROSYTH_SCH@MOE.EDU.SG",
//         "mrt_desc": "Ang Mo Kio, Serangoon",
//         "bus_desc": "73, 315, 116",
//         "principal_name": "MR SURAJ NAIR S/O VENUGOPAL",
//         "first_vp_name": "MISS KWAN RUIYING KAREN",
//         "second_vp_name": "MADAM TAN LAY WAH",
//         "third_vp_name": "MR TAN BOON SENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "RULANG PRIMARY SCHOOL",
//         "url_address": "http://www.rulangpri.moe.edu.sg/",
//         "address": "6 JURONG WEST STREET 52",
//         "postal_code": 649295,
//         "telephone_no": 65657771,
//         "telephone_no_2": "na",
//         "fax_no": 65632382,
//         "fax_no_2": "na",
//         "email_address": "RULANG_PS@MOE.EDU.SG",
//         "mrt_desc": "Lakeside",
//         "bus_desc": "SBS 335",
//         "principal_name": "MS TRACY TAN I- LIAN",
//         "first_vp_name": "MR TAN JIAN ZHONG ADRIAN",
//         "second_vp_name": "MR TOH JIN TIAN",
//         "third_vp_name": "MR TAN KOK LENG, STEVEN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SCHOOL OF SCIENCE AND TECHNOLOGY, SINGAPORE",
//         "url_address": "http://www.sst.edu.sg",
//         "address": "1 Technology Drive",
//         "postal_code": 138572,
//         "telephone_no": 65717200,
//         "telephone_no_2": "na",
//         "fax_no": 68720856,
//         "fax_no_2": "na",
//         "email_address": "contactus@sst.edu.sg",
//         "mrt_desc": "Dover",
//         "bus_desc": "14, 74, 105, 106, 147, 166, 185",
//         "principal_name": "MR CHAN CHOON LOONG",
//         "first_vp_name": "MR SZE GUAN KIAT",
//         "second_vp_name": "MR TAN BOON TIONG VINCENT",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CLEMENTI",
//         "zone_code": "WEST",
//         "type_code": "SPECIALISED INDEPENDENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SCHOOL OF THE ARTS, SINGAPORE",
//         "url_address": "http://www.sota.edu.sg/",
//         "address": "1 Zubir Said Drive 05 01",
//         "postal_code": 227968,
//         "telephone_no": "6338 9663",
//         "telephone_no_2": "6342 5857",
//         "fax_no": "6338 9763",
//         "fax_no_2": "na",
//         "email_address": "enquiries@sota.edu.sg",
//         "mrt_desc": "Dhoby Ghaut",
//         "bus_desc": "7, 14, 16, 36, 64, 65, 77, 106, 111, 124, 128, 131, 147, 162, 166, 167, 171, 174, 175, 190, 502, 518, 700, 857,",
//         "principal_name": "MADAM WONG YEE MIN MARY",
//         "first_vp_name": "MS KHOO MEI LING AMY",
//         "second_vp_name": "MR LIONG HUAI YU",
//         "third_vp_name": "MISS PAULINE ANN TAN POH LING",
//         "fourth_vp_name": "MADAM TAN PEI YIN",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CENTRAL",
//         "zone_code": "SOUTH",
//         "type_code": "SPECIALISED INDEPENDENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SEMBAWANG PRIMARY SCHOOL",
//         "url_address": "http://www.sembawangpri.moe.edu.sg",
//         "address": "10 SEMBAWANG DRIVE",
//         "postal_code": 757715,
//         "telephone_no": 67567330,
//         "telephone_no_2": "na",
//         "fax_no": 67560367,
//         "fax_no_2": "na",
//         "email_address": "SEMBAWANG_PS@MOE.EDU.SG",
//         "mrt_desc": "Sembawang MRT (6 to 8-minute walk)",
//         "bus_desc": "656, 859, 859B, 962, 980",
//         "principal_name": "MR NG AIK BOON",
//         "first_vp_name": "MR SEE KOK KIONG",
//         "second_vp_name": "MISS TIFFANY CHONG",
//         "third_vp_name": "MR TAN THIAM SIONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SEMBAWANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SEMBAWANG SECONDARY SCHOOL",
//         "url_address": "http://www.sembawangsec.moe.edu.sg",
//         "address": "30 SEMBAWANG CRESCENT",
//         "postal_code": 757704,
//         "telephone_no": 67566760,
//         "telephone_no_2": "na",
//         "fax_no": 67585380,
//         "fax_no_2": "na",
//         "email_address": "SEMBAWANG_SS@MOE.EDU.SG",
//         "mrt_desc": "SEMBAWANG MRT",
//         "bus_desc": "859, 859A, 962",
//         "principal_name": "MADAM KOH HOON CHOO JESSIE",
//         "first_vp_name": "MR CHAN YING CHUNG",
//         "second_vp_name": "MR LEE YONG KIANG JUSTIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SEMBAWANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SENG KANG PRIMARY SCHOOL",
//         "url_address": "http://www.sengkangpri.moe.edu.sg/",
//         "address": "21 COMPASSVALE WALK",
//         "postal_code": 545166,
//         "telephone_no": 63840809,
//         "telephone_no_2": "na",
//         "fax_no": 63840839,
//         "fax_no_2": "na",
//         "email_address": "SKPS@MOE.EDU.SG",
//         "mrt_desc": "Sengkang MRT",
//         "bus_desc": "27, 80, 82, 83, 86, 87, 88, 89, 119, 156, 163, 371, 372 & 965",
//         "principal_name": "MRS LEE SIEW HONG",
//         "first_vp_name": "MR MOHAMED AZHAR BIN MOHAMED NOOR",
//         "second_vp_name": "MISS THIEN LI CHIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SENG KANG SECONDARY SCHOOL",
//         "url_address": "http://www.sengkangsec.moe.edu.sg",
//         "address": "10 COMPASSVALE LANE",
//         "postal_code": 545090,
//         "telephone_no": 63887258,
//         "telephone_no_2": "na",
//         "fax_no": 63887254,
//         "fax_no_2": "na",
//         "email_address": "SKSS@MOE.EDU.SG",
//         "mrt_desc": "SENGKANG MRT, RANGGUNG LRT",
//         "bus_desc": "27, 80, 85, 86, 87, 89, 89E, 163, 163M, 372",
//         "principal_name": "MR N SIVARAJAN",
//         "first_vp_name": "MR NG CHENG SONG, JEREMY",
//         "second_vp_name": "MR LAK YAU HUI",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SENGKANG GREEN PRIMARY SCHOOL",
//         "url_address": "https://sengkanggreenpri.moe.edu.sg/",
//         "address": "15 Fernvale Road",
//         "postal_code": 797636,
//         "telephone_no": 63864255,
//         "telephone_no_2": "na",
//         "fax_no": 62428796,
//         "fax_no_2": "na",
//         "email_address": "sengkanggreen_ps@moe.edu.sg",
//         "mrt_desc": "Fernvale LRT (SW5) - (Sengkang West Loop)",
//         "bus_desc": "Sengkang and Toa Payoh Interchange - no 163, Along Yio Chu Kang Road - no 70, 86, 103 and 854, Punggol Interchange to Bishan Interchange - no 50, Hougang Central Interchange - no 102",
//         "principal_name": "MR GAU POH TECK",
//         "first_vp_name": "MADAM ADILA ONG KIM LUAN",
//         "second_vp_name": "MR TAN KENG LIM JEREMY",
//         "third_vp_name": "MADAM GINNY CHUA GEOK HONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SERANGOON GARDEN SECONDARY SCHOOL",
//         "url_address": "http://www.sgs.edu.sg",
//         "address": "21 SERANGOON NORTH AVENUE 1",
//         "postal_code": 555889,
//         "telephone_no": 62889227,
//         "telephone_no_2": 65789177,
//         "fax_no": 62888695,
//         "fax_no_2": "na",
//         "email_address": "sgss@moe.edu.sg",
//         "mrt_desc": "SERANGOON MRT, ANG MO KIO MRT",
//         "bus_desc": "25, 55, 73, 74, 76, 132, 165, 315",
//         "principal_name": "MADAM MAH PATSY",
//         "first_vp_name": "MS HO GEOK LAN",
//         "second_vp_name": "MR NG SONG LIM STEVEN",
//         "third_vp_name": "MR ZAINAL ABIDIN BIN MAHMOOD",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SERANGOON SECONDARY SCHOOL",
//         "url_address": "http://www.serangoonsec.moe.edu.sg",
//         "address": "11 UPPER SERANGOON VIEW",
//         "postal_code": 534237,
//         "telephone_no": 63851589,
//         "telephone_no_2": "na",
//         "fax_no": 63851635,
//         "fax_no_2": "na",
//         "email_address": "SERANGOON_SS@MOE.EDU.SG",
//         "mrt_desc": "HOUGANG MRT, KANGKAR LRT",
//         "bus_desc": "62, 74, 102, 113, 119, 136, 147, 324",
//         "principal_name": "MR CHEN FOOK PANG",
//         "first_vp_name": "MR LIM KAH LEONG MARC",
//         "second_vp_name": "MADAM LIM PUAY KHENG",
//         "third_vp_name": "MR MEYYAPPAN NADARAJAN THEVAR",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SHUQUN PRIMARY SCHOOL",
//         "url_address": "http://www.shuqunpri.moe.edu.sg",
//         "address": "8 JURONG WEST STREET 51",
//         "postal_code": 649332,
//         "telephone_no": 65637129,
//         "telephone_no_2": "na",
//         "fax_no": 65637418,
//         "fax_no_2": "na",
//         "email_address": "SQPS@MOE.EDU.SG",
//         "mrt_desc": "W11 Lakeside",
//         "bus_desc": "98, 187, 335",
//         "principal_name": "MRS SARA DE SOUZA",
//         "first_vp_name": "MDM SO KAH LAY",
//         "second_vp_name": "DR. CHOONG PEK LAN",
//         "third_vp_name": "MS LEE KOON HAR ANGELA (LI KUNXIA)",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SI LING PRIMARY SCHOOL",
//         "url_address": "http://www.silingpri.moe.edu.sg",
//         "address": "61 WOODLANDS AVENUE 1",
//         "postal_code": 739067,
//         "telephone_no": 62698832,
//         "telephone_no_2": "na",
//         "fax_no": 63675516,
//         "fax_no_2": "na",
//         "email_address": "SLPS@MOE.EDU.SG",
//         "mrt_desc": "Woodlands",
//         "bus_desc": "912 from Woodlands Interchange",
//         "principal_name": "MR KOE EE TIONG",
//         "first_vp_name": "MADAM NURAZIAN BINTE BAJURI",
//         "second_vp_name": "MR RAJ KUMAR S/O V SIVALINGAM",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SINGAPORE CHINESE GIRLS' PRIMARY SCHOOL",
//         "url_address": "www.scgs.moe.edu.sg",
//         "address": "190 DUNEARN ROAD",
//         "postal_code": 309437,
//         "telephone_no": 62527966,
//         "telephone_no_2": "na",
//         "fax_no": 62523076,
//         "fax_no_2": "na",
//         "email_address": "SCGPS@MOE.EDU.SG",
//         "mrt_desc": "Stevens",
//         "bus_desc": "66, 67, 105, 132, 151, 153, 154, 156, 170, 171, 186, 190, 605, 700, 960",
//         "principal_name": "MRS LINDA CHAN",
//         "first_vp_name": "MADAM LIM YING YING",
//         "second_vp_name": "MADAM PEH TAN WEE",
//         "third_vp_name": "MADAM SIA YAN SAN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "NOVENA",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SINGAPORE CHINESE GIRLS' SCHOOL",
//         "url_address": "http://www.scgs.moe.edu.sg",
//         "address": "190 DUNEARN ROAD",
//         "postal_code": 309437,
//         "telephone_no": 62527966,
//         "telephone_no_2": "na",
//         "fax_no": 62523076,
//         "fax_no_2": "na",
//         "email_address": "SCGSS@MOE.EDU.SG",
//         "mrt_desc": "STEVENS MRT",
//         "bus_desc": "48, 67, 105, 132, 151, 153, 154, 156, 170, 186, 190, 960, 960E, 972, 972M",
//         "principal_name": "MRS LINDA CHAN",
//         "first_vp_name": "MISS LEONG KAI LING",
//         "second_vp_name": "MRS SHERMAINE TANG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "NOVENA",
//         "zone_code": "SOUTH",
//         "type_code": "INDEPENDENT SCHOOL",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SINGAPORE SPORTS SCHOOL",
//         "url_address": "http://www.sportsschool.edu.sg",
//         "address": "1 Champions Way",
//         "postal_code": 737913,
//         "telephone_no": 67660100,
//         "telephone_no_2": "na",
//         "fax_no": 67662100,
//         "fax_no_2": "na",
//         "email_address": "enquire@sportsschool.edu.sg",
//         "mrt_desc": "Woodlands South MRT",
//         "bus_desc": 901,
//         "principal_name": "MR ONG KIM SOON",
//         "first_vp_name": "MR EDMUND SONG",
//         "second_vp_name": "MR HO BENG KIAT",
//         "third_vp_name": "MDM QUEK YAU KENN LYNN",
//         "fourth_vp_name": "MR LIM HOW CHUEN CLEMENT",
//         "fifth_vp_name": "MISS TAN HUI HUI JEANIE",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "SPECIALISED INDEPENDENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "MIXED LEVEL (S1-S5, JC1-JC2)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SOUTH VIEW PRIMARY SCHOOL",
//         "url_address": "http://www.southviewpri.moe.edu.sg",
//         "address": "6 Choa Chu Kang Central",
//         "postal_code": 689762,
//         "telephone_no": 67697176,
//         "telephone_no_2": "na",
//         "fax_no": 67631091,
//         "fax_no_2": "na",
//         "email_address": "SVPS@MOE.EDU.SG",
//         "mrt_desc": "Choa Chu Kang MRT Station",
//         "bus_desc": "307 / South View LRT Station",
//         "principal_name": "MISS ANG MUI KHOONG",
//         "first_vp_name": "MISS GOH JIA LI",
//         "second_vp_name": "MR ONG HONG GHEE",
//         "third_vp_name": "MR RAMESH TIWARI S/O RAMADHAR TIWARI",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SPECTRA SECONDARY SCHOOL",
//         "url_address": "https://www.spectra.edu.sg",
//         "address": "1 WOODLANDS DRIVE 64",
//         "postal_code": 737758,
//         "telephone_no": 64660775,
//         "telephone_no_2": "na",
//         "fax_no": 64623928,
//         "fax_no_2": "na",
//         "email_address": "spectra@schools.gov.sg",
//         "mrt_desc": "ADMIRALTY",
//         "bus_desc": "901M, 962 (Bus Stop IDs: 47549 or 47541); 904 (Bus Stop IDs: 47649 or 47641)",
//         "principal_name": "MR TAN TECK HOCK",
//         "first_vp_name": "MS GRACE HO CHEN YEE",
//         "second_vp_name": "MISS GUO XINHUI",
//         "third_vp_name": "MR NG E-HIAN",
//         "fourth_vp_name": "MISS LOW YING XIU",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "SPECIALISED SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SPRINGDALE PRIMARY SCHOOL",
//         "url_address": "http://springdalepri.moe.edu.sg/",
//         "address": "71 Anchorvale Link",
//         "postal_code": 544799,
//         "telephone_no": 63157600,
//         "telephone_no_2": "na",
//         "fax_no": 63153351,
//         "fax_no_2": "na",
//         "email_address": "springdale_ps@moe.edu.sg",
//         "mrt_desc": "Sengkang Station (NE16); Nearest LRT station: Farmway; *10-15 min walk from either station",
//         "bus_desc": "50, 85, 102, 372; Nearest Bus Stop: In front of Blk 326 Car Park; *1-2 min walk from bus stop; enter by Main Gate along Anchorvale Link or Rear Gate",
//         "principal_name": "MRS QUEK-SIM KIM LIANG ANNE",
//         "first_vp_name": "MR SHOEB BURHANUDDIN",
//         "second_vp_name": "MISS SONG XIUHUA SHAFIQAH NADIAH",
//         "third_vp_name": "MADAM LIM BEE TIN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SENG KANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SPRINGFIELD SECONDARY SCHOOL",
//         "url_address": "http://www.springfieldsec.moe.edu.sg",
//         "address": "30 TAMPINES AVENUE 8",
//         "postal_code": 529593,
//         "telephone_no": 63183053,
//         "telephone_no_2": "na",
//         "fax_no": 63183050,
//         "fax_no_2": "na",
//         "email_address": "SPRINGFIELDS@MOE.EDU.SG",
//         "mrt_desc": "TAMPINES MRT, TAMPINES WEST MRT",
//         "bus_desc": "8, 15, 23, 58, 69, 118, 129, 291, 293, 298, 513, 518",
//         "principal_name": "MISS CHIA SHUEN LI ELEANOR",
//         "first_vp_name": "MADAM YEHIDAAH BEEVI D/O SHAIK A",
//         "second_vp_name": "MR WU CHE VUN STEVEN (WU QIWEN)",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "ST ANDREW'S SCHOOL (JUNIOR)",
//         "url_address": "http://www.saintandrewsjunior.moe.edu.sg",
//         "address": "2 FRANCIS THOMAS DRIVE",
//         "postal_code": 359337,
//         "telephone_no": 62884303,
//         "telephone_no_2": "na",
//         "fax_no": 62895242,
//         "fax_no_2": "na",
//         "email_address": "SAJS@MOE.EDU.SG",
//         "mrt_desc": "Potong Pasir, Toa Payoh",
//         "bus_desc": "8,13,26,31,90,90A,107,133,142,147,853,NR6",
//         "principal_name": "MRS ELSIE POEY",
//         "first_vp_name": "MISS HEW YI QIAN CAROLINE",
//         "second_vp_name": "MRS STEPHANIE GOH",
//         "third_vp_name": "MR BOEY WENG YUE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST ANDREW'S SCHOOL (SECONDARY)",
//         "url_address": "http://www.standrewssec.moe.edu.sg",
//         "address": "15 FRANCIS THOMAS DRIVE",
//         "postal_code": 359342,
//         "telephone_no": 62851944,
//         "telephone_no_2": "na",
//         "fax_no": 63823779,
//         "fax_no_2": "na",
//         "email_address": "SASS@MOE.EDU.SG",
//         "mrt_desc": "POTONG PASIR MRT",
//         "bus_desc": "8, 13, 26, 31, 90, 90A, 107, 133, 142, 147, 853",
//         "principal_name": "MR LEE HAN HWA",
//         "first_vp_name": "MISS TEO PEK HOON AGNES",
//         "second_vp_name": "MADAM GUINIEVE YEO LI-LYN",
//         "third_vp_name": "TEO PENG YONG DANNY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. ANDREW'S JUNIOR COLLEGE",
//         "url_address": "http://www.standrewsjc.moe.edu.sg/",
//         "address": "5 Sorby Adams Drive",
//         "postal_code": 357691,
//         "telephone_no": 62857008,
//         "telephone_no_2": 62852007,
//         "fax_no": 62850037,
//         "fax_no_2": "na",
//         "email_address": "SAJC@MOE.EDU.SG",
//         "mrt_desc": "Potong Pasir NE10",
//         "bus_desc": "SBSTransit: 8, 26, 31, 90, 142 ,151, 154 (Diocese of Singapore); SMRT Buses: 857, 966, 985 (Diocese of Singapore), 853 (Upper Serangoon Road)",
//         "principal_name": "MR THAM KINE THONG",
//         "first_vp_name": "MR ANG KHENG SAN CECIL",
//         "second_vp_name": "MRS TEE AI LEE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TOA PAYOH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. ANTHONY'S CANOSSIAN PRIMARY SCHOOL",
//         "url_address": "http://www.stanthonyscanossianpri.moe.edu.sg",
//         "address": "1602 BEDOK NORTH AVE 4",
//         "postal_code": 469701,
//         "telephone_no": 64492239,
//         "telephone_no_2": "na",
//         "fax_no": 64492146,
//         "fax_no_2": "na",
//         "email_address": "SACPS@MOE.EDU.SG",
//         "mrt_desc": "Bedok MRT",
//         "bus_desc": "17, 18",
//         "principal_name": "MRS SHARON CLARISSA FOO",
//         "first_vp_name": "MISS LEE XINYUN FELICIA",
//         "second_vp_name": "MISS THIA HWEI LING SHARON",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. ANTHONY'S CANOSSIAN SECONDARY SCHOOL",
//         "url_address": "https://stanthonyscanossiansec.moe.edu.sg",
//         "address": "1600 BEDOK NORTH AVENUE 4",
//         "postal_code": 469700,
//         "telephone_no": 64490616,
//         "telephone_no_2": "na",
//         "fax_no": 64490162,
//         "fax_no_2": "na",
//         "email_address": "SACSS@MOE.EDU.SG",
//         "mrt_desc": "BEDOK MRT, BEDOK RESERVOIR MRT",
//         "bus_desc": "17, 14, 46, 222",
//         "principal_name": "MADAM KOH TYNG YUANN FIONA",
//         "first_vp_name": "MISS CHIONH CHEW PENG",
//         "second_vp_name": "MRS YEO SHU WEN MELISSA MARY",
//         "third_vp_name": "MISS CHEN HUIQING CHRISTINE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. ANTHONY'S PRIMARY SCHOOL",
//         "url_address": "http://www.stanthonyspri.moe.edu.sg",
//         "address": "30 Bukit Batok St 32",
//         "postal_code": 659401,
//         "telephone_no": 65690822,
//         "telephone_no_2": "na",
//         "fax_no": 65690811,
//         "fax_no_2": "na",
//         "email_address": "SAPS@MOE.EDU.SG",
//         "mrt_desc": "Bukit Gombak MRT Station",
//         "bus_desc": 945,
//         "principal_name": "MADAM GOH LUNG ENG",
//         "first_vp_name": "MISS MATHEW ANNA",
//         "second_vp_name": "MR TEE LENG TECK",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. GABRIEL'S PRIMARY SCHOOL",
//         "url_address": "http://www.stgabrielspri.moe.edu.sg",
//         "address": "220 Lorong Chuan",
//         "postal_code": 556742,
//         "telephone_no": 62803628,
//         "telephone_no_2": "na",
//         "fax_no": 63820344,
//         "fax_no_2": "na",
//         "email_address": "STGPS@MOE.EDU.SG",
//         "mrt_desc": "Lor Chuan MRT Station (Circle Line)",
//         "bus_desc": "73, 105, 159",
//         "principal_name": "MR MARTIN TAN SIEW KIN",
//         "first_vp_name": "MADAM CHUA WANG LING IRENE",
//         "second_vp_name": "MR LIM CHONG ENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. GABRIEL'S SECONDARY SCHOOL",
//         "url_address": "http://www.stgabrielssec.moe.edu.sg",
//         "address": "24 SERANGOON AVENUE 1",
//         "postal_code": 556140,
//         "telephone_no": 62889470,
//         "telephone_no_2": "na",
//         "fax_no": 62898615,
//         "fax_no_2": "na",
//         "email_address": "STGSS@MOE.EDU.SG",
//         "mrt_desc": "SERANGOON MRT",
//         "bus_desc": 158,
//         "principal_name": "MR LIM CHEE KOON SHAWN",
//         "first_vp_name": "MR CHRISTOPHER THOMAS",
//         "second_vp_name": "MADAM YEE WHOY CHONG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. HILDA'S PRIMARY SCHOOL",
//         "url_address": "http://www.shps.moe.edu.sg",
//         "address": "2 Tampines Ave 3",
//         "postal_code": 529706,
//         "telephone_no": 67811916,
//         "telephone_no_2": "na",
//         "fax_no": 67830527,
//         "fax_no_2": "na",
//         "email_address": "SHPS@MOE.EDU.SG",
//         "mrt_desc": "Tampines West, Tampines Central",
//         "bus_desc": "Feeder Bus service: 293 from Tampines Interchange (towards St 71)",
//         "principal_name": "MADAM LAW LI MEI",
//         "first_vp_name": "MADAM LOW AI LING",
//         "second_vp_name": "MADAM NG YIN SZE JOSEPHINE",
//         "third_vp_name": "MADAM POH LYE IMM",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. HILDA'S SECONDARY SCHOOL",
//         "url_address": "http://www.sthildassec.moe.edu.sg",
//         "address": "2 TAMPINES STREET 82",
//         "postal_code": 528986,
//         "telephone_no": 63055277,
//         "telephone_no_2": "na",
//         "fax_no": 67865011,
//         "fax_no_2": "na",
//         "email_address": "SHSS@MOE.EDU.SG",
//         "mrt_desc": "TAMPINES MRT, TAMPINES WEST MRT",
//         "bus_desc": "22, 129, 293, 298",
//         "principal_name": "MR LEW KING LUN JULIAN",
//         "first_vp_name": "MADAM SO MUN YEE",
//         "second_vp_name": "MR GOH WEE SIONG JARED",
//         "third_vp_name": "MR LOY WEE JIN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. JOSEPH'S INSTITUTION",
//         "url_address": "http://www.sji.edu.sg",
//         "address": "38 MALCOLM ROAD",
//         "postal_code": 308274,
//         "telephone_no": 62500022,
//         "telephone_no_2": "na",
//         "fax_no": 62533640,
//         "fax_no_2": "na",
//         "email_address": "SJI@MOE.EDU.SG",
//         "mrt_desc": "STEVENS MRT",
//         "bus_desc": "105, 132, 151, 153, 154, 156, 186, 190, 960, 972",
//         "principal_name": "MR JUSTIN ARUL PIERRE",
//         "first_vp_name": "MR DOMINIC ANG SWEE KENG",
//         "second_vp_name": "MR LAM CHUEN SENG ERIC",
//         "third_vp_name": "MR TSAO WEN JIE NICHOLAS",
//         "fourth_vp_name": "MDM SHIRLEY YONG WAI YEE",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "NOVENA",
//         "zone_code": "SOUTH",
//         "type_code": "INDEPENDENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. JOSEPH'S INSTITUTION JUNIOR",
//         "url_address": "https://sjijunior.moe.edu.sg",
//         "address": "3 ESSEX ROAD",
//         "postal_code": 309331,
//         "telephone_no": 62552700,
//         "telephone_no_2": "na",
//         "fax_no": 62557455,
//         "fax_no_2": "na",
//         "email_address": "STMICHAELSCH@MOE.EDU.SG",
//         "mrt_desc": "Novena",
//         "bus_desc": "21;54;56;57;124;131;141;166;518;851;980",
//         "principal_name": "MR LEONG YEW HON ERIC",
//         "first_vp_name": "MISS YAK HIOK WOON, FAITH (YE YUYUN)",
//         "second_vp_name": "MISS SNG WAN XIAN",
//         "third_vp_name": "MR LIM YEW TEE COLLIN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "NOVENA",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. MARGARET'S SCHOOL (PRIMARY)",
//         "url_address": "https://stmargaretspri.moe.edu.sg",
//         "address": "136 Sophia Road",
//         "postal_code": 228197,
//         "telephone_no": 63394247,
//         "telephone_no_2": "na",
//         "fax_no": 63394264,
//         "fax_no_2": "na",
//         "email_address": "STMARGARETPS@MOE.EDU.SG",
//         "mrt_desc": "Little India MRT Station (NE7/DT12); Dhoby Ghaut MRT Station (NS24/NE6/CC1)",
//         "bus_desc": "64, 65, 131, 139, 147, 857, 166 (alight at the bus stop after Parklane Shopping Mall)",
//         "principal_name": "MADAM KO-TAN LI LING",
//         "first_vp_name": "MDM WENDY SENG GEK CHENG",
//         "second_vp_name": "MRS NEO HUI EN CHERLYN",
//         "third_vp_name": "MISS TAN CHER LANG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CENTRAL",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. MARGARET'S SCHOOL (SECONDARY)",
//         "url_address": "http://www.stmargaretssec.moe.edu.sg",
//         "address": "111 FARRER ROAD",
//         "postal_code": 259240,
//         "telephone_no": 64664525,
//         "telephone_no_2": "na",
//         "fax_no": 64666709,
//         "fax_no_2": "na",
//         "email_address": "STMARGARETSS@MOE.EDU.SG",
//         "mrt_desc": "FARRER ROAD MRT",
//         "bus_desc": "48, 93, 153, 165, 174, 186, 855, 961",
//         "principal_name": "MISS LIM HUI KHENG LINDA",
//         "first_vp_name": "MDM CHIN YIH MIN",
//         "second_vp_name": "MS WOON CHIN FONG CHRYSTINE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT TIMAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "UNITY SECONDARY SCHOOL",
//         "url_address": "http://www.unitysec.moe.edu.sg",
//         "address": "20 CHOA CHU KANG STREET 62",
//         "postal_code": 689143,
//         "telephone_no": 67671070,
//         "telephone_no_2": "na",
//         "fax_no": 67654189,
//         "fax_no_2": "na",
//         "email_address": "UNITY_SS@MOE.EDU.SG",
//         "mrt_desc": "YEW TEE MRT",
//         "bus_desc": 307,
//         "principal_name": "MADAM ONG LIANG FUNG",
//         "first_vp_name": "MR LIM YONG CHAI ALAN",
//         "second_vp_name": "MS YUEN CHAI LIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. PATRICK'S SCHOOL",
//         "url_address": "http://www.stpatricks.moe.edu.sg",
//         "address": "490 EAST COAST ROAD",
//         "postal_code": 429058,
//         "telephone_no": 63440929,
//         "telephone_no_2": 63441429,
//         "fax_no": 63445152,
//         "fax_no_2": "na",
//         "email_address": "STPATRICKSCH@MOE.EDU.SG",
//         "mrt_desc": "MARINE TERRACE MRT (TEL)",
//         "bus_desc": "10, 10E, 12, 13, 14, 14E, 15, 16, 31, 32, 36, 40, 43, 47, 48, 55, 135, 150, 155, 196, 197",
//         "principal_name": "MR MARK GERARD MINJOOT",
//         "first_vp_name": "MR TAN YII HSIEN BARNABAS",
//         "second_vp_name": "MR KWAN YEW MENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ST. STEPHEN'S SCHOOL",
//         "url_address": "http://www.ststephens.moe.edu.sg",
//         "address": "20 SIGLAP VIEW",
//         "postal_code": 455789,
//         "telephone_no": 62419513,
//         "telephone_no_2": 64441645,
//         "fax_no": 64422576,
//         "fax_no_2": "na",
//         "email_address": "STSTEPHENSCH@MOE.EDU.SG",
//         "mrt_desc": "Kembangan MRT Station",
//         "bus_desc": "2,7,24,25,26,28,30,32,33,67,854",
//         "principal_name": "MR GOH HENG LIANG TIMOTHY",
//         "first_vp_name": "MR EDWIN HENG TOW YANG",
//         "second_vp_name": "MR CHEW SOO KWANG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "SWISS COTTAGE SECONDARY SCHOOL",
//         "url_address": "http://www.swisscottagesec.moe.edu.sg",
//         "address": "3 BUKIT BATOK STREET 34",
//         "postal_code": 659322,
//         "telephone_no": 65637173,
//         "telephone_no_2": "na",
//         "fax_no": 65693028,
//         "fax_no_2": "na",
//         "email_address": "SCSS@MOE.EDU.SG",
//         "mrt_desc": "BUKIT GOMBAK MRT",
//         "bus_desc": "187, 188, 985, 945",
//         "principal_name": "MDM MANDY CHENG MUN YI",
//         "first_vp_name": "MR TAN BOON PIANG",
//         "second_vp_name": "na",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT BATOK",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TAMPINES MERIDIAN JUNIOR COLLEGE",
//         "url_address": "http://www.tmjc.moe.edu.sg",
//         "address": "21 Pasir Ris Street 71",
//         "postal_code": 518799,
//         "telephone_no": 63493660,
//         "telephone_no_2": "na",
//         "fax_no": 63493667,
//         "fax_no_2": "na",
//         "email_address": "tmjc@moe.edu.sg",
//         "mrt_desc": "Pasir Ris MRT Station",
//         "bus_desc": "3, 39, 53, 68, 81, 89, 109, 358, 359, 518, 518A",
//         "principal_name": "MR SIN KIM HO",
//         "first_vp_name": "MADAM TOH LAY HAR",
//         "second_vp_name": "MR ANG YEOU PENG",
//         "third_vp_name": "MDM YASMINE D/O KAMALUDHEEN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TAMPINES NORTH PRIMARY SCHOOL",
//         "url_address": "http://www.tampinesnorthpri.moe.edu.sg",
//         "address": "30 TAMPINES AVENUE 9",
//         "postal_code": 529565,
//         "telephone_no": 67854329,
//         "telephone_no_2": "na",
//         "fax_no": 67863117,
//         "fax_no_2": "na",
//         "email_address": "TNPS@MOE.EDU.SG",
//         "mrt_desc": "Tampines MRT",
//         "bus_desc": "SBS Transit 28, 29, 293",
//         "principal_name": "MADAM RATNA KUMARI D/O R RAMACHANDRA",
//         "first_vp_name": "MR MOHAMED YUSUFF MOHAMED ALLIE",
//         "second_vp_name": "MISS CHARMAINE TAY",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TAMPINES PRIMARY SCHOOL",
//         "url_address": "http://www.tampinespri.moe.edu.sg",
//         "address": "250 TAMPINES STREET 12",
//         "postal_code": 529426,
//         "telephone_no": 67831190,
//         "telephone_no_2": "na",
//         "fax_no": 67843521,
//         "fax_no_2": "na",
//         "email_address": "TPPS@MOE.EDU.SG",
//         "mrt_desc": "Tampines MRT",
//         "bus_desc": "8, 10, 17,18, 27, 31, 65, 292, 293, or any bus going into Tampines Interchange",
//         "principal_name": "MADAM LEE LAY SEE/ MRS LAY SEE NEUFELD",
//         "first_vp_name": "MADAM ARIKEN CHARMAINE CARRIE",
//         "second_vp_name": "MR HO WEE MIN  KELVIN",
//         "third_vp_name": "MR TIN CHEE KUANG EDMUND",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TAMPINES SECONDARY SCHOOL",
//         "url_address": "https://www.tampinessec.moe.edu.sg",
//         "address": "252 TAMPINES ST 12",
//         "postal_code": 529427,
//         "telephone_no": 67835423,
//         "telephone_no_2": "na",
//         "fax_no": 67843059,
//         "fax_no_2": "na",
//         "email_address": "TPSS@MOE.EDU.SG",
//         "mrt_desc": "TAMPINES MRT",
//         "bus_desc": "3,  8,  10,  15,  17,  18,  20,  21,  23,  27,  28,  31,  34,  39,  59,  65,  129,  168,  292,  298,  518",
//         "principal_name": "MADAM TAN YANG FERN",
//         "first_vp_name": "MR MOHAMED FAHIZEL S/O M EGUEYAMAREC",
//         "second_vp_name": "MS LEE PECK WEN AMANDA (LI BIWEN)",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TANJONG KATONG GIRLS' SCHOOL",
//         "url_address": "http://www.tkgs.moe.edu.sg",
//         "address": "20 Dunman Lane",
//         "postal_code": 439272,
//         "telephone_no": 63441593,
//         "telephone_no_2": "na",
//         "fax_no": 63451487,
//         "fax_no_2": "64409187(from 2017)",
//         "email_address": "TKGS@MOE.EDU.SG",
//         "mrt_desc": "PAYA LEBAR MRT, DAKOTA MRT",
//         "bus_desc": "10, 16, 31, 32, 33, 40, 43, 134, 135, 197",
//         "principal_name": "MISS CHEW ING LIM",
//         "first_vp_name": "MS XU WANJING",
//         "second_vp_name": "MR CHAI CHI YANG MOSES",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "MARINE PARADE",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "GIRLS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TANJONG KATONG PRIMARY SCHOOL",
//         "url_address": "http://www.tanjongkatongpri.moe.edu.sg/",
//         "address": "10 Seraya Road",
//         "postal_code": 437259,
//         "telephone_no": 63444728,
//         "telephone_no_2": "na",
//         "fax_no": 63445370,
//         "fax_no_2": "na",
//         "email_address": "TKPS@MOE.EDU.SG",
//         "mrt_desc": "na",
//         "bus_desc": "na",
//         "principal_name": "MS TAN SEOK KUAN",
//         "first_vp_name": "MISS ONG CHUXIAN",
//         "second_vp_name": "MADAM TOH LENG LENG",
//         "third_vp_name": "MRS VIJAYA GANESH",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "MARINE PARADE",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TANJONG KATONG SECONDARY SCHOOL",
//         "url_address": "http://www.tanjongkatongsec.moe.edu.sg",
//         "address": "130 HAIG ROAD",
//         "postal_code": 438796,
//         "telephone_no": 63443471,
//         "telephone_no_2": "na",
//         "fax_no": 64409624,
//         "fax_no_2": "na",
//         "email_address": "TKSS@MOE.EDU.SG",
//         "mrt_desc": "PAYA LEBAR MRT, DAKOTA MRT",
//         "bus_desc": "10, 16, 31, 32, 33, 40, 76, 135, 197",
//         "principal_name": "MADAM TAN YOK CHING RUBY",
//         "first_vp_name": "MADAM NG SIEW CHIN",
//         "second_vp_name": "MR ARUUMUGAM SAMIKKANNU",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "MARINE PARADE",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TAO NAN SCHOOL",
//         "url_address": "http://www.taonan.moe.edu.sg",
//         "address": "49 MARINE CRESCENT",
//         "postal_code": 449761,
//         "telephone_no": 64428307,
//         "telephone_no_2": "na",
//         "fax_no": 64435973,
//         "fax_no_2": "na",
//         "email_address": "TAONAN_SCH@MOE.EDU.SG",
//         "mrt_desc": "Marine Parade, Marine Terrace",
//         "bus_desc": "13, 16, 31, 36, 43, 48, 55, 134, 196, 197",
//         "principal_name": "MADAM POH QINYU",
//         "first_vp_name": "MS NG HUI MIN",
//         "second_vp_name": "MR CHAN TUCK CHEONG",
//         "third_vp_name": "MADAM FOO MEI PING",
//         "fourth_vp_name": "MRS TEO CHAI HIAH",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "MARINE PARADE",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "Yes",
//         "autonomous_ind": "No",
//         "gifted_ind": "Yes",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "na",
//         "mothertongue3_code": "na"
//     },
//     {
//         "school_name": "TECK GHEE PRIMARY SCHOOL",
//         "url_address": "http://www.teckgheepri.moe.edu.sg",
//         "address": "1 ANG MO KIO STREET 32",
//         "postal_code": 569299,
//         "telephone_no": 64548769,
//         "telephone_no_2": "na",
//         "fax_no": 64589886,
//         "fax_no_2": "na",
//         "email_address": "TGPS@MOE.EDU.SG",
//         "mrt_desc": "Ang Mo Kio & Bishan",
//         "bus_desc": "22,24,135,853,162,262,159",
//         "principal_name": "MISS REZIA RAHUMATHULLAH",
//         "first_vp_name": "MADAM CHOH THIAN JENG CELIA",
//         "second_vp_name": "MR TAN CHUAN YANG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TECK WHYE PRIMARY SCHOOL",
//         "url_address": "http://www.teckwhyepri.moe.edu.sg",
//         "address": "11 TECK WHYE WALK",
//         "postal_code": 688261,
//         "telephone_no": 67691025,
//         "telephone_no_2": "na",
//         "fax_no": 67635191,
//         "fax_no_2": "na",
//         "email_address": "TWPS@MOE.EDU.SG",
//         "mrt_desc": "Choa Chu Kang MRT & LRT",
//         "bus_desc": "975, 190 & 985",
//         "principal_name": "MADAM WONG SU MAY",
//         "first_vp_name": "MRS LIM GEK NOI",
//         "second_vp_name": "MR MURALIDHARAN S/O NARAYANAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TELOK KURAU PRIMARY SCHOOL",
//         "url_address": "http://www.telokkuraupri.moe.edu.sg",
//         "address": "50 BEDOK RESERVOIR RD",
//         "postal_code": 479239,
//         "telephone_no": 62441600,
//         "telephone_no_2": "na",
//         "fax_no": 62442182,
//         "fax_no_2": "na",
//         "email_address": "TELOKKRAU_PS@MOE.EDU.SG",
//         "mrt_desc": "Kaki Bukit MRT (nearest)",
//         "bus_desc": "8, 21, 60 & 65",
//         "principal_name": "MADAM GRACE HO LI JUN",
//         "first_vp_name": "MDM SHANTHI D/O VEERASWAMY",
//         "second_vp_name": "MADAM TAN KIM YAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TEMASEK JUNIOR COLLEGE",
//         "url_address": "http://www.temasekjc.moe.edu.sg",
//         "address": "2 Tampines Avenue 9   Temasek Junior College",
//         "postal_code": 529564,
//         "telephone_no": 64428066,
//         "telephone_no_2": "na",
//         "fax_no": 64428762,
//         "fax_no_2": "na",
//         "email_address": "TEMASEK_JC@MOE.EDU.SG",
//         "mrt_desc": "TAMPINES EAST MRT",
//         "bus_desc": "Bus Service along Tampines Ave 9: 18, 29 and 29A; Bus Service along Tampines Ave 7: 3, 3A, 4, 9, 9A, 12, 12e, 17, 18, 19, 21, 29, 29A, 34, 34B, 37, 39, 59, 81, 293 and 518.",
//         "principal_name": "MR LIU EARNLER",
//         "first_vp_name": "MRS WENDY GOH",
//         "second_vp_name": "MR QUEK POH BENG, KENNETH",
//         "third_vp_name": "MR CHAN KOK YEW MARK",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "MIXED LEVEL (S1-JC2)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TEMASEK PRIMARY SCHOOL",
//         "url_address": "http://www.temasekpri.moe.edu.sg",
//         "address": "501 BEDOK SOUTH AVE 3",
//         "postal_code": 469300,
//         "telephone_no": 64438134,
//         "telephone_no_2": "na",
//         "fax_no": 64495871,
//         "fax_no_2": "na",
//         "email_address": "TEMASEK_PS@MOE.EDU.SG",
//         "mrt_desc": "Tanah Merah MRT",
//         "bus_desc": "25,46, 48, 229",
//         "principal_name": "MADAM ANG GEK LENG ALISON AMANDA",
//         "first_vp_name": "MADAM ONG SEOW PENG",
//         "second_vp_name": "MADAM HASLINDAH BTE BAHROM",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TEMASEK SECONDARY SCHOOL",
//         "url_address": "https://temaseksec.moe.edu.sg",
//         "address": "600 UPPER EAST COAST ROAD",
//         "postal_code": 465561,
//         "telephone_no": 64495020,
//         "telephone_no_2": "na",
//         "fax_no": 64491450,
//         "fax_no_2": "na",
//         "email_address": "TEMASEK_SS@MOE.EDU.SG",
//         "mrt_desc": "BEDOK MRT, TANAH MERAH MRT",
//         "bus_desc": "10, 10E, 13, 14, 25, 43, 46, 55, 137, 229, 506, 531, 853",
//         "principal_name": "MR TAN SHUN LOONG",
//         "first_vp_name": "MR PONG WEN LONG",
//         "second_vp_name": "MR CHANDRASEKARAN S/O AMMIAPPAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "TOWNSVILLE PRIMARY SCHOOL",
//         "url_address": "http://www.townsvillepri.moe.edu.sg/",
//         "address": "3 ANG MO KIO AVE 10",
//         "postal_code": 569730,
//         "telephone_no": 64574345,
//         "telephone_no_2": "na",
//         "fax_no": 64570141,
//         "fax_no_2": "na",
//         "email_address": "TOWNSVILLEPS@MOE.EDU.SG",
//         "mrt_desc": "Bishan MRT, Ang Mo Kio MRT Stations",
//         "bus_desc": "45, 50, 55, 261, 548, 22, 24, 128, 135, 159, 162, 162M, 262, 853",
//         "principal_name": "MR EDDIE FOO CHIT CHEONG",
//         "first_vp_name": "MR HO SENG TAT SUNNY",
//         "second_vp_name": "MADAM LYNETTE FERNANDEZ",
//         "third_vp_name": "MR MARTIN VELAN ANTHONY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "VICTORIA JUNIOR COLLEGE",
//         "url_address": "https://www.victoriajc.moe.edu.sg/",
//         "address": "20 MARINE VISTA",
//         "postal_code": 449035,
//         "telephone_no": 64485011,
//         "telephone_no_2": "na",
//         "fax_no": 64438337,
//         "fax_no_2": "na",
//         "email_address": "VICTORIA_JC@MOE.EDU.SG",
//         "mrt_desc": "Nearest MRT Stations:  Marine Terrace, Kembangan, Eunos",
//         "bus_desc": "13, 16, 16M, 31, 36, 36A, 36B, 43, 47, 48, 55, 196, 196A, 196e, 197, 853M",
//         "principal_name": "MR LOW SWEE HENG JEFFREY",
//         "first_vp_name": "MR KOH WEINING",
//         "second_vp_name": "MS LEE YUN YUN GRACE",
//         "third_vp_name": "MRS KAREN TAY",
//         "fourth_vp_name": "MR LIM KWEE HONG KYLE",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "VICTORIA SCHOOL",
//         "url_address": "http://www.victoria.moe.edu.sg",
//         "address": "2 SIGLAP LINK",
//         "postal_code": 448880,
//         "telephone_no": 62912965,
//         "telephone_no_2": "na",
//         "fax_no": 64452609,
//         "fax_no_2": "na",
//         "email_address": "VICTORIA_SCH@MOE.EDU.SG",
//         "mrt_desc": "SIGLAP, BEDOK MRT, PAYA LEBAR MRT",
//         "bus_desc": "31, 36, 43, 47, 48, 55, 155, 196, 196E, 197, 401, 853M",
//         "principal_name": "MR LOW CHUN MENG",
//         "first_vp_name": "MR LIM WEI ZHONG CLARENCE",
//         "second_vp_name": "MR WU BIWEI, IVAN",
//         "third_vp_name": "MR ANG JOHNNY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "BOYS' SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S4)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "Yes",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WATERWAY PRIMARY SCHOOL",
//         "url_address": "https://waterwaypri.moe.edu.sg",
//         "address": "70 Punggol Drive",
//         "postal_code": 828802,
//         "telephone_no": "6636 6880",
//         "telephone_no_2": "na",
//         "fax_no": "6315 3451",
//         "fax_no_2": "na",
//         "email_address": "waterway_ps@moe.edu.sg",
//         "mrt_desc": "Kadaloor LRT Station",
//         "bus_desc": "50, 381",
//         "principal_name": "MR WONG KENG YUIN WILBUR",
//         "first_vp_name": "MADAM TAN GEK SIM MAGELLA",
//         "second_vp_name": "MADAM CHUA KIM LAN JUDY",
//         "third_vp_name": "MADAM SHARIFAH MASTURAH BTE S OSMAN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WELLINGTON PRIMARY SCHOOL",
//         "url_address": "http://www.wellingtonpri.moe.edu.sg",
//         "address": "10 WELLINGTON CIRCLE",
//         "postal_code": 757702,
//         "telephone_no": 67533319,
//         "telephone_no_2": "na",
//         "fax_no": 67533765,
//         "fax_no_2": "na",
//         "email_address": "WELLINGTONPS@MOE.EDU.SG",
//         "mrt_desc": "Sembawang MRT",
//         "bus_desc": "980, 856, 859",
//         "principal_name": "MR ALCANTARA ALBERT ALFRED",
//         "first_vp_name": "MADAM HOONG WHEE SIEN",
//         "second_vp_name": "MADAM SHAHRULHANA BTE MOHAMED",
//         "third_vp_name": "MR NG WEE MING DENNIS",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SEMBAWANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WEST GROVE PRIMARY SCHOOL",
//         "url_address": "http://www.westgrovepri.moe.edu.sg/",
//         "address": "1 JURONG WEST ST 72",
//         "postal_code": 649223,
//         "telephone_no": 62679234,
//         "telephone_no_2": "na",
//         "fax_no": 62679235,
//         "fax_no_2": "na",
//         "email_address": "WGPS@MOE.EDU.SG",
//         "mrt_desc": "Boon Lay MRT",
//         "bus_desc": "Bus 99, 242",
//         "principal_name": "MISS MABEL GOH",
//         "first_vp_name": "MADAM GOH XUEMIN CHERMAINE",
//         "second_vp_name": "MADAM TAY SOOK HIAN, AUDREY",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WEST SPRING PRIMARY SCHOOL",
//         "url_address": "http://www.westspringpri.moe.edu.sg",
//         "address": "60 Bukit Panjang Ring Road",
//         "postal_code": 679946,
//         "telephone_no": 63144192,
//         "telephone_no_2": "na",
//         "fax_no": "na",
//         "fax_no_2": 63140648,
//         "email_address": "westspring_ps@moe.edu.sg",
//         "mrt_desc": "Jelapang LRT",
//         "bus_desc": "920, 922",
//         "principal_name": "MR WILLY TAN",
//         "first_vp_name": "MR WILLY TAN NGUAN PENG",
//         "second_vp_name": "MADAM KUM LAI MENG",
//         "third_vp_name": "MR SIM KOOI SUEN",
//         "fourth_vp_name": "MR CHIN HONG FAI HUMPHREY",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WEST SPRING SECONDARY SCHOOL",
//         "url_address": "http://www.westspringsec.moe.edu.sg",
//         "address": "61 SENJA  ROAD",
//         "postal_code": 677737,
//         "telephone_no": 68920369,
//         "telephone_no_2": "na",
//         "fax_no": 68929468,
//         "fax_no_2": "na",
//         "email_address": "WESTSPRINGSS@MOE.EDU.SG",
//         "mrt_desc": "BUKIT PANJANG MRT, JELAPANG LRT, SENJA LRT",
//         "bus_desc": "920, 972, 976",
//         "principal_name": "MADAM YONG LI LING BELINDA",
//         "first_vp_name": "MR MALVIN CHAN HUAN JIAN",
//         "second_vp_name": "MADAM SIM BEE LIAN (SHEN MEILIAN)",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WEST VIEW PRIMARY SCHOOL",
//         "url_address": "http://www.westviewpri.moe.edu.sg",
//         "address": "31 SENJA ROAD",
//         "postal_code": 677742,
//         "telephone_no": 67600178,
//         "telephone_no_2": "na",
//         "fax_no": 67600147,
//         "fax_no_2": "na",
//         "email_address": "WVPS@MOE.EDU.SG",
//         "mrt_desc": "Bukit Panjang MRT, SENJA LRT (A13)",
//         "bus_desc": "170,171,176,178,180,000,000,000,000,000",
//         "principal_name": "MR LEE FOOK LOONG EUGENE",
//         "first_vp_name": "MADAM ONG POH CHOO DORIS",
//         "second_vp_name": "MADAM SITI SUHAILA BTE SAPIHE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WESTWOOD PRIMARY SCHOOL",
//         "url_address": "http://www.westwoodpri.moe.edu.sg",
//         "address": "1 Jurong West Street 73",
//         "postal_code": 649188,
//         "telephone_no": 64121690,
//         "telephone_no_2": "na",
//         "fax_no": 67945084,
//         "fax_no_2": "na",
//         "email_address": "westwood_ps@moe.edu.sg",
//         "mrt_desc": "Boon Lay MRT Station",
//         "bus_desc": "181, 502 & 243",
//         "principal_name": "MR MAH SENG THONG ANDREW",
//         "first_vp_name": "MR CHEE CHIT YENG",
//         "second_vp_name": "MR LOW MIN CHYE",
//         "third_vp_name": "MISS CHONG HUAY LENG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WESTWOOD SECONDARY SCHOOL",
//         "url_address": "https://www.westwoodsec.moe.edu.sg",
//         "address": "11 JURONG WEST STREET 25",
//         "postal_code": 648350,
//         "telephone_no": 67929737,
//         "telephone_no_2": "na",
//         "fax_no": 67929738,
//         "fax_no_2": "na",
//         "email_address": "WESTWOOD_SS@MOE.EDU.SG",
//         "mrt_desc": "BOON LAY MRT",
//         "bus_desc": "172, 181, 181M, 185, 199, 405, 974, 974A",
//         "principal_name": "MR ABDUL HARRIS B SUMARDI",
//         "first_vp_name": "MR HOI WENG KIT DERRICK",
//         "second_vp_name": "MISS THEODORA HUANG XINYI",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WHITE SANDS PRIMARY SCHOOL",
//         "url_address": "http://www.whitesandspri.moe.edu.sg",
//         "address": "2 PASIR RIS ST 11",
//         "postal_code": 519075,
//         "telephone_no": 69229100,
//         "telephone_no_2": "na",
//         "fax_no": 65815013,
//         "fax_no_2": "na",
//         "email_address": "WSPS@MOE.EDU.SG",
//         "mrt_desc": "Pasir Ris MRT Station",
//         "bus_desc": "12, 17, 21, 39, 53, 81, 518, 109",
//         "principal_name": "MADAM WONG LIN LIN AUDREY",
//         "first_vp_name": "MS REZINA KHAN D/O ABDUL RAHIM",
//         "second_vp_name": "MISS TIONG LINA",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PASIR RIS",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WHITLEY SECONDARY SCHOOL",
//         "url_address": "http://www.whitleysec.moe.edu.sg",
//         "address": "30 BISHAN STREET 24",
//         "postal_code": 579747,
//         "telephone_no": 64561336,
//         "telephone_no_2": "na",
//         "fax_no": 64591330,
//         "fax_no_2": "na",
//         "email_address": "WHITLEY_SS@MOE.EDU.SG",
//         "mrt_desc": "BISHAN MRT, MARYMOUNT MRT",
//         "bus_desc": "13, 52, 54, 74, 74E, 88, 162, 162M,  588, 410, 851, 852",
//         "principal_name": "MISS KOH LIN LYNN",
//         "first_vp_name": "MR TAN YIT KEE",
//         "second_vp_name": "MR TAY KIM SENG",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BISHAN",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WOODGROVE PRIMARY SCHOOL",
//         "url_address": "http://www.woodgrovepri.moe.edu.sg/",
//         "address": "2 WOODLANDS DRIVE 14",
//         "postal_code": 738079,
//         "telephone_no": 68943371,
//         "telephone_no_2": "na",
//         "fax_no": 68943372,
//         "fax_no_2": "na",
//         "email_address": "WOODGROVE_PS@MOE.EDU.SG",
//         "mrt_desc": "Woodlands MRT Station",
//         "bus_desc": 901,
//         "principal_name": "MS ADELINE TAN WEE KIAW",
//         "first_vp_name": "MR PHANG TECK HOW",
//         "second_vp_name": "MR SIM YONG MING",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WOODGROVE SECONDARY SCHOOL",
//         "url_address": "https://www.woodgrovesec.moe.edu.sg",
//         "address": "3 WOODLANDS AVENUE 6",
//         "postal_code": 738990,
//         "telephone_no": 68932564,
//         "telephone_no_2": "na",
//         "fax_no": 68934458,
//         "fax_no_2": "na",
//         "email_address": "WOODGROVE_SS@MOE.EDU.SG",
//         "mrt_desc": "WOODLANDS MRT, WOODLANDS SOUTH MRT",
//         "bus_desc": "901, 901M",
//         "principal_name": "MR CHUA CHOR HUAT",
//         "first_vp_name": "MADAM TAN PHAIK HOON (CHEN BIHONG)",
//         "second_vp_name": "MRS VENKATRAMAN CHITHRA",
//         "third_vp_name": "MR LOKE KOK LEONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WOODLANDS PRIMARY SCHOOL",
//         "url_address": "http://www.woodlandspri.moe.edu.sg",
//         "address": "10 WOODLANDS DRIVE 50",
//         "postal_code": 738853,
//         "telephone_no": 62697410,
//         "telephone_no_2": "na",
//         "fax_no": 63671165,
//         "fax_no_2": "na",
//         "email_address": "WPS@MOE.EDU.SG",
//         "mrt_desc": "Woodlands",
//         "bus_desc": "912 & 912E",
//         "principal_name": "MISS KUCK LI LIAN LILLIAN",
//         "first_vp_name": "MR RAZALI B SENIN",
//         "second_vp_name": "MISS SUSANNA CHAU",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WOODLANDS RING PRIMARY SCHOOL",
//         "url_address": "HTTP://www.woodlandsringpri.moe.edu.sg",
//         "address": "11 WOODLANDS RING ROAD",
//         "postal_code": 738240,
//         "telephone_no": 63643679,
//         "telephone_no_2": "na",
//         "fax_no": 63643490,
//         "fax_no_2": "na",
//         "email_address": "WRPS@MOE.EDU.SG",
//         "mrt_desc": "Admiralty MRT Station",
//         "bus_desc": 912,
//         "principal_name": "MISS GEETHA D/O DORAISAMY",
//         "first_vp_name": "MR LIM KIM THYE",
//         "second_vp_name": "MR CHEW CHIN MING",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WOODLANDS RING SECONDARY SCHOOL",
//         "url_address": "http://www.woodlandsringsec.moe.edu.sg",
//         "address": "21 WOODLANDS AVENUE 1",
//         "postal_code": 739062,
//         "telephone_no": 63643712,
//         "telephone_no_2": "na",
//         "fax_no": "na",
//         "fax_no_2": "na",
//         "email_address": "WRSS@MOE.EDU.SG",
//         "mrt_desc": "ADMIRALTY MRT",
//         "bus_desc": 912,
//         "principal_name": "MR LAM YUI- P'NG",
//         "first_vp_name": "MR TAY YONG SEAH MELVIN",
//         "second_vp_name": "MR SIM KOK HIAN, KENNETH",
//         "third_vp_name": "MR HEE JUAY AY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "WOODLANDS SECONDARY SCHOOL",
//         "url_address": "http://www.woodlandssec.moe.edu.sg",
//         "address": "11 MARSILING ROAD",
//         "postal_code": 739111,
//         "telephone_no": 68494400,
//         "telephone_no_2": "na",
//         "fax_no": 62691774,
//         "fax_no_2": "na",
//         "email_address": "WSS@MOE.EDU.SG",
//         "mrt_desc": "MARSILING MRT, WOODLANDS MRT",
//         "bus_desc": "913, 913M, 913, 913T, 178, 856, 903",
//         "principal_name": "MISS MOH CUI RONG REBECCA",
//         "first_vp_name": "MADAM MASAYU BINTE MAHMUD",
//         "second_vp_name": "MR TAY HONG JOO STEVEN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "WOODLANDS",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "XINGHUA PRIMARY SCHOOL",
//         "url_address": "http://www.xinghuapri.moe.edu.sg",
//         "address": "45 HOUGANG AVENUE 1",
//         "postal_code": 538882,
//         "telephone_no": 62889121,
//         "telephone_no_2": "na",
//         "fax_no": 62838831,
//         "fax_no_2": "na",
//         "email_address": "XINGHUA_PS@MOE.EDU.SG",
//         "mrt_desc": "Kovan MRT Station",
//         "bus_desc": "Bus services 53, 62, 112, 113, 115",
//         "principal_name": "MR LEOW YEN MIN",
//         "first_vp_name": "MISS PHUA AI LEI",
//         "second_vp_name": "MS TAN BEE YIN (CHEN MEIYING)",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "XINGNAN PRIMARY SCHOOL",
//         "url_address": "http://www.xingnanpri.moe.edu.sg",
//         "address": "5 JURONG WEST STREET 91",
//         "postal_code": 649036,
//         "telephone_no": 67913679,
//         "telephone_no_2": "na",
//         "fax_no": 67921493,
//         "fax_no_2": "na",
//         "email_address": "XINGNAN_PS@MOE.EDU.SG",
//         "mrt_desc": "Pioneer MRT Station",
//         "bus_desc": "Bus 99 & 241",
//         "principal_name": "MADAM CHAN SIN LI, CINDY",
//         "first_vp_name": "MDM ANG HWEE LOO",
//         "second_vp_name": "MADAM S ANITHA",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "XINMIN PRIMARY SCHOOL",
//         "url_address": "https://xinminpri.moe.edu.sg/",
//         "address": "9 HOUGANG AVENUE 8",
//         "postal_code": 538784,
//         "telephone_no": 62835479,
//         "telephone_no_2": "na",
//         "fax_no": 62880334,
//         "fax_no_2": "na",
//         "email_address": "XINMIN_PS@MOE.EDU.SG",
//         "mrt_desc": "Nil",
//         "bus_desc": "74, 147, 165, 112",
//         "principal_name": "MADAM TAN KAY LING",
//         "first_vp_name": "MRS AHKEELA JULIA BEE D/O HANIFAH",
//         "second_vp_name": "MR LIM BOON TECK",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "XINMIN SECONDARY SCHOOL",
//         "url_address": "http://www.xinminsec.moe.edu.sg",
//         "address": "11 HOUGANG AVENUE 8",
//         "postal_code": 538789,
//         "telephone_no": 62889382,
//         "telephone_no_2": "na",
//         "fax_no": 63851068,
//         "fax_no_2": "na",
//         "email_address": "XINMIN_SS@MOE.EDU.SG",
//         "mrt_desc": "HOUGANG MRT",
//         "bus_desc": "25, 43, 43M, 55, 70, 70A, 70B, 70M, 72, 72A, 73, 73A, 74, 88, 88A, 103, 109, 109A, 112, 116, 132, 147, 159, 159A, 161, 165, 329, 660, 854, 854E",
//         "principal_name": "MR TAN SOON HUI",
//         "first_vp_name": "MR GOH KAR WHEE",
//         "second_vp_name": "MADAM KOMATHI D/O P KESAVAN",
//         "third_vp_name": "MR TAN KOK KWANG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "XISHAN PRIMARY SCHOOL",
//         "url_address": "https://www.xishanpri.moe.edu.sg/",
//         "address": "8 YISHUN STREET 21",
//         "postal_code": 768611,
//         "telephone_no": 67588837,
//         "telephone_no_2": "na",
//         "fax_no": 67588361,
//         "fax_no_2": "na",
//         "email_address": "XISHAN_PS@MOE.EDU.SG",
//         "mrt_desc": "Alight at Yishun MRT Station; Take Exit C; Walk towards Yishun Street 21",
//         "bus_desc": "Along Yishun Ave 2,take Bus Service 117, 169, 804, 812, 965. Alight at Blk 220. Along Yishun Ring Road,take Bus Service 1N, 800, 804, NR1. Alight at Blk 227 or 236.",
//         "principal_name": "MADAM NGOH YING LI, JANE",
//         "first_vp_name": "MISS LATHA D/O SINASAMY",
//         "second_vp_name": "MADAM LEE WEE LING (LI WEILIN)",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YANGZHENG PRIMARY SCHOOL",
//         "url_address": "http://www.yangzhengpri.moe.edu.sg/",
//         "address": "15 SERANGOON AVENUE 3",
//         "postal_code": 556108,
//         "telephone_no": 62846298,
//         "telephone_no_2": "na",
//         "fax_no": 62879778,
//         "fax_no_2": "na",
//         "email_address": "YZPS@MOE.EDU.SG",
//         "mrt_desc": "Serangoon Station",
//         "bus_desc": "58 & 105 (Outside the school, Serangoon Ave 3); 133 & 135(Serangoon Ave 2)",
//         "principal_name": "MRS LIM- FOO BOON CHING",
//         "first_vp_name": "MR ERIC LEE WEI TAT",
//         "second_vp_name": "MISS MICHELLE HUANG",
//         "third_vp_name": "MADAM TAN ENG ENG JENNY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YEW TEE PRIMARY SCHOOL",
//         "url_address": "http://www.yewteepri.moe.edu.sg",
//         "address": "10 CHOA CHU KANG ST 64",
//         "postal_code": 689100,
//         "telephone_no": 67670027,
//         "telephone_no_2": "na",
//         "fax_no": 67675450,
//         "fax_no_2": "na",
//         "email_address": "YTPS@MOE.EDU.SG",
//         "mrt_desc": "Yew Tee MRT Station",
//         "bus_desc": 307,
//         "principal_name": "MADAM NUR SABARIAH BTE MOHD IBRAHIM",
//         "first_vp_name": "MR NG SIOK KWANG ANDREW",
//         "second_vp_name": "MADAM TOH GUAT HWA PAULINE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "CHOA CHU KANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YIO CHU KANG PRIMARY SCHOOL",
//         "url_address": "http://www.yiochukangpri.moe.edu.sg",
//         "address": "1 HOUGANG STREET 51",
//         "postal_code": 538720,
//         "telephone_no": 63851365,
//         "telephone_no_2": "na",
//         "fax_no": 63855915,
//         "fax_no_2": "na",
//         "email_address": "YCKPS@MOE.EDU.SG",
//         "mrt_desc": "Hougang MRT Station; Yio Chu Kang MRT Station",
//         "bus_desc": "88,101,109,159,161 and 325",
//         "principal_name": "MS POH HWEE THING",
//         "first_vp_name": "MADAM RAMACHANDRA SUGUNA",
//         "second_vp_name": "MR TAN TECK MING",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YIO CHU KANG SECONDARY SCHOOL",
//         "url_address": "http://www.yiochukangsec.moe.edu.sg",
//         "address": "3063 ANG MO KIO AVENUE 5",
//         "postal_code": 569868,
//         "telephone_no": 64560669,
//         "telephone_no_2": "na",
//         "fax_no": 65522927,
//         "fax_no_2": "na",
//         "email_address": "YCKSS@MOE.EDU.SG",
//         "mrt_desc": "YIO CHU KANG MRT",
//         "bus_desc": "13, 45, 86, 138, 162, 269, 851, 852, 853",
//         "principal_name": "MADAM BETTY CHANG",
//         "first_vp_name": "MR LIM HOCK CHYE KEVIN",
//         "second_vp_name": "MR PEK XU HAO, ALVIN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "ANG MO KIO",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YISHUN INNOVA JUNIOR COLLEGE",
//         "url_address": "https://yijc.moe.edu.sg/",
//         "address": "3 YISHUN RING ROAD",
//         "postal_code": 768675,
//         "telephone_no": 62579873,
//         "telephone_no_2": "na",
//         "fax_no": 62574373,
//         "fax_no_2": "na",
//         "email_address": "yijc@moe.edu.sg",
//         "mrt_desc": "Yishun, Khatib",
//         "bus_desc": "167, 169, 171, 800, 812",
//         "principal_name": "MR MICHAEL DE SILVA",
//         "first_vp_name": "MRS LEE HUI XIN",
//         "second_vp_name": "MR LOI GUANG YOU",
//         "third_vp_name": "MISS CHOY WEN JU JULIEANNE",
//         "fourth_vp_name": "MR LONG TIEN HO",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "FULL DAY",
//         "mainlevel_code": "JUNIOR COLLEGE",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YISHUN PRIMARY SCHOOL",
//         "url_address": "http://www.yishunpri.moe.edu.sg",
//         "address": "500 YISHUN RING ROAD",
//         "postal_code": 768679,
//         "telephone_no": 62577461,
//         "telephone_no_2": "na",
//         "fax_no": 67554198,
//         "fax_no_2": "na",
//         "email_address": "YPS@MOE.EDU.SG",
//         "mrt_desc": "Yishun",
//         "bus_desc": "Translink Feeder Service 800 & 812",
//         "principal_name": "MR CHAN WENG YEW MARVIN",
//         "first_vp_name": "MADAM FARLINAH SUPAAH",
//         "second_vp_name": "MISS WONG PEI LI, PAMELA",
//         "third_vp_name": "MR LEE HAN KEONG",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YISHUN SECONDARY SCHOOL",
//         "url_address": "http://www.yishunsec.moe.edu.sg",
//         "address": "4 YISHUN STREET 71",
//         "postal_code": 768516,
//         "telephone_no": 68767129,
//         "telephone_no_2": "na",
//         "fax_no": 67557748,
//         "fax_no_2": "na",
//         "email_address": "YISHUN_SS@MOE.EDU.SG",
//         "mrt_desc": "YISHUN MRT, KHATIB MRT",
//         "bus_desc": "167,  169,  171,  800,  807, 811, 812,  856,  858,  859,  860,  969, 980",
//         "principal_name": "MRS REGINA LEE",
//         "first_vp_name": "MRS CHAN WEE MING",
//         "second_vp_name": "MR TAY HIANG SOON",
//         "third_vp_name": "MR JAYAKUMAR S/O NAVARETNAM",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YISHUN TOWN SECONDARY SCHOOL",
//         "url_address": "http://www.yishuntownsec.moe.edu.sg",
//         "address": "6 YISHUN STREET 21",
//         "postal_code": 768610,
//         "telephone_no": 67587219,
//         "telephone_no_2": "na",
//         "fax_no": 67559112,
//         "fax_no_2": "na",
//         "email_address": "YTSS@MOE.EDU.SG",
//         "mrt_desc": "YISHUN MRT",
//         "bus_desc": "39, 85, 171, 800, 803, 804, 806, 811, 812, 851, 852, 853, 853C, 854, 854E, 855, 856, 857, 859, 860",
//         "principal_name": "MR NG TEO HENG",
//         "first_vp_name": "MADAM CH'NG YUEN PING",
//         "second_vp_name": "MR GOH YINGLUN ALLAN",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "YISHUN",
//         "zone_code": "NORTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YU NENG PRIMARY SCHOOL",
//         "url_address": "http://www.ynps.moe.edu.sg/",
//         "address": "56 BEDOK NORTH ST 3",
//         "postal_code": 469623,
//         "telephone_no": 64490121,
//         "telephone_no_2": "na",
//         "fax_no": 64498564,
//         "fax_no_2": "na",
//         "email_address": "YNPS@MOE.EDU.SG",
//         "mrt_desc": "Bedok MRT Station (East-West Line), Bedok Reservoir MRT STation (Downtown line)",
//         "bus_desc": "14, 17, 18, 28, 66, 67, 69, 225",
//         "principal_name": "MR NG YEOW LING",
//         "first_vp_name": "MISS ONG PEI FEN JAMIE",
//         "second_vp_name": "MR EDWIN ONG YOKE YAM",
//         "third_vp_name": "MR SATIISH SATHASILVAM",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BEDOK",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YUAN CHING SECONDARY SCHOOL",
//         "url_address": "https://yuanchingsec.moe.edu.sg/",
//         "address": "103 YUAN CHING ROAD",
//         "postal_code": 618654,
//         "telephone_no": 62612489,
//         "telephone_no_2": "na",
//         "fax_no": 62616275,
//         "fax_no_2": "na",
//         "email_address": "YCSS@MOE.EDU.SG",
//         "mrt_desc": "LAKESIDE MRT",
//         "bus_desc": "49, 98, 98M, 154, 180, 187, 240, 240M, 246",
//         "principal_name": "MR SHAWAL BIN HUSSIN",
//         "first_vp_name": "MR TANG HSIN WEI",
//         "second_vp_name": "MISS TANG SHIEN YIN",
//         "third_vp_name": "MR TEO HUI YAO, JULIUS",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YUHUA PRIMARY SCHOOL",
//         "url_address": "http://www.yuhuapri.moe.edu.sg",
//         "address": "158 JURONG EAST STREET 24",
//         "postal_code": 609558,
//         "telephone_no": 65605062,
//         "telephone_no_2": "na",
//         "fax_no": 65648278,
//         "fax_no_2": "na",
//         "email_address": "YUHUA_PS@MOE.EDU.SG",
//         "mrt_desc": "Jurong East, Bukit Batok",
//         "bus_desc": "98,98A,187,333,502,507,NR5",
//         "principal_name": "MRS RUTH TAI MEI FEN",
//         "first_vp_name": "MADAM ZOEY LIM CHING SIA",
//         "second_vp_name": "na",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG EAST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YUHUA SECONDARY SCHOOL",
//         "url_address": "http://www.yuhuasec.moe.edu.sg",
//         "address": "35 JURONG WEST STREET 41",
//         "postal_code": 649406,
//         "telephone_no": 65661985,
//         "telephone_no_2": "na",
//         "fax_no": 65696689,
//         "fax_no_2": "na",
//         "email_address": "YUHUA_SS@MOE.EDU.SG",
//         "mrt_desc": "LAKESIDE MRT",
//         "bus_desc": "49, 98, 99, 157, 180, 185, 187, 198, 334, 335, 502",
//         "principal_name": "MR PANG CHIN KEAT, KEVIN",
//         "first_vp_name": "MR TAN CHIN GUAN",
//         "second_vp_name": "MISS CHIA KEL- LI",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "JURONG WEST",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YUMIN PRIMARY SCHOOL",
//         "url_address": "http://www.yuminpri.moe.edu.sg",
//         "address": "3 TAMPINES STREET 21",
//         "postal_code": 529393,
//         "telephone_no": 67811262,
//         "telephone_no_2": "na",
//         "fax_no": 67845554,
//         "fax_no_2": "na",
//         "email_address": "YUMIN_PS@MOE.EDU.SG",
//         "mrt_desc": "Tampines MRT Station",
//         "bus_desc": 3,
//         "principal_name": "MRS NG- TEO SOCK HUA",
//         "first_vp_name": "MR ABDUL MUTALIB B MOHAMMED AMIN",
//         "second_vp_name": "MADAM TAN BETTY",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "TAMPINES",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YUSOF ISHAK SECONDARY SCHOOL",
//         "url_address": "http://www.yusofishaksec.moe.edu.sg",
//         "address": "8 SUMANG WALK",
//         "postal_code": 828676,
//         "telephone_no": 65009800,
//         "telephone_no_2": "na",
//         "fax_no": 65675502,
//         "fax_no_2": "na",
//         "email_address": "YISS@MOE.EDU.SG",
//         "mrt_desc": "PUNGGOL MRT",
//         "bus_desc": "117, 382W, 43",
//         "principal_name": "MR CHEN ZIYANG",
//         "first_vp_name": "MISS LOH SEIN LING",
//         "second_vp_name": "MR CHEONG TIEN BENG",
//         "third_vp_name": "LIN ZHEN JIANG, TEDDY",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "PUNGGOL",
//         "zone_code": "EAST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "YUYING SECONDARY SCHOOL",
//         "url_address": "http://www.yuyingsec.moe.edu.sg",
//         "address": "47 HOUGANG AVENUE 1",
//         "postal_code": 538884,
//         "telephone_no": 62827968,
//         "telephone_no_2": "na",
//         "fax_no": 62871607,
//         "fax_no_2": "na",
//         "email_address": "YUYING_SS@MOE.EDU.SG",
//         "mrt_desc": "KOVAN MRT, SERANGOON MRT, HOUGANG MRT",
//         "bus_desc": "25, 51, 53, 53M, 55, 62, 87, 113, 119, 151, 854",
//         "principal_name": "MR CHONG JACK SHENG",
//         "first_vp_name": "MR CHAN IVIN",
//         "second_vp_name": "MR CHEONG KAH KAY GABRIEL",
//         "third_vp_name": "MADAM TAN HUI LING",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "HOUGANG",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT-AIDED SCH",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ZHANGDE PRIMARY SCHOOL",
//         "url_address": "http://www.zhangdepri.moe.edu.sg/",
//         "address": "51 Jalan Membina",
//         "postal_code": 169485,
//         "telephone_no": 62740357,
//         "telephone_no_2": "na",
//         "fax_no": 62763042,
//         "fax_no_2": "na",
//         "email_address": "ZHANGDE_PS@MOE.EDU.SG",
//         "mrt_desc": "Tiong Bahru MRT Station",
//         "bus_desc": "16,33,63,123,195,605,851,14,65,147,167,196,197,961",
//         "principal_name": "MADAM RITA RAJ LAL",
//         "first_vp_name": "MRS LIM PEGGY",
//         "second_vp_name": "MR CHAN CHEONG CHEONG",
//         "third_vp_name": "MADAM WOO LI SAN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT MERAH",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ZHENGHUA PRIMARY SCHOOL",
//         "url_address": "http://www.zhenghuapri.moe.edu.sg",
//         "address": "9 Fajar Road",
//         "postal_code": 679002,
//         "telephone_no": 67697478,
//         "telephone_no_2": "na",
//         "fax_no": 67636459,
//         "fax_no_2": "na",
//         "email_address": "ZHENGHUA_PS@MOE.EDU.SG",
//         "mrt_desc": "LRT: Fajar Station",
//         "bus_desc": "190, 184, 187, 700, 700A, 921",
//         "principal_name": "MADAM WONG HIAN HWEE CONSTANCE",
//         "first_vp_name": "MR YANG PECK CHIONG TOMMY",
//         "second_vp_name": "MISS SANTHANA MARY D/O POOBALAN",
//         "third_vp_name": "MADAM SNG YEE YEE",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ZHENGHUA SECONDARY SCHOOL",
//         "url_address": "http://www.zhenghuasec.moe.edu.sg",
//         "address": "62 Bukit Panjang Ring Road",
//         "postal_code": 679962,
//         "telephone_no": 67639455,
//         "telephone_no_2": "na",
//         "fax_no": 67633577,
//         "fax_no_2": "na",
//         "email_address": "ZHENGHUA_SS@MOE.EDU.SG",
//         "mrt_desc": "JELAPANG LRT",
//         "bus_desc": "920, 922, 976",
//         "principal_name": "MR NG HOCK SOON",
//         "first_vp_name": "MADAM TAN PEI LEE ELAINE",
//         "second_vp_name": "MR SAMUEL LIM KOK BOON",
//         "third_vp_name": "MISS HE AIFEN",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "BUKIT PANJANG",
//         "zone_code": "WEST",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ZHONGHUA PRIMARY SCHOOL",
//         "url_address": "http://www.zhonghuapri.moe.edu.sg",
//         "address": "12 SERANGOON AVENUE 4",
//         "postal_code": 556095,
//         "telephone_no": 62835413,
//         "telephone_no_2": "na",
//         "fax_no": 62823882,
//         "fax_no_2": "na",
//         "email_address": "ZHONGHUA_PS@MOE.EDU.SG",
//         "mrt_desc": "Ang Mo Kio MRT, Bishan MRT, Serangoon MRT",
//         "bus_desc": "Boundary Road: 22,24,53,105,156,315,853,501,502; Yio Chu Kang Road: 70,76,103,147,156,501,502",
//         "principal_name": "MRS CHAN LE CHIN",
//         "first_vp_name": "MADAM THAM SIEW LENG MRS TAN SIEW LENG",
//         "second_vp_name": "MRS TRINA POOK SIM NAR",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "PRIMARY",
//         "sap_ind": "No",
//         "autonomous_ind": "No",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "TAMIL"
//     },
//     {
//         "school_name": "ZHONGHUA SECONDARY SCHOOL",
//         "url_address": "https://www.zhonghuasec.moe.edu.sg",
//         "address": "13 SERANGOON AVENUE 3",
//         "postal_code": 556123,
//         "telephone_no": 62824339,
//         "telephone_no_2": "na",
//         "fax_no": 62823472,
//         "fax_no_2": "na",
//         "email_address": "ZHONGHUA_SS@MOE.EDU.SG",
//         "mrt_desc": "SERANGOON MRT",
//         "bus_desc": "22, 43, 45, 53, 58, 70, 81, 82, 100, 101, 103, 105, 107, 109, 133, 135, 147, 153, 158, 315, 317, 853",
//         "principal_name": "MR TAN KIM KOON",
//         "first_vp_name": "MR SHAHUL HAMEED S/O KUTHUBUDEEN",
//         "second_vp_name": "MS TEO CELINE",
//         "third_vp_name": "na",
//         "fourth_vp_name": "na",
//         "fifth_vp_name": "na",
//         "sixth_vp_name": "na",
//         "dgp_code": "SERANGOON",
//         "zone_code": "SOUTH",
//         "type_code": "GOVERNMENT SCHOOL",
//         "nature_code": "CO-ED SCHOOL",
//         "session_code": "SINGLE SESSION",
//         "mainlevel_code": "SECONDARY (S1-S5)",
//         "sap_ind": "No",
//         "autonomous_ind": "Yes",
//         "gifted_ind": "No",
//         "ip_ind": "No",
//         "mothertongue1_code": "CHINESE",
//         "mothertongue2_code": "MALAY",
//         "mothertongue3_code": "na"
//     }
// ]




export const SCHOOLS_WITH_COORDINATES = [
    {
        "school_name": "ADMIRALTY PRIMARY SCHOOL",
        "url_address": "https://admiraltypri.moe.edu.sg/",
        "address": "11 WOODLANDS CIRCLE",
        "postal_code": 738907,
        "telephone_no": 63620598,
        "telephone_no_2": "na",
        "fax_no": 63627512,
        "fax_no_2": "na",
        "email_address": "ADMIRALTY_PS@MOE.EDU.SG",
        "mrt_desc": "Admiralty Station",
        "bus_desc": "TIBS 965, 964, 913",
        "principal_name": "MR CHEN ZHONGYI",
        "first_vp_name": "MADAM CHUA MUI LING",
        "second_vp_name": "MR HAMRI BIN A JALIL",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4430452,
        "lng": 103.8003087
    },
    {
        "school_name": "ADMIRALTY SECONDARY SCHOOL",
        "url_address": "http://www.admiraltysec.moe.edu.sg",
        "address": "31 WOODLANDS CRESCENT",
        "postal_code": 737916,
        "telephone_no": 63651733,
        "telephone_no_2": 63654596,
        "fax_no": 63652774,
        "fax_no_2": "na",
        "email_address": "Admiralty_SS@moe.edu.sg",
        "mrt_desc": "ADMIRALTY MRT",
        "bus_desc": 904,
        "principal_name": "MR TAN KELLY",
        "first_vp_name": "MR CHAN YEW REN EUGENE",
        "second_vp_name": "MR TAN HOCK CHUAN MICHAEL",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4462673,
        "lng": 103.8026082
    },
    {
        "school_name": "AHMAD IBRAHIM PRIMARY SCHOOL",
        "url_address": "http://www.ahmadibrahimpri.moe.edu.sg",
        "address": "10 YISHUN STREET 11",
        "postal_code": 768643,
        "telephone_no": 67592906,
        "telephone_no_2": "na",
        "fax_no": 67592927,
        "fax_no_2": "na",
        "email_address": "AIPS@MOE.EDU.SG",
        "mrt_desc": "Yishun",
        "bus_desc": "Yishun Ring Road - 812 (white plate); Yishun Ave 2 - 169, 804, 965, 117, 883",
        "principal_name": "MS BAEY EE-LYN",
        "first_vp_name": "MADAM YEO SIAU YEN",
        "second_vp_name": "MADAM ZHANG JUNLI",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4337349,
        "lng": 103.8327825
    },
    {
        "school_name": "AHMAD IBRAHIM SECONDARY SCHOOL",
        "url_address": "http://www.ahmadibrahimsec.moe.edu.sg",
        "address": "751 YISHUN AVENUE 7",
        "postal_code": 768928,
        "telephone_no": 67585384,
        "telephone_no_2": "na",
        "fax_no": 67557778,
        "fax_no_2": "na",
        "email_address": "AISS@MOE.EDU.SG",
        "mrt_desc": "CANBERRA MRT, YISHUN MRT",
        "bus_desc": "117, 167, 169, 800, 811, 812, 883, 856, 858, 859, 965, 969, 980",
        "principal_name": "MR GOH SOON HOE",
        "first_vp_name": "MISS LEA SHU HUI",
        "second_vp_name": "MR QUEK CHOON HSIONG",
        "third_vp_name": "MISS LATIFAH BTE ABDUL LATIFF",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4364306,
        "lng": 103.8299804
    },
    {
        "school_name": "AI TONG SCHOOL",
        "url_address": "http://www.aitong.moe.edu.sg",
        "address": "100 Bright Hill Drive",
        "postal_code": 579646,
        "telephone_no": 64547672,
        "telephone_no_2": "na",
        "fax_no": 64532726,
        "fax_no_2": "na",
        "email_address": "AITONG_SCH@MOE.EDU.SG",
        "mrt_desc": "Bishan MRT",
        "bus_desc": "410, 162, 52",
        "principal_name": "MR WONG JIA WANG",
        "first_vp_name": "MR YAK BENG WEI",
        "second_vp_name": "MR CHIU SHEK MAN PHILIP",
        "third_vp_name": "MR KHOO THIAM HUAT",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BISHAN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3603066,
        "lng": 103.8327064
    },
    {
        "school_name": "ALEXANDRA PRIMARY SCHOOL",
        "url_address": "http://alexandrapri.moe.edu.sg",
        "address": "2A Prince Charles Crescent",
        "postal_code": 159016,
        "telephone_no": 62485400,
        "telephone_no_2": "na",
        "fax_no": 62485409,
        "fax_no_2": "na",
        "email_address": "alexandra_ps@moe.edu.sg",
        "mrt_desc": "Redhill Station; Tiong Bahru Station",
        "bus_desc": "51, 122, 139, 186, 970.",
        "principal_name": "MADAM TEO CHING LING",
        "first_vp_name": "MADAM RAPS AZRINAH",
        "second_vp_name": "MR LOH KAH HONG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2912575,
        "lng": 103.8237619
    },
    {
        "school_name": "ANCHOR GREEN PRIMARY SCHOOL",
        "url_address": "http://www.anchorgreenpri.moe.edu.sg",
        "address": "31 Anchorvale Drive",
        "postal_code": 544969,
        "telephone_no": 68861356,
        "telephone_no_2": "na",
        "fax_no": 63159825,
        "fax_no_2": "na",
        "email_address": "anchorgreen_ps@moe.edu.sg",
        "mrt_desc": "MRT : NE16-Sengkang; LRT : SW7-TongKang",
        "bus_desc": "Bus 372, 110, 50",
        "principal_name": "MR CHEONG LIT SERN WESLEY",
        "first_vp_name": "MDM MUMTAAS BINTE MOHAMED KASSIM",
        "second_vp_name": "MADAM NEO LAY PIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3908643,
        "lng": 103.8871175
    },
    {
        "school_name": "ANDERSON PRIMARY SCHOOL",
        "url_address": "http://www.andersonpri.moe.edu.sg",
        "address": "19 ANG MO KIO AVE 9",
        "postal_code": 569785,
        "telephone_no": 64560340,
        "telephone_no_2": "na",
        "fax_no": 65522310,
        "fax_no_2": "na",
        "email_address": "ANDERSON_PS@MOE.EDU.SG",
        "mrt_desc": "Yio Chu Kang MRT Station (NS 15); Lentor MRT Station (TE5)",
        "bus_desc": "Ang Mo Kio Ave 9 - Bus 76, 265, 268",
        "principal_name": "MS SHIRLEY LEOW",
        "first_vp_name": "MR BOH CHEK KEOW",
        "second_vp_name": "MADAM TAN AI CHOO",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3840518,
        "lng": 103.8413617
    },
    {
        "school_name": "ANDERSON SECONDARY SCHOOL",
        "url_address": "http://www.andersonsec.moe.edu.sg",
        "address": "10 ANG MO KIO STREET 53",
        "postal_code": 569206,
        "telephone_no": 64598303,
        "telephone_no_2": "na",
        "fax_no": 64586104,
        "fax_no_2": "na",
        "email_address": "ANDERSON_SS@MOE.EDU.SG",
        "mrt_desc": "ANG MO KIO MRT, YIO CHU KANG MRT",
        "bus_desc": "265, 45, 50, 72, 159",
        "principal_name": "MISS TAN PO CHIN",
        "first_vp_name": "MR JONAH LIM TUCK HWAY (LIN DAHUI)",
        "second_vp_name": "MR LEE CHUN YANG EUGENE",
        "third_vp_name": "MR SHAHREEN BIN AMAN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3751207,
        "lng": 103.8515701
    },
    {
        "school_name": "ANDERSON SERANGOON JUNIOR COLLEGE",
        "url_address": "www.asrjc.moe.edu.sg",
        "address": "1033 Upper Serangoon Road",
        "postal_code": 534768,
        "telephone_no": 64596822,
        "telephone_no_2": "na",
        "fax_no": 64598734,
        "fax_no_2": "na",
        "email_address": "asrjc@moe.edu.sg",
        "mrt_desc": "Kovan MRT Station",
        "bus_desc": "25, 55, 62, 80, 81, 82, 101, 107, 107M, 112, 113, 115, 119, 132, 136, 153, 325, 854",
        "principal_name": "MR HENG YEW SENG",
        "first_vp_name": "MR GURUSHARAN SINGH S/O M SINGH",
        "second_vp_name": "MADAM TEY LI SHUN",
        "third_vp_name": "MR MOHAMAD AMRAN SHAH BIN ABDUL RAHIM",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3650925,
        "lng": 103.8878158
    },
    {
        "school_name": "ANG MO KIO PRIMARY SCHOOL",
        "url_address": "http://www.angmokiopri.moe.edu.sg",
        "address": "20 ANG MO KIO AVENUE 3",
        "postal_code": 569920,
        "telephone_no": 64520794,
        "telephone_no_2": "na",
        "fax_no": 64588121,
        "fax_no_2": "na",
        "email_address": "AMKPS@MOE.EDU.SG",
        "mrt_desc": "Ang Mo Kio MRT Station; Mayflower MRT Station",
        "bus_desc": "76, 132, 165, 166, 169, 265, 268, 269",
        "principal_name": "MR MUHAMMAD FARIZAL BIN UMAR EFFE",
        "first_vp_name": "MADAM TAN SIEW KHIM (CHEN XIUQIN)",
        "second_vp_name": "MISS CHEN YANTING NATHALIE",
        "third_vp_name": "MADAM LIEW KAH CHANG ALETHEA",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3693482,
        "lng": 103.8398126
    },
    {
        "school_name": "ANG MO KIO SECONDARY SCHOOL",
        "url_address": "http://www.angmokiosec.moe.edu.sg",
        "address": "6 ANG MO KIO STREET 22",
        "postal_code": 569362,
        "telephone_no": 64548605,
        "telephone_no_2": "na",
        "fax_no": 64582425,
        "fax_no_2": "na",
        "email_address": "AMKSS@MOE.EDU.SG",
        "mrt_desc": "ANG MO KIO MRT",
        "bus_desc": "13, 74, 76, 88, 130, 132, 133, 136, 165, 169, 265, 268, 269, 851, 852",
        "principal_name": "MR ASHRAF HYDER YUSOFF MANIAM",
        "first_vp_name": "MR CHAN WENG ONN MARTIN",
        "second_vp_name": "MADAM LEE KEE CHIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3672319,
        "lng": 103.8426326
    },
    {
        "school_name": "ANGLICAN HIGH SCHOOL",
        "url_address": "http://www.anglicanhigh.moe.edu.sg",
        "address": "600 UPPER CHANGI ROAD",
        "postal_code": 487012,
        "telephone_no": 62414866,
        "telephone_no_2": "na",
        "fax_no": 64414690,
        "fax_no_2": "na",
        "email_address": "AHS@MOE.EDU.SG",
        "mrt_desc": "TANAH MERAH MRT",
        "bus_desc": "2, 9, 12, 14, 24, 31, 35, 38, 45, 46, 47, 48, 222",
        "principal_name": "MR LIM HOCK CHUAN ALVIN",
        "first_vp_name": "MR CHIN LIH KEONG",
        "second_vp_name": "MISS WONG HSIEN HUI",
        "third_vp_name": "MR SEAH THIAM SIONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "Yes",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3303585,
        "lng": 103.9423495
    },
    {
        "school_name": "ANGLO-CHINESE JUNIOR COLLEGE",
        "url_address": "https://acjc.moe.edu.sg",
        "address": "25 DOVER CLOSE EAST",
        "postal_code": 139745,
        "telephone_no": 67750511,
        "telephone_no_2": "na",
        "fax_no": 67775479,
        "fax_no_2": "na",
        "email_address": "ACJC@MOE.EDU.SG",
        "mrt_desc": "Buona Vista",
        "bus_desc": "74,95,100,105,106,111,145,147,191,196,198,602",
        "principal_name": "DR. CHEE YAN HOON SHIRLEEN",
        "first_vp_name": "MR ANG YUAN PENG",
        "second_vp_name": "MISS AUDREY LIM",
        "third_vp_name": "MS QUEK SI MIN",
        "fourth_vp_name": "MADAM LIM SING THOE",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "QUEENSTOWN",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3031354,
        "lng": 103.785109
    },
    {
        "school_name": "ANGLO-CHINESE SCHOOL (BARKER ROAD)",
        "url_address": "http://www.acsbr.moe.edu.sg",
        "address": "60 BARKER ROAD",
        "postal_code": 309919,
        "telephone_no": 62561633,
        "telephone_no_2": "na",
        "fax_no": 62561366,
        "fax_no_2": "na",
        "email_address": "ACBRS@MOE.EDU.SG",
        "mrt_desc": "NEWTON MRT, STEVENS MRT",
        "bus_desc": "48, 66, 67, 170, 960, 972",
        "principal_name": "MR KHOO TSE HORNG",
        "first_vp_name": "MR TAN WHYE WEE JEFFREY",
        "second_vp_name": "MR CHEN HONG MING",
        "third_vp_name": "MADAM MARIE LOH MEI LING",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "NOVENA",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3187104,
        "lng": 103.834291
    },
    {
        "school_name": "ANGLO-CHINESE SCHOOL (INDEPENDENT)",
        "url_address": "http://www.acsindep.moe.edu.sg",
        "address": "121 DOVER ROAD",
        "postal_code": 139650,
        "telephone_no": 67731633,
        "telephone_no_2": "na",
        "fax_no": 67731433,
        "fax_no_2": "na",
        "email_address": "ACIS@MOE.EDU.SG",
        "mrt_desc": "DOVER MRT, BUONA VISTA MRT, ONE-NORTH MRT",
        "bus_desc": "33, 74, 166, 196",
        "principal_name": "MR KOH SUNG- YI ARENE",
        "first_vp_name": "MR CHIEW TECK TZER TERENCE",
        "second_vp_name": "MR SOO MUN KEONG PATRICK",
        "third_vp_name": "MRS TEO LAI CHENG JUDY-HO",
        "fourth_vp_name": "DR YONG YUN LEONG ANDREW",
        "fifth_vp_name": "MS ALICE TAN SHIH SHIN",
        "sixth_vp_name": "na",
        "dgp_code": "QUEENSTOWN",
        "zone_code": "SOUTH",
        "type_code": "INDEPENDENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3025841,
        "lng": 103.7807147
    },
    {
        "school_name": "ANGLO-CHINESE SCHOOL (JUNIOR)",
        "url_address": "www.acsj.moe.edu.sg",
        "address": "16 WINSTEDT ROAD",
        "postal_code": 227988,
        "telephone_no": 67337911,
        "telephone_no_2": 67337912,
        "fax_no": 67346518,
        "fax_no_2": "na",
        "email_address": "ACJS@MOE.EDU.SG",
        "mrt_desc": "Newton MRT Station",
        "bus_desc": "5, 54, 124, 143, 162, 162M, 167, 167e, 518, 518A, 972M",
        "principal_name": "MISS CHEE CHUERN HWEI CHERYL",
        "first_vp_name": "MADAM ANG CHAI TING",
        "second_vp_name": "MR GOH SHEOW EN",
        "third_vp_name": "MR AARON CHUA BEE HOCK",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CENTRAL",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3090345,
        "lng": 103.8416385
    },
    {
        "school_name": "ANGLO-CHINESE SCHOOL (PRIMARY)",
        "url_address": "http://www.acspri.moe.edu.sg/",
        "address": "50 BARKER ROAD",
        "postal_code": 309918,
        "telephone_no": 62501633,
        "telephone_no_2": "na",
        "fax_no": 63531366,
        "fax_no_2": "na",
        "email_address": "ACPS@MOE.EDU.SG",
        "mrt_desc": "Newton MRT Station",
        "bus_desc": "Bus 48, 66, 67, 170, 960, 972M",
        "principal_name": "MRS LEONG-HO HIL MAY",
        "first_vp_name": "MR CHUA THIAN KEONG",
        "second_vp_name": "MADAM TEH HSIAO CHUIN",
        "third_vp_name": "MADAM SEOW LAY YEN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "NOVENA",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3187555,
        "lng": 103.8358322
    },
    {
        "school_name": "ANGSANA PRIMARY SCHOOL",
        "url_address": "https://angsanapri.moe.edu.sg/",
        "address": "51 Tampines Street 61",
        "postal_code": 528565,
        "telephone_no": 67830427,
        "telephone_no_2": "na",
        "fax_no": 67845293,
        "fax_no_2": "na",
        "email_address": "angsana_pri@moe.edu.sg",
        "mrt_desc": "Tampines",
        "bus_desc": "Bus Service 68, 68A",
        "principal_name": "MR WONG WOEN LONG",
        "first_vp_name": "MADAM SULASNI BINTE ABDUL RAHMAN",
        "second_vp_name": "MADAM LEE HUAY MENG CAROL",
        "third_vp_name": "MR KONG CHEE CHIEW",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3632271,
        "lng": 103.9392867
    },
    {
        "school_name": "ASSUMPTION ENGLISH SCHOOL",
        "url_address": "http://www.assumptionenglish.moe.edu.sg",
        "address": "622 UPPER BUKIT TIMAH ROAD",
        "postal_code": 678117,
        "telephone_no": 65729100,
        "telephone_no_2": "na",
        "fax_no": 67636560,
        "fax_no_2": "na",
        "email_address": "AES@MOE.EDU.SG",
        "mrt_desc": "CASHEW MRT",
        "bus_desc": "67, 75, 170, 176, 178, 184, 961, 963, 970",
        "principal_name": "MR TOH KIM YONG VINCENT",
        "first_vp_name": "MR TAN WEIMING BRIAN",
        "second_vp_name": "MISS WONG KER SIN",
        "third_vp_name": "MR QUEK SER HIANG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3684449,
        "lng": 103.7664767
    },
    {
        "school_name": "ASSUMPTION PATHWAY SCHOOL",
        "url_address": "http://www.aps.edu.sg",
        "address": "30 Cashew Road",
        "postal_code": 679697,
        "telephone_no": 62793000,
        "telephone_no_2": "na",
        "fax_no": 67622857,
        "fax_no_2": "na",
        "email_address": "aps@schools.gov.sg",
        "mrt_desc": "DOWNTOWN LINE 2, CASHEW MRT",
        "bus_desc": "SBS Transit No 170; SMRT No 67, 75, 171, 176, 178, 184, 961, 963 & 970",
        "principal_name": "MR STEPHEN CHIN",
        "first_vp_name": "MADAM SHABNAM LENA",
        "second_vp_name": "DR WEE SIEW FONG",
        "third_vp_name": "MRS TANG HUAY JIUAN NEE CHONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "SPECIALISED SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3705844,
        "lng": 103.7663395
    },
    {
        "school_name": "BARTLEY SECONDARY SCHOOL",
        "url_address": "http://www.bartleysec.moe.edu.sg",
        "address": "10 JALAN BUNGA RAMPAI",
        "postal_code": 538403,
        "telephone_no": 62889013,
        "telephone_no_2": "na",
        "fax_no": 62805595,
        "fax_no_2": "na",
        "email_address": "BARTLEY_SS@MOE.EDU.SG",
        "mrt_desc": "BARTLEY MRT, TAI SENG MRT",
        "bus_desc": "22, 24, 28, 43, 58, 62, 70, 70M, 76, 80, 80A, 93, 158",
        "principal_name": "MISS SEET YING LING BRITTA",
        "first_vp_name": "MR NG CHOR YAM",
        "second_vp_name": "MR TING POH LEONG ALOYSIUS",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3402886,
        "lng": 103.8828396
    },
    {
        "school_name": "BEACON PRIMARY SCHOOL",
        "url_address": "https://beaconpri.moe.edu.sg/",
        "address": "36 Bukit Panjang Ring Road",
        "postal_code": 679944,
        "telephone_no": 67697255,
        "telephone_no_2": "na",
        "fax_no": 67697244,
        "fax_no_2": "na",
        "email_address": "beaconprisch@moe.edu.sg",
        "mrt_desc": "Bangkit LRT, Fajar LRT Station, Bukit Panjang MRT",
        "bus_desc": "920, 922, 971, 972, 972A, 972M, 976",
        "principal_name": "MISS PANG WEE MIAN",
        "first_vp_name": "MADAM LELA BTE SHAMSUHADI",
        "second_vp_name": "MISS MELISSA CHANG SUET MUN",
        "third_vp_name": "MR CHEN WEI NGIAP",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3839141,
        "lng": 103.7736916
    },
    {
        "school_name": "BEATTY SECONDARY SCHOOL",
        "url_address": "http://www.beattysec.moe.edu.sg",
        "address": "1 TOA PAYOH NORTH",
        "postal_code": 318990,
        "telephone_no": 62569108,
        "telephone_no_2": "na",
        "fax_no": 62542284,
        "fax_no_2": "na",
        "email_address": "BEATTY_SS@MOE.EDU.SG",
        "mrt_desc": "BRADDELL MRT, TOA PAYOH MRT",
        "bus_desc": "13, 28, 56, 57, 59, 73, 88, 93, 105, 129, 153, 155, 157, 159, 163, 231, 232",
        "principal_name": "MR HARMAN AUGUSTUS JOHLL",
        "first_vp_name": "MR YEO KOK SAN WILLIAM",
        "second_vp_name": "MADAM LIM SOK NGIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3416799,
        "lng": 103.8518807
    },
    {
        "school_name": "BEDOK GREEN PRIMARY SCHOOL",
        "url_address": "http://www.bedokgreenpri.moe.edu.sg",
        "address": "1 BEDOK SOUTH AVE 2",
        "postal_code": 469317,
        "telephone_no": 64425416,
        "telephone_no_2": "na",
        "fax_no": 64491491,
        "fax_no_2": "na",
        "email_address": "bgps@moe.edu.sg",
        "mrt_desc": "Bedok MRT Station, Tanah Merah MRT Station",
        "bus_desc": "Bus No. 2, 9, 12, 24, 31, 34 & 38",
        "principal_name": "MR YONG YIK YEN BENJAMIN",
        "first_vp_name": "MR YEO SHO HOR",
        "second_vp_name": "CHUA KOK SENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3242773,
        "lng": 103.9375185
    },
    {
        "school_name": "BEDOK GREEN SECONDARY SCHOOL",
        "url_address": "http://www.bedokgreensec.moe.edu.sg",
        "address": "360 BEDOK NORTH AVE 3",
        "postal_code": 469722,
        "telephone_no": 64463301,
        "telephone_no_2": "na",
        "fax_no": 64465969,
        "fax_no_2": "na",
        "email_address": "BGSS@MOE.EDU.SG",
        "mrt_desc": "BEDOK MRT, BEDOK RESERVOIR MRT",
        "bus_desc": "14, 17, 18, 28, 46, 66, 67, 69, 168, 222, 228, 506",
        "principal_name": "MR SHAW SWEE TAT",
        "first_vp_name": "MISS SAKINAH BINTE MOHAMED SARIP",
        "second_vp_name": "MR CHEONG HUEI LEONARD",
        "third_vp_name": "MR LEE CHEE CHONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3341416,
        "lng": 103.935336
    },
    {
        "school_name": "BEDOK SOUTH SECONDARY SCHOOL",
        "url_address": "https://bedoksouthsec.moe.edu.sg/",
        "address": "1 JALAN LANGGAR BEDOK",
        "postal_code": 468585,
        "telephone_no": 64414479,
        "telephone_no_2": "na",
        "fax_no": 64491314,
        "fax_no_2": "na",
        "email_address": "BSSS@MOE.EDU.SG",
        "mrt_desc": "TANAH MERAH MRT",
        "bus_desc": "10, 14, 45",
        "principal_name": "MR KOH YONG HWEE DARYL (XU RONGHUI)",
        "first_vp_name": "MISS AZLINDA BTE SAMSUDIN",
        "second_vp_name": "MR CHEN JINGYUAN ALVIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.325871,
        "lng": 103.9508335
    },
    {
        "school_name": "BEDOK VIEW SECONDARY SCHOOL",
        "url_address": "http://www.bedokviewsec.moe.edu.sg",
        "address": "6 BEDOK SOUTH AVENUE 3",
        "postal_code": 469293,
        "telephone_no": 64430563,
        "telephone_no_2": "na",
        "fax_no": 64494286,
        "fax_no_2": "na",
        "email_address": "BEDOKVIEW_SS@MOE.EDU.SG",
        "mrt_desc": "TANAH MERAH MRT",
        "bus_desc": "2, 9, 12, 14, 24, 25, 31, 35, 38, 45, 46, 47, 48",
        "principal_name": "MADAM CHENG HWEE YEANG",
        "first_vp_name": "MR TYEBALLY AZIZ",
        "second_vp_name": "MR NEO WEI CHUNG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3246274,
        "lng": 103.9438629
    },
    {
        "school_name": "BENDEMEER PRIMARY SCHOOL",
        "url_address": "http://www.bendemeerpri.moe.edu.sg/",
        "address": "91 BENDEMEER ROAD",
        "postal_code": 339948,
        "telephone_no": 62982911,
        "telephone_no_2": "na",
        "fax_no": 62995735,
        "fax_no_2": "na",
        "email_address": "BENDEMEER_PS@MOE.EDU.SG",
        "mrt_desc": "Boon Keng, Kallang",
        "bus_desc": "13 23 31 61 64 65 65M 66 125, 125X ,133,140,147,853,857,985",
        "principal_name": "MADAM LIM KIM GEK",
        "first_vp_name": "MRS LINDA TAN",
        "second_vp_name": "MR TOH KIM SING (ZHUO JINSHENG)",
        "third_vp_name": "MR TOO MENG NGEE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "KALLANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.322193,
        "lng": 103.8650825
    },
    {
        "school_name": "BENDEMEER SECONDARY SCHOOL",
        "url_address": "http://www.bendemeersec.moe.edu.sg",
        "address": "1 ST WILFRED ROAD",
        "postal_code": 327919,
        "telephone_no": 62927616,
        "telephone_no_2": "na",
        "fax_no": 62932594,
        "fax_no_2": "na",
        "email_address": "BENDEMEER_SS@MOE.EDU.SG",
        "mrt_desc": "BOON KENG MRT",
        "bus_desc": "13,  23,  31,  64,  65,  66, 125, 133, 140, 147, 857, 985",
        "principal_name": "MS FOO SHEUE FENG",
        "first_vp_name": "MR HO CHI CHENG",
        "second_vp_name": "MR MOHD AZMAN B MOHD SIDEK",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "KALLANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3245163,
        "lng": 103.8605913
    },
    {
        "school_name": "BLANGAH RISE PRIMARY SCHOOL",
        "url_address": "http://www.blangahrisepri.moe.edu.sg/",
        "address": "91 TELOK BLANGAH HEIGHTS",
        "postal_code": 109100,
        "telephone_no": 62717387,
        "telephone_no_2": "na",
        "fax_no": 62763037,
        "fax_no_2": "na",
        "email_address": "BRPS@MOE.EDU.SG",
        "mrt_desc": "Telok Blangah, Tiong Bahru & Redhill",
        "bus_desc": "SBS 273 & 124",
        "principal_name": "MISS NG POR JOO PEARLY",
        "first_vp_name": "MISS NARAYANASAMY UMA RANI",
        "second_vp_name": "MR CHIONH BOON SOO",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2761562,
        "lng": 103.8086762
    },
    {
        "school_name": "BOON LAY GARDEN PRIMARY SCHOOL",
        "url_address": "www.boonlaygardenpri.moe.edu.sg",
        "address": "20 BOON LAY DRIVE",
        "postal_code": 649930,
        "telephone_no": 63160998,
        "telephone_no_2": "na",
        "fax_no": 63160209,
        "fax_no_2": "na",
        "email_address": "BLGPS@MOE.EDU.SG",
        "mrt_desc": "Lakeside & Boon Lay",
        "bus_desc": "30,99,154,178,180,187,240,246",
        "principal_name": "MADAM CHRISTINE LIM MIN HUI",
        "first_vp_name": "MADAM NG BOON IN",
        "second_vp_name": "MRS AVINASH MURUGESUVARI",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3433969,
        "lng": 103.7131343
    },
    {
        "school_name": "BOON LAY SECONDARY SCHOOL",
        "url_address": "https://www.boonlaysec.moe.edu.sg",
        "address": "11 JURONG WEST STREET 65",
        "postal_code": 648354,
        "telephone_no": 67940161,
        "telephone_no_2": "na",
        "fax_no": 67941324,
        "fax_no_2": "na",
        "email_address": "BLSS@MOE.EDU.SG",
        "mrt_desc": "Boon Lay",
        "bus_desc": "30, 79, 99, 154, 157, 172, 174, 178, 179, 180, 181, 181M, 187, 192, 193, 194, 198, 199, 240, 241, 242, 243G/W, 246, 249, 251, 252, 258, 405, 502, 974",
        "principal_name": "MR CHAN ZHENG MING",
        "first_vp_name": "MR KOH CHON KIAT",
        "second_vp_name": "MR TAN HWEE SIANG",
        "third_vp_name": "",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.343319,
        "lng": 103.7019012
    },
    {
        "school_name": "BOWEN SECONDARY SCHOOL",
        "url_address": "http://www.bowensec.moe.edu.sg",
        "address": "2 LORONG NAPIRI",
        "postal_code": 547529,
        "telephone_no": 63859466,
        "telephone_no_2": "na",
        "fax_no": 63856559,
        "fax_no_2": "na",
        "email_address": "BOWEN_SS@MOE.EDU.SG",
        "mrt_desc": "HOUGANG MRT, SERANGOON MRT, SENGKANG MRT",
        "bus_desc": "43, 70, 73, 103, 109, 156, 854, 25, 74, 74E, 76, 112, 132, 147, 165, 55",
        "principal_name": "MR LOH CHIH HUI",
        "first_vp_name": "MR CHEN ZHAOKAI BENJAMIN",
        "second_vp_name": "MR GOH KEE YONG @ GOH CHONG HENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3706875,
        "lng": 103.877572
    },
    {
        "school_name": "BROADRICK SECONDARY SCHOOL",
        "url_address": "http://www.broadricksec.moe.edu.sg",
        "address": "61 DAKOTA CRESCENT",
        "postal_code": 399935,
        "telephone_no": 63445025,
        "telephone_no_2": "na",
        "fax_no": 64471427,
        "fax_no_2": "na",
        "email_address": "BROADRICK_SS@MOE.EDU.SG",
        "mrt_desc": "DAKOTA MRT",
        "bus_desc": "10, 16, 30, 31, 32, 33",
        "principal_name": "MR NG TIONG NAM",
        "first_vp_name": "MR BAMBANG PURNAMA PUTRA SHAKNI",
        "second_vp_name": "MS NG FOONG MENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "GEYLANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3072755,
        "lng": 103.8872129
    },
    {
        "school_name": "BUKIT BATOK SECONDARY SCHOOL",
        "url_address": "http://www.bukitbatoksec.moe.edu.sg",
        "address": "50 BUKIT BATOK WEST AVE 8",
        "postal_code": 658962,
        "telephone_no": 63799413,
        "telephone_no_2": "na",
        "fax_no": 65607006,
        "fax_no_2": "na",
        "email_address": "BBSS@MOE.EDU.SG",
        "mrt_desc": "BUKIT BATOK MRT",
        "bus_desc": "66, 66C, 157, 174, 174E, 178, 506, 941, 991",
        "principal_name": "MISS WONG KAH WAI SHIRLEY",
        "first_vp_name": "MR CHENG POH HUAT, ALAN",
        "second_vp_name": "MADAM CHIA BEE KHIM MABEL",
        "third_vp_name": "MR CHAN TECK HONG DAVID",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3483821,
        "lng": 103.7401883
    },
    {
        "school_name": "BUKIT MERAH SECONDARY SCHOOL",
        "url_address": "http://www.bukitmerahsec.moe.edu.sg",
        "address": "10 LENGKOK BAHRU",
        "postal_code": 159050,
        "telephone_no": 64748934,
        "telephone_no_2": "na",
        "fax_no": 64744122,
        "fax_no_2": "na",
        "email_address": "BMSS@MOE.EDU.SG",
        "mrt_desc": "REDHILL MRT",
        "bus_desc": "14, 32, 33, 63, 64, 120, 132, 139, 145, 147, 196, 197, 855, 961",
        "principal_name": "MR DARREN CHONG WAI KI",
        "first_vp_name": "MR KOH SIEW BOON",
        "second_vp_name": "MS CHAN LAI YING",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2862117,
        "lng": 103.8136467
    },
    {
        "school_name": "BUKIT PANJANG GOVT. HIGH SCHOOL",
        "url_address": "http://www.bpghs.moe.edu.sg",
        "address": "7 CHOA CHU KANG AVE 4",
        "postal_code": 689809,
        "telephone_no": 67691031,
        "telephone_no_2": "na",
        "fax_no": 67626576,
        "fax_no_2": "na",
        "email_address": "BPGHS@MOE.EDU.SG",
        "mrt_desc": "CHOA CHU KANG MRT",
        "bus_desc": "300, 983",
        "principal_name": "MR SEET TIAT HEE",
        "first_vp_name": "MDM TEO TING TING",
        "second_vp_name": "MR TAN FONG WEI",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3815132,
        "lng": 103.7388106
    },
    {
        "school_name": "BUKIT PANJANG PRIMARY SCHOOL",
        "url_address": "http://www.bukitpanjangpri.moe.edu.sg",
        "address": "109 CASHEW ROAD",
        "postal_code": 679676,
        "telephone_no": 67691912,
        "telephone_no_2": "na",
        "fax_no": 67637462,
        "fax_no_2": "na",
        "email_address": "BPPS@MOE.EDU.SG",
        "mrt_desc": "From Pending LRT station to Choa Chu Kang MRT station",
        "bus_desc": "75, 184",
        "principal_name": "MADAM LEN LENG LENG TERESA KELLY",
        "first_vp_name": "MR CHAN WENG KIT MARK",
        "second_vp_name": "MADAM KAY HWEE GEAK",
        "third_vp_name": "MR CHAN KEN YAN MICHAEL",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3730121,
        "lng": 103.7690821
    },
    {
        "school_name": "BUKIT TIMAH PRIMARY SCHOOL",
        "url_address": "http://www.bukittimahpri.moe.edu.sg",
        "address": "111 Lorong Kismis",
        "postal_code": 598112,
        "telephone_no": 64662863,
        "telephone_no_2": "na",
        "fax_no": 64692179,
        "fax_no_2": "na",
        "email_address": "bukittimahps@moe.edu.sg",
        "mrt_desc": "Beauty World, Bukit Batok and Clementi Stations",
        "bus_desc": 173,
        "principal_name": "MISS LAU WAN SZE",
        "first_vp_name": "MDM JAN LIN",
        "second_vp_name": "MADAM KOH LEE KUN, SHIRLYN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3373813,
        "lng": 103.7667738
    },
    {
        "school_name": "BUKIT VIEW PRIMARY SCHOOL",
        "url_address": "http://www.bukitviewpri.moe.edu.sg",
        "address": "18 BUKIT BATOK STREET 21",
        "postal_code": 659634,
        "telephone_no": 65661980,
        "telephone_no_2": "na",
        "fax_no": 65635015,
        "fax_no_2": "na",
        "email_address": "BUKITVIEW_PS@MOE.EDU.SG",
        "mrt_desc": "Bukit Batok MRT Station",
        "bus_desc": "173,157,178,852,66,106,61,506,963,77",
        "principal_name": "MADAM TEO ENG HUI",
        "first_vp_name": "MADAM LAI SEOW POH",
        "second_vp_name": "MRS LEE JUN WEN",
        "third_vp_name": "MR GOH GIN HOWE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3461955,
        "lng": 103.7537972
    },
    {
        "school_name": "BUKIT VIEW SECONDARY SCHOOL",
        "url_address": "https://www.bukitviewsec.moe.edu.sg",
        "address": "16 BUKIT BATOK STREET 21",
        "postal_code": 659633,
        "telephone_no": 65661990,
        "telephone_no_2": "na",
        "fax_no": 65630945,
        "fax_no_2": "na",
        "email_address": "BUKITVIEW_SS@MOE.EDU.SG",
        "mrt_desc": "BUKIT BATOK MRT",
        "bus_desc": "61, 66, 77, 106, 157, 173, 174, 178, 189, 506, 653, 852, 963, 990",
        "principal_name": "na",
        "first_vp_name": "MR MAK YEW CHONG",
        "second_vp_name": "MISS MRS ANNA LING",
        "third_vp_name": "MR NEO KIM HANG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3460903,
        "lng": 103.752164
    },
    {
        "school_name": "CANBERRA PRIMARY SCHOOL",
        "url_address": "http://www.canberrapri.moe.edu.sg",
        "address": "21 ADMIRALTY DRIVE",
        "postal_code": 757714,
        "telephone_no": 67597433,
        "telephone_no_2": "na",
        "fax_no": 67587312,
        "fax_no_2": "na",
        "email_address": "CANBERRA_PS@MOE.EDU.SG",
        "mrt_desc": "Sembawang MRT Station",
        "bus_desc": "Bus No. 859",
        "principal_name": "MR TAN SIAN YEOW TERENCE",
        "first_vp_name": "MADAM ONG LIXIANG JOYCE",
        "second_vp_name": "MR SHAH JAHAN B MOHAMED IQBAL",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SEMBAWANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4505141,
        "lng": 103.8156974
    },
    {
        "school_name": "CANBERRA SECONDARY SCHOOL",
        "url_address": "https://canberrasec.moe.edu.sg",
        "address": "51 SEMBAWANG DRIVE",
        "postal_code": 757699,
        "telephone_no": 67585070,
        "telephone_no_2": "na",
        "fax_no": 67583110,
        "fax_no_2": "na",
        "email_address": "CANBERRA_SS@MOE.EDU.SG",
        "mrt_desc": "SEMBAWANG MRT",
        "bus_desc": "859, 962",
        "principal_name": "MR LEONG KOK KEE",
        "first_vp_name": "MADAM ONG LAY YEN",
        "second_vp_name": "MR SYED FAISAL BIN SYED ISMAIL",
        "third_vp_name": "MRS AMANDA TAN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SEMBAWANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4537005,
        "lng": 103.8141663
    },
    {
        "school_name": "CANOSSA CATHOLIC PRIMARY SCHOOL",
        "url_address": "https://canossacatholicpri.moe.edu.sg/",
        "address": "1 Sallim Road",
        "postal_code": 387621,
        "telephone_no": 68441418,
        "telephone_no_2": "na",
        "fax_no": 68441417,
        "fax_no_2": "na",
        "email_address": "ccps@moe.edu.sg",
        "mrt_desc": "Nearest MRT station: Mattar Station (about 3-minute walk)",
        "bus_desc": "Aljunied Road (same side as CCPS): 62, 64, 100; Aljunied Road (opposite CCPS): 61, 62, 64, 66, 100, 135, 154, 155; Merpati Rd (after Jln Anggerek): 40, 61, 63, 65, 66, 135,",
        "principal_name": "MADAM SIA LU-MING EUGENIE",
        "first_vp_name": "MR LEE KOK MENG CLEMENT",
        "second_vp_name": "MR LIM TIAN SIONG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "GEYLANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3262861,
        "lng": 103.8817743
    },
    {
        "school_name": "CANTONMENT PRIMARY SCHOOL",
        "url_address": "http://www.cantonmentpri.moe.edu.sg",
        "address": "1 CANTONMENT CLOSE",
        "postal_code": 88256,
        "telephone_no": 65119555,
        "telephone_no_2": "na",
        "fax_no": 65119556,
        "fax_no_2": "na",
        "email_address": "cantonment_ps@moe.edu.sg",
        "mrt_desc": "Tanjong Pagar; Outram Park",
        "bus_desc": "121, 167, 196",
        "principal_name": "MADAM FOO YIN PING GRACE",
        "first_vp_name": "MISS CHENG SHIN MIIN",
        "second_vp_name": "MRS JANE CHEAH",
        "third_vp_name": "MR LOH SIANG KIANG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2754926,
        "lng": 103.8399129
    },
    {
        "school_name": "CASUARINA PRIMARY SCHOOL",
        "url_address": "http://www.casuarinapri.moe.edu.sg/",
        "address": "30 PASIR RIS ST 41",
        "postal_code": 518935,
        "telephone_no": 65837132,
        "telephone_no_2": "na",
        "fax_no": 65836227,
        "fax_no_2": "na",
        "email_address": "CASUARINA_PS@MOE.EDU.SG",
        "mrt_desc": "Pasir Ris MRT Station",
        "bus_desc": "Nos. 12, 21 & 358",
        "principal_name": "MR POH CHEE YANG",
        "first_vp_name": "MR TAYEB B RAJIB",
        "second_vp_name": "MADAM HAFSAH BINTE ABDULLAH",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3725006,
        "lng": 103.9570205
    },
    {
        "school_name": "CATHOLIC HIGH SCHOOL",
        "url_address": "http://www.catholichigh.moe.edu.sg",
        "address": "9 BISHAN STREET 22",
        "postal_code": 579767,
        "telephone_no": "64582177 (Secondary)",
        "telephone_no_2": "64589869 (Primary)",
        "fax_no": "64561322 (Secondary)",
        "fax_no_2": "64593938 (Primary)",
        "email_address": "CHS@MOE.EDU.SG",
        "mrt_desc": "BISHAN MRT",
        "bus_desc": "13, 52, 54, 88, 156, 162, 162M, 410",
        "principal_name": "MADAM TEO YVONNE",
        "first_vp_name": "MR TAN CHER HUI PHILIP",
        "second_vp_name": "MADAM WONG WAI SEE KELLIE",
        "third_vp_name": "MISS LOW PEI LIN BEVERLY",
        "fourth_vp_name": "MR FONG KOK WAI",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BISHAN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (P1-S4)",
        "sap_ind": "Yes",
        "autonomous_ind": "Yes",
        "gifted_ind": "Yes",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3546049,
        "lng": 103.8451234
    },
    {
        "school_name": "CATHOLIC JUNIOR COLLEGE",
        "url_address": "https://cjc.moe.edu.sg/",
        "address": "129 WHITLEY ROAD",
        "postal_code": 297822,
        "telephone_no": 62524083,
        "telephone_no_2": "na",
        "fax_no": 62537267,
        "fax_no_2": "na",
        "email_address": "CATHOLIC_JC@MOE.EDU.SG",
        "mrt_desc": "Toa Payoh (NS Line), Novena (NS Line), Stevens (DT Line), Caldecott (CC Line,TE Line)",
        "bus_desc": "105, 132, 151, 153, 154, 156, 186, 966, 985",
        "principal_name": "MRS WOO SOO MIN",
        "first_vp_name": "MADAM KAM WAI CHIN",
        "second_vp_name": "MR TAN JEK SUAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "NOVENA",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3249907,
        "lng": 103.8354662
    },
    {
        "school_name": "CEDAR GIRLS' SECONDARY SCHOOL",
        "url_address": "http://www.cedargirlssec.moe.edu.sg",
        "address": "1 CEDAR AVENUE",
        "postal_code": 349692,
        "telephone_no": 62884909,
        "telephone_no_2": "na",
        "fax_no": 62820244,
        "fax_no_2": "na",
        "email_address": "CEDARGIRLSSS@MOE.EDU.SG",
        "mrt_desc": "WOODLEIGH MRT, POTONG PASIR MRT, MATTAR MRT",
        "bus_desc": "8, 13, 61, 64, 65, 66, 90, 100, 107, 133, 135, 142, 147, 151, 154, 155, 853",
        "principal_name": "MADAM THONG MAY TENG",
        "first_vp_name": "MADAM TAN GEOK LAN",
        "second_vp_name": "MISS ONG SHU HUI",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3342298,
        "lng": 103.8744464
    },
    {
        "school_name": "CEDAR PRIMARY SCHOOL",
        "url_address": "Http://www.cedarpri.moe.edu.sg",
        "address": "15 CEDAR AVENUE",
        "postal_code": 349700,
        "telephone_no": 62885633,
        "telephone_no_2": "na",
        "fax_no": 62830113,
        "fax_no_2": "na",
        "email_address": "CEDAR_PS@MOE.EDU.SG",
        "mrt_desc": "Potong Pasir MRT Station",
        "bus_desc": "8, 61, 64, 65, 66, 66A, 90, 90A, 100, 135, 151, 154, 155",
        "principal_name": "MR CHRIS CHUA",
        "first_vp_name": "MS CHOONG PEI CHIN",
        "second_vp_name": "MR NG CHU SIU",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.335401,
        "lng": 103.8758022
    },
    {
        "school_name": "CHANGKAT CHANGI SECONDARY SCHOOL",
        "url_address": "http://www.changkatchangisec.moe.edu.sg",
        "address": "23 SIMEI ST 3",
        "postal_code": 529894,
        "telephone_no": 67859790,
        "telephone_no_2": "na",
        "fax_no": 67868481,
        "fax_no_2": "na",
        "email_address": "CHANGKATCHGI@MOE.EDU.SG",
        "mrt_desc": "SIMEI MRT",
        "bus_desc": "5, 9, 20, 38",
        "principal_name": "MR HO MING DA",
        "first_vp_name": "MS SUBASHINI D/O SIVARAM",
        "second_vp_name": "na",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3410453,
        "lng": 103.9528122
    },
    {
        "school_name": "CHANGKAT PRIMARY SCHOOL",
        "url_address": "http://www.changkatpri.moe.edu.sg/",
        "address": "11 SIMEI ST 3",
        "postal_code": 529896,
        "telephone_no": 67830923,
        "telephone_no_2": "na",
        "fax_no": 67844740,
        "fax_no_2": "na",
        "email_address": "CHANGKAT_PS@MOE.EDU.SG",
        "mrt_desc": "Simei MRT Station",
        "bus_desc": "9,38,5",
        "principal_name": "MADAM CHENG HUEY TENG",
        "first_vp_name": "MRS LEE LI THENG",
        "second_vp_name": "MADAM SITI NAZRAH BTE ABDUL RAHMAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.340245,
        "lng": 103.9522864
    },
    {
        "school_name": "CHIJ (KATONG) PRIMARY",
        "url_address": "http://chijkcp.moe.edu.sg/",
        "address": "17 MARTIA ROAD",
        "postal_code": 424821,
        "telephone_no": 63443072,
        "telephone_no_2": "na",
        "fax_no": 63459007,
        "fax_no_2": "na",
        "email_address": "CHIJKTPS@MOE.EDU.SG",
        "mrt_desc": "MARINE PARADE; EUNOS; PAYA LEBAR",
        "bus_desc": "15, 55, 36, 16, 135, 197, 196, 31, 13, 76, 12, 10, 14, 32, 40",
        "principal_name": "MADAM MISCHA LEIGH PEREIRA",
        "first_vp_name": "MADAM TAN POH KUAN JOYCELYN",
        "second_vp_name": "MISS SHARON NG YE CHIN",
        "third_vp_name": "MR ONG HENG KIONG (KONG QINGQIANG)",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3064102,
        "lng": 103.9109673
    },
    {
        "school_name": "VALOUR PRIMARY SCHOOL",
        "url_address": "valourpri.moe.edu.sg",
        "address": "49 Punggol Central",
        "postal_code": 828728,
        "telephone_no": 62426390,
        "telephone_no_2": "na",
        "fax_no": "na",
        "fax_no_2": "na",
        "email_address": "valour_ps@moe.edu.sg",
        "mrt_desc": "na",
        "bus_desc": "na",
        "principal_name": "MRS CHARIS WONG",
        "first_vp_name": "MADAM TAN PIN PIN",
        "second_vp_name": "MR LEE WEI TE",
        "third_vp_name": "MR BOH HONG JIK",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4070767,
        "lng": 103.8989595
    },
    {
        "school_name": "CHIJ (KELLOCK)",
        "url_address": "http://www.chijkellock.moe.edu.sg/",
        "address": "1 Bukit Teresa Road",
        "postal_code": 99757,
        "telephone_no": 62730096,
        "telephone_no_2": "na",
        "fax_no": 62731710,
        "fax_no_2": "na",
        "email_address": "CHIJKS@MOE.EDU.SG",
        "mrt_desc": "Outram Park Station",
        "bus_desc": "61, 124, 143, 166",
        "principal_name": "MRS SHANTHI SURAJ NAIR",
        "first_vp_name": "MS NG CHIOU HIEN, HELEN MRS HELEN TAN",
        "second_vp_name": "MADAM YUE  SHARON",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2750626,
        "lng": 103.8283114
    },
    {
        "school_name": "CHIJ KATONG CONVENT",
        "url_address": "http://www.chijkatongconvent.moe.edu.sg",
        "address": "346 MARINE TERRACE",
        "postal_code": 449150,
        "telephone_no": 64486433,
        "telephone_no_2": "na",
        "fax_no": 64494405,
        "fax_no_2": "na",
        "email_address": "CHIJKTCS@MOE.EDU.SG",
        "mrt_desc": "BEDOK MRT, KEMBANGAN MRT, EUNOS MRT, PAYA LEBAR MRT, MARINE TERRACE MRT",
        "bus_desc": "4N, 13, 16, 31, 36, 36A, 36B, 43, 47, 48, 55, 134, 135, 135A, 150, 196, 196E, 197, 853C, 763",
        "principal_name": "MISS CHEN MEI CHUEN",
        "first_vp_name": "MISS CHIA SIEW HUI",
        "second_vp_name": "MISS LIM AI HUI ANNIE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "MARINE PARADE",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3065932,
        "lng": 103.9173898
    },
    {
        "school_name": "CHIJ OUR LADY OF GOOD COUNSEL",
        "url_address": "http://www.chijourladyofgoodcounsel.moe.edu.sg",
        "address": "2C Burghley Drive",
        "postal_code": 558979,
        "telephone_no": 62886930,
        "telephone_no_2": "na",
        "fax_no": 62814132,
        "fax_no_2": "na",
        "email_address": "CHIJOLGCS@MOE.EDU.SG",
        "mrt_desc": "Ang Mo Kio MRT, Bishan MRT, Serangoon MRT station.",
        "bus_desc": "317 Feeder Bus Service from Serangoon Interchange. 135,136 from Ang Mo Kio Interchange.",
        "principal_name": "MISS TAN LEE YIN GRACE",
        "first_vp_name": "MISS LIAT MEI KUEN GERALDINE SHARON",
        "second_vp_name": "MRS WONG- LIM ENG LING ANGELINA",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3574239,
        "lng": 103.8637879
    },
    {
        "school_name": "CHIJ OUR LADY OF THE NATIVITY",
        "url_address": "http://www.chijourladyofthenativity.moe.edu.sg/",
        "address": "1257 UPPER SERANGOON ROAD",
        "postal_code": 534793,
        "telephone_no": 63852455,
        "telephone_no_2": "na",
        "fax_no": 63852012,
        "fax_no_2": "na",
        "email_address": "CHIJPS@MOE.EDU.SG",
        "mrt_desc": "Hougang MRT",
        "bus_desc": "74, 102, 112, 113, 119, 136, 147, 324, 672",
        "principal_name": "MS ALBUQUERQUE KAREN ANNE",
        "first_vp_name": "MADAM LOH AH LAH CATHERINE MICHELLE",
        "second_vp_name": "MADAM WONG YEN LING",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3735318,
        "lng": 103.897543
    },
    {
        "school_name": "CHIJ OUR LADY QUEEN OF PEACE",
        "url_address": "http://www.chijourladyqueenofpeace.moe.edu.sg/",
        "address": "4 Chestnut Drive",
        "postal_code": 679287,
        "telephone_no": 67691529,
        "telephone_no_2": "na",
        "fax_no": 67653551,
        "fax_no_2": "na",
        "email_address": "CHIJBTS@MOE.EDU.SG",
        "mrt_desc": "Cashew and Hillview",
        "bus_desc": "180, 67, 171, 176, 177, 178, 184, 961, 963, 970",
        "principal_name": "MS PHAM HONG LIEN PHYLLIS G.",
        "first_vp_name": "MADAM ADELINE CHONG NGOR YIM",
        "second_vp_name": "MADAM SNG POH GEOK",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3667455,
        "lng": 103.7674463
    },
    {
        "school_name": "CHIJ PRIMARY (TOA PAYOH)",
        "url_address": "http://www.chijpritoapayoh.moe.edu.sg",
        "address": "628 Lorong 1 Toa Payoh",
        "postal_code": 319765,
        "telephone_no": 63532164,
        "telephone_no_2": "na",
        "fax_no": 63536362,
        "fax_no_2": "na",
        "email_address": "CHIJTPPS@MOE.EDU.SG",
        "mrt_desc": "Toa Payoh",
        "bus_desc": "59, 231, 141",
        "principal_name": "MADAM CHUA SOOK LIAN JUDINA",
        "first_vp_name": "MRS SNG CHARMAINE",
        "second_vp_name": "MRS MELISSA YAP",
        "third_vp_name": "MADAM YVONNE LIM BUAY HUANG (LIN MEIFANG)",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3333971,
        "lng": 103.8425739
    },
    {
        "school_name": "CHIJ SECONDARY (TOA PAYOH)",
        "url_address": "http://www.chijsec.edu.sg",
        "address": "626 LORONG 1 TOA PAYOH",
        "postal_code": 319764,
        "telephone_no": 63534972,
        "telephone_no_2": "na",
        "fax_no": 63544573,
        "fax_no_2": "na",
        "email_address": "CHIJTPSS@MOE.EDU.SG",
        "mrt_desc": "TOA PAYOH MRT",
        "bus_desc": "59, 141, 231",
        "principal_name": "MADAM RACHEL ANG LAY KOON",
        "first_vp_name": "MADAM CHRIS KOH",
        "second_vp_name": "MADAM LIM LAY HOON",
        "third_vp_name": "MISS KESAVAN PAULA ANNE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.332431,
        "lng": 103.8432942
    },
    {
        "school_name": "CHIJ ST. JOSEPH'S CONVENT",
        "url_address": "http://www.chijstjosephsconvent.moe.edu.sg",
        "address": "62 SENGKANG EAST WAY",
        "postal_code": 548595,
        "telephone_no": 64897580,
        "telephone_no_2": "na",
        "fax_no": 64897589,
        "fax_no_2": "na",
        "email_address": "CHIJSJCS@MOE.EDU.SG",
        "mrt_desc": "SENGKANG MRT",
        "bus_desc": "50, 82, 86, 88, 119, 136",
        "principal_name": "MRS VALERIE PINTO",
        "first_vp_name": "MISS HO WEI LING",
        "second_vp_name": "MISS TAN LAI YEE MICHELLE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.391747,
        "lng": 103.902461
    },
    {
        "school_name": "CHIJ ST. NICHOLAS GIRLS' SCHOOL",
        "url_address": "http://www.chijstnicholasgirls.moe.edu.sg",
        "address": "501 ANG MO KIO STREET 13",
        "postal_code": 569405,
        "telephone_no": "63541839 (Secondary)",
        "telephone_no_2": "64549698 (Primary)",
        "fax_no": "64511335 (Secondary)",
        "fax_no_2": "64566169 (Primary)",
        "email_address": "CHIJSNG@MOE.EDU.SG",
        "mrt_desc": "ANG MO KIO MRT, YIO CHU KANG MRT, MAYFLOWER MRT",
        "bus_desc": "76, 265, 268, 269",
        "principal_name": "MISS TAN SIN WEI WINNIE",
        "first_vp_name": "MADAM LOW CHIA YEE",
        "second_vp_name": "MR NG WAI KIT KELVIN",
        "third_vp_name": "MISS YEO TECK WOON",
        "fourth_vp_name": "MADAM TAN LIH LIN (CHEN LILIN)",
        "fifth_vp_name": "MR LIM KAY WAH BENEDICT",
        "sixth_vp_name": "MR THAM WAI KONG",
        "dgp_code": "ANG MO KIO",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (P1-S4)",
        "sap_ind": "Yes",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3740005,
        "lng": 103.8341542
    },
    {
        "school_name": "CHIJ ST. THERESA'S CONVENT",
        "url_address": "http://www.chijsttheresasconvent.moe.edu.sg",
        "address": "160 LOWER DELTA ROAD",
        "postal_code": 99138,
        "telephone_no": 64775777,
        "telephone_no_2": "na",
        "fax_no": 64775700,
        "fax_no_2": "na",
        "email_address": "CHIJSTCS@MOE.EDU.SG",
        "mrt_desc": "HARBOURFRONT MRT, TIONG BAHRU MRT",
        "bus_desc": "65, 121, 123, 123M, 124, 131, 131M, 195, 195A, 272, 855",
        "principal_name": "MADAM TAN MEI MEI JENNY",
        "first_vp_name": "MISS WEE MEI YEN JANICE",
        "second_vp_name": "MR YEO NGEE YANG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2757944,
        "lng": 103.8222117
    },
    {
        "school_name": "CHONGFU SCHOOL",
        "url_address": "http://www.chongfu.moe.edu.sg/",
        "address": "170 YISHUN AVENUE 6",
        "postal_code": 768959,
        "telephone_no": 67585527,
        "telephone_no_2": "na",
        "fax_no": 62579571,
        "fax_no_2": "na",
        "email_address": "CFPS@MOE.EDU.SG",
        "mrt_desc": "Yishun MRT station",
        "bus_desc": "Feeder Service 811",
        "principal_name": "MR TAN KING MING",
        "first_vp_name": "MISS LIM HWEE MIEN ANGELYNNA",
        "second_vp_name": "MR SOON WOO SIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4387232,
        "lng": 103.8393414
    },
    {
        "school_name": "CHONGZHENG PRIMARY SCHOOL",
        "url_address": "http://www.chongzhengpri.moe.edu.sg",
        "address": "1 TAMPINES STREET 21",
        "postal_code": 529392,
        "telephone_no": 67819002,
        "telephone_no_2": "na",
        "fax_no": 67845054,
        "fax_no_2": "na",
        "email_address": "CZPS@MOE.EDU.SG",
        "mrt_desc": "Tampines MRT Station; Tampines East MRT Station",
        "bus_desc": "3,3A, 8, 17, 18, 20, 28, 34, 39, 59, 518",
        "principal_name": "MR LIM WEE JAMES",
        "first_vp_name": "MADAM RANJIT KAUR D/O MUKHTAR SINGH",
        "second_vp_name": "MISS SHERRY OH SWEE LYN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3508639,
        "lng": 103.9512472
    },
    {
        "school_name": "CHRIST CHURCH SECONDARY SCHOOL",
        "url_address": "http://www.christchurchsec.moe.edu.sg",
        "address": "20 WOODLANDS DRIVE 17",
        "postal_code": 737924,
        "telephone_no": 68933297,
        "telephone_no_2": "na",
        "fax_no": 68932789,
        "fax_no_2": "na",
        "email_address": "CCSS@MOE.EDU.SG",
        "mrt_desc": "WOODLANDS MRT, WOODLANDS SOUTH MRT",
        "bus_desc": "901, 901M, 665",
        "principal_name": "MR TAY JUNCHENG ADRIAN",
        "first_vp_name": "MADAM HENG EU LIN",
        "second_vp_name": "MR ONG KAH HUI VICTOR",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4263994,
        "lng": 103.7934218
    },
    {
        "school_name": "CHUA CHU KANG PRIMARY SCHOOL",
        "url_address": "http://www.chuachukangpri.moe.edu.sg",
        "address": "20 CHOA CHU KANG AVENUE 2",
        "postal_code": 689905,
        "telephone_no": 67661574,
        "telephone_no_2": "na",
        "fax_no": 67661583,
        "fax_no_2": "na",
        "email_address": "CCKPS@MOE.EDU.SG",
        "mrt_desc": "Choa Chu Kang MRT Station and Southview LRT Station",
        "bus_desc": "Bus Service 300, 301 and NR3 along Chua Chu Kang Ave 2; Bus Service 172, 301, 991 along Chua Chu Kang Ave 1",
        "principal_name": "MADAM KUEK YEN YEN SHEREE",
        "first_vp_name": "MADAM CHEW BOON HWEE",
        "second_vp_name": "MS LIM CHWEE ENG MRS ONG PI HOCK",
        "third_vp_name": "MADAM PUSPHAALATHA D/O AYAVOO",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3778193,
        "lng": 103.7423121
    },
    {
        "school_name": "CHUA CHU KANG SECONDARY SCHOOL",
        "url_address": "http://www.chuachukangsec.moe.edu.sg",
        "address": "31 TECK WHYE CRESCENT",
        "postal_code": 688848,
        "telephone_no": 67655228,
        "telephone_no_2": 67664425,
        "fax_no": 67636807,
        "fax_no_2": "na",
        "email_address": "CCKSS@MOE.EDU.SG",
        "mrt_desc": "CHOA CHU KANG MRT, PHOENIX LRT",
        "bus_desc": "190, 190A, 307, 975, 982E, 985",
        "principal_name": "MR CHENG GHEE HOCK TIMOTHY",
        "first_vp_name": "MADAM HARTATI BTE OSMAN",
        "second_vp_name": "MADAM LEE EE LEI JANE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3834832,
        "lng": 103.7515449
    },
    {
        "school_name": "CHUNG CHENG HIGH SCHOOL (MAIN)",
        "url_address": "http://www.chungchenghighmain.moe.edu.sg",
        "address": "50 GOODMAN ROAD",
        "postal_code": 439012,
        "telephone_no": 63441393,
        "telephone_no_2": "na",
        "fax_no": 63449686,
        "fax_no_2": "na",
        "email_address": "CCHMS@MOE.EDU.SG",
        "mrt_desc": "DAKOTA MRT",
        "bus_desc": "10, 12, 14, 14A, 14E 16, 16M, 30, 31, 32, 33, 40, 43, 43E 135, 134, 196, 196A 197, 401, 853M",
        "principal_name": "MR YAO ZHIXUAN TERENCE",
        "first_vp_name": "MR CHONG TENG YUAN",
        "second_vp_name": "MADAM NG BEE LING",
        "third_vp_name": "MADAM ONG LEE FONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "MARINE PARADE",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "Yes",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3054121,
        "lng": 103.8915495
    },
    {
        "school_name": "CHUNG CHENG HIGH SCHOOL (YISHUN)",
        "url_address": "http://www.chungchenghighyishun.moe.edu.sg",
        "address": "11 YISHUN STREET 61",
        "postal_code": 768547,
        "telephone_no": 67583912,
        "telephone_no_2": "na",
        "fax_no": 67587397,
        "fax_no_2": "na",
        "email_address": "CCHBS@MOE.EDU.SG",
        "mrt_desc": "KHATIB MRT",
        "bus_desc": "Yishun Street 61 (opposite school) - 812; Yishun Ave 2 - 39, 85, 117, 851, 852, 853, 854, 855, 857, 858, 860, 965, 969",
        "principal_name": "MR CHIA GUO HAO",
        "first_vp_name": "MR WOO LEE YEN",
        "second_vp_name": "MR CHEONG WING FOOK MELVIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4193805,
        "lng": 103.8377455
    },
    {
        "school_name": "CLEMENTI PRIMARY SCHOOL",
        "url_address": "http://www.clementipri.moe.edu.sg",
        "address": "8 CLEMENTI AVE 3",
        "postal_code": 129903,
        "telephone_no": 67797449,
        "telephone_no_2": "na",
        "fax_no": 67732898,
        "fax_no_2": "na",
        "email_address": "CLEMENTI_PS@MOE.EDU.SG",
        "mrt_desc": "Clementi MRT Station",
        "bus_desc": "We are just beside Clementi Bus Interchange.",
        "principal_name": "MR VIMALENTHIRAN S/O VIJAYASINGAM",
        "first_vp_name": "MADAM KHOO HENG OI CATHERINE",
        "second_vp_name": "MADAM LEE SWEE MEI CHERYL",
        "third_vp_name": "MADAM LOW TAN YING",
        "fourth_vp_name": "MS TUNG AI JUI",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CLEMENTI",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3153018,
        "lng": 103.7632831
    },
    {
        "school_name": "CLEMENTI TOWN SECONDARY SCHOOL",
        "url_address": "http://www.clementitownsec.moe.edu.sg",
        "address": "10 CLEMENTI AVE 3",
        "postal_code": 129904,
        "telephone_no": 67777362,
        "telephone_no_2": "na",
        "fax_no": 67789543,
        "fax_no_2": "na",
        "email_address": "CTSS@MOE.EDU.SG",
        "mrt_desc": "CLEMENTI MRT",
        "bus_desc": "14, 105, 106, 147, 156, 165, 166, 173, 175, 184, 196, 282, 284, 285, 7, 96, 99",
        "principal_name": "MADAM RASIDAH BTE RAHIM",
        "first_vp_name": "MISS HUANG KEXIN",
        "second_vp_name": "MR NG PING HWEE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CLEMENTI",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3154596,
        "lng": 103.7622755
    },
    {
        "school_name": "COMMONWEALTH SECONDARY SCHOOL",
        "url_address": "http://www.commonwealthsec.moe.edu.sg",
        "address": "698 WEST COAST ROAD",
        "postal_code": 608784,
        "telephone_no": 65606866,
        "telephone_no_2": "na",
        "fax_no": 65645204,
        "fax_no_2": "na",
        "email_address": "CWSS@MOE.EDU.SG",
        "mrt_desc": "JURONG EAST MRT, CLEMENTI MRT",
        "bus_desc": "30, 51, 78, 79, 143, 143M, 176, 201",
        "principal_name": "MR ANG KAY YONG JEREMY",
        "first_vp_name": "MRS CLAIRE TAN SHI YING",
        "second_vp_name": "MR DANIEL ONG POH SOON",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG EAST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.318987,
        "lng": 103.7456026
    },
    {
        "school_name": "COMPASSVALE PRIMARY SCHOOL",
        "url_address": "https://www.compassvalepri.moe.edu.sg",
        "address": "21 COMPASSVALE ST",
        "postal_code": 545091,
        "telephone_no": 63882819,
        "telephone_no_2": "na",
        "fax_no": 63882798,
        "fax_no_2": "na",
        "email_address": "CVPS@MOE.EDU.SG",
        "mrt_desc": "Sengkang",
        "bus_desc": "83 (along Compassvale Street); 27, 89, 89E & 965 (along Compassvale Road).",
        "principal_name": "MR VINCENT LEE WEI YEE",
        "first_vp_name": "MRS MARIA KOH",
        "second_vp_name": "MR CHIN WENG KIT KELVIN",
        "third_vp_name": "MR KHOU BENG CHEW",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3945602,
        "lng": 103.8980513
    },
    {
        "school_name": "COMPASSVALE SECONDARY SCHOOL",
        "url_address": "http://www.compassvalesec.moe.edu.sg",
        "address": "51 COMPASSVALE CRESCENT",
        "postal_code": 545083,
        "telephone_no": 68815047,
        "telephone_no_2": "na",
        "fax_no": 68815998,
        "fax_no_2": "na",
        "email_address": "CVSS@MOE.EDU.SG",
        "mrt_desc": "SENGKANG MRT, COMPASSVALE LRT",
        "bus_desc": "27, 27A, 82,  83,  86,  88,  89, 89E, 136, 161, 371, 965",
        "principal_name": "MR CHUA TUNG KIAN",
        "first_vp_name": "MADAM LEE WUI LIN JACQUELINE",
        "second_vp_name": "MR SUKHDEV SINGH S/O GURDEEP SINGH",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3960452,
        "lng": 103.9002456
    },
    {
        "school_name": "CONCORD PRIMARY SCHOOL",
        "url_address": "http://www.concordpri.moe.edu.sg/",
        "address": "3 CHOA CHU KANG AVE 4",
        "postal_code": 689814,
        "telephone_no": 67632139,
        "telephone_no_2": "na",
        "fax_no": 67632452,
        "fax_no_2": "na",
        "email_address": "CONCORD_PS@MOE.EDU.SG",
        "mrt_desc": "Choa Chu Kang MRT Station",
        "bus_desc": "Bus 300 and 983",
        "principal_name": "MDM CHUA LENG YIN",
        "first_vp_name": "MADAM GOH PUAY HOON JENNY",
        "second_vp_name": "MADAM SALBIAH BTE ABAS",
        "third_vp_name": "MR LEE ENG LOO",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.380347,
        "lng": 103.7363383
    },
    {
        "school_name": "CORPORATION PRIMARY SCHOOL",
        "url_address": "http://www.corporationpri.moe.edu.sg",
        "address": "31 JURONG WEST STREET 24",
        "postal_code": 648347,
        "telephone_no": 67957381,
        "telephone_no_2": "na",
        "fax_no": 67957098,
        "fax_no_2": "na",
        "email_address": "CPS@MOE.EDU.SG",
        "mrt_desc": "BOON LAY STATION; LAKESIDE STATION",
        "bus_desc": "157 (from Boon Lay Interchange), or 185",
        "principal_name": "MR MUHAMMAD FADYLLA B RASHIMAN",
        "first_vp_name": "MDM GOH MUI EE",
        "second_vp_name": "MADAM NG SEOW WEI JOSEPHINE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3514322,
        "lng": 103.7076403
    },
    {
        "school_name": "CRESCENT GIRLS' SCHOOL",
        "url_address": "http://www.crescent.edu.sg",
        "address": "357 TANGLIN ROAD",
        "postal_code": 247961,
        "telephone_no": 64758711,
        "telephone_no_2": "na",
        "fax_no": 64741248,
        "fax_no_2": "na",
        "email_address": "CRESCENTGIRL@MOE.EDU.SG",
        "mrt_desc": "REDHILL MRT",
        "bus_desc": "32, 111, 122, 132, 51, 139, 186, 970",
        "principal_name": "MISS LOW SHIOK CHENG CINDY",
        "first_vp_name": "MRS TAY PO LIN",
        "second_vp_name": "MISS USHA JEYARAJAH",
        "third_vp_name": "MR LIM HAN CHEE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2940214,
        "lng": 103.8168823
    },
    {
        "school_name": "CREST SECONDARY SCHOOL",
        "url_address": "http://www.crestsec.edu.sg",
        "address": "561 JURONG EAST STREET 24",
        "postal_code": 609561,
        "telephone_no": 68992779,
        "telephone_no_2": "na",
        "fax_no": 68992668,
        "fax_no_2": "na",
        "email_address": "info@crestsec.edu.sg",
        "mrt_desc": "BUKIT BATOK MRT, JURONG EAST MRT",
        "bus_desc": "41, 52, 98, 98M, 105, 176, 183, 187, 188, 188R, 333, 502, 868, 990",
        "principal_name": "MR KWOK CHIN POH BENJAMIN",
        "first_vp_name": "MR TEH TUAN ANN",
        "second_vp_name": "MADAM LEE KEE MENG",
        "third_vp_name": "MR OTHMAN ARSAN BIN MOHD ABUBAKAR",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG EAST",
        "zone_code": "WEST",
        "type_code": "SPECIALISED SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3431881,
        "lng": 103.7428957
    },
    {
        "school_name": "DAMAI PRIMARY SCHOOL",
        "url_address": "http://www.damaipri.moe.edu.sg",
        "address": "52 BEDOK RESERVOIR CRESCENT",
        "postal_code": 479226,
        "telephone_no": 64456483,
        "telephone_no_2": "na",
        "fax_no": 64499681,
        "fax_no_2": "na",
        "email_address": "DAMAI_PS@MOE.EDU.SG",
        "mrt_desc": "Bedok North MRT Station",
        "bus_desc": "Bus 228,66,65,22,21,5 and 506",
        "principal_name": "MRS LEONG- TAN LING LING JENNY",
        "first_vp_name": "MADAM LIM PECK CHIN YENLYN",
        "second_vp_name": "MR MOHAMED JURAIMI BIN ABDUL MUHIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3356727,
        "lng": 103.9211476
    },
    {
        "school_name": "DAMAI SECONDARY SCHOOL",
        "url_address": "http://www.damaisec.moe.edu.sg",
        "address": "4800 BEDOK RESERVOIR ROAD",
        "postal_code": 479229,
        "telephone_no": 64436848,
        "telephone_no_2": "na",
        "fax_no": 64425629,
        "fax_no_2": "na",
        "email_address": "DAMAI_SS@MOE.EDU.SG",
        "mrt_desc": "BEDOK RESERVOIR MRT, BEDOK MRT, TAMPINES MRT",
        "bus_desc": "5, 21, 22, 59, 65, 66, 228, 506, CT18",
        "principal_name": "MADAM CHAN WAN SIONG",
        "first_vp_name": "MR NG CHENG KEONG",
        "second_vp_name": "MADAM PREMLATHA D/O SELVARAJ",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.33838,
        "lng": 103.9263581
    },
    {
        "school_name": "DAZHONG PRIMARY SCHOOL",
        "url_address": "http://www.dazhongpri.moe.edu.sg",
        "address": "35 BUKIT BATOK STREET 31",
        "postal_code": 659441,
        "telephone_no": 65658002,
        "telephone_no_2": "na",
        "fax_no": 65636421,
        "fax_no_2": "na",
        "email_address": "DAZHONG_PS@MOE.EDU.SG",
        "mrt_desc": "Bukit Gombak",
        "bus_desc": "187, 188",
        "principal_name": "MR CHRIS LOH KAI MUN",
        "first_vp_name": "MR KOH KAH HOCK",
        "second_vp_name": "MRS LIM SEOW KHIM MRS BOEY- LIM SEOW KHIM",
        "third_vp_name": "MISS TAN HUI YAH",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.35922,
        "lng": 103.7479191
    },
    {
        "school_name": "DE LA SALLE SCHOOL",
        "url_address": "http://www.delasalle.moe.edu.sg",
        "address": "11 Choa Chu Kang St 52",
        "postal_code": 689285,
        "telephone_no": 67667675,
        "telephone_no_2": "na",
        "fax_no": 67622075,
        "fax_no_2": "na",
        "email_address": "DLSS@MOE.EDU.SG",
        "mrt_desc": "YEW TEE MRT",
        "bus_desc": "TIBS 302, 979",
        "principal_name": "MADAM CHERYL CHOO SHUEH-LI",
        "first_vp_name": "MISS CECILIA TAN LI HUA",
        "second_vp_name": "MISS LIU JIAZHEN ADELINE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3950704,
        "lng": 103.7433723
    },
    {
        "school_name": "DEYI SECONDARY SCHOOL",
        "url_address": "http://www.deyisec.moe.edu.sg",
        "address": "1 ANG MO KIO STREET 42",
        "postal_code": 569277,
        "telephone_no": 64561565,
        "telephone_no_2": "na",
        "fax_no": 64583364,
        "fax_no_2": "na",
        "email_address": "DEYI_SS@MOE.EDU.SG",
        "mrt_desc": "ANG MO KIO MRT",
        "bus_desc": "22, 24, 25, 45, 50, 55, 73, 74, 76, 88, 132, 135, 159, 162, 165, 261, 262, 268, 652, 853",
        "principal_name": "MR CHOW WEISI",
        "first_vp_name": "MR APOLLOS INDUCHOODAN PILLAI",
        "second_vp_name": "MISS CHIANG HUIMIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.366291,
        "lng": 103.8526883
    },
    {
        "school_name": "DUNEARN SECONDARY SCHOOL",
        "url_address": "http://www.dunearnsec.moe.edu.sg",
        "address": "21 BUKIT BATOK WEST AVENUE 2",
        "postal_code": 659204,
        "telephone_no": 65653692,
        "telephone_no_2": "na",
        "fax_no": 65668650,
        "fax_no_2": "na",
        "email_address": "DUNEARN_SS@MOE.EDU.SG",
        "mrt_desc": "BUKIT BATOK MRT, BUKIT GOMBAK MRT",
        "bus_desc": "160, 180, 187, 188, 945, 947, 985",
        "principal_name": "MADAM SOH BENG MUI",
        "first_vp_name": "MR LEE KAH SIONG JIMMY",
        "second_vp_name": "YAP KWEE CHYE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.363167,
        "lng": 103.7445869
    },
    {
        "school_name": "DUNMAN HIGH SCHOOL",
        "url_address": "http://www.dunmanhigh.moe.edu.sg",
        "address": "10 TANJONG RHU ROAD",
        "postal_code": 436895,
        "telephone_no": 63450533,
        "telephone_no_2": "na",
        "fax_no": 63442316,
        "fax_no_2": "na",
        "email_address": "DHS@MOE.EDU.SG",
        "mrt_desc": "KATONG PARK MRT,ALJUNIED MRT, KALLANG MRT, MOUNTBATTEN MRT,",
        "bus_desc": "12, 14, 30, 158, 196",
        "principal_name": "MR CHAN YING YIN",
        "first_vp_name": "MADAM LEONG SOOK HING",
        "second_vp_name": "MR MELVIN NG YONG HUI",
        "third_vp_name": "MR PUAH YOU KAI",
        "fourth_vp_name": "MR ONG QIU JIE",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "KALLANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "Yes",
        "autonomous_ind": "Yes",
        "gifted_ind": "Yes",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.2986982,
        "lng": 103.882844
    },
    {
        "school_name": "DUNMAN SECONDARY SCHOOL",
        "url_address": "http://www.dunmansec.moe.edu.sg",
        "address": "21 TAMPINES STREET 45",
        "postal_code": 529093,
        "telephone_no": 67862668,
        "telephone_no_2": "na",
        "fax_no": 67842164,
        "fax_no_2": "na",
        "email_address": "DUNMAN_SS@MOE.EDU.SG",
        "mrt_desc": "TAMPINES EAST MRT",
        "bus_desc": "28, 29, 293",
        "principal_name": "MR TOH THIAM CHYE",
        "first_vp_name": "MR FATHUL RAHMAN BIN KAMSANI",
        "second_vp_name": "MISS PRIYA PRASAD",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3610555,
        "lng": 103.9559258
    },
    {
        "school_name": "EAST SPRING PRIMARY SCHOOL",
        "url_address": "http://www.eastspringpri.moe.edu.sg",
        "address": "31 TAMPINES ST 33",
        "postal_code": 529258,
        "telephone_no": 67866192,
        "telephone_no_2": "na",
        "fax_no": 67866649,
        "fax_no_2": "na",
        "email_address": "ESPS@MOE.EDU.SG",
        "mrt_desc": "Tampines",
        "bus_desc": "291, 28,18",
        "principal_name": "MADAM NEO LAY WAH",
        "first_vp_name": "MADAM FAZILAH MARICAR D/O MD ALI M",
        "second_vp_name": "MS NG HUI ENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3529446,
        "lng": 103.9618398
    },
    {
        "school_name": "EAST SPRING SECONDARY SCHOOL",
        "url_address": "http://www.eastspringsec.moe.edu.sg",
        "address": "30 TAMPINES STREET 34",
        "postal_code": 529231,
        "telephone_no": 65873805,
        "telephone_no_2": "na",
        "fax_no": 65873804,
        "fax_no_2": "na",
        "email_address": "ESSS@MOE.EDU.SG",
        "mrt_desc": "TAMPINES MRT, TAMPINES EAST MRT",
        "bus_desc": "3, 4, 9, 12, 17, 18, 19, 21, 28, 29, 34, 37, 39, 59, 81, 291, 518",
        "principal_name": "MISS HO SUSIE",
        "first_vp_name": "MR LIM PIA LEONG",
        "second_vp_name": "MR KOH CHEE HUI",
        "third_vp_name": "MR PHAY CHYE HOCK ADRIAN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3568208,
        "lng": 103.9607517
    },
    {
        "school_name": "EDGEFIELD PRIMARY SCHOOL",
        "url_address": "http://www.edgefieldpri.moe.edu.sg",
        "address": "41 EDGEFIELD PLAINS",
        "postal_code": 828869,
        "telephone_no": 63126091,
        "telephone_no_2": "na",
        "fax_no": 63126093,
        "fax_no_2": "na",
        "email_address": "edgefield_ps@moe.edu.sg",
        "mrt_desc": "Punggol MRT",
        "bus_desc": "3, 34, 62, 82, 83, 136",
        "principal_name": "MADAM RABIATHUL BAZRIYA D/O ABU BAKAR",
        "first_vp_name": "MR YAP LIH MIN SAMUEL",
        "second_vp_name": "MS TAN PEY SAN",
        "third_vp_name": "TEH CHONG ANN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4004367,
        "lng": 103.9076926
    },
    {
        "school_name": "EDGEFIELD SECONDARY SCHOOL",
        "url_address": "http://www.edgefieldsec.moe.edu.sg",
        "address": "36 PUNGGOL FIELD",
        "postal_code": 828814,
        "telephone_no": 68839511,
        "telephone_no_2": "na",
        "fax_no": 63153120,
        "fax_no_2": "na",
        "email_address": "edgefield_ss@moe.edu.sg",
        "mrt_desc": "PUNGGOL MRT",
        "bus_desc": "3, 34, 62, 82, 83, 119, 136, 381, 382G",
        "principal_name": "MR FOO JUNG HIN SIMON",
        "first_vp_name": "MR BENSON TEO HONG GUAN (ZHANG HONGYUAN)",
        "second_vp_name": "MR HOW PUI SENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4002914,
        "lng": 103.9021546
    },
    {
        "school_name": "ELIAS PARK PRIMARY SCHOOL",
        "url_address": "http://www.eliasparkpri.moe.edu.sg",
        "address": "11 PASIR RIS STREET 52",
        "postal_code": 518866,
        "telephone_no": 65844393,
        "telephone_no_2": "na",
        "fax_no": 65844392,
        "fax_no_2": "na",
        "email_address": "EPPS@MOE.EDU.SG",
        "mrt_desc": "Pasir Ris MRT",
        "bus_desc": "3, 15, 39, 53, 81, 88, 89, 357, 403, 518",
        "principal_name": "MADAM CHUA PEI PEI",
        "first_vp_name": "MR HO FU CHEW",
        "second_vp_name": "PEH BEE KUAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3749538,
        "lng": 103.9452385
    },
    {
        "school_name": "ENDEAVOUR PRIMARY SCHOOL",
        "url_address": "https://endeavourpri.moe.edu.sg/",
        "address": "10 Admiralty Link",
        "postal_code": 757521,
        "telephone_no": 64824650,
        "telephone_no_2": 64824835,
        "fax_no": 64824670,
        "fax_no_2": "na",
        "email_address": "endeavour_ps@moe.edu.sg",
        "mrt_desc": "Sembawang MRT Station",
        "bus_desc": "859, 962",
        "principal_name": "MR KOH KIAN SENG THOMAS",
        "first_vp_name": "MADAM CHUA HUI PIN",
        "second_vp_name": "MISS FAUZIAH DAUD",
        "third_vp_name": "MISS CELESTE LOH SHI MIN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SEMBAWANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4545646,
        "lng": 103.8171781
    },
    {
        "school_name": "EUNOIA JUNIOR COLLEGE",
        "url_address": "http://www.eunoiajc.moe.edu.sg",
        "address": "2 Sin Ming Place",
        "postal_code": 573838,
        "telephone_no": 63518388,
        "telephone_no_2": "na",
        "fax_no": 63518399,
        "fax_no_2": "na",
        "email_address": "eunoiajc@moe.edu.sg",
        "mrt_desc": "Bishan MRT Station, Marymount MRT Station, Ang Mo Kio MRT Station, Bright Hill MRT Station",
        "bus_desc": "13, 52, 74, 88, 130, 410G, 410W, 851, 852",
        "principal_name": "MR TAN ENG HIAN ANDREW",
        "first_vp_name": "MDM NEW YI CHEEN",
        "second_vp_name": "MADAM PHUA KIA LING",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BISHAN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3626165,
        "lng": 103.8394527
    },
    {
        "school_name": "EVERGREEN PRIMARY SCHOOL",
        "url_address": "http://www.evergreenpri.moe.edu.sg/",
        "address": "31 WOODLANDS CIRCLE",
        "postal_code": 738908,
        "telephone_no": 63687705,
        "telephone_no_2": "na",
        "fax_no": 63688084,
        "fax_no_2": "na",
        "email_address": "EVERGREEN_PS@MOE.EDU.SG",
        "mrt_desc": "Admiralty",
        "bus_desc": "913(front), 911 & 858(back)",
        "principal_name": "MR JEFFREY AW",
        "first_vp_name": "MR BOH CHUAN XIANG",
        "second_vp_name": "MADAM ONG HWEE LENG",
        "third_vp_name": "MR CHENG YOU NENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.444082,
        "lng": 103.795038
    },
    {
        "school_name": "EVERGREEN SECONDARY SCHOOL",
        "url_address": "http://www.evergreensec.moe.edu.sg",
        "address": "11 WOODLANDS STREET 83",
        "postal_code": 738489,
        "telephone_no": 63656392,
        "telephone_no_2": "na",
        "fax_no": 63658083,
        "fax_no_2": "na",
        "email_address": "EVERGREEN_SS@MOE.EDU.SG",
        "mrt_desc": "WOODLANDS MRT",
        "bus_desc": 911,
        "principal_name": "MS BIAN YU WEI",
        "first_vp_name": "MR LIM KANGYU",
        "second_vp_name": "MADAM TAY CHOR HWEE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4415377,
        "lng": 103.7936021
    },
    {
        "school_name": "FAIRFIELD METHODIST SCHOOL (PRIMARY)",
        "url_address": "http://www.fmsp.moe.edu.sg/",
        "address": "100 DOVER ROAD",
        "postal_code": 139648,
        "telephone_no": 67788431,
        "telephone_no_2": "na",
        "fax_no": 67762948,
        "fax_no_2": "na",
        "email_address": "FMPS@MOE.EDU.SG",
        "mrt_desc": "One-North MRT, Buona Vista MRT & Dover MRT",
        "bus_desc": "SBS Bus 14,33,74,166 & 196",
        "principal_name": "MADAM WONG MEI FOONG",
        "first_vp_name": "MR HO KOK SOON",
        "second_vp_name": "MADAM QUEK TSUI LAN PRISCA",
        "third_vp_name": "MR KNG WEE BENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "QUEENSTOWN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3005321,
        "lng": 103.7848697
    },
    {
        "school_name": "FAIRFIELD METHODIST SCHOOL (SECONDARY)",
        "url_address": "http://www.fairfieldmethodistsec.moe.edu.sg",
        "address": "102 DOVER ROAD",
        "postal_code": 139649,
        "telephone_no": 67788702,
        "telephone_no_2": "na",
        "fax_no": 67797482,
        "fax_no_2": "na",
        "email_address": "FMSS@MOE.EDU.SG",
        "mrt_desc": "BUONA VISTA MRT, ONE-NORTH MRT",
        "bus_desc": "33, 74, 166, 196",
        "principal_name": "MR WEE TAT CHUEN",
        "first_vp_name": "MR JEROMY NGIAN KUN CHUAN",
        "second_vp_name": "MISS STELLA KOH LI HUI",
        "third_vp_name": "MADAM CHUA JIAYIN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "QUEENSTOWN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.301545,
        "lng": 103.7845145
    },
    {
        "school_name": "FARRER PARK PRIMARY SCHOOL",
        "url_address": "http://www.farrerparkpri.moe.edu.sg",
        "address": "2 FARRER PARK ROAD",
        "postal_code": 217567,
        "telephone_no": 62952272,
        "telephone_no_2": "na",
        "fax_no": 62942272,
        "fax_no_2": "na",
        "email_address": "FPPS@MOE.EDU.SG",
        "mrt_desc": "Farrer Park MRT Station",
        "bus_desc": 131,
        "principal_name": "MR YAP SWEE BENG, DENNIS",
        "first_vp_name": "MADAM RAHIMA BTE ABDUL RAHMAN",
        "second_vp_name": "MR YONG WEI LEONG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "KALLANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.312316,
        "lng": 103.850874
    },
    {
        "school_name": "FENGSHAN PRIMARY SCHOOL",
        "url_address": "http://www.fengshanpri.moe.edu.sg",
        "address": "307 BEDOK NORTH ROAD",
        "postal_code": 469680,
        "telephone_no": 65860123,
        "telephone_no_2": "na",
        "fax_no": 65860122,
        "fax_no_2": "na",
        "email_address": "FSPS@MOE.EDU.SG",
        "mrt_desc": "Bedok MRT",
        "bus_desc": "18, 228, 222, 17, 69, 66, 67, 168, 28, 506, 14, 45",
        "principal_name": "MISS WONG LIANG- JI TABITHA",
        "first_vp_name": "MADAM LAI KAI CHING",
        "second_vp_name": "MS SIEW GEOK LING (SHAO YULING)",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3298137,
        "lng": 103.93195
    },
    {
        "school_name": "FERN GREEN PRIMARY SCHOOL",
        "url_address": "www.ferngreenpri.moe.edu.sg",
        "address": "70 Fernvale Link   Fern Green Primary School",
        "postal_code": 797538,
        "telephone_no": 68343100,
        "telephone_no_2": "na",
        "fax_no": 68343116,
        "fax_no_2": "na",
        "email_address": "ferngreen_ps@moe.edu.sg",
        "mrt_desc": "Kupang LRT Station (SW3)",
        "bus_desc": "85, 102",
        "principal_name": "na",
        "first_vp_name": "MADAM KYLICIA SOO GEOK LING",
        "second_vp_name": "MISS CHOW CHIA MIN AGNES",
        "third_vp_name": "MADAM QUEK HWEE PENG, ANDREA (GUO HUIPING, ANDREA)",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3975342,
        "lng": 103.8798637
    },
    {
        "school_name": "FERNVALE PRIMARY SCHOOL",
        "url_address": "www.fernvalepri.moe.edu.sg",
        "address": "1 Fernvale Lane",
        "postal_code": 797701,
        "telephone_no": 63153051,
        "telephone_no_2": "na",
        "fax_no": 63153067,
        "fax_no_2": "na",
        "email_address": "fernvale_ps@moe.edu.sg",
        "mrt_desc": "Fernvale LRT (Sengkang West Loop)",
        "bus_desc": "Along Sengkang West Ave - Bus Services 50, 163; Along Yio Chu Kang Road - Bus Services 70, 86, 103 and 854.",
        "principal_name": "MR LAU ENOCH",
        "first_vp_name": "MISS YAP AI LI",
        "second_vp_name": "MR RAMESH MUKUNDHAN",
        "third_vp_name": "MR KEVIN PATT",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3900136,
        "lng": 103.8741783
    },
    {
        "school_name": "FIRST TOA PAYOH PRIMARY SCHOOL",
        "url_address": "http://www.firsttoapayohpri.moe.edu.sg",
        "address": "7 LORONG 8 TOA PAYOH",
        "postal_code": 319252,
        "telephone_no": 62567822,
        "telephone_no_2": "na",
        "fax_no": 62561102,
        "fax_no_2": "na",
        "email_address": "FTPPS@MOE.EDU.SG",
        "mrt_desc": "Braddell & Toa Payoh Stations",
        "bus_desc": "157,153,105,159,88,FS238",
        "principal_name": "MADAM JENNIFER HAN ENG JUAN",
        "first_vp_name": "MR KOH PENG YEOW",
        "second_vp_name": "MS TAY YAM ENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3402883,
        "lng": 103.8555874
    },
    {
        "school_name": "FRONTIER PRIMARY SCHOOL",
        "url_address": "http://www.frontierpri.moe.edu.sg",
        "address": "20 Jurong West Street 61",
        "postal_code": 648200,
        "telephone_no": 65789555,
        "telephone_no_2": "na",
        "fax_no": 67908596,
        "fax_no_2": "na",
        "email_address": "frontier_ps@moe.edu.sg",
        "mrt_desc": "Pioneer MRT Station (EW28)",
        "bus_desc": "241, 974, 179",
        "principal_name": "MADAM LEE YEW KOON TONNINE",
        "first_vp_name": "MADAM CHAN YEE CHIN WILNA",
        "second_vp_name": "MADAM WONG SHI-LEI",
        "third_vp_name": "MR ANG BOON CHIN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.336807,
        "lng": 103.6994043
    },
    {
        "school_name": "FUCHUN PRIMARY SCHOOL",
        "url_address": "http://www.fuchunpri.moe.edu.sg",
        "address": "23 WOODLANDS AVENUE 1",
        "postal_code": 739063,
        "telephone_no": 63683925,
        "telephone_no_2": "na",
        "fax_no": 63670117,
        "fax_no_2": "na",
        "email_address": "FCPS@MOE.EDU.SG",
        "mrt_desc": "Marsiling",
        "bus_desc": "187,856,912,925,950,960,961,963,963E,963R,966",
        "principal_name": "MADAM EUNICE LIM",
        "first_vp_name": "MR SUDHESH VASU DASH",
        "second_vp_name": "MR TAN CHIN KEE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4304356,
        "lng": 103.7781651
    },
    {
        "school_name": "FUHUA PRIMARY SCHOOL",
        "url_address": "http://www.fuhuapri.moe.edu.sg",
        "address": "65 JURONG EAST STREET 13",
        "postal_code": 609647,
        "telephone_no": 65624370,
        "telephone_no_2": "na",
        "fax_no": 65639542,
        "fax_no_2": "na",
        "email_address": "FHPS@MOE.EDU.SG",
        "mrt_desc": "JURONG EAST MRT STATION",
        "bus_desc": "JURONG EAST CENTRAL (BS28441): 41,49,52,105,160,160A,160M,176,183,334,506; JURONG EAST CENTRAL (BS28431):51,66,78,79,143, 143M, 176, 335",
        "principal_name": "MR GANESAN S/O RAMAN",
        "first_vp_name": "MADAM SEOW SWEE NEO CHRISTINA",
        "second_vp_name": "MS SAIMA HANIF D/O MOHAMED HANIF",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG EAST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3363949,
        "lng": 103.7368184
    },
    {
        "school_name": "FUHUA SECONDARY SCHOOL",
        "url_address": "http://www.fuhuasec.moe.edu.sg",
        "address": "5 JURONG WEST STREET 41",
        "postal_code": 649410,
        "telephone_no": 65633067,
        "telephone_no_2": "na",
        "fax_no": 65634379,
        "fax_no_2": "na",
        "email_address": "FHSS@MOE.EDU.SG",
        "mrt_desc": "CHINESE GARDEN MRT, LAKESIDE MRT",
        "bus_desc": "49, 98, 99, 157, 180, 185, 187, 198, 334, 335, 502, 657",
        "principal_name": "MRS LIM CAROL",
        "first_vp_name": "MR CHNG PUAY KEONG",
        "second_vp_name": "MISS PEH LEE CHIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3474524,
        "lng": 103.7265396
    },
    {
        "school_name": "GAN ENG SENG PRIMARY SCHOOL",
        "url_address": "http://www.ganengsengpri.moe.edu.sg",
        "address": "100 REDHILL CLOSE",
        "postal_code": 158901,
        "telephone_no": 64717451,
        "telephone_no_2": "na",
        "fax_no": 64794152,
        "fax_no_2": "na",
        "email_address": "GESPS@MOE.EDU.SG",
        "mrt_desc": "Redhill",
        "bus_desc": "14, 63, 147, 196, 197, 855, 961",
        "principal_name": "MR LEE WEI YAP, ROY",
        "first_vp_name": "MR KYAW SAW LYNN",
        "second_vp_name": "MADAM WONG SEOK GHEE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2854763,
        "lng": 103.8149056
    },
    {
        "school_name": "GAN ENG SENG SCHOOL",
        "url_address": "http://www.ganengsengsch.moe.edu.sg",
        "address": "1 HENDERSON ROAD",
        "postal_code": 159561,
        "telephone_no": 64745594,
        "telephone_no_2": "na",
        "fax_no": 64732479,
        "fax_no_2": "na",
        "email_address": "GESS@MOE.EDU.SG",
        "mrt_desc": "REDHILL MRT, TIONG BAHRU MRT",
        "bus_desc": "14, 16, 32, 33, 51, 63, 64, 120, 122, 145, 139, 186, 851, 970",
        "principal_name": "MISS TAN HWEE PIN",
        "first_vp_name": "MADAM SARAWATHY D/O VARADARAJU",
        "second_vp_name": "MR TAN TZE JWEE GLYNN",
        "third_vp_name": "MR GOH THYE HENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2900347,
        "lng": 103.8235117
    },
    {
        "school_name": "GEYLANG METHODIST SCHOOL (PRIMARY)",
        "url_address": "www.geylangmethodistpri.moe.edu.sg",
        "address": "4 Geylang East Central",
        "postal_code": 389706,
        "telephone_no": 67486746,
        "telephone_no_2": "na",
        "fax_no": 67488980,
        "fax_no_2": "na",
        "email_address": "GMPS@MOE.EDU.SG",
        "mrt_desc": "Aljunied",
        "bus_desc": "80, 134, 155",
        "principal_name": "MADAM LEONG BENG YUET DAPHNE",
        "first_vp_name": "MR LUA EE PING",
        "second_vp_name": "MADAM SHARON CHANTALE KOK YENG LING",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "GEYLANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3181599,
        "lng": 103.8838404
    },
    {
        "school_name": "GEYLANG METHODIST SCHOOL (SECONDARY)",
        "url_address": "http://www.geylangmethodistsec.moe.edu.sg",
        "address": "2 GEYLANG EAST CENTRAL",
        "postal_code": 389705,
        "telephone_no": 67466503,
        "telephone_no_2": "na",
        "fax_no": 67477317,
        "fax_no_2": "na",
        "email_address": "GMSS@MOE.EDU.SG",
        "mrt_desc": "ALJUNIED MRT",
        "bus_desc": "40, 62, 63, 80, 100, 125, 134, 155, 158",
        "principal_name": "MR OWYONG TUCK SING VICTOR",
        "first_vp_name": "MR JOHN WU YIFAN",
        "second_vp_name": "MISS TAY HUI CHENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "GEYLANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3181272,
        "lng": 103.8828971
    },
    {
        "school_name": "GONGSHANG PRIMARY SCHOOL",
        "url_address": "http://www.gongshangpri.moe.edu.sg",
        "address": "1 TAMPINES STREET 42",
        "postal_code": 529176,
        "telephone_no": 67831191,
        "telephone_no_2": "na",
        "fax_no": 67880004,
        "fax_no_2": "na",
        "email_address": "GSPS@MOE.EDU.SG",
        "mrt_desc": "Tampines (Downtown Line and East West Line) and Tampines East (Downtown Line)",
        "bus_desc": "4, 8, 18, 19, 21, 37, 38, 81, 293",
        "principal_name": "MRS STELLA KWAN",
        "first_vp_name": "MDM NORA BTE OSMAN",
        "second_vp_name": "MRS YIO YEN LING SELINA",
        "third_vp_name": "MR FONG WAI KHIN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3571755,
        "lng": 103.9491666
    },
    {
        "school_name": "GREENDALE PRIMARY SCHOOL",
        "url_address": "http://www.greendalepri.moe.edu.sg",
        "address": "50 Edgedale Plains",
        "postal_code": 828848,
        "telephone_no": 68861413,
        "telephone_no_2": "na",
        "fax_no": 68861419,
        "fax_no_2": "na",
        "email_address": "greendale_ps@moe.edu.sg",
        "mrt_desc": "Punggol LRT:  Coral Edge",
        "bus_desc": "3,62, 83, 85, 386",
        "principal_name": "MADAM NOORISMAWATY BTE ISMAIL",
        "first_vp_name": "MR SIM CHIN BENG WILSON",
        "second_vp_name": "MR CHING KIN HIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3962652,
        "lng": 103.9127224
    },
    {
        "school_name": "GREENDALE SECONDARY SCHOOL",
        "url_address": "http://www.greendalesec.moe.edu.sg",
        "address": "51 EDGEDALE PLAINS",
        "postal_code": 828866,
        "telephone_no": 63158616,
        "telephone_no_2": "na",
        "fax_no": 63158420,
        "fax_no_2": "na",
        "email_address": "greendale_ss@moe.edu.sg",
        "mrt_desc": "PUNGGOL MRT, MERIDIAN LRT",
        "bus_desc": "3, 62, 83, 85, 136, 386",
        "principal_name": "MR SULAIMAN B MOHAMAD YUSOF",
        "first_vp_name": "MRS YU WEN YEN ANNE MRS ANNE CHAN",
        "second_vp_name": "MR CHIA KENG HWEE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3974817,
        "lng": 103.9120177
    },
    {
        "school_name": "GREENRIDGE PRIMARY SCHOOL",
        "url_address": "http://www.greenridgepri.moe.edu.sg",
        "address": "11 JELAPANG ROAD",
        "postal_code": 677744,
        "telephone_no": 67604265,
        "telephone_no_2": "na",
        "fax_no": 67620189,
        "fax_no_2": "na",
        "email_address": "GRPS@MOE.EDU.SG",
        "mrt_desc": "Senja LRT station, Jelapang LRT Station",
        "bus_desc": "Bus 920, 922, 972",
        "principal_name": "MADAM ONG FEI MIN",
        "first_vp_name": "MR WONG SUNG LAI",
        "second_vp_name": "MR ANG KONG BENG ANDY",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3856591,
        "lng": 103.7679301
    },
    {
        "school_name": "GREENRIDGE SECONDARY SCHOOL",
        "url_address": "http://www.greenridgesec.moe.edu.sg",
        "address": "31 Gangsa Road",
        "postal_code": 678972,
        "telephone_no": 67691491,
        "telephone_no_2": "na",
        "fax_no": "na",
        "fax_no_2": "na",
        "email_address": "GRSS@MOE.EDU.SG",
        "mrt_desc": "Bukit Panjang MRT, Bukit Panjang LRT, Petir LRT",
        "bus_desc": "65, 75, 170, 170A, 171, 176, 177, 178, 180, 180A, 920, 922, 960, 961, 963, 963E, 963R, 970, 972, 972A, 972, 972A, 972M, 973, 973A, 974, 975, 976, 979, 983",
        "principal_name": "MR NG BOON KIAT",
        "first_vp_name": "MRS DALINA BTE ABDULLAH",
        "second_vp_name": "MR NGOH SING KIEN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3754112,
        "lng": 103.7644315
    },
    {
        "school_name": "GREENWOOD PRIMARY SCHOOL",
        "url_address": "http://www.greenwoodpri.moe.edu.sg",
        "address": "11 WOODLANDS  DR  62",
        "postal_code": 737942,
        "telephone_no": 63666158,
        "telephone_no_2": "na",
        "fax_no": 63666159,
        "fax_no_2": "na",
        "email_address": "GREENWOOD_PS@MOE.EDU.SG",
        "mrt_desc": "Admiralty MRT Station",
        "bus_desc": "912, 913, 962",
        "principal_name": "MADAM TANG PEI LU TRICILIA",
        "first_vp_name": "MR KIRUPANANTHA KUMAR S/O PALAIYAN",
        "second_vp_name": "MR LEE HUAN SIAK",
        "third_vp_name": "MR TAN KAR WEE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4397028,
        "lng": 103.8049819
    },
    {
        "school_name": "GUANGYANG SECONDARY SCHOOL",
        "url_address": "http://guangyangsec.moe.edu.sg",
        "address": "8 BISHAN STREET 12",
        "postal_code": 579807,
        "telephone_no": 62589781,
        "telephone_no_2": "na",
        "fax_no": 63543108,
        "fax_no_2": "na",
        "email_address": "GYSS@MOE.EDU.SG",
        "mrt_desc": "BISHAN MRT",
        "bus_desc": "13, 56, 57, 59, 71, 88, 93, 157, 163, 410",
        "principal_name": "MISS TAN KE XIN",
        "first_vp_name": "MR HAN WEE FONG (HAN WEIFENG)",
        "second_vp_name": "MISS WU XINPING JENNIFER",
        "third_vp_name": "MR ANBALAGAN S/O THANGARAJAH",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BISHAN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3452268,
        "lng": 103.8505585
    },
    {
        "school_name": "HAI SING CATHOLIC SCHOOL",
        "url_address": "http://www.haisingcatholic.moe.edu.sg",
        "address": "15 PASIR RIS STREET 21",
        "postal_code": 518969,
        "telephone_no": 65827864,
        "telephone_no_2": "na",
        "fax_no": 65822543,
        "fax_no_2": "na",
        "email_address": "HSHS@MOE.EDU.SG",
        "mrt_desc": "PASIR RIS MRT",
        "bus_desc": "3, 5, 6, 89, 109",
        "principal_name": "MISS LIM MUI MUI ADELINE",
        "first_vp_name": "MISS SHEREEN WONG MINGRUI",
        "second_vp_name": "MADAM TAN PHUAY BOON, GWEN",
        "third_vp_name": "MR KONG WEI FOONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3692102,
        "lng": 103.9624183
    },
    {
        "school_name": "HAIG GIRLS' SCHOOL",
        "url_address": "http://www.haiggirls.moe.edu.sg",
        "address": "51 Koon Seng Road",
        "postal_code": 427072,
        "telephone_no": 63440293,
        "telephone_no_2": "na",
        "fax_no": 64474169,
        "fax_no_2": "na",
        "email_address": "HAIGGIRLSSCH@MOE.EDU.SG",
        "mrt_desc": "Eunos, Dakota",
        "bus_desc": "16,33",
        "principal_name": "MS MARION DONNE TAY SZE LENG (ZHENG SHILING)",
        "first_vp_name": "MADAM GOH SWEE LIN EVELYN",
        "second_vp_name": "MISS SEAH XIAO YUN SHERLYN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "GEYLANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3120003,
        "lng": 103.9026307
    },
    {
        "school_name": "HENRY PARK PRIMARY SCHOOL",
        "url_address": "http://www.henryparkpri.moe.edu.sg",
        "address": "1 HOLLAND GROVE ROAD",
        "postal_code": 278790,
        "telephone_no": 64663600,
        "telephone_no_2": "na",
        "fax_no": 64691840,
        "fax_no_2": "na",
        "email_address": "HPPS@MOE.EDU.SG",
        "mrt_desc": "Buona Vista MRT, Clementi MRT",
        "bus_desc": "7, 61, 75, 156, 157, 165, 92",
        "principal_name": "MR CHAN GEOK ANN CHARLES",
        "first_vp_name": "MR CHUA CHYE HOCK",
        "second_vp_name": "MRS JEAN TOH",
        "third_vp_name": "MISS REGINA KIM LEE HOON",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3167825,
        "lng": 103.7841363
    },
    {
        "school_name": "HILLGROVE SECONDARY SCHOOL",
        "url_address": "http://www.hillgrovesec.moe.edu.sg",
        "address": "10 BUKIT BATOK STREET 52",
        "postal_code": 659250,
        "telephone_no": 65603726,
        "telephone_no_2": "na",
        "fax_no": 65630920,
        "fax_no_2": "na",
        "email_address": "HILLGROVE_SS@MOE.EDU.SG",
        "mrt_desc": "BUKIT BATOK MRT, BUKIT GOMBAK MRT",
        "bus_desc": "176, 985, 945",
        "principal_name": "MADAM LEE CHING GUAN HELEN",
        "first_vp_name": "MR ADAM BIN AHMAD",
        "second_vp_name": "CHIANG HOCK YEE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3537023,
        "lng": 103.7532001
    },
    {
        "school_name": "HOLY INNOCENTS' HIGH SCHOOL",
        "url_address": "http://www.holyinnocentshigh.moe.edu.sg",
        "address": "1191 UPPER SERANGOON ROAD",
        "postal_code": 534786,
        "telephone_no": 62833381,
        "telephone_no_2": "na",
        "fax_no": 62831737,
        "fax_no_2": "na",
        "email_address": "HIHS@MOE.EDU.SG",
        "mrt_desc": "HOUGANG MRT",
        "bus_desc": "27, 72, 74, 80, 87, 89, 101, 107, 113, 116, 119, 132, 136, 147, 153, 161, 165, 324, 325",
        "principal_name": "MRS REBECCA CHEW",
        "first_vp_name": "MISS CAROL ANN MARTIN",
        "second_vp_name": "MR TEO HAN WOON, DENNIS",
        "third_vp_name": "MADAM ONG LEE LEE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3711442,
        "lng": 103.8960138
    },
    {
        "school_name": "HOLY INNOCENTS' PRIMARY SCHOOL",
        "url_address": "http://www.holyinnocentspri.moe.edu.sg/",
        "address": "5 Lorong Low Koon",
        "postal_code": 536451,
        "telephone_no": 62886516,
        "telephone_no_2": "na",
        "fax_no": 62876393,
        "fax_no_2": "na",
        "email_address": "HOLYINNOCENT@MOE.EDU.SG",
        "mrt_desc": "2km walk to Hougang MRT",
        "bus_desc": "51,72,80,101,119,132,136,153.",
        "principal_name": "MISS SEET ENG GEOK LENA",
        "first_vp_name": "MADAM TOO SIEW HAN JOYCE",
        "second_vp_name": "MADAM GOH HUI CHENG",
        "third_vp_name": "MR NG CHEONG ANN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3666609,
        "lng": 103.8936553
    },
    {
        "school_name": "HONG WEN SCHOOL",
        "url_address": "http://www.hongwen.moe.edu.sg",
        "address": "30 TOWNER ROAD",
        "postal_code": 327829,
        "telephone_no": 62943340,
        "telephone_no_2": "na",
        "fax_no": 62937625,
        "fax_no_2": "na",
        "email_address": "HWS@MOE.EDU.SG",
        "mrt_desc": "Boon Keng MRT",
        "bus_desc": "Serangoon Road: 13, 23, 31, 64, 65, 66, 125, 133, 147, 857, 985; Balestier Road: 21, 125, 130, 139, 145",
        "principal_name": "MRS THERESA HONG-NG",
        "first_vp_name": "MR ONG SZE CHONG",
        "second_vp_name": "MISS TEO AI LIN",
        "third_vp_name": "MADAM CHRISTINE POON TZE MEI",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "KALLANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3213838,
        "lng": 103.8570129
    },
    {
        "school_name": "HORIZON PRIMARY SCHOOL",
        "url_address": "http://www.horizonpri.moe.edu.sg",
        "address": "61 Edgedale Plains",
        "postal_code": 828819,
        "telephone_no": 67535411,
        "telephone_no_2": "na",
        "fax_no": 67523971,
        "fax_no_2": "na",
        "email_address": "horizon_ps@moe.edu.sg",
        "mrt_desc": "Punggol MRT Station (NE17); (LRT: Kadaloor [PE5] or Oasis [PE6])",
        "bus_desc": "3, 50, 83, 85, 569",
        "principal_name": "MADAM CHIA HUI KHIM",
        "first_vp_name": "MISS SEET SIEW LIN, PAMELA",
        "second_vp_name": "MADAM SENTHIL POONKODI D/O R K",
        "third_vp_name": "MR PHANG CHEE KHENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3998175,
        "lng": 103.9131302
    },
    {
        "school_name": "HOUGANG PRIMARY SCHOOL",
        "url_address": "http://www.hougangpri.moe.edu.sg/",
        "address": "1 HOUGANG ST 93",
        "postal_code": 534238,
        "telephone_no": 64897445,
        "telephone_no_2": "na",
        "fax_no": 64897446,
        "fax_no_2": "na",
        "email_address": "HOUGANG_PS@MOE.EDU.SG",
        "mrt_desc": "Ang Mo Kio, Buangkok, Hougang, Sengkang, Yio Chu Kang",
        "bus_desc": "SBS 43, 72, 88, 101, 109, 116, 156, 159, 325, 329",
        "principal_name": "MR GOH WAI MIN, JASON",
        "first_vp_name": "MISS LIEW PANG HAI",
        "second_vp_name": "MADAM SHARIFAH FAIRUZ BTE S Y A",
        "third_vp_name": "MADAM LIM SIEW GIM",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3781206,
        "lng": 103.8812046
    },
    {
        "school_name": "HOUGANG SECONDARY SCHOOL",
        "url_address": "http://www.hougangsec.moe.edu.sg",
        "address": "2 HOUGANG STREET 93",
        "postal_code": 534256,
        "telephone_no": 63851990,
        "telephone_no_2": "na",
        "fax_no": 63852015,
        "fax_no_2": "na",
        "email_address": "HOUGANG_SS@MOE.EDU.SG",
        "mrt_desc": "HOUGANG MRT, BUANGKOK MRT",
        "bus_desc": "43, 88, 101, 109, 156, 159, 161, 325, 329",
        "principal_name": "MR LEE THUAN SIM",
        "first_vp_name": "MR LIM SOON WAI",
        "second_vp_name": "MR TAY YUAN ZHUANG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.377661,
        "lng": 103.88253
    },
    {
        "school_name": "HUA YI SECONDARY SCHOOL",
        "url_address": "http://www.huayisec.moe.edu.sg",
        "address": "60 JURONG WEST ST 42",
        "postal_code": 649371,
        "telephone_no": 65634568,
        "telephone_no_2": "na",
        "fax_no": 65634505,
        "fax_no_2": "na",
        "email_address": "HYSS@MOE.EDU.SG",
        "mrt_desc": "LAKESIDE MRT, CHINESE GARDEN MRT",
        "bus_desc": "49, 98, 98B, 98M, 99, 157, 185, 187, 198, 198A, 334, 335, 502",
        "principal_name": "DR. LIM SIEW YEE",
        "first_vp_name": "MADAM TAN KAY BIN",
        "second_vp_name": "MR NG JOO KOON",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3522705,
        "lng": 103.7216407
    },
    {
        "school_name": "HUAMIN PRIMARY SCHOOL",
        "url_address": "http://www.huaminpri.moe.edu.sg",
        "address": "21 YISHUN AVENUE 11",
        "postal_code": 768857,
        "telephone_no": 67529004,
        "telephone_no_2": "na",
        "fax_no": 67552455,
        "fax_no_2": "na",
        "email_address": "HUAMIN_PS@MOE.EDU.SG",
        "mrt_desc": "Yishun MRT Station",
        "bus_desc": "806, 804",
        "principal_name": "MADAM LOE LAI PINK",
        "first_vp_name": "MADAM BALAKRISHNAN CORINNE ANNE",
        "second_vp_name": "MR HONG CHIN KEAT",
        "third_vp_name": "MR LEE LIN CHIEH",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.427311,
        "lng": 103.8443612
    },
    {
        "school_name": "HWA CHONG INSTITUTION",
        "url_address": "http://www.hwachong.edu.sg",
        "address": "661 BUKIT TIMAH ROAD",
        "postal_code": 269734,
        "telephone_no": 64683955,
        "telephone_no_2": 65786644,
        "fax_no": 67695857,
        "fax_no_2": "na",
        "email_address": "admin@hci.edu.sg",
        "mrt_desc": "TAN KAH KEE MRT",
        "bus_desc": "66, 67, 74, 151, 154, 156, 157, 170, 170A, 174, 852, 961, 961M",
        "principal_name": "MR LEE PECK PING",
        "first_vp_name": "MR CHAN KWOK LEONG",
        "second_vp_name": "MRS CHIN-LEOW BEE KUAN",
        "third_vp_name": "MISS HO PING PING",
        "fourth_vp_name": "DR LIM HONG SENG MELVYN",
        "fifth_vp_name": "MISS HOW LAI YIN DEBORAH",
        "sixth_vp_name": "MDM LIM MIAU TENG CHERYL",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "WEST",
        "type_code": "INDEPENDENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3261287,
        "lng": 103.803582
    },
    {
        "school_name": "INNOVA PRIMARY SCHOOL",
        "url_address": "http://www.innovapri.moe.edu.sg/",
        "address": "80 Woodlands Drive 17",
        "postal_code": 737888,
        "telephone_no": 68944693,
        "telephone_no_2": "na",
        "fax_no": 68942573,
        "fax_no_2": "na",
        "email_address": "innova_pri@moe.edu.sg",
        "mrt_desc": "Woodlands",
        "bus_desc": "900A (weekdays only - 7.00 am to 8.30 am & 4.30 pm to 6.30 pm), 901",
        "principal_name": "MR YEE YEW LOONG",
        "first_vp_name": "MR LAU YEAN HUI",
        "second_vp_name": "na",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4293039,
        "lng": 103.790427
    },
    {
        "school_name": "JIEMIN PRIMARY SCHOOL",
        "url_address": "http://www.jieminpri.moe.edu.sg",
        "address": "2 YISHUN STREET 71",
        "postal_code": 768515,
        "telephone_no": 67586472,
        "telephone_no_2": "na",
        "fax_no": 67559958,
        "fax_no_2": "na",
        "email_address": "JIEMIN_PS@MOE.EDU.SG",
        "mrt_desc": "Yishun MRT Station",
        "bus_desc": "167, 169, 171, 800, 811, 812, 856, 858, 859, 969, 980",
        "principal_name": "MR ANDY MICKEY CHOONG TEK CHOY",
        "first_vp_name": "MRS NUR FATIMAH BTE ABDUL MALIK MRS NUR FATIMAH FRAUDER",
        "second_vp_name": "MISS WONG KAH WAN JOY",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.427671,
        "lng": 103.830498
    },
    {
        "school_name": "JING SHAN PRIMARY SCHOOL",
        "url_address": "http://www.jingshanpri.moe.edu.sg",
        "address": "5 ANG MO KIO ST 52",
        "postal_code": 569228,
        "telephone_no": 64566305,
        "telephone_no_2": "na",
        "fax_no": 64581619,
        "fax_no_2": "na",
        "email_address": "JSPS@MOE.EDU.SG",
        "mrt_desc": "Ang Mo Kio MRT",
        "bus_desc": "Bus 265",
        "principal_name": "MADAM BOEY HUEY PENG SHARON",
        "first_vp_name": "MISS NG SUAT THENG ANGELA",
        "second_vp_name": "MR JONATHON LOH",
        "third_vp_name": "MISS LIM EE LENG ELLEN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3723262,
        "lng": 103.8517128
    },
    {
        "school_name": "JUNYUAN PRIMARY SCHOOL",
        "url_address": "https://junyuanpri.moe.edu.sg",
        "address": "2 Tampines Street 91",
        "postal_code": 528906,
        "telephone_no": 67830375,
        "telephone_no_2": "na",
        "fax_no": 67887395,
        "fax_no_2": "na",
        "email_address": "JUNYUAN_PS@MOE.EDU.SG",
        "mrt_desc": "Tampines West (Downtown Line); Tampines (East-West Line)",
        "bus_desc": "76281: 46, 65, 129; 76061: 10, 15, 20, 21, 23, 27, 31, 34, 39, 67, 168, 292; 75051: 5, 8, 15, 18, 21, 23, 28, 59, 67, 118, 168, 513, 518",
        "principal_name": "MR CHAN WENG CHEONG",
        "first_vp_name": "MRS CHEANG MENG TSING",
        "second_vp_name": "MADAM CHUT SHI LIN",
        "third_vp_name": "MR WILLIAM CHUE WAI LEONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3479731,
        "lng": 103.9399917
    },
    {
        "school_name": "JUNYUAN SECONDARY SCHOOL",
        "url_address": "https://junyuansec.moe.edu.sg/",
        "address": "11 TAMPINES STREET 84",
        "postal_code": 528933,
        "telephone_no": 65873683,
        "telephone_no_2": "na",
        "fax_no": "na",
        "fax_no_2": "na",
        "email_address": "JUNYUAN_SS@MOE.EDU.SG",
        "mrt_desc": "TAMPINES MRT, TAMPINES WEST MRT",
        "bus_desc": "69, 291, 293, 46",
        "principal_name": "MR TAY MENG KIAT",
        "first_vp_name": "MR LIN PEI",
        "second_vp_name": "MR GAN THIAM SOON ALLAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3533278,
        "lng": 103.9335232
    },
    {
        "school_name": "JURONG PIONEER JUNIOR COLLEGE",
        "url_address": "http://jpjc.moe.edu.sg",
        "address": "21 Teck Whye Walk",
        "postal_code": 688258,
        "telephone_no": 65646878,
        "telephone_no_2": "na",
        "fax_no": 67651861,
        "fax_no_2": "na",
        "email_address": "jpjc@moe.edu.sg",
        "mrt_desc": "Choa Chu Kang / Bt Panjang / Phoenix Station (LRT)",
        "bus_desc": "975, 190, 985",
        "principal_name": "MR KEVIN ANG",
        "first_vp_name": "MRS LEE BEE CHEOW",
        "second_vp_name": "MR NAH HONG LEONG",
        "third_vp_name": "MR POW TIEN MIN JARON",
        "fourth_vp_name": "MR PHUA YONG SWEE",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3847446,
        "lng": 103.753857
    },
    {
        "school_name": "JURONG PRIMARY SCHOOL",
        "url_address": "http://www.jurongpri.moe.edu.sg",
        "address": "320 JURONG EAST Street 32",
        "postal_code": 609476,
        "telephone_no": 65618837,
        "telephone_no_2": "na",
        "fax_no": 65641964,
        "fax_no_2": "na",
        "email_address": "JPS@MOE.EDU.SG",
        "mrt_desc": "Lakeside MRT Station, Jurong East MRT Station",
        "bus_desc": 333,
        "principal_name": "MR LEONARD CHUA",
        "first_vp_name": "MISS TAN PEIRU",
        "second_vp_name": "MR TAN YUAN SHIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG EAST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.348679,
        "lng": 103.732992
    },
    {
        "school_name": "JURONG SECONDARY SCHOOL",
        "url_address": "http://www.jurongsec.moe.edu.sg",
        "address": "31 YUAN CHING ROAD",
        "postal_code": 618652,
        "telephone_no": 62655980,
        "telephone_no_2": "na",
        "fax_no": 62686414,
        "fax_no_2": "na",
        "email_address": "JURONG_SS@MOE.EDU.SG",
        "mrt_desc": "LAKESIDE MRT",
        "bus_desc": "30, 49, 98, 154, 240, 246",
        "principal_name": "MISS YEO SIOK EE",
        "first_vp_name": "MADAM LER SIAH WOON JULIA",
        "second_vp_name": "MR LU YEOW CHOR",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.330365,
        "lng": 103.724282
    },
    {
        "school_name": "JURONG WEST PRIMARY SCHOOL",
        "url_address": "http://www.jurongwestpri.moe.edu.sg",
        "address": "30 JURONG WEST ST 61",
        "postal_code": 648368,
        "telephone_no": 67933419,
        "telephone_no_2": "na",
        "fax_no": 67936593,
        "fax_no_2": "na",
        "email_address": "JWPS@MOE.EDU.SG",
        "mrt_desc": "Pioneer MRT Station",
        "bus_desc": 192,
        "principal_name": "MRS CHRISTINA LIM LAY LENG",
        "first_vp_name": "MADAM SIM EE KOON PATRICIA",
        "second_vp_name": "MISS TAN WAN KHENG",
        "third_vp_name": "MR LIM CHIN GUAN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3390605,
        "lng": 103.6988498
    },
    {
        "school_name": "JURONG WEST SECONDARY SCHOOL",
        "url_address": "https://www.jurongwestsec.moe.edu.sg",
        "address": "61 JURONG WEST STREET 65",
        "postal_code": 648348,
        "telephone_no": 62623593,
        "telephone_no_2": "na",
        "fax_no": 62623587,
        "fax_no_2": "na",
        "email_address": "JWSS@MOE.EDU.SG",
        "mrt_desc": "BOON LAY MRT, PIONEER MRT",
        "bus_desc": "30, 154, 157, 180, 187, 198, 242",
        "principal_name": "MISS TAN MING MING",
        "first_vp_name": "MS TAN JIING SHYUAN",
        "second_vp_name": "MDM ZARINA BINTE AMIR",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3358625,
        "lng": 103.7016785
    },
    {
        "school_name": "JURONGVILLE SECONDARY SCHOOL",
        "url_address": "http://www.jurongvillesec.moe.edu.sg",
        "address": "202 JURONG EAST AVENUE 1",
        "postal_code": 609790,
        "telephone_no": 65638704,
        "telephone_no_2": "na",
        "fax_no": 65662137,
        "fax_no_2": "na",
        "email_address": "JURONGVILLE@MOE.EDU.SG",
        "mrt_desc": "JURONG EAST MRT, LAKESIDE MRT",
        "bus_desc": "98, 98M, 99, 157, 185, 187, 198, 334, 502",
        "principal_name": "MR LEOW ZHI WEN PHILIBERT",
        "first_vp_name": "MR YONG KEK SHOONG",
        "second_vp_name": "MISS IBAIDAH BINTE IBRAHIM",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG EAST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3516392,
        "lng": 103.7291022
    },
    {
        "school_name": "JUYING SECONDARY SCHOOL",
        "url_address": "http://juyingsec.moe.edu.sg",
        "address": "33 JURONG WEST STREET 91",
        "postal_code": 649038,
        "telephone_no": 63089898,
        "telephone_no_2": "na",
        "fax_no": 67932835,
        "fax_no_2": "na",
        "email_address": "JUYING_SS@MOE.EDU.SG",
        "mrt_desc": "BOON LAY MRT, PIONEER MRT, JOO KOON MRT",
        "bus_desc": "99, 241",
        "principal_name": "MR ANG CHERN KWANG",
        "first_vp_name": "MR NG HAN MING",
        "second_vp_name": "MR CHUA YEW WEI",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3392826,
        "lng": 103.687185
    },
    {
        "school_name": "MEE TOH SCHOOL",
        "url_address": "http://www.meetoh.moe.edu.sg/",
        "address": "21 EDGEDALE PLAINS",
        "postal_code": 828867,
        "telephone_no": 64893326,
        "telephone_no_2": "na",
        "fax_no": 64893243,
        "fax_no_2": "na",
        "email_address": "MEETOH_SCH@MOE.EDU.SG",
        "mrt_desc": "Punggol Station",
        "bus_desc": "3,62,83,381",
        "principal_name": "MR TAY HSIEN CHUAN KELVIN",
        "first_vp_name": "MISS HUANG YILAN LYNNE",
        "second_vp_name": "MR LEE CHONG TART RONALD",
        "third_vp_name": "MR NG KOK HENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3947729,
        "lng": 103.9089333
    },
    {
        "school_name": "KEMING PRIMARY SCHOOL",
        "url_address": "http://www.kemingpri.moe.edu.sg",
        "address": "90 BUKIT BATOK EAST AVENUE 6",
        "postal_code": 659762,
        "telephone_no": 68962054,
        "telephone_no_2": "na",
        "fax_no": 65632356,
        "fax_no_2": "na",
        "email_address": "KMPS@MOE.EDU.SG",
        "mrt_desc": "Bukit Batok",
        "bus_desc": "61,66,77,106,157,174,178,963",
        "principal_name": "MRS MRS YAP DAI JEE",
        "first_vp_name": "MS LEOW MEI LENG (LIU MEICEN)",
        "second_vp_name": "MISS NG MEI YUN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3453287,
        "lng": 103.7563823
    },
    {
        "school_name": "KENT RIDGE SECONDARY SCHOOL",
        "url_address": "http://www.kentridgesec.moe.edu.sg",
        "address": "147 WEST COAST ROAD",
        "postal_code": 127368,
        "telephone_no": 67731127,
        "telephone_no_2": "na",
        "fax_no": 67735119,
        "fax_no_2": "na",
        "email_address": "KRSS@MOE.EDU.SG",
        "mrt_desc": "CLEMENTI MRT, HAW PAR VILLA MRT",
        "bus_desc": "30, 51, 143, 175, 176, 201, 282",
        "principal_name": "MADAM GOH MIEN HUI VALERIE",
        "first_vp_name": "MADAM YAP SHARON",
        "second_vp_name": "MR POH LEONG BERG, ALBERT",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CLEMENTI",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "na",
        "lat": 1.3013766,
        "lng": 103.7649426
    },
    {
        "school_name": "KHENG CHENG SCHOOL",
        "url_address": "http://www.khengcheng.moe.edu.sg/",
        "address": "15 LORONG 3 TOA PAYOH",
        "postal_code": 319580,
        "telephone_no": 62552502,
        "telephone_no_2": "na",
        "fax_no": 62556569,
        "fax_no_2": "na",
        "email_address": "KCS@MOE.EDU.SG",
        "mrt_desc": "Braddell",
        "bus_desc": "SBS 235,56,73,88,157,159,163,231,",
        "principal_name": "MADAM TAN HUILING CHERYL",
        "first_vp_name": "MR KHOO GHEE HAN",
        "second_vp_name": "MR PUN KIAN PENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3376497,
        "lng": 103.8477955
    },
    {
        "school_name": "KONG HWA SCHOOL",
        "url_address": "http://www.konghwa.moe.edu.sg",
        "address": "350 GUILLEMARD ROAD",
        "postal_code": 399772,
        "telephone_no": 63421195,
        "telephone_no_2": "na",
        "fax_no": 63421120,
        "fax_no_2": "na",
        "email_address": "KONGHWA_SCH@MOE.EDU.SG",
        "mrt_desc": "Dakota",
        "bus_desc": "Service 7,70,70M,197(to Guillemard Road)",
        "principal_name": "MR POON SIOW LENG RAYMOND",
        "first_vp_name": "MADAM UE TAY SZE YIN",
        "second_vp_name": "MADAM TEO SIEW KHIM",
        "third_vp_name": "MADAM NG BEE HOON",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "GEYLANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.311089,
        "lng": 103.8881773
    },
    {
        "school_name": "KRANJI PRIMARY SCHOOL",
        "url_address": "http://kranjipri.moe.edu.sg",
        "address": "11 CHOA CHU KANG STREET 54",
        "postal_code": 689189,
        "telephone_no": 67634812,
        "telephone_no_2": "na",
        "fax_no": 67634568,
        "fax_no_2": "na",
        "email_address": "KRANJI_PS@MOE.EDU.SG",
        "mrt_desc": "Yew Tee MRT",
        "bus_desc": "Bus No 307, 302",
        "principal_name": "MADAM GOH MEEI YUNN",
        "first_vp_name": "MR SATHYA PRASAD S/O G",
        "second_vp_name": "MADAM WONG SEOW LING",
        "third_vp_name": "MADAM LEE LENG HUI (LI LINGHUI)",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3936035,
        "lng": 103.747804
    },
    {
        "school_name": "KRANJI SECONDARY SCHOOL",
        "url_address": "http://www.kranjisec.moe.edu.sg",
        "address": "61 CHOA CHU KANG STREET 51",
        "postal_code": 689333,
        "telephone_no": 67662464,
        "telephone_no_2": "na",
        "fax_no": 67662095,
        "fax_no_2": "na",
        "email_address": "KRANJI_SS@MOE.EDU.SG",
        "mrt_desc": "CHOA CHU KANG MRT, YEW TEE MRT",
        "bus_desc": "302, 974, 979",
        "principal_name": "MR CHUA LEK HONG",
        "first_vp_name": "MR KOO TIANNUO",
        "second_vp_name": "MADAM ONG LAY LING",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3906192,
        "lng": 103.7415227
    },
    {
        "school_name": "KUO CHUAN PRESBYTERIAN PRIMARY SCHOOL",
        "url_address": "http://www.kuochuanpresbyterianpri.moe.edu.sg",
        "address": "8 BISHAN STREET 13",
        "postal_code": 579793,
        "telephone_no": 62595396,
        "telephone_no_2": "na",
        "fax_no": 62588012,
        "fax_no_2": "na",
        "email_address": "KCPPS@MOE.EDU.SG",
        "mrt_desc": "Bishan MRT Station",
        "bus_desc": "54, 56, 410, 410G",
        "principal_name": "MADAM YEE-TOH GEK KHIAW",
        "first_vp_name": "MISS LIN HUIXIN SHARON",
        "second_vp_name": "MR TAN CHIN HENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BISHAN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3493915,
        "lng": 103.8552309
    },
    {
        "school_name": "KUO CHUAN PRESBYTERIAN SECONDARY SCHOOL",
        "url_address": "http://www.kuochuanpresbyteriansec.moe.edu.sg",
        "address": "10 BISHAN STREET 13",
        "postal_code": 579795,
        "telephone_no": 62593811,
        "telephone_no_2": "na",
        "fax_no": 63536535,
        "fax_no_2": "na",
        "email_address": "KCPSS@MOE.EDU.SG",
        "mrt_desc": "BISHAN MRT",
        "bus_desc": "54, 56, 410G, 410W",
        "principal_name": "MR JUSTIN TAN",
        "first_vp_name": "MADAM LEE CHUI ENG",
        "second_vp_name": "MR EKA TANU",
        "third_vp_name": "MR PHANG TECK KING",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BISHAN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.349824,
        "lng": 103.8549463
    },
    {
        "school_name": "LAKESIDE PRIMARY SCHOOL",
        "url_address": "http://www.lakesidepri.moe.edu.sg/",
        "address": "161 Corporation Walk",
        "postal_code": 618310,
        "telephone_no": 62620918,
        "telephone_no_2": "na",
        "fax_no": 62621021,
        "fax_no_2": "na",
        "email_address": "lakeside_ps@moe.edu.sg",
        "mrt_desc": "Lakeside MRT",
        "bus_desc": "30, 49, 98, 98M",
        "principal_name": "MADAM YAP SIU LIN",
        "first_vp_name": "MISS HAN MINGFANG CHARMAIN",
        "second_vp_name": "MISS TAN HUI PING",
        "third_vp_name": "MADAM CHUA LENG LENG (CAI LINGLING)",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3384657,
        "lng": 103.7181475
    },
    {
        "school_name": "LIANHUA PRIMARY SCHOOL",
        "url_address": "http://www.lianhuapri.moe.edu.sg/",
        "address": "2 BUKIT BATOK STREET 52",
        "postal_code": 659243,
        "telephone_no": 65639502,
        "telephone_no_2": "na",
        "fax_no": 65639591,
        "fax_no_2": "na",
        "email_address": "LIANHUA_PS@MOE.EDU.SG",
        "mrt_desc": "Bukit Gombak/Bukit Batok",
        "bus_desc": 945,
        "principal_name": "MISS KIEW HUI LI PAMELA",
        "first_vp_name": "MADAM MAVIS SIEW SOOK LING",
        "second_vp_name": "MADAM TAN WAN PHING JANICE",
        "third_vp_name": "MR LEE TZE WEI, JEFFREY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3536088,
        "lng": 103.754424
    },
    {
        "school_name": "LOYANG VIEW SECONDARY SCHOOL",
        "url_address": "http://www.loyangviewsec.moe.edu.sg",
        "address": "12 PASIR RIS STREET 11",
        "postal_code": 519073,
        "telephone_no": 65821727,
        "telephone_no_2": "na",
        "fax_no": 65810557,
        "fax_no_2": "na",
        "email_address": "loyangview_ss@moe.edu.sg",
        "mrt_desc": "PASIR RIS MRT",
        "bus_desc": "12, 21, 39, 53, 81, 109, 359, 518",
        "principal_name": "MR LIN YUCHENG EUGENE",
        "first_vp_name": "MS SAADIAH SAADON WYLDE",
        "second_vp_name": "MADAM TAN SHAO MAY",
        "third_vp_name": "MISS LIEW XUE TING ADELINE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3668644,
        "lng": 103.9568413
    },
    {
        "school_name": "MAHA BODHI SCHOOL",
        "url_address": "http://www.mahabodhi.moe.edu.sg/",
        "address": "10 UBI AVENUE 1",
        "postal_code": 408931,
        "telephone_no": 67442115,
        "telephone_no_2": "na",
        "fax_no": 67443752,
        "fax_no_2": "na",
        "email_address": "MBS@MOE.EDU.SG",
        "mrt_desc": "Eunos Station (Transfer Bus No.63, 63M); Ubi Station (Transfer Bus No. 137)",
        "bus_desc": "5,8,15,22,25,45,51,55,59,61,63,63M,65,66,93,94,137,854",
        "principal_name": "MADAM TENG LAI KWAN",
        "first_vp_name": "MR WEE HOCK MENG VICTOR",
        "second_vp_name": "MR YE JIAMING AARON",
        "third_vp_name": "MADAM LENG BING LING (LIANG BINGLING)",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "GEYLANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3284131,
        "lng": 103.9015463
    },
    {
        "school_name": "MANJUSRI SECONDARY SCHOOL",
        "url_address": "http://www.manjusrisec.moe.edu.sg",
        "address": "20 UBI AVENUE 1",
        "postal_code": 408940,
        "telephone_no": 68424558,
        "telephone_no_2": "na",
        "fax_no": 67454492,
        "fax_no_2": "na",
        "email_address": "MANJUSRI_SS@MOE.EDU.SG",
        "mrt_desc": "UBI MRT, MACPHERSON MRT",
        "bus_desc": "5, 8, 15, 22, 25, 45, 51, 55, 59, 61, 63, 63M, 65, 66, 93, 94, 137, 854",
        "principal_name": "MR SIM CHONG BOON",
        "first_vp_name": "MR LIN JUNKAI",
        "second_vp_name": "MR GOH PAI SHEN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "GEYLANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "na",
        "lat": 1.3275247,
        "lng": 103.901507
    },
    {
        "school_name": "MARIS STELLA HIGH SCHOOL",
        "url_address": "http://www.marisstellahigh.moe.edu.sg",
        "address": "25 MOUNT VERNON ROAD",
        "postal_code": 368051,
        "telephone_no": "62803880 (Sec)",
        "telephone_no_2": "62827743 (Pri)",
        "fax_no": "62886905 (Sec)",
        "fax_no_2": "62827905 (Pri)",
        "email_address": "MSH@MOE.EDU.SG",
        "mrt_desc": "BARTLEY MRT",
        "bus_desc": "28, 93, 129, 158",
        "principal_name": "MR BOY ENG SENG",
        "first_vp_name": "MRS LIM QING YI",
        "second_vp_name": "MR PAN JINGLIU",
        "third_vp_name": "MR TAN CHING HUAT",
        "fourth_vp_name": "MDM ANG CHWEE YING PEARLY",
        "fifth_vp_name": "MR LEE KO YONG",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (P1-S4)",
        "sap_ind": "Yes",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3411414,
        "lng": 103.8776654
    },
    {
        "school_name": "MARSILING PRIMARY SCHOOL",
        "url_address": "http://www.marsilingpri.moe.edu.sg",
        "address": "31 WOODLANDS CENTRE ROAD",
        "postal_code": 738927,
        "telephone_no": 62696193,
        "telephone_no_2": "na",
        "fax_no": 62699050,
        "fax_no_2": "na",
        "email_address": "MARSILING_PS@MOE.EDU.SG",
        "mrt_desc": "Marsiling MRT Station",
        "bus_desc": "856, 911, 912",
        "principal_name": "MADAM HEATHER SIM SIAW CHENG",
        "first_vp_name": "MR JACKSON KEK",
        "second_vp_name": "na",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4338104,
        "lng": 103.7736593
    },
    {
        "school_name": "MARSILING SECONDARY SCHOOL",
        "url_address": "http://www.marsilingsec.moe.edu.sg",
        "address": "12 MARSILING ROAD",
        "postal_code": 739110,
        "telephone_no": 68941413,
        "telephone_no_2": "na",
        "fax_no": 68946156,
        "fax_no_2": "na",
        "email_address": "MARSILING_SS@MOE.EDU.SG",
        "mrt_desc": "MARSILING MRT",
        "bus_desc": "913, 911",
        "principal_name": "MR KOH YIAK KHENG",
        "first_vp_name": "MR MOHAMED NASIM S/O ABDUL RAHIM",
        "second_vp_name": "MR TAN TONG AIK",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4381054,
        "lng": 103.7763303
    },
    {
        "school_name": "MARYMOUNT CONVENT SCHOOL",
        "url_address": "HTTP://WWW.MARYMOUNTCONVENT.MOE.EDU.SG",
        "address": "20 Marymount Road",
        "postal_code": 297754,
        "telephone_no": "6256 6701",
        "telephone_no_2": "6256 6532",
        "fax_no": "6254 3080",
        "fax_no_2": "na",
        "email_address": "MMCS@MOE.EDU.SG",
        "mrt_desc": "Braddell MRT Station or Caldecott MRT Station",
        "bus_desc": "141, 235",
        "principal_name": "MISS CHEONG HWEE KHIM",
        "first_vp_name": "MRS HING SZE MEING DEBBIE (XING SIMIN DEBBIE)",
        "second_vp_name": "MADAM TAN MEI MEI ANNA",
        "third_vp_name": "MR LOH YEH CHANG HENRY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3406106,
        "lng": 103.8400154
    },
    {
        "school_name": "MAYFLOWER PRIMARY SCHOOL",
        "url_address": "http://www.mayflowerpri.moe.edu.sg",
        "address": "200 Ang Mo Kio Avenue 5",
        "postal_code": 569878,
        "telephone_no": 64520849,
        "telephone_no_2": "na",
        "fax_no": 64534116,
        "fax_no_2": "na",
        "email_address": "MAYFLOWER_PS@MOE.EDU.SG",
        "mrt_desc": "Yio Chu Kang MRT Station.",
        "bus_desc": "13,86,138,162,269,851,852,853.",
        "principal_name": "MISS CECILIA LIM SEOK CHENG",
        "first_vp_name": "MADAM CHNG HWUI LIN WINEFREDE",
        "second_vp_name": "MRS SANTHI D/O K RAMACHANDRAN",
        "third_vp_name": "MR KWOK KENG LIAN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3766994,
        "lng": 103.8431573
    },
    {
        "school_name": "MAYFLOWER SECONDARY SCHOOL",
        "url_address": "http://www.mayflowersec.moe.edu.sg",
        "address": "2 ANG MO KIO STREET 21",
        "postal_code": 569384,
        "telephone_no": 64577783,
        "telephone_no_2": "na",
        "fax_no": 64583284,
        "fax_no_2": "na",
        "email_address": "MAYFLOWER_SS@MOE.EDU.SG",
        "mrt_desc": "ANG MO KIO MRT, MAYFLOWER MRT",
        "bus_desc": "71, 76, 132, 165, 166, 169, 262, 265, 268, 269",
        "principal_name": "MR LIM YU KEE",
        "first_vp_name": "MR GOH KENG TENG",
        "second_vp_name": "MR PRASHANT S/O JAYAPRAGAS",
        "third_vp_name": "MADAM NUR HIDAYANI IBRAHIM",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3687527,
        "lng": 103.835656
    },
    {
        "school_name": "MERIDIAN PRIMARY SCHOOL",
        "url_address": "http://www.meridianpri.moe.edu.sg/",
        "address": "20 PASIR RIS ST 71",
        "postal_code": 518798,
        "telephone_no": 65832125,
        "telephone_no_2": "na",
        "fax_no": 65834993,
        "fax_no_2": "na",
        "email_address": "MERIDIAN_PS@MOE.EDU.SG",
        "mrt_desc": "Pasir Ris MRT Station",
        "bus_desc": "3,359",
        "principal_name": "MDM CHEW SIANG JIUN",
        "first_vp_name": "MR LIM KIM MIN (LIN JINMIN)",
        "second_vp_name": "MR WANG TAI WEE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3767228,
        "lng": 103.9354461
    },
    {
        "school_name": "MERIDIAN SECONDARY SCHOOL",
        "url_address": "http://www.meridiansec.moe.edu.sg",
        "address": "31 PASIR RIS STREET 51",
        "postal_code": 518901,
        "telephone_no": 65831387,
        "telephone_no_2": "na",
        "fax_no": 65836467,
        "fax_no_2": "na",
        "email_address": "meridian_sec@moe.edu.sg",
        "mrt_desc": "PASIR RIS MRT",
        "bus_desc": "39, 53, 81, 89, 109, 359, 403, 518",
        "principal_name": "MR MOHAMED RAZALI B ABDUL HAMED",
        "first_vp_name": "MISS TAN LI PING",
        "second_vp_name": "MRS TAY NGEE SEEW",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3675302,
        "lng": 103.9492665
    },
    {
        "school_name": "METHODIST GIRLS' SCHOOL (PRIMARY)",
        "url_address": "https://www.mgs.moe.edu.sg/",
        "address": "11 Blackmore Drive",
        "postal_code": 599986,
        "telephone_no": 64694800,
        "telephone_no_2": "na",
        "fax_no": 64624166,
        "fax_no_2": "na",
        "email_address": "MGPS@MOE.EDU.SG",
        "mrt_desc": "King Albert Park MRT",
        "bus_desc": "66, 67, 74, 77, 151, 154, 157, 170, 171, 174, 852, 961, 970",
        "principal_name": "KOH MING-LI VALARIE",
        "first_vp_name": "MADAM YEOW CHERN EE",
        "second_vp_name": "MR TENG TAT MENG, CHARLES",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3329949,
        "lng": 103.783453
    },
    {
        "school_name": "METHODIST GIRLS' SCHOOL (SECONDARY)",
        "url_address": "http://www.mgs.moe.edu.sg",
        "address": "11 BLACKMORE DRIVE",
        "postal_code": 599986,
        "telephone_no": 64694800,
        "telephone_no_2": "na",
        "fax_no": 64698717,
        "fax_no_2": "na",
        "email_address": "MGSS@MOE.EDU.SG",
        "mrt_desc": "KING ALBERT PARK MRT",
        "bus_desc": "66, 67, 74, 77, 151, 154, 157, 170, 174, 852, 961, 970",
        "principal_name": "MADAM KOH MING- LI VALARIE",
        "first_vp_name": "MADAM CHNG YI NA @MRS WRIGHT YI NA",
        "second_vp_name": "MDM TAN P'ENG DIANA",
        "third_vp_name": "MR YIP WAI CHOONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "WEST",
        "type_code": "INDEPENDENT SCHOOL",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3329949,
        "lng": 103.783453
    },
    {
        "school_name": "MILLENNIA INSTITUTE",
        "url_address": "http://www.millenniainstitute.moe.edu.sg",
        "address": "60 Bukit Batok West Avenue 8",
        "postal_code": 658965,
        "telephone_no": 63023700,
        "telephone_no_2": "na",
        "fax_no": 63023767,
        "fax_no_2": "na",
        "email_address": "millennia_inst@moe.edu.sg",
        "mrt_desc": "Bukit Batok (NS 2)",
        "bus_desc": "157, 174, 174e, 178, 506, 870, 941, 991, 993",
        "principal_name": "MR LOO MING YAW",
        "first_vp_name": "MR LIN GUOJING",
        "second_vp_name": "MR TAN KENG CHEONG",
        "third_vp_name": "MR DAVID ALLAN D'SOUZA",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "CENTRALISED INSTITUTE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3508257,
        "lng": 103.7413873
    },
    {
        "school_name": "MONTFORT JUNIOR SCHOOL",
        "url_address": "http://www.montfortjunior.moe.edu.sg/",
        "address": "52 HOUGANG AVENUE 8",
        "postal_code": 538786,
        "telephone_no": 65101588,
        "telephone_no_2": "na",
        "fax_no": 65101599,
        "fax_no_2": "na",
        "email_address": "MONTFORT_JS@MOE.EDU.SG",
        "mrt_desc": "Hougang MRT & Bus Interchange",
        "bus_desc": "74,88,101,147,161,",
        "principal_name": "MR TAN BOON HONG VICTOR",
        "first_vp_name": "MADAM POH LEE SIEW",
        "second_vp_name": "MR TAN WEE BOON",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.373863,
        "lng": 103.8895082
    },
    {
        "school_name": "MONTFORT SECONDARY SCHOOL",
        "url_address": "https://montfortsec.moe.edu.sg/",
        "address": "50 HOUGANG AVENUE 8",
        "postal_code": 538785,
        "telephone_no": 65107070,
        "telephone_no_2": "na",
        "fax_no": 63862804,
        "fax_no_2": "na",
        "email_address": "MONTFORT_SS@MOE.EDU.SG",
        "mrt_desc": "HOUGANG MRT",
        "bus_desc": "74, 74e, 88, 88A, 101, 147, 147A, 161",
        "principal_name": "MADAM HENG SUE LIN, JANICE",
        "first_vp_name": "MR WILSON TAY SWEE KIAT",
        "second_vp_name": "MISS TAN MEI LING AUDREY",
        "third_vp_name": "MADAM TAN LAY YEN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3741106,
        "lng": 103.8887182
    },
    {
        "school_name": "NAN CHIAU HIGH SCHOOL",
        "url_address": "http://www.nanchiauhigh.moe.edu.sg",
        "address": "20 ANCHORVALE LINK",
        "postal_code": 545079,
        "telephone_no": 64897971,
        "telephone_no_2": "na",
        "fax_no": 64897970,
        "fax_no_2": "na",
        "email_address": "NCHS@MOE.EDU.SG",
        "mrt_desc": "SENGKANG MRT, RENJONG LRT, TONGKANG LRT",
        "bus_desc": "43, 83, 85, 109, 156, 159, 161, 163, 372",
        "principal_name": "MADAM LER JIA LUEN",
        "first_vp_name": "MADAM CHOW NYET YOON",
        "second_vp_name": "DR. OH BEE LENG HESTER",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3892826,
        "lng": 103.8902985
    },
    {
        "school_name": "NAN CHIAU PRIMARY SCHOOL",
        "url_address": "http://www.ncps.moe.edu.sg",
        "address": "50 ANCHORVALE LINK",
        "postal_code": 545080,
        "telephone_no": 64897905,
        "telephone_no_2": "na",
        "fax_no": 64897906,
        "fax_no_2": "na",
        "email_address": "NCPS@MOE.EDU.SG",
        "mrt_desc": "Sengkang Station",
        "bus_desc": "156, 159, 161, 371, 372",
        "principal_name": "MRS ONG LOH JIA MIIN",
        "first_vp_name": "MDM HOE QUEE HIANG, BELINDA",
        "second_vp_name": "MADAM LIM SHEUE TYUG",
        "third_vp_name": "MR WINSTON TAN WEE SING",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3922351,
        "lng": 103.8907825
    },
    {
        "school_name": "NAN HUA HIGH SCHOOL",
        "url_address": "http://www.nanhuahigh.moe.edu.sg",
        "address": "41 CLEMENTI AVENUE 1",
        "postal_code": 129956,
        "telephone_no": 67788303,
        "telephone_no_2": "na",
        "fax_no": 67751956,
        "fax_no_2": "na",
        "email_address": "NHSS@MOE.EDU.SG",
        "mrt_desc": "CLEMENTI MRT",
        "bus_desc": "14, 33, 52, 78, 96, 97, 105, 106, 147, 151, 154, 165, 166, 183, 185, 188, 189, 196, 197, 198, 282, 285, 963",
        "principal_name": "MR CHIEW JING WEN",
        "first_vp_name": "MISS TAY JIA MING JASMINE",
        "second_vp_name": "MR LOO JIAMING",
        "third_vp_name": "MR LEE KOK BOON",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CLEMENTI",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "Yes",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3084132,
        "lng": 103.7689985
    },
    {
        "school_name": "NAN HUA PRIMARY SCHOOL",
        "url_address": "http://www.nanhuapri.moe.edu.sg",
        "address": "30 Jalan Lempeng",
        "postal_code": 128806,
        "telephone_no": 67788050,
        "telephone_no_2": "na",
        "fax_no": 67784127,
        "fax_no_2": "na",
        "email_address": "NHPS@MOE.EDU.SG",
        "mrt_desc": "Clementi MRT Station",
        "bus_desc": "30, 51, 143, 175, 201, 533, 655, 727, 762",
        "principal_name": "MADAM PHUA YIN LIN GRACE",
        "first_vp_name": "MISS TEH LAY CHOO ANNE",
        "second_vp_name": "MR LIM PENG YUAN, ANDY",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CLEMENTI",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3197989,
        "lng": 103.7619428
    },
    {
        "school_name": "NANYANG GIRLS' HIGH SCHOOL",
        "url_address": "https://www.nygh.edu.sg",
        "address": "2 LINDEN DRIVE",
        "postal_code": 288683,
        "telephone_no": 64663275,
        "telephone_no_2": "na",
        "fax_no": 64667564,
        "fax_no_2": "na",
        "email_address": "NYGHS@MOE.EDU.SG",
        "mrt_desc": "SIXTH AVENUE MRT, TAN KAH KEE MRT",
        "bus_desc": "67, 74, 151, 154, 156, 157, 170, 174, 852, 961",
        "principal_name": "MISS SIAU FONG FUI",
        "first_vp_name": "MS NG MIEN MIEN AGNES",
        "second_vp_name": "MISS GAYNOR TEH",
        "third_vp_name": "MS TAN MEEI YEE MAE PAULINE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "WEST",
        "type_code": "INDEPENDENT SCHOOL",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3307195,
        "lng": 103.8024603
    },
    {
        "school_name": "NANYANG JUNIOR COLLEGE",
        "url_address": "http://www.nanyangjc.moe.edu.sg/",
        "address": "128 SERANGOON AVENUE 3",
        "postal_code": 556111,
        "telephone_no": 62842281,
        "telephone_no_2": "na",
        "fax_no": 62855147,
        "fax_no_2": "na",
        "email_address": "NYJC@MOE.EDU.SG",
        "mrt_desc": "Lorong Chuan (Circle Line/CC14); 3-minute walk via sheltered walkway",
        "bus_desc": "22, 24, 45, 53, 58, 73, 105, 109, 133, 135, 136, 156, 853",
        "principal_name": "MR PANG CHOON HOW",
        "first_vp_name": "MISS JASMINE ONG PEISHAN",
        "second_vp_name": "MRS OH-YOW SIHUA KEN",
        "third_vp_name": "MADAM CHAN MEI FUNG JOYCE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3503224,
        "lng": 103.8664323
    },
    {
        "school_name": "NANYANG PRIMARY SCHOOL",
        "url_address": "http://www.nyps.moe.edu.sg",
        "address": "52 KING'S ROAD",
        "postal_code": 268097,
        "telephone_no": 64672677,
        "telephone_no_2": "na",
        "fax_no": 64686913,
        "fax_no_2": "na",
        "email_address": "NYPS@MOE.EDU.SG",
        "mrt_desc": "Farrer Rd MRT Station",
        "bus_desc": "66, 67, 74, 93, 151, 153, 154, 156, 157, 165, 170, 171, 174, 186, 852, 855, 961",
        "principal_name": "MADAM WONG LI PENG",
        "first_vp_name": "MS LIM KAR WAE FIONA",
        "second_vp_name": "MISS SHARLENE CHYE HUI TING",
        "third_vp_name": "MR JAMES CHONG KOK CHIANG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3205401,
        "lng": 103.80852
    },
    {
        "school_name": "NATIONAL JUNIOR COLLEGE",
        "url_address": "http://www.nationaljc.moe.edu.sg",
        "address": "37 HILLCREST ROAD",
        "postal_code": 288913,
        "telephone_no": 64661144,
        "telephone_no_2": "na",
        "fax_no": 64684535,
        "fax_no_2": "na",
        "email_address": "NJC@MOE.EDU.SG",
        "mrt_desc": "BOTANIC GARDENS MRT, TAN KAH KEE MRT, SIXTH AVENUE MRT",
        "bus_desc": "67, 74, 151, 154, 156, 157, 170, 174, 852, 961",
        "principal_name": "MRS TOH LUCY",
        "first_vp_name": "MR HARESH S/O SIVARAM",
        "second_vp_name": "MISS SIM SOO LENG AILEEN",
        "third_vp_name": "MR CHONG CHEE KEONG ALVIN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.330476,
        "lng": 103.8045
    },
    {
        "school_name": "NAVAL BASE PRIMARY SCHOOL",
        "url_address": "http://www.navalbasepri.moe.edu.sg/",
        "address": "7 YISHUN AVE 4",
        "postal_code": 769028,
        "telephone_no": 67537114,
        "telephone_no_2": "na",
        "fax_no": 67555355,
        "fax_no_2": "na",
        "email_address": "NBPS@MOE.EDU.SG",
        "mrt_desc": "Yishun MRT Station",
        "bus_desc": "Feeder bus No. 811 from Yishun Interchange.",
        "principal_name": "MR CHIA CHEE WENG RICHARD CHRIS",
        "first_vp_name": "MADAM LIM WAI CHOO MRS GOH WAI CHOO",
        "second_vp_name": "MADAM WANG MING HWEE",
        "third_vp_name": "MADAM THAM LAI PENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4160913,
        "lng": 103.8389168
    },
    {
        "school_name": "NAVAL BASE SECONDARY SCHOOL",
        "url_address": "http://www.navalbasesec.moe.edu.sg",
        "address": "901 YISHUN RING ROAD",
        "postal_code": 768689,
        "telephone_no": 62571996,
        "telephone_no_2": "na",
        "fax_no": 67557706,
        "fax_no_2": "na",
        "email_address": "NBSS@MOE.EDU.SG",
        "mrt_desc": "KHATIB MRT",
        "bus_desc": "39, 85, 117, 670, 807, 811, 812, 851, 852, 853, 854, 855, 857, 858, 861, 965, 969",
        "principal_name": "MADAM LINDA YEO SOCK KHOON",
        "first_vp_name": "MR LIM SEOW KUAN",
        "second_vp_name": "MR MUHAMMAD SHAHARI B ABU BAKAR",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4186356,
        "lng": 103.8310575
    },
    {
        "school_name": "NEW TOWN PRIMARY SCHOOL",
        "url_address": "http://www.newtownpri.moe.edu.sg/",
        "address": "300 Tanglin Halt Road",
        "postal_code": 148812,
        "telephone_no": 64748805,
        "telephone_no_2": "na",
        "fax_no": 64741249,
        "fax_no_2": "na",
        "email_address": "NTPS@MOE.EDU.SG",
        "mrt_desc": "Commonwealth MRT Station",
        "bus_desc": "SBS Numbers 32, 100, 105, 111, 145, 147, 195, 196, 198, 855",
        "principal_name": "MISS HANNAH CHIA CUI'E",
        "first_vp_name": "MRS CHIN WEY LING LYNNE",
        "second_vp_name": "MADAM FOO HUEY YING (FU HUIYING)",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "QUEENSTOWN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2999524,
        "lng": 103.7999953
    },
    {
        "school_name": "NEW TOWN SECONDARY SCHOOL",
        "url_address": "http://www.newtownsec.moe.edu.sg",
        "address": "1020 DOVER ROAD",
        "postal_code": 139657,
        "telephone_no": 67754140,
        "telephone_no_2": "na",
        "fax_no": 67752310,
        "fax_no_2": "na",
        "email_address": "NTSS@MOE.EDU.SG",
        "mrt_desc": "DOVER MRT, CLEMENTI MRT",
        "bus_desc": "33, 96, 96A, 151, 196, 183",
        "principal_name": "MR ARIVAZHAGAN MANICKAM",
        "first_vp_name": "MISS GOH YI LING ELISSA",
        "second_vp_name": "MR LEONARD TAN SOON TECK",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "QUEENSTOWN",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3100184,
        "lng": 103.7731811
    },
    {
        "school_name": "NGEE ANN PRIMARY SCHOOL",
        "url_address": "http://www.ngeeannpri.moe.edu.sg",
        "address": "344 MARINE TERRACE",
        "postal_code": 449149,
        "telephone_no": 64418677,
        "telephone_no_2": "na",
        "fax_no": 64417411,
        "fax_no_2": "na",
        "email_address": "NAPS@MOE.EDU.SG",
        "mrt_desc": "Nil",
        "bus_desc": "13, 16, 16M, 31,36, 43, 47, 48, 55, 135, 196, 196E, 197, 853M (at Marine Parade road); 13, 16, 16M, 196 and 196E(at Marine Terrace)",
        "principal_name": "MADAM PANG SIU SAN",
        "first_vp_name": "MADAM LEE LI LI",
        "second_vp_name": "MADAM LOW LEE CHERN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "MARINE PARADE",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3056219,
        "lng": 103.9180054
    },
    {
        "school_name": "NGEE ANN SECONDARY SCHOOL",
        "url_address": "http://www.ngeeannsec.moe.edu.sg",
        "address": "1 TAMPINES STREET 32",
        "postal_code": 529283,
        "telephone_no": 67844583,
        "telephone_no_2": "na",
        "fax_no": 67840453,
        "fax_no_2": "na",
        "email_address": "NASS@MOE.EDU.SG",
        "mrt_desc": "TAMPINES MRT, SIMEI MRT, TAMPINES EAST MRT",
        "bus_desc": "3, 4, 8, 9, 12, 17, 18, 19, 21, 28, 29, 34, 37, 38, 39, 59, 81, 291, 293, 518, 552",
        "principal_name": "MISS POH SHI HUI",
        "first_vp_name": "MR GOH CHIN WEI",
        "second_vp_name": "MADAM TAN LAY GIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3544373,
        "lng": 103.9569646
    },
    {
        "school_name": "NORTH SPRING PRIMARY SCHOOL",
        "url_address": "http://www.northspringpri.moe.edu.sg",
        "address": "1 RIVERVALE STREET",
        "postal_code": 545088,
        "telephone_no": 68816887,
        "telephone_no_2": 63888764,
        "fax_no": 63851044,
        "fax_no_2": "na",
        "email_address": "NSPS@MOE.EDU.SG",
        "mrt_desc": "NEL - Sengkang Station; LRT - Bakau Station",
        "bus_desc": "SBS Transit Services 82, 85, 86, 88, 119, 136, 163, 372",
        "principal_name": "MADAM PHAN SWEE LIN SHERIN JACINTA",
        "first_vp_name": "MR TAN YEW LEE",
        "second_vp_name": "MADAM SALIEMA BINTE MOHAMED IQBAL",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3872399,
        "lng": 103.9035985
    },
    {
        "school_name": "NORTH VIEW PRIMARY SCHOOL",
        "url_address": "http://www.northviewpri.moe.edu.sg",
        "address": "210 YISHUN AVENUE 6",
        "postal_code": 768960,
        "telephone_no": 67593235,
        "telephone_no_2": "na",
        "fax_no": 67593237,
        "fax_no_2": "na",
        "email_address": "NVPS@MOE.EDU.SG",
        "mrt_desc": "Yishun; Khatib",
        "bus_desc": "Feeder Service 804, 806, 807, 860",
        "principal_name": "MRS GRACE CHUA",
        "first_vp_name": "MR RAJINDER SINGH S/O PIARA SINGH",
        "second_vp_name": "MADAM LING SOOK LENG",
        "third_vp_name": "MR CHAN SOON HUA",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.427616,
        "lng": 103.848313
    },
    {
        "school_name": "NORTH VISTA PRIMARY SCHOOL",
        "url_address": "http://www.northvistapri.moe.edu.sg",
        "address": "20 Compassvale Link",
        "postal_code": 544974,
        "telephone_no": 64843566,
        "telephone_no_2": "na",
        "fax_no": 64843568,
        "fax_no_2": "na",
        "email_address": "nvtps@moe.edu.sg",
        "mrt_desc": "Buangkok MRT (NE15), Ranggung LRT (SE5)",
        "bus_desc": "na",
        "principal_name": "MR ONG LYE WHATT",
        "first_vp_name": "MR AMRAN B TASRIF",
        "second_vp_name": "MISS GOH AI LING",
        "third_vp_name": "MADAM KANG SIEW LENG AUDREY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3829142,
        "lng": 103.8958131
    },
    {
        "school_name": "NORTH VISTA SECONDARY SCHOOL",
        "url_address": "http://www.northvistasec.moe.edu.sg",
        "address": "11 RIVERVALE LINK",
        "postal_code": 545081,
        "telephone_no": 68793930,
        "telephone_no_2": "na",
        "fax_no": 68793931,
        "fax_no_2": "na",
        "email_address": "NORTHVISTASS@MOE.EDU.SG",
        "mrt_desc": "SENGKANG MRT, BUANGKOK MRT, RANGGUNG LRT",
        "bus_desc": "80, 82, 87, 88, 89, 119",
        "principal_name": "MR YAP THIAM CHUAN",
        "first_vp_name": "MR PILLAY P KRISHNAN",
        "second_vp_name": "MISS WU XIAOYUAN",
        "third_vp_name": "MR KWEK CHIN LEONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3815792,
        "lng": 103.8988936
    },
    {
        "school_name": "NORTHBROOKS SECONDARY SCHOOL",
        "url_address": "http://www.northbrookssec.moe.edu.sg",
        "address": "585 YISHUN RING ROAD",
        "postal_code": 768692,
        "telephone_no": 67524311,
        "telephone_no_2": "na",
        "fax_no": 67566110,
        "fax_no_2": "na",
        "email_address": "NORTHBROOKS@MOE.EDU.SG",
        "mrt_desc": "YISHUN MRT, KHATIB MRT",
        "bus_desc": "804, 806, 807, 860, 103",
        "principal_name": "MR CHEN XUANTING EDMUND",
        "first_vp_name": "MISS GOH PEISHI",
        "second_vp_name": "MR YIP KOK HOONG (YE GUOXIONG)",
        "third_vp_name": "MR LIM YANG CHERNG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4210901,
        "lng": 103.8451567
    },
    {
        "school_name": "NORTHLAND PRIMARY SCHOOL",
        "url_address": "http://www.northlandpri.moe.edu.sg",
        "address": "15 YISHUN AVENUE 4",
        "postal_code": 769026,
        "telephone_no": 67598884,
        "telephone_no_2": "na",
        "fax_no": 67559196,
        "fax_no_2": "na",
        "email_address": "NORTHLAND_PS@MOE.EDU.SG",
        "mrt_desc": "Yishun MRT Station",
        "bus_desc": "812 (next to bus service number 171) at Yishun Interchange",
        "principal_name": "MR JAY WESTLY MAHARDALE",
        "first_vp_name": "MR CHONG CHOONG HIAN",
        "second_vp_name": "MISS LEE QUEE CHOO GINA",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4210098,
        "lng": 103.8405561
    },
    {
        "school_name": "NORTHLAND SECONDARY SCHOOL",
        "url_address": "http://www.northlandsec.moe.edu.sg",
        "address": "3 YISHUN STREET 22",
        "postal_code": 768578,
        "telephone_no": 62576781,
        "telephone_no_2": "na",
        "fax_no": 62573634,
        "fax_no_2": "na",
        "email_address": "NORTHLAND_SS@MOE.EDU.SG",
        "mrt_desc": "YISHUN MRT",
        "bus_desc": "811, 804, 800",
        "principal_name": "MR LIM KOK HWA",
        "first_vp_name": "MR PETERSON JOSEPH STANLEY",
        "second_vp_name": "MR LOW CHEE WAI",
        "third_vp_name": "MR CHEEN HSIEN HONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4358326,
        "lng": 103.8401937
    },
    {
        "school_name": "NORTHLIGHT SCHOOL",
        "url_address": "https://www.nls.edu.sg",
        "address": "151 Towner Road",
        "postal_code": 327830,
        "telephone_no": 69296290,
        "telephone_no_2": "na",
        "fax_no": 62912423,
        "fax_no_2": "na",
        "email_address": "nls@moe.edu.sg",
        "mrt_desc": "BOON KENG (NE9)",
        "bus_desc": "21, 125, 130, 139, 145, 13, 23, 31, 64, 65, 133, 147, 857, 985",
        "principal_name": "MADAM SUNG MEE HAR",
        "first_vp_name": "MR GAN KOK SOON SIMON",
        "second_vp_name": "MR HSU YU CHIH TOMMY",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "KALLANG",
        "zone_code": "SOUTH",
        "type_code": "SPECIALISED SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3197107,
        "lng": 103.8559121
    },
    {
        "school_name": "NORTHOAKS PRIMARY SCHOOL",
        "url_address": "http://www.northoakspri.moe.edu.sg",
        "address": "61 Sembawang Drive",
        "postal_code": 757622,
        "telephone_no": "6753 8835",
        "telephone_no_2": "na",
        "fax_no": "6753 8864",
        "fax_no_2": "na",
        "email_address": "northoaks_ps@moe.edu.sg",
        "mrt_desc": "Sembawang MRT",
        "bus_desc": "Bus number 962",
        "principal_name": "MR CHER TECK YIANG, LUKE MELVIN",
        "first_vp_name": "MADAM KOMATHI D/O GOVINDASAMY",
        "second_vp_name": "MR OW EU GENE JOHN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SEMBAWANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4569403,
        "lng": 103.8137084
    },
    {
        "school_name": "NORTHSHORE PRIMARY SCHOOL",
        "url_address": "https://northshorepri.moe.edu.sg/",
        "address": "30 Northshore Drive",
        "postal_code": 828671,
        "telephone_no": 62026490,
        "telephone_no_2": "na",
        "fax_no": 62026491,
        "fax_no_2": "na",
        "email_address": "northhshore_ps@moe.edu.sg",
        "mrt_desc": "Puggol Point LRT Station",
        "bus_desc": "84, 384",
        "principal_name": "MADAM LEE YEN PING CHRISTINE",
        "first_vp_name": "MADAM GAN SER MIN",
        "second_vp_name": "MADAM ONG YIN PENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4185055,
        "lng": 103.9047876
    },
    {
        "school_name": "NUS HIGH SCHOOL OF MATHEMATICS AND SCIENCE",
        "url_address": "www.nushigh.edu.sg",
        "address": "20 Clementi Avenue 1",
        "postal_code": 129957,
        "telephone_no": 65161709,
        "telephone_no_2": "na",
        "fax_no": 67756910,
        "fax_no_2": "na",
        "email_address": "einstein@highsch.nus.edu.sg",
        "mrt_desc": "Nearest MRT Stations - Clementi and Dover",
        "bus_desc": "96, 97, 151, 183, 188, 189, 196, 197, 198",
        "principal_name": "MADAM SOH LAI LENG MAGDALEN",
        "first_vp_name": "MR GOH HOCK LEONG",
        "second_vp_name": "MS KHOO LEE YONG, SHARON",
        "third_vp_name": "MRS LAI SOO HONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CLEMENTI",
        "zone_code": "WEST",
        "type_code": "SPECIALISED INDEPENDENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3071072,
        "lng": 103.7693914
    },
    {
        "school_name": "OASIS PRIMARY SCHOOL",
        "url_address": "http://www.oasispri.moe.edu.sg/",
        "address": "71 Edgefield Plains",
        "postal_code": 828716,
        "telephone_no": "6320 9855",
        "telephone_no_2": "na",
        "fax_no": "6320 9856",
        "fax_no_2": "na",
        "email_address": "oasis_ps@moe.edu.sg",
        "mrt_desc": "Damai LRT Station",
        "bus_desc": "50, 386",
        "principal_name": "MR POH LEONG KIAT DANNY",
        "first_vp_name": "MADAM HO JUN- LYNN",
        "second_vp_name": "MR MOHAMED IMRAN B MOHAMED IHSAN",
        "third_vp_name": "MISS CHUA MAY CHING",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.404285,
        "lng": 103.9109661
    },
    {
        "school_name": "OPERA ESTATE PRIMARY SCHOOL",
        "url_address": "http://www.operaestatepri.moe.edu.sg",
        "address": "48 FIDELIO STREET",
        "postal_code": 458436,
        "telephone_no": 62410417,
        "telephone_no_2": "na",
        "fax_no": 64493042,
        "fax_no_2": "na",
        "email_address": "OEPS@MOE.EDU.SG",
        "mrt_desc": "Bedok, Kembangan",
        "bus_desc": 42,
        "principal_name": "MADAM HOO WAI LING",
        "first_vp_name": "MR KENNY RAPHAEL REYES",
        "second_vp_name": "MR RAYMOND TAY KOON MING",
        "third_vp_name": "MR GOH LENG SENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3193914,
        "lng": 103.9235753
    },
    {
        "school_name": "ORCHID PARK SECONDARY SCHOOL",
        "url_address": "http://www.orchidparksec.moe.edu.sg",
        "address": "10 YISHUN STREET 81",
        "postal_code": 768454,
        "telephone_no": 67598547,
        "telephone_no_2": "na",
        "fax_no": 67588770,
        "fax_no_2": "na",
        "email_address": "OPSS@MOE.EDU.SG",
        "mrt_desc": "KHATIB MRT",
        "bus_desc": 811,
        "principal_name": "MR CHUNG KWOK LEONG DANIEL",
        "first_vp_name": "MADAM TEO MEI LIN YVONNE",
        "second_vp_name": "MR NG KOK WING",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4152284,
        "lng": 103.8380148
    },
    {
        "school_name": "OUTRAM SECONDARY SCHOOL",
        "url_address": "http://www.outramsec.moe.edu.sg",
        "address": "3 YORK HILL",
        "postal_code": 168622,
        "telephone_no": 67334077,
        "telephone_no_2": "na",
        "fax_no": 62352337,
        "fax_no_2": "na",
        "email_address": "OSS@MOE.EDU.SG",
        "mrt_desc": "OUTRAM PARK MRT, CHINATOWN MRT",
        "bus_desc": "174 , 123, 16, 175, 195, 33, 5, 63, 75, 851, 970, 123, 186, 51, 64",
        "principal_name": "MR TAN KOK HONG",
        "first_vp_name": "MISS TAN YEE LIN ELAINE",
        "second_vp_name": "na",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CENTRAL",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.286507,
        "lng": 103.837091
    },
    {
        "school_name": "PALM VIEW PRIMARY SCHOOL",
        "url_address": "http://www.palmviewpri.moe.edu.sg",
        "address": "150 Compassvale Bow",
        "postal_code": 544822,
        "telephone_no": 65087300,
        "telephone_no_2": "na",
        "fax_no": 68754150,
        "fax_no_2": "na",
        "email_address": "palmview_ps@moe.edu.sg",
        "mrt_desc": "Buangkok",
        "bus_desc": "27,43,109,156,159,161,163,163M,550",
        "principal_name": "MRS MING KUM",
        "first_vp_name": "MR ANG WEI TECK",
        "second_vp_name": "MISS KHAIRIAH BTE HAIROMAN",
        "third_vp_name": "MISS CHUA CHEW HIANG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3835374,
        "lng": 103.8913013
    },
    {
        "school_name": "PARK VIEW PRIMARY SCHOOL",
        "url_address": "http://www.parkviewpri.moe.edu.sg",
        "address": "60 PASIR RIS DRIVE 1",
        "postal_code": 519524,
        "telephone_no": 65851421,
        "telephone_no_2": "na",
        "fax_no": 65851401,
        "fax_no_2": "na",
        "email_address": "PVPS@MOE.EDU.SG",
        "mrt_desc": "Pasir Ris MRT Station",
        "bus_desc": "358,39,53,81,89",
        "principal_name": "MISS LIE SUYIN JAMIE",
        "first_vp_name": "MADAM HO FUI FONG",
        "second_vp_name": "MADAM LIM CHIU EE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3775806,
        "lng": 103.9395361
    },
    {
        "school_name": "PASIR RIS CREST SECONDARY SCHOOL",
        "url_address": "http://www.prcss.moe.edu.sg",
        "address": "11 PASIR RIS STREET 41",
        "postal_code": 518934,
        "telephone_no": 65811655,
        "telephone_no_2": "na",
        "fax_no": 65813226,
        "fax_no_2": "na",
        "email_address": "PRCSS@MOE.EDU.SG",
        "mrt_desc": "PASIR RIS MRT",
        "bus_desc": "358, 17, 81, 12, 3",
        "principal_name": "MRS KOH CAIYU",
        "first_vp_name": "MR HANSEL LIN DAOYANG",
        "second_vp_name": "MR LEE SENG LEE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3728817,
        "lng": 103.959416
    },
    {
        "school_name": "PASIR RIS PRIMARY SCHOOL",
        "url_address": "http://www.pasirrispri.moe.edu.sg",
        "address": "5 PASIR RIS STREET 21",
        "postal_code": 518968,
        "telephone_no": 65822606,
        "telephone_no_2": "na",
        "fax_no": 65828492,
        "fax_no_2": "na",
        "email_address": "PRPS@MOE.EDU.SG",
        "mrt_desc": "Pasir Ris MRT",
        "bus_desc": "3,5,6,89",
        "principal_name": "MS LIZA BTE RAHMAT",
        "first_vp_name": "MADAM HENG WEI SHAN",
        "second_vp_name": "MADAM THILAGAMANI D/O T SIVANANDAM",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.372403,
        "lng": 103.9629666
    },
    {
        "school_name": "PASIR RIS SECONDARY SCHOOL",
        "url_address": "https://pasirrissec.moe.edu.sg",
        "address": "390 TAMPINES STREET 21",
        "postal_code": 529400,
        "telephone_no": 65010800,
        "telephone_no_2": 65010855,
        "fax_no": 65010900,
        "fax_no_2": "na",
        "email_address": "PRSS@MOE.EDU.SG",
        "mrt_desc": "TAMPINES MRT, TAMPINES EAST MRT,  TAMPINES WEST MRT",
        "bus_desc": "3, 4, 8, 10, 15, 18, 19, 20, 21, 22, 23, 27, 28, 29, 31, 37, 38, 39, 46, 65, 67, 68, 69, 72, 81, 127, 129, 168, 291, 292, 293, 298, 969",
        "principal_name": "MADAM GRACE TAN BEE SIM",
        "first_vp_name": "MS S SANTHA D/O SUKUMARAN",
        "second_vp_name": "MADAM LEE BENG CHOO",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3548646,
        "lng": 103.9485724
    },
    {
        "school_name": "PAYA LEBAR METHODIST GIRLS' SCHOOL (PRIMARY)",
        "url_address": "http://www.payalebarmethodistgirlspri.moe.edu.sg/",
        "address": "298 LORONG AH SOO",
        "postal_code": 536741,
        "telephone_no": 62862795,
        "telephone_no_2": "na",
        "fax_no": 62803915,
        "fax_no_2": "na",
        "email_address": "PLMGPS@MOE.EDU.SG",
        "mrt_desc": "Kovan (NE13), Serangoon(NE12/CC13)",
        "bus_desc": "45, 53, 53M, 62, 113",
        "principal_name": "MRS MRS JOYCE ANG",
        "first_vp_name": "MADAM TANG WAI YUE",
        "second_vp_name": "MRS ESTHER SEE-LING SZENGEN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3503198,
        "lng": 103.8853393
    },
    {
        "school_name": "PAYA LEBAR METHODIST GIRLS' SCHOOL (SECONDARY)",
        "url_address": "http://www.plmgss.moe.edu.sg",
        "address": "296 LOR AH SOO",
        "postal_code": 536742,
        "telephone_no": 62816606,
        "telephone_no_2": "na",
        "fax_no": 63820558,
        "fax_no_2": "na",
        "email_address": "PLMGSS@MOE.EDU.SG",
        "mrt_desc": "KOVAN MRT, SERANGOON MRT",
        "bus_desc": "45, 53, 53M, 62, 113",
        "principal_name": "MISS NG AMY",
        "first_vp_name": "MADAM TAN MAY LIN SELINA",
        "second_vp_name": "MS TOH SUSAN",
        "third_vp_name": "MR NING TAU YEE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3511063,
        "lng": 103.884904
    },
    {
        "school_name": "PEI CHUN PUBLIC SCHOOL",
        "url_address": "http://www.peichunpublic.moe.edu.sg",
        "address": "16 LORONG 7 TOA PAYOH",
        "postal_code": 319320,
        "telephone_no": 63539450,
        "telephone_no_2": "na",
        "fax_no": 63538418,
        "fax_no_2": "na",
        "email_address": "PCPS@MOE.EDU.SG",
        "mrt_desc": "Toa Payoh MRT Station and Braddell MRT Station",
        "bus_desc": "Bus Service 232, 57",
        "principal_name": "MISS ONG LEE CHOO",
        "first_vp_name": "MR LIM JIT HIN",
        "second_vp_name": "MISS YANG JINGYU",
        "third_vp_name": "MR REEVE SIM (SHEN GUANZE)",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3369754,
        "lng": 103.855803
    },
    {
        "school_name": "PEI HWA PRESBYTERIAN PRIMARY SCHOOL",
        "url_address": "http://www.peihwapresbyterianpri.moe.edu.sg/",
        "address": "7 PEI WAH AVENUE",
        "postal_code": 597610,
        "telephone_no": 64663787,
        "telephone_no_2": 64663797,
        "fax_no": 64621944,
        "fax_no_2": "na",
        "email_address": "PHPPS@MOE.EDU.SG",
        "mrt_desc": "Beauty World",
        "bus_desc": "970, 852, 174, 173, 157, 77, 61",
        "principal_name": "MRS ALLISON LIM",
        "first_vp_name": "MR LEONG WEI MING CALEB",
        "second_vp_name": "MADAM YONG MING WOEI CHLOE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.338081,
        "lng": 103.77613
    },
    {
        "school_name": "PEI HWA SECONDARY SCHOOL",
        "url_address": "http://www.peihwasec.moe.edu.sg",
        "address": "21 FERNVALE LINK",
        "postal_code": 797702,
        "telephone_no": 65009580,
        "telephone_no_2": "na",
        "fax_no": 63438326,
        "fax_no_2": "na",
        "email_address": "peihwasec@moe.edu.sg",
        "mrt_desc": "SENGKANG MRT, LAYAR LRT",
        "bus_desc": "50, 70, 86, 103, 163, 854",
        "principal_name": "MR MOHD AZHAR B TERIMO",
        "first_vp_name": "MRS MICHELLE RAJARATHNAM",
        "second_vp_name": "MR OW WENG KEONG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3907202,
        "lng": 103.8787946
    },
    {
        "school_name": "PEI TONG PRIMARY SCHOOL",
        "url_address": "http://www.peitongpri.moe.edu.sg/",
        "address": "15 CLEMENTI AVENUE 5",
        "postal_code": 129857,
        "telephone_no": 67775458,
        "telephone_no_2": "na",
        "fax_no": 67789784,
        "fax_no_2": "na",
        "email_address": "PTPS@MOE.EDU.SG",
        "mrt_desc": "Clementi",
        "bus_desc": "7, 184, 282",
        "principal_name": "MRS ONG-CHEW LU SEE",
        "first_vp_name": "MR JASON WONG QI HUA",
        "second_vp_name": "MR MOHAMED YAZEED BIN MOHAMED SAID",
        "third_vp_name": "MR KOH SEE CHOON",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CLEMENTI",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3161197,
        "lng": 103.7675906
    },
    {
        "school_name": "PEICAI SECONDARY SCHOOL",
        "url_address": "http://www.peicaisec.moe.edu.sg",
        "address": "10 SERANGOON AVENUE 4",
        "postal_code": 556094,
        "telephone_no": 62021260,
        "telephone_no_2": "na",
        "fax_no": "na",
        "fax_no_2": "na",
        "email_address": "PEICAI_SS@MOE.EDU.SG",
        "mrt_desc": "SERANGOON MRT",
        "bus_desc": "22, 24, 43, 53, 70, 76, 103, 109, 116, 147, 156, 315, 317, 853",
        "principal_name": "MR MICHAEL MUHUNTHAN S/O SUBRAMANIAM",
        "first_vp_name": "MADAM JESMINE CHUNG KAH MIN",
        "second_vp_name": "MR SHUE PEI YAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3586499,
        "lng": 103.8705579
    },
    {
        "school_name": "PEIRCE SECONDARY SCHOOL",
        "url_address": "http://www.peircesec.moe.edu.sg",
        "address": "10 SIN MING WALK",
        "postal_code": 575566,
        "telephone_no": 64576454,
        "telephone_no_2": "na",
        "fax_no": 64576448,
        "fax_no_2": "na",
        "email_address": "PEIRCE_SS@MOE.EDU.SG",
        "mrt_desc": "ANG MO KIO MRT, BISHAN MRT, MARYMOUNT MRT, BRIGHT HILL MRT",
        "bus_desc": "52, 132, 162, 163, 165, 166, 167, 410, 855, 980",
        "principal_name": "MR KEH CHIN CHUAN BENEDICT",
        "first_vp_name": "MR JIN SEBASTIAN",
        "second_vp_name": "MS NG BOON MIN",
        "third_vp_name": "MADAM PEH TZU FENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BISHAN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3663952,
        "lng": 103.8298414
    },
    {
        "school_name": "PEIYING PRIMARY SCHOOL",
        "url_address": "http://www.peiyingpri.moe.edu.sg",
        "address": "651 YISHUN RING ROAD",
        "postal_code": 768687,
        "telephone_no": 62575684,
        "telephone_no_2": "na",
        "fax_no": 67558802,
        "fax_no_2": "na",
        "email_address": "PYPS@MOE.EDU.SG",
        "mrt_desc": "Khatib",
        "bus_desc": "851, 852, 853, 854, 855",
        "principal_name": "MADAM WONG WEI YONG",
        "first_vp_name": "MR ABDUL RANI BIN IDRIS",
        "second_vp_name": "MISS NG PEI SUN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4175241,
        "lng": 103.8302678
    },
    {
        "school_name": "PIONEER PRIMARY SCHOOL",
        "url_address": "http://www.pioneerpri.moe.edu.sg",
        "address": "80 TENGAH GARDEN AVENUE",
        "postal_code": 699915,
        "telephone_no": 67932039,
        "telephone_no_2": "na",
        "fax_no": 67932040,
        "fax_no_2": "na",
        "email_address": "PIONEER_PS@MOE.EDU.SG",
        "mrt_desc": "Boon Lay Station",
        "bus_desc": "219, 241",
        "principal_name": "MADAM LOKE WAI LING",
        "first_vp_name": "MR TAN HOCK CHYE CHARLES",
        "second_vp_name": "MADAM WONG WEI YI",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TENGAH",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.33837,
        "lng": 103.688061
    },
    {
        "school_name": "POI CHING SCHOOL",
        "url_address": "http://www.poiching.moe.edu.sg",
        "address": "21 TAMPINES STREET 71",
        "postal_code": 529067,
        "telephone_no": 67856420,
        "telephone_no_2": "na",
        "fax_no": 67857198,
        "fax_no_2": "na",
        "email_address": "POICHING_SCH@MOE.EDU.SG",
        "mrt_desc": "Tampines MRT",
        "bus_desc": "Bus 293, 72, 27 and 168",
        "principal_name": "MADAM LIM TZYY SHIUAN",
        "first_vp_name": "MISS CHAN JING JING",
        "second_vp_name": "MRS TAN MEI LING IRENE MRS IRENE GOH HOCK NGUAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3579299,
        "lng": 103.9356567
    },
    {
        "school_name": "PRESBYTERIAN HIGH SCHOOL",
        "url_address": "http://www.presbyterian.moe.edu.sg",
        "address": "5209 ANG MO KIO AVENUE 6",
        "postal_code": 569845,
        "telephone_no": 64543722,
        "telephone_no_2": "na",
        "fax_no": 64543430,
        "fax_no_2": "na",
        "email_address": "PRESBYTERIAN@MOE.EDU.SG",
        "mrt_desc": "YIO CHU KANG MRT",
        "bus_desc": "45, 70, 70M, 71, 76, 86, 668, 825, 851, 851e, 852, 853, 853M",
        "principal_name": "MADAM ONG HUI MIIN ANGELINE",
        "first_vp_name": "MR CHENG CHI EN",
        "second_vp_name": "MR TAY SOON INN TIMOTHY",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3821667,
        "lng": 103.843
    },
    {
        "school_name": "PRINCESS ELIZABETH PRIMARY SCHOOL",
        "url_address": "http://www.princesselizabethpri.moe.edu.sg",
        "address": "30 BUKIT BATOK WEST AVENUE 3",
        "postal_code": 659163,
        "telephone_no": 65655111,
        "telephone_no_2": "na",
        "fax_no": 65637859,
        "fax_no_2": "na",
        "email_address": "PEPS@MOE.EDU.SG",
        "mrt_desc": "Bukit Batok MRT Station",
        "bus_desc": "Bus 174, 157, 178, 66, 941",
        "principal_name": "MR BUCKTHA SEELAN",
        "first_vp_name": "MADAM CHU SING EE",
        "second_vp_name": "MISS NGIAM WEE HENG",
        "third_vp_name": "MISS TOH CUI LIN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3494947,
        "lng": 103.7410015
    },
    {
        "school_name": "PUNGGOL COVE PRIMARY SCHOOL",
        "url_address": "https://punggolcovepri.moe.edu.sg/",
        "address": "52 Sumang Walk",
        "postal_code": 828674,
        "telephone_no": 63857339,
        "telephone_no_2": "na",
        "fax_no": 63857261,
        "fax_no_2": "na",
        "email_address": "punggolcove_ps@moe.edu.sg",
        "mrt_desc": "Nibong LRT Station",
        "bus_desc": "382W, 84",
        "principal_name": "MADAM SEAH WHYE CHOO",
        "first_vp_name": "MR ANDREW CHONG WENYI",
        "second_vp_name": "MADAM CAI XIRUI",
        "third_vp_name": "MISS CHNG SHI HUA",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4116904,
        "lng": 103.89861
    },
    {
        "school_name": "PUNGGOL GREEN PRIMARY SCHOOL",
        "url_address": "http://www.punggolgreenpri.moe.edu.sg",
        "address": "98 Punggol Walk",
        "postal_code": 828772,
        "telephone_no": 65383011,
        "telephone_no_2": "na",
        "fax_no": 65383210,
        "fax_no_2": "na",
        "email_address": "admin_punggolgreen_ps@moe.edu.sg",
        "mrt_desc": "Punggol MRT Station",
        "bus_desc": "117, 117M, 119, 381, 382G, 666",
        "principal_name": "MR HANAFI B ASMORE",
        "first_vp_name": "MRS TAY CHAI HONG",
        "second_vp_name": "MR JASBIR SINGH",
        "third_vp_name": "MADAM CHRISTINA TEE SIEW PING",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4019222,
        "lng": 103.8988272
    },
    {
        "school_name": "PUNGGOL PRIMARY SCHOOL",
        "url_address": "http://www.punggolpri.moe.edu.sg/",
        "address": "61 HOUGANG AVENUE 8",
        "postal_code": 538787,
        "telephone_no": 63850762,
        "telephone_no_2": "na",
        "fax_no": 63877793,
        "fax_no_2": "na",
        "email_address": "PUNGGOL_PS@MOE.EDU.SG",
        "mrt_desc": "Hougang, Buangkok",
        "bus_desc": "62 74 88 113 147 325",
        "principal_name": "MADAM NORLIZA BTE A RAHIM",
        "first_vp_name": "MR GOH CHANG CHUEN",
        "second_vp_name": "MADAM LIM HUI MEOW ANNIE",
        "third_vp_name": "MISS USHA RANI HENRY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3773646,
        "lng": 103.8945949
    },
    {
        "school_name": "PUNGGOL SECONDARY SCHOOL",
        "url_address": "http://www.punggolsec.moe.edu.sg",
        "address": "51 EDGEFIELD PLAINS",
        "postal_code": 828870,
        "telephone_no": 64897851,
        "telephone_no_2": "na",
        "fax_no": 64897859,
        "fax_no_2": "na",
        "email_address": "PUNGGOL_SS@MOE.EDU.SG",
        "mrt_desc": "PUNGGOL MRT, COVE LRT",
        "bus_desc": "3, 34, 62, 82, 83, 85, 136, 965, 386",
        "principal_name": "MS TNG YA WEN VALERIE",
        "first_vp_name": "MR ANITH KUMAR S/O NADESAN",
        "second_vp_name": "MADAM GOH YEONG JING",
        "third_vp_name": "MR NG CHEE KIANG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4022738,
        "lng": 103.9090934
    },
    {
        "school_name": "PUNGGOL VIEW PRIMARY SCHOOL",
        "url_address": "http://www.punggolviewpri.moe.edu.sg",
        "address": "9 Punggol Place",
        "postal_code": 828845,
        "telephone_no": "6570 1588",
        "telephone_no_2": "na",
        "fax_no": "6570 3680",
        "fax_no_2": "na",
        "email_address": "punggolview_ps@moe.edu.sg",
        "mrt_desc": "Punggol MRT Station",
        "bus_desc": "50; 382",
        "principal_name": "MR WONG KIN MUN",
        "first_vp_name": "MDM DE SOUZA SANDRA ANNE",
        "second_vp_name": "MADAM SHARIFAH SAMIRAH BTE SYED MOHAMAD",
        "third_vp_name": "MR CHONG WEE MING",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4052688,
        "lng": 103.9051887
    },
    {
        "school_name": "QIFA PRIMARY SCHOOL",
        "url_address": "http://www.qifapri.moe.edu.sg",
        "address": "50 WEST COAST AVENUE",
        "postal_code": 128104,
        "telephone_no": 67783085,
        "telephone_no_2": "na",
        "fax_no": 67761485,
        "fax_no_2": "na",
        "email_address": "QIFA_PS@MOE.EDU.SG",
        "mrt_desc": "Clementi MRT Station",
        "bus_desc": "30,51,78,143,285,655",
        "principal_name": "MRS CATHERINE CHIANG",
        "first_vp_name": "MADAM CHOO SIEW HONG",
        "second_vp_name": "MADAM NORAINI BTE MANSOOR",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CLEMENTI",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3128971,
        "lng": 103.7569168
    },
    {
        "school_name": "QIHUA PRIMARY SCHOOL",
        "url_address": "http://www.qihuapri.moe.edu.sg",
        "address": "5 WOODLANDS STREET 81",
        "postal_code": 738525,
        "telephone_no": 62696250,
        "telephone_no_2": "na",
        "fax_no": 62693114,
        "fax_no_2": "na",
        "email_address": "QIHUA_PS@MOE.EDU.SG",
        "mrt_desc": "Woodlands MRT Station",
        "bus_desc": "911, 900",
        "principal_name": "MRS LEE HUI FENG",
        "first_vp_name": "MR FOO CHUAN KAI",
        "second_vp_name": "MISS NURUL SUHANA BINTE SULAIMAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4421018,
        "lng": 103.7884731
    },
    {
        "school_name": "QUEENSTOWN PRIMARY SCHOOL",
        "url_address": "http://www.queenstownpri.moe.edu.sg",
        "address": "310 MARGARET DR",
        "postal_code": 149303,
        "telephone_no": 64741044,
        "telephone_no_2": "na",
        "fax_no": 64713640,
        "fax_no_2": "na",
        "email_address": "QTPS@MOE.EDU.SG",
        "mrt_desc": "Queenstown MRT",
        "bus_desc": "32, 111, 145, 195",
        "principal_name": "MADAM LIM PEI LIN OLIVIA MRS OLIVIA CHEONG",
        "first_vp_name": "MISS CHEW MAY",
        "second_vp_name": "MR LOW KAY KIAT",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "QUEENSTOWN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2962213,
        "lng": 103.8079624
    },
    {
        "school_name": "QUEENSTOWN SECONDARY SCHOOL",
        "url_address": "http://www.queenstownsec.moe.edu.sg",
        "address": "1 STRATHMORE ROAD",
        "postal_code": 148800,
        "telephone_no": 64741055,
        "telephone_no_2": "na",
        "fax_no": 64741295,
        "fax_no_2": "na",
        "email_address": "QTSS@MOE.EDU.SG",
        "mrt_desc": "REDHILL MRT, QUEENSTOWN MRT",
        "bus_desc": "33, 51, 64, 111, 120, 139, 145, 186, 970",
        "principal_name": "MR SIM HOW CHONG",
        "first_vp_name": "MRS CHANG TECK HUI",
        "second_vp_name": "MR TAN TAI HUAT",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "QUEENSTOWN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2937568,
        "lng": 103.8131978
    },
    {
        "school_name": "QUEENSWAY SECONDARY SCHOOL",
        "url_address": "http://www.queenswaysec.moe.edu.sg",
        "address": "2A MARGARET DRIVE",
        "postal_code": 149295,
        "telephone_no": 64741421,
        "telephone_no_2": "na",
        "fax_no": 64741302,
        "fax_no_2": "na",
        "email_address": "QWSS@MOE.EDU.SG",
        "mrt_desc": "COMMONWEALTH MRT, QUEENSTOWN MRT",
        "bus_desc": "32, 51, 93, 100, 105, 111, 122, 123, 145, 147, 153, 186, 195, 196, 198, 855, 961, 970",
        "principal_name": "MS CHEN LI YING AUDREY",
        "first_vp_name": "MR TEO WEIHONG",
        "second_vp_name": "MADAM V PRIYA RAJAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "QUEENSTOWN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3000009,
        "lng": 103.8027544
    },
    {
        "school_name": "RADIN MAS PRIMARY SCHOOL",
        "url_address": "http://www.radinmasps.moe.edu.sg",
        "address": "1 BUKIT PURMEI AVENUE",
        "postal_code": 99840,
        "telephone_no": 62733937,
        "telephone_no_2": "na",
        "fax_no": 62763083,
        "fax_no_2": "na",
        "email_address": "RMPS@MOE.EDU.SG",
        "mrt_desc": "Tiong Bahru MRT; HarbourFront MRT",
        "bus_desc": "SBS 123, 123M, 131, 131M; SBS 65, 121, 195, 855",
        "principal_name": "MADAM TAN SUN SUN",
        "first_vp_name": "MADAM NG LI YI",
        "second_vp_name": "MS GOH CHIU KENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2750693,
        "lng": 103.8238799
    },
    {
        "school_name": "RAFFLES GIRLS' PRIMARY SCHOOL",
        "url_address": "http://www.rafflesgirlspri.moe.edu.sg",
        "address": "21 Hillcrest Road",
        "postal_code": 289072,
        "telephone_no": 64684377,
        "telephone_no_2": "na",
        "fax_no": 64692024,
        "fax_no_2": "na",
        "email_address": "RGPS@MOE.EDU.SG",
        "mrt_desc": "TAN KAH KEE MRT STATION",
        "bus_desc": "66, 67, 74, 151, 154, 156, 157, 170, 171, 174, 852, 961",
        "principal_name": "MADAM ELAINE QUEK-LIM HWEE BIN",
        "first_vp_name": "MISS KONG SU MAY",
        "second_vp_name": "MISS SUJATHA PARAMATHAYALAN",
        "third_vp_name": "MR LOH YUH POR",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3299574,
        "lng": 103.8062236
    },
    {
        "school_name": "RAFFLES GIRLS' SCHOOL (SECONDARY)",
        "url_address": "http://www.rgs.edu.sg",
        "address": "2 BRADDELL RISE",
        "postal_code": 318871,
        "telephone_no": 67371845,
        "telephone_no_2": "na",
        "fax_no": 62353731,
        "fax_no_2": "na",
        "email_address": "RGSS@MOE.EDU.SG",
        "mrt_desc": "BRADDELL MRT, CALDECOTT MRT",
        "bus_desc": "59, 93, 129, 156, 157, 163, 231, 232, 235",
        "principal_name": "MADAM LIM HONG PENG",
        "first_vp_name": "MS TAN HWEE MIAN MAY",
        "second_vp_name": "MS YEO XIUTING VALERIE",
        "third_vp_name": "MISS MAGDALENE SUEY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "INDEPENDENT SCHOOL",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.311665,
        "lng": 103.8287358
    },
    {
        "school_name": "RAFFLES INSTITUTION",
        "url_address": "http://www.ri.edu.sg",
        "address": "1 RAFFLES INSTITUTION LANE",
        "postal_code": 575954,
        "telephone_no": 64199242,
        "telephone_no_2": "na",
        "fax_no": 64199238,
        "fax_no_2": "na",
        "email_address": "RAFFLES_INST@MOE.EDU.SG",
        "mrt_desc": "BISHAN MRT, MARYMOUNT MRT",
        "bus_desc": "410,13,50,52,53,54,55,56,57,58,59,71,74,88,93,128,130,132,156,157,162,163,165,166,167,851,852,855,980",
        "principal_name": "MR LOH HONG OON, AARON",
        "first_vp_name": "MR ANG PENG SIONG BRIAN LAGMAN",
        "second_vp_name": "MR EDWARD NG",
        "third_vp_name": "MS MELISSA LIM AI LIN",
        "fourth_vp_name": "MS NG MEI SZE",
        "fifth_vp_name": "TAN MENG FONG DESMOND",
        "sixth_vp_name": "MISS SEE PEI LOO",
        "dgp_code": "BISHAN",
        "zone_code": "SOUTH",
        "type_code": "INDEPENDENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3466071,
        "lng": 103.843095
    },
    {
        "school_name": "RED SWASTIKA SCHOOL",
        "url_address": "http://www.redswastika.moe.edu.sg",
        "address": "350 BEDOK NORTH AVENUE 3",
        "postal_code": 469719,
        "telephone_no": 64430380,
        "telephone_no_2": "na",
        "fax_no": 62448391,
        "fax_no_2": "na",
        "email_address": "REDSWASTIKA@MOE.EDU.SG",
        "mrt_desc": "Bedok Reservoir MRT",
        "bus_desc": "Bus 14, 17, 28, 46, 66, 67, 69, 222, 228",
        "principal_name": "MR LIM MENG WEI",
        "first_vp_name": "MS ANGELA GOH BEE LIAN",
        "second_vp_name": "MADAM ESTHER E TZY KWEI",
        "third_vp_name": "MR TAN MENG KHIANG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3331408,
        "lng": 103.9341987
    },
    {
        "school_name": "REGENT SECONDARY SCHOOL",
        "url_address": "http://regentsec.moe.edu.sg",
        "address": "50 CHOA CHU KANG NORTH 5",
        "postal_code": 689621,
        "telephone_no": 67653828,
        "telephone_no_2": "na",
        "fax_no": 67653413,
        "fax_no_2": "na",
        "email_address": "REGENT_SS@MOE.EDU.SG",
        "mrt_desc": "YEW TEE MRT, CHOA CHU KANG MRT",
        "bus_desc": "307, 160, 170, 178, 925, 927, 960, 961, 979",
        "principal_name": "MADAM TAN SIEW HONG (MRS SNG)",
        "first_vp_name": "MISS NG TZE FANG",
        "second_vp_name": "MR THANGARASU PUBALAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3933418,
        "lng": 103.7508581
    },
    {
        "school_name": "RIVER VALLEY HIGH SCHOOL",
        "url_address": "https://rivervalleyhigh.moe.edu.sg/",
        "address": "6 BOON LAY AVENUE",
        "postal_code": 649961,
        "telephone_no": 65678115,
        "telephone_no_2": "na",
        "fax_no": 65677351,
        "fax_no_2": "na",
        "email_address": "RVHS@MOE.EDU.SG",
        "mrt_desc": "BOON LAY MRT, LAKESIDE MRT",
        "bus_desc": "99, 157, 172, 174, 174E, 198, 240, 502, 974",
        "principal_name": "na",
        "first_vp_name": "MS CHUA SHI QIAN",
        "second_vp_name": "MR LAU WAI CHI ALVIN",
        "third_vp_name": "MR NG HONG PENG",
        "fourth_vp_name": "MR MICHAEL JOHN PETER LAU CHONG LUM",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "Yes",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3438847,
        "lng": 103.7095372
    },
    {
        "school_name": "RIVER VALLEY PRIMARY SCHOOL",
        "url_address": "http://www.rivervalleypri.moe.edu.sg",
        "address": "2 RIVER VALLEY GREEN",
        "postal_code": 237993,
        "telephone_no": 67371785,
        "telephone_no_2": "na",
        "fax_no": 67321951,
        "fax_no_2": "na",
        "email_address": "RVPS@MOE.EDU.SG",
        "mrt_desc": "Somerset MRT",
        "bus_desc": "5, 16, 32, 54, 65, 75, 175, 970",
        "principal_name": "MRS JENNIFER PANG CHEE CHYN",
        "first_vp_name": "MRS LOH SOK HIANG JACQUELINE",
        "second_vp_name": "MADAM NUR RASHIDAH BTE ABDUL RASHID",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CENTRAL",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2938838,
        "lng": 103.8363894
    },
    {
        "school_name": "RIVERSIDE PRIMARY SCHOOL",
        "url_address": "http://www.riversidepri.moe.edu.sg",
        "address": "110 Woodlands Crescent",
        "postal_code": 737803,
        "telephone_no": 63654490,
        "telephone_no_2": "na",
        "fax_no": 63654460,
        "fax_no_2": "na",
        "email_address": "riverside_ps@moe.edu.sg",
        "mrt_desc": "Admiralty MRT Station",
        "bus_desc": "Bus No 913 and Bus No 964",
        "principal_name": "MR TAN CHOON KHENG",
        "first_vp_name": "MADAM KHOO PHAIK HOON REGINA",
        "second_vp_name": "MRS RANUKA PALANIVELU",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4468546,
        "lng": 103.8015922
    },
    {
        "school_name": "RIVERSIDE SECONDARY SCHOOL",
        "url_address": "http://www.riversidesec.moe.edu.sg",
        "address": "3 WOODLANDS STREET 81",
        "postal_code": 738524,
        "telephone_no": 62699631,
        "telephone_no_2": "na",
        "fax_no": 63683677,
        "fax_no_2": "na",
        "email_address": "RIVERSIDE_SS@MOE.EDU.SG",
        "mrt_desc": "WOODLANDS MRT",
        "bus_desc": "169, 858, 900, 900A, 903, 904, 911, 913, 964, 965, 969",
        "principal_name": "MISS THAM YOKE CHUN",
        "first_vp_name": "MR CHAN KOK TUNG TOM",
        "second_vp_name": "MISS HUI AI LIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4404834,
        "lng": 103.788591
    },
    {
        "school_name": "UNITY PRIMARY SCHOOL",
        "url_address": "http://www.unitypri.moe.edu.sg",
        "address": "21 CHOA CHU KANG CRESCENT",
        "postal_code": 688268,
        "telephone_no": 67676750,
        "telephone_no_2": "na",
        "fax_no": 67676751,
        "fax_no_2": "na",
        "email_address": "UNITY_PS@MOE.EDU.SG",
        "mrt_desc": "Yew Tee MRT",
        "bus_desc": "TIBs 302",
        "principal_name": "MRS LEE-KOH SIEW CHENG",
        "first_vp_name": "MR SYAMSUL ANWAR BIN AWANG",
        "second_vp_name": "MRS JASMINE TAN RODRIGO",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.403245,
        "lng": 103.74729
    },
    {
        "school_name": "RIVERVALE PRIMARY SCHOOL",
        "url_address": "http://www.rivervalepri.moe.edu.sg/",
        "address": "80 RIVERVALE DRIVE",
        "postal_code": 545092,
        "telephone_no": 63887450,
        "telephone_no_2": "na",
        "fax_no": 63887449,
        "fax_no_2": "na",
        "email_address": "RIVERVALE_PS@MOE.EDU.SG",
        "mrt_desc": "Nearest LRT Station : Rumbia",
        "bus_desc": "Bus Service 86, 371.",
        "principal_name": "MISS RADHA D/O G SUBRAMANIAM",
        "first_vp_name": "MRS GOH SIEW LING MARIA",
        "second_vp_name": "MR CHIA SENG CHIANG AARON",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3932451,
        "lng": 103.9043989
    },
    {
        "school_name": "ROSYTH SCHOOL",
        "url_address": "https://www.rosyth.moe.edu.sg",
        "address": "21 Serangoon North Avenue 4",
        "postal_code": 555855,
        "telephone_no": 64812273,
        "telephone_no_2": "na",
        "fax_no": 64831102,
        "fax_no_2": "na",
        "email_address": "ROSYTH_SCH@MOE.EDU.SG",
        "mrt_desc": "Ang Mo Kio, Serangoon",
        "bus_desc": "73, 315, 116",
        "principal_name": "MR SURAJ NAIR S/O VENUGOPAL",
        "first_vp_name": "MISS KWAN RUIYING KAREN",
        "second_vp_name": "MADAM TAN LAY WAH",
        "third_vp_name": "MR TAN BOON SENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3729086,
        "lng": 103.8746431
    },
    {
        "school_name": "RULANG PRIMARY SCHOOL",
        "url_address": "http://www.rulangpri.moe.edu.sg/",
        "address": "6 JURONG WEST STREET 52",
        "postal_code": 649295,
        "telephone_no": 65657771,
        "telephone_no_2": "na",
        "fax_no": 65632382,
        "fax_no_2": "na",
        "email_address": "RULANG_PS@MOE.EDU.SG",
        "mrt_desc": "Lakeside",
        "bus_desc": "SBS 335",
        "principal_name": "MS TRACY TAN I- LIAN",
        "first_vp_name": "MR TAN JIAN ZHONG ADRIAN",
        "second_vp_name": "MR TOH JIN TIAN",
        "third_vp_name": "MR TAN KOK LENG, STEVEN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.34694,
        "lng": 103.71896
    },
    {
        "school_name": "SCHOOL OF SCIENCE AND TECHNOLOGY, SINGAPORE",
        "url_address": "http://www.sst.edu.sg",
        "address": "1 Technology Drive",
        "postal_code": 138572,
        "telephone_no": 65717200,
        "telephone_no_2": "na",
        "fax_no": 68720856,
        "fax_no_2": "na",
        "email_address": "contactus@sst.edu.sg",
        "mrt_desc": "Dover",
        "bus_desc": "14, 74, 105, 106, 147, 166, 185",
        "principal_name": "MR CHAN CHOON LOONG",
        "first_vp_name": "MR SZE GUAN KIAT",
        "second_vp_name": "MR TAN BOON TIONG VINCENT",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CLEMENTI",
        "zone_code": "WEST",
        "type_code": "SPECIALISED INDEPENDENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3130711,
        "lng": 103.7743164
    },
    {
        "school_name": "SCHOOL OF THE ARTS, SINGAPORE",
        "url_address": "http://www.sota.edu.sg/",
        "address": "1 Zubir Said Drive 05 01",
        "postal_code": 227968,
        "telephone_no": "6338 9663",
        "telephone_no_2": "6342 5857",
        "fax_no": "6338 9763",
        "fax_no_2": "na",
        "email_address": "enquiries@sota.edu.sg",
        "mrt_desc": "Dhoby Ghaut",
        "bus_desc": "7, 14, 16, 36, 64, 65, 77, 106, 111, 124, 128, 131, 147, 162, 166, 167, 171, 174, 175, 190, 502, 518, 700, 857,",
        "principal_name": "MADAM WONG YEE MIN MARY",
        "first_vp_name": "MS KHOO MEI LING AMY",
        "second_vp_name": "MR LIONG HUAI YU",
        "third_vp_name": "MISS PAULINE ANN TAN POH LING",
        "fourth_vp_name": "MADAM TAN PEI YIN",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CENTRAL",
        "zone_code": "SOUTH",
        "type_code": "SPECIALISED INDEPENDENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2993734,
        "lng": 103.8487619
    },
    {
        "school_name": "SEMBAWANG PRIMARY SCHOOL",
        "url_address": "http://www.sembawangpri.moe.edu.sg",
        "address": "10 SEMBAWANG DRIVE",
        "postal_code": 757715,
        "telephone_no": 67567330,
        "telephone_no_2": "na",
        "fax_no": 67560367,
        "fax_no_2": "na",
        "email_address": "SEMBAWANG_PS@MOE.EDU.SG",
        "mrt_desc": "Sembawang MRT (6 to 8-minute walk)",
        "bus_desc": "656, 859, 859B, 962, 980",
        "principal_name": "MR NG AIK BOON",
        "first_vp_name": "MR SEE KOK KIONG",
        "second_vp_name": "MISS TIFFANY CHONG",
        "third_vp_name": "MR TAN THIAM SIONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SEMBAWANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4454114,
        "lng": 103.8209921
    },
    {
        "school_name": "SEMBAWANG SECONDARY SCHOOL",
        "url_address": "http://www.sembawangsec.moe.edu.sg",
        "address": "30 SEMBAWANG CRESCENT",
        "postal_code": 757704,
        "telephone_no": 67566760,
        "telephone_no_2": "na",
        "fax_no": 67585380,
        "fax_no_2": "na",
        "email_address": "SEMBAWANG_SS@MOE.EDU.SG",
        "mrt_desc": "SEMBAWANG MRT",
        "bus_desc": "859, 859A, 962",
        "principal_name": "MADAM KOH HOON CHOO JESSIE",
        "first_vp_name": "MR CHAN YING CHUNG",
        "second_vp_name": "MR LEE YONG KIANG JUSTIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SEMBAWANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4454666,
        "lng": 103.8168532
    },
    {
        "school_name": "SENG KANG PRIMARY SCHOOL",
        "url_address": "http://www.sengkangpri.moe.edu.sg/",
        "address": "21 COMPASSVALE WALK",
        "postal_code": 545166,
        "telephone_no": 63840809,
        "telephone_no_2": "na",
        "fax_no": 63840839,
        "fax_no_2": "na",
        "email_address": "SKPS@MOE.EDU.SG",
        "mrt_desc": "Sengkang MRT",
        "bus_desc": "27, 80, 82, 83, 86, 87, 88, 89, 119, 156, 163, 371, 372 & 965",
        "principal_name": "MRS LEE SIEW HONG",
        "first_vp_name": "MR MOHAMED AZHAR BIN MOHAMED NOOR",
        "second_vp_name": "MISS THIEN LI CHIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3894988,
        "lng": 103.8994163
    },
    {
        "school_name": "SENG KANG SECONDARY SCHOOL",
        "url_address": "http://www.sengkangsec.moe.edu.sg",
        "address": "10 COMPASSVALE LANE",
        "postal_code": 545090,
        "telephone_no": 63887258,
        "telephone_no_2": "na",
        "fax_no": 63887254,
        "fax_no_2": "na",
        "email_address": "SKSS@MOE.EDU.SG",
        "mrt_desc": "SENGKANG MRT, RANGGUNG LRT",
        "bus_desc": "27, 80, 85, 86, 87, 89, 89E, 163, 163M, 372",
        "principal_name": "MR N SIVARAJAN",
        "first_vp_name": "MR NG CHENG SONG, JEREMY",
        "second_vp_name": "MR LAK YAU HUI",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3865592,
        "lng": 103.8985521
    },
    {
        "school_name": "SENGKANG GREEN PRIMARY SCHOOL",
        "url_address": "https://sengkanggreenpri.moe.edu.sg/",
        "address": "15 Fernvale Road",
        "postal_code": 797636,
        "telephone_no": 63864255,
        "telephone_no_2": "na",
        "fax_no": 62428796,
        "fax_no_2": "na",
        "email_address": "sengkanggreen_ps@moe.edu.sg",
        "mrt_desc": "Fernvale LRT (SW5) - (Sengkang West Loop)",
        "bus_desc": "Sengkang and Toa Payoh Interchange - no 163, Along Yio Chu Kang Road - no 70, 86, 103 and 854, Punggol Interchange to Bishan Interchange - no 50, Hougang Central Interchange - no 102",
        "principal_name": "MR GAU POH TECK",
        "first_vp_name": "MADAM ADILA ONG KIM LUAN",
        "second_vp_name": "MR TAN KENG LIM JEREMY",
        "third_vp_name": "MADAM GINNY CHUA GEOK HONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3928381,
        "lng": 103.8754243
    },
    {
        "school_name": "SERANGOON GARDEN SECONDARY SCHOOL",
        "url_address": "http://www.sgs.edu.sg",
        "address": "21 SERANGOON NORTH AVENUE 1",
        "postal_code": 555889,
        "telephone_no": 62889227,
        "telephone_no_2": 65789177,
        "fax_no": 62888695,
        "fax_no_2": "na",
        "email_address": "sgss@moe.edu.sg",
        "mrt_desc": "SERANGOON MRT, ANG MO KIO MRT",
        "bus_desc": "25, 55, 73, 74, 76, 132, 165, 315",
        "principal_name": "MADAM MAH PATSY",
        "first_vp_name": "MS HO GEOK LAN",
        "second_vp_name": "MR NG SONG LIM STEVEN",
        "third_vp_name": "MR ZAINAL ABIDIN BIN MAHMOOD",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3697049,
        "lng": 103.8687336
    },
    {
        "school_name": "SERANGOON SECONDARY SCHOOL",
        "url_address": "http://www.serangoonsec.moe.edu.sg",
        "address": "11 UPPER SERANGOON VIEW",
        "postal_code": 534237,
        "telephone_no": 63851589,
        "telephone_no_2": "na",
        "fax_no": 63851635,
        "fax_no_2": "na",
        "email_address": "SERANGOON_SS@MOE.EDU.SG",
        "mrt_desc": "HOUGANG MRT, KANGKAR LRT",
        "bus_desc": "62, 74, 102, 113, 119, 136, 147, 324",
        "principal_name": "MR CHEN FOOK PANG",
        "first_vp_name": "MR LIM KAH LEONG MARC",
        "second_vp_name": "MADAM LIM PUAY KHENG",
        "third_vp_name": "MR MEYYAPPAN NADARAJAN THEVAR",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3750872,
        "lng": 103.9022816
    },
    {
        "school_name": "SHUQUN PRIMARY SCHOOL",
        "url_address": "http://www.shuqunpri.moe.edu.sg",
        "address": "8 JURONG WEST STREET 51",
        "postal_code": 649332,
        "telephone_no": 65637129,
        "telephone_no_2": "na",
        "fax_no": 65637418,
        "fax_no_2": "na",
        "email_address": "SQPS@MOE.EDU.SG",
        "mrt_desc": "W11 Lakeside",
        "bus_desc": "98, 187, 335",
        "principal_name": "MRS SARA DE SOUZA",
        "first_vp_name": "MDM SO KAH LAY",
        "second_vp_name": "DR. CHOONG PEK LAN",
        "third_vp_name": "MS LEE KOON HAR ANGELA (LI KUNXIA)",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.347546,
        "lng": 103.7215517
    },
    {
        "school_name": "SI LING PRIMARY SCHOOL",
        "url_address": "http://www.silingpri.moe.edu.sg",
        "address": "61 WOODLANDS AVENUE 1",
        "postal_code": 739067,
        "telephone_no": 62698832,
        "telephone_no_2": "na",
        "fax_no": 63675516,
        "fax_no_2": "na",
        "email_address": "SLPS@MOE.EDU.SG",
        "mrt_desc": "Woodlands",
        "bus_desc": "912 from Woodlands Interchange",
        "principal_name": "MR KOE EE TIONG",
        "first_vp_name": "MADAM NURAZIAN BINTE BAJURI",
        "second_vp_name": "MR RAJ KUMAR S/O V SIVALINGAM",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.432693,
        "lng": 103.78577
    },
    {
        "school_name": "SINGAPORE CHINESE GIRLS' PRIMARY SCHOOL",
        "url_address": "www.scgs.moe.edu.sg",
        "address": "190 DUNEARN ROAD",
        "postal_code": 309437,
        "telephone_no": 62527966,
        "telephone_no_2": "na",
        "fax_no": 62523076,
        "fax_no_2": "na",
        "email_address": "SCGPS@MOE.EDU.SG",
        "mrt_desc": "Stevens",
        "bus_desc": "66, 67, 105, 132, 151, 153, 154, 156, 170, 171, 186, 190, 605, 700, 960",
        "principal_name": "MRS LINDA CHAN",
        "first_vp_name": "MADAM LIM YING YING",
        "second_vp_name": "MADAM PEH TAN WEE",
        "third_vp_name": "MADAM SIA YAN SAN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "NOVENA",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3202303,
        "lng": 103.8296851
    },
    {
        "school_name": "SINGAPORE CHINESE GIRLS' SCHOOL",
        "url_address": "http://www.scgs.moe.edu.sg",
        "address": "190 DUNEARN ROAD",
        "postal_code": 309437,
        "telephone_no": 62527966,
        "telephone_no_2": "na",
        "fax_no": 62523076,
        "fax_no_2": "na",
        "email_address": "SCGSS@MOE.EDU.SG",
        "mrt_desc": "STEVENS MRT",
        "bus_desc": "48, 67, 105, 132, 151, 153, 154, 156, 170, 186, 190, 960, 960E, 972, 972M",
        "principal_name": "MRS LINDA CHAN",
        "first_vp_name": "MISS LEONG KAI LING",
        "second_vp_name": "MRS SHERMAINE TANG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "NOVENA",
        "zone_code": "SOUTH",
        "type_code": "INDEPENDENT SCHOOL",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3212977,
        "lng": 103.828876
    },
    {
        "school_name": "SINGAPORE SPORTS SCHOOL",
        "url_address": "http://www.sportsschool.edu.sg",
        "address": "1 Champions Way",
        "postal_code": 737913,
        "telephone_no": 67660100,
        "telephone_no_2": "na",
        "fax_no": 67662100,
        "fax_no_2": "na",
        "email_address": "enquire@sportsschool.edu.sg",
        "mrt_desc": "Woodlands South MRT",
        "bus_desc": 901,
        "principal_name": "MR ONG KIM SOON",
        "first_vp_name": "MR EDMUND SONG",
        "second_vp_name": "MR HO BENG KIAT",
        "third_vp_name": "MDM QUEK YAU KENN LYNN",
        "fourth_vp_name": "MR LIM HOW CHUEN CLEMENT",
        "fifth_vp_name": "MISS TAN HUI HUI JEANIE",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "SPECIALISED INDEPENDENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "MIXED LEVEL (S1-S5, JC1-JC2)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4265,
        "lng": 103.7891347
    },
    {
        "school_name": "SOUTH VIEW PRIMARY SCHOOL",
        "url_address": "http://www.southviewpri.moe.edu.sg",
        "address": "6 Choa Chu Kang Central",
        "postal_code": 689762,
        "telephone_no": 67697176,
        "telephone_no_2": "na",
        "fax_no": 67631091,
        "fax_no_2": "na",
        "email_address": "SVPS@MOE.EDU.SG",
        "mrt_desc": "Choa Chu Kang MRT Station",
        "bus_desc": "307 / South View LRT Station",
        "principal_name": "MISS ANG MUI KHOONG",
        "first_vp_name": "MISS GOH JIA LI",
        "second_vp_name": "MR ONG HONG GHEE",
        "third_vp_name": "MR RAMESH TIWARI S/O RAMADHAR TIWARI",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.381324,
        "lng": 103.7471451
    },
    {
        "school_name": "SPECTRA SECONDARY SCHOOL",
        "url_address": "https://www.spectra.edu.sg",
        "address": "1 WOODLANDS DRIVE 64",
        "postal_code": 737758,
        "telephone_no": 64660775,
        "telephone_no_2": "na",
        "fax_no": 64623928,
        "fax_no_2": "na",
        "email_address": "spectra@schools.gov.sg",
        "mrt_desc": "ADMIRALTY",
        "bus_desc": "901M, 962 (Bus Stop IDs: 47549 or 47541); 904 (Bus Stop IDs: 47649 or 47641)",
        "principal_name": "MR TAN TECK HOCK",
        "first_vp_name": "MS GRACE HO CHEN YEE",
        "second_vp_name": "MISS GUO XINHUI",
        "third_vp_name": "MR NG E-HIAN",
        "fourth_vp_name": "MISS LOW YING XIU",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "SPECIALISED SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4363404,
        "lng": 103.8044352
    },
    {
        "school_name": "SPRINGDALE PRIMARY SCHOOL",
        "url_address": "http://springdalepri.moe.edu.sg/",
        "address": "71 Anchorvale Link",
        "postal_code": 544799,
        "telephone_no": 63157600,
        "telephone_no_2": "na",
        "fax_no": 63153351,
        "fax_no_2": "na",
        "email_address": "springdale_ps@moe.edu.sg",
        "mrt_desc": "Sengkang Station (NE16); Nearest LRT station: Farmway; *10-15 min walk from either station",
        "bus_desc": "50, 85, 102, 372; Nearest Bus Stop: In front of Blk 326 Car Park; *1-2 min walk from bus stop; enter by Main Gate along Anchorvale Link or Rear Gate",
        "principal_name": "MRS QUEK-SIM KIM LIANG ANNE",
        "first_vp_name": "MR SHOEB BURHANUDDIN",
        "second_vp_name": "MISS SONG XIUHUA SHAFIQAH NADIAH",
        "third_vp_name": "MADAM LIM BEE TIN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SENG KANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3949667,
        "lng": 103.8896801
    },
    {
        "school_name": "SPRINGFIELD SECONDARY SCHOOL",
        "url_address": "http://www.springfieldsec.moe.edu.sg",
        "address": "30 TAMPINES AVENUE 8",
        "postal_code": 529593,
        "telephone_no": 63183053,
        "telephone_no_2": "na",
        "fax_no": 63183050,
        "fax_no_2": "na",
        "email_address": "SPRINGFIELDS@MOE.EDU.SG",
        "mrt_desc": "TAMPINES MRT, TAMPINES WEST MRT",
        "bus_desc": "8, 15, 23, 58, 69, 118, 129, 291, 293, 298, 513, 518",
        "principal_name": "MISS CHIA SHUEN LI ELEANOR",
        "first_vp_name": "MADAM YEHIDAAH BEEVI D/O SHAIK A",
        "second_vp_name": "MR WU CHE VUN STEVEN (WU QIWEN)",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "na",
        "lat": 1.3500736,
        "lng": 103.9300201
    },
    {
        "school_name": "ST ANDREW'S SCHOOL (JUNIOR)",
        "url_address": "http://www.saintandrewsjunior.moe.edu.sg",
        "address": "2 FRANCIS THOMAS DRIVE",
        "postal_code": 359337,
        "telephone_no": 62884303,
        "telephone_no_2": "na",
        "fax_no": 62895242,
        "fax_no_2": "na",
        "email_address": "SAJS@MOE.EDU.SG",
        "mrt_desc": "Potong Pasir, Toa Payoh",
        "bus_desc": "8,13,26,31,90,90A,107,133,142,147,853,NR6",
        "principal_name": "MRS ELSIE POEY",
        "first_vp_name": "MISS HEW YI QIAN CAROLINE",
        "second_vp_name": "MRS STEPHANIE GOH",
        "third_vp_name": "MR BOEY WENG YUE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3309872,
        "lng": 103.8652758
    },
    {
        "school_name": "ST ANDREW'S SCHOOL (SECONDARY)",
        "url_address": "http://www.standrewssec.moe.edu.sg",
        "address": "15 FRANCIS THOMAS DRIVE",
        "postal_code": 359342,
        "telephone_no": 62851944,
        "telephone_no_2": "na",
        "fax_no": 63823779,
        "fax_no_2": "na",
        "email_address": "SASS@MOE.EDU.SG",
        "mrt_desc": "POTONG PASIR MRT",
        "bus_desc": "8, 13, 26, 31, 90, 90A, 107, 133, 142, 147, 853",
        "principal_name": "MR LEE HAN HWA",
        "first_vp_name": "MISS TEO PEK HOON AGNES",
        "second_vp_name": "MADAM GUINIEVE YEO LI-LYN",
        "third_vp_name": "TEO PENG YONG DANNY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3313365,
        "lng": 103.8660109
    },
    {
        "school_name": "ST. ANDREW'S JUNIOR COLLEGE",
        "url_address": "http://www.standrewsjc.moe.edu.sg/",
        "address": "5 Sorby Adams Drive",
        "postal_code": 357691,
        "telephone_no": 62857008,
        "telephone_no_2": 62852007,
        "fax_no": 62850037,
        "fax_no_2": "na",
        "email_address": "SAJC@MOE.EDU.SG",
        "mrt_desc": "Potong Pasir NE10",
        "bus_desc": "SBSTransit: 8, 26, 31, 90, 142 ,151, 154 (Diocese of Singapore); SMRT Buses: 857, 966, 985 (Diocese of Singapore), 853 (Upper Serangoon Road)",
        "principal_name": "MR THAM KINE THONG",
        "first_vp_name": "MR ANG KHENG SAN CECIL",
        "second_vp_name": "MRS TEE AI LEE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TOA PAYOH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.333255,
        "lng": 103.8631819
    },
    {
        "school_name": "ST. ANTHONY'S CANOSSIAN PRIMARY SCHOOL",
        "url_address": "http://www.stanthonyscanossianpri.moe.edu.sg",
        "address": "1602 BEDOK NORTH AVE 4",
        "postal_code": 469701,
        "telephone_no": 64492239,
        "telephone_no_2": "na",
        "fax_no": 64492146,
        "fax_no_2": "na",
        "email_address": "SACPS@MOE.EDU.SG",
        "mrt_desc": "Bedok MRT",
        "bus_desc": "17, 18",
        "principal_name": "MRS SHARON CLARISSA FOO",
        "first_vp_name": "MISS LEE XINYUN FELICIA",
        "second_vp_name": "MISS THIA HWEI LING SHARON",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3343022,
        "lng": 103.9411549
    },
    {
        "school_name": "ST. ANTHONY'S CANOSSIAN SECONDARY SCHOOL",
        "url_address": "https://stanthonyscanossiansec.moe.edu.sg",
        "address": "1600 BEDOK NORTH AVENUE 4",
        "postal_code": 469700,
        "telephone_no": 64490616,
        "telephone_no_2": "na",
        "fax_no": 64490162,
        "fax_no_2": "na",
        "email_address": "SACSS@MOE.EDU.SG",
        "mrt_desc": "BEDOK MRT, BEDOK RESERVOIR MRT",
        "bus_desc": "17, 14, 46, 222",
        "principal_name": "MADAM KOH TYNG YUANN FIONA",
        "first_vp_name": "MISS CHIONH CHEW PENG",
        "second_vp_name": "MRS YEO SHU WEN MELISSA MARY",
        "third_vp_name": "MISS CHEN HUIQING CHRISTINE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3349488,
        "lng": 103.9413436
    },
    {
        "school_name": "ST. ANTHONY'S PRIMARY SCHOOL",
        "url_address": "http://www.stanthonyspri.moe.edu.sg",
        "address": "30 Bukit Batok St 32",
        "postal_code": 659401,
        "telephone_no": 65690822,
        "telephone_no_2": "na",
        "fax_no": 65690811,
        "fax_no_2": "na",
        "email_address": "SAPS@MOE.EDU.SG",
        "mrt_desc": "Bukit Gombak MRT Station",
        "bus_desc": 945,
        "principal_name": "MADAM GOH LUNG ENG",
        "first_vp_name": "MISS MATHEW ANNA",
        "second_vp_name": "MR TEE LENG TECK",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3641887,
        "lng": 103.748959
    },
    {
        "school_name": "ST. GABRIEL'S PRIMARY SCHOOL",
        "url_address": "http://www.stgabrielspri.moe.edu.sg",
        "address": "220 Lorong Chuan",
        "postal_code": 556742,
        "telephone_no": 62803628,
        "telephone_no_2": "na",
        "fax_no": 63820344,
        "fax_no_2": "na",
        "email_address": "STGPS@MOE.EDU.SG",
        "mrt_desc": "Lor Chuan MRT Station (Circle Line)",
        "bus_desc": "73, 105, 159",
        "principal_name": "MR MARTIN TAN SIEW KIN",
        "first_vp_name": "MADAM CHUA WANG LING IRENE",
        "second_vp_name": "MR LIM CHONG ENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3493594,
        "lng": 103.8621025
    },
    {
        "school_name": "ST. GABRIEL'S SECONDARY SCHOOL",
        "url_address": "http://www.stgabrielssec.moe.edu.sg",
        "address": "24 SERANGOON AVENUE 1",
        "postal_code": 556140,
        "telephone_no": 62889470,
        "telephone_no_2": "na",
        "fax_no": 62898615,
        "fax_no_2": "na",
        "email_address": "STGSS@MOE.EDU.SG",
        "mrt_desc": "SERANGOON MRT",
        "bus_desc": 158,
        "principal_name": "MR LIM CHEE KOON SHAWN",
        "first_vp_name": "MR CHRISTOPHER THOMAS",
        "second_vp_name": "MADAM YEE WHOY CHONG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3470106,
        "lng": 103.8757857
    },
    {
        "school_name": "ST. HILDA'S PRIMARY SCHOOL",
        "url_address": "http://www.shps.moe.edu.sg",
        "address": "2 Tampines Ave 3",
        "postal_code": 529706,
        "telephone_no": 67811916,
        "telephone_no_2": "na",
        "fax_no": 67830527,
        "fax_no_2": "na",
        "email_address": "SHPS@MOE.EDU.SG",
        "mrt_desc": "Tampines West, Tampines Central",
        "bus_desc": "Feeder Bus service: 293 from Tampines Interchange (towards St 71)",
        "principal_name": "MADAM LAW LI MEI",
        "first_vp_name": "MADAM LOW AI LING",
        "second_vp_name": "MADAM NG YIN SZE JOSEPHINE",
        "third_vp_name": "MADAM POH LYE IMM",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3496843,
        "lng": 103.9361045
    },
    {
        "school_name": "ST. HILDA'S SECONDARY SCHOOL",
        "url_address": "http://www.sthildassec.moe.edu.sg",
        "address": "2 TAMPINES STREET 82",
        "postal_code": 528986,
        "telephone_no": 63055277,
        "telephone_no_2": "na",
        "fax_no": 67865011,
        "fax_no_2": "na",
        "email_address": "SHSS@MOE.EDU.SG",
        "mrt_desc": "TAMPINES MRT, TAMPINES WEST MRT",
        "bus_desc": "22, 129, 293, 298",
        "principal_name": "MR LEW KING LUN JULIAN",
        "first_vp_name": "MADAM SO MUN YEE",
        "second_vp_name": "MR GOH WEE SIONG JARED",
        "third_vp_name": "MR LOY WEE JIN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3502316,
        "lng": 103.9364048
    },
    {
        "school_name": "ST. JOSEPH'S INSTITUTION",
        "url_address": "http://www.sji.edu.sg",
        "address": "38 MALCOLM ROAD",
        "postal_code": 308274,
        "telephone_no": 62500022,
        "telephone_no_2": "na",
        "fax_no": 62533640,
        "fax_no_2": "na",
        "email_address": "SJI@MOE.EDU.SG",
        "mrt_desc": "STEVENS MRT",
        "bus_desc": "105, 132, 151, 153, 154, 156, 186, 190, 960, 972",
        "principal_name": "MR JUSTIN ARUL PIERRE",
        "first_vp_name": "MR DOMINIC ANG SWEE KENG",
        "second_vp_name": "MR LAM CHUEN SENG ERIC",
        "third_vp_name": "MR TSAO WEN JIE NICHOLAS",
        "fourth_vp_name": "MDM SHIRLEY YONG WAI YEE",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "NOVENA",
        "zone_code": "SOUTH",
        "type_code": "INDEPENDENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3234128,
        "lng": 103.8276442
    },
    {
        "school_name": "ST. JOSEPH'S INSTITUTION JUNIOR",
        "url_address": "https://sjijunior.moe.edu.sg",
        "address": "3 ESSEX ROAD",
        "postal_code": 309331,
        "telephone_no": 62552700,
        "telephone_no_2": "na",
        "fax_no": 62557455,
        "fax_no_2": "na",
        "email_address": "STMICHAELSCH@MOE.EDU.SG",
        "mrt_desc": "Novena",
        "bus_desc": "21;54;56;57;124;131;141;166;518;851;980",
        "principal_name": "MR LEONG YEW HON ERIC",
        "first_vp_name": "MISS YAK HIOK WOON, FAITH (YE YUYUN)",
        "second_vp_name": "MISS SNG WAN XIAN",
        "third_vp_name": "MR LIM YEW TEE COLLIN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "NOVENA",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3173615,
        "lng": 103.8454801
    },
    {
        "school_name": "ST. MARGARET'S SCHOOL (PRIMARY)",
        "url_address": "https://stmargaretspri.moe.edu.sg",
        "address": "136 Sophia Road",
        "postal_code": 228197,
        "telephone_no": 63394247,
        "telephone_no_2": "na",
        "fax_no": 63394264,
        "fax_no_2": "na",
        "email_address": "STMARGARETPS@MOE.EDU.SG",
        "mrt_desc": "Little India MRT Station (NE7/DT12); Dhoby Ghaut MRT Station (NS24/NE6/CC1)",
        "bus_desc": "64, 65, 131, 139, 147, 857, 166 (alight at the bus stop after Parklane Shopping Mall)",
        "principal_name": "MADAM KO-TAN LI LING",
        "first_vp_name": "MDM WENDY SENG GEK CHENG",
        "second_vp_name": "MRS NEO HUI EN CHERLYN",
        "third_vp_name": "MISS TAN CHER LANG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CENTRAL",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3034962,
        "lng": 103.8458939
    },
    {
        "school_name": "ST. MARGARET'S SCHOOL (SECONDARY)",
        "url_address": "http://www.stmargaretssec.moe.edu.sg",
        "address": "111 FARRER ROAD",
        "postal_code": 259240,
        "telephone_no": 64664525,
        "telephone_no_2": "na",
        "fax_no": 64666709,
        "fax_no_2": "na",
        "email_address": "STMARGARETSS@MOE.EDU.SG",
        "mrt_desc": "FARRER ROAD MRT",
        "bus_desc": "48, 93, 153, 165, 174, 186, 855, 961",
        "principal_name": "MISS LIM HUI KHENG LINDA",
        "first_vp_name": "MDM CHIN YIH MIN",
        "second_vp_name": "MS WOON CHIN FONG CHRYSTINE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT TIMAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3199548,
        "lng": 103.8100803
    },
    {
        "school_name": "UNITY SECONDARY SCHOOL",
        "url_address": "http://www.unitysec.moe.edu.sg",
        "address": "20 CHOA CHU KANG STREET 62",
        "postal_code": 689143,
        "telephone_no": 67671070,
        "telephone_no_2": "na",
        "fax_no": 67654189,
        "fax_no_2": "na",
        "email_address": "UNITY_SS@MOE.EDU.SG",
        "mrt_desc": "YEW TEE MRT",
        "bus_desc": 307,
        "principal_name": "MADAM ONG LIANG FUNG",
        "first_vp_name": "MR LIM YONG CHAI ALAN",
        "second_vp_name": "MS YUEN CHAI LIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4000286,
        "lng": 103.7461254
    },
    {
        "school_name": "ST. PATRICK'S SCHOOL",
        "url_address": "http://www.stpatricks.moe.edu.sg",
        "address": "490 EAST COAST ROAD",
        "postal_code": 429058,
        "telephone_no": 63440929,
        "telephone_no_2": 63441429,
        "fax_no": 63445152,
        "fax_no_2": "na",
        "email_address": "STPATRICKSCH@MOE.EDU.SG",
        "mrt_desc": "MARINE TERRACE MRT (TEL)",
        "bus_desc": "10, 10E, 12, 13, 14, 14E, 15, 16, 31, 32, 36, 40, 43, 47, 48, 55, 135, 150, 155, 196, 197",
        "principal_name": "MR MARK GERARD MINJOOT",
        "first_vp_name": "MR TAN YII HSIEN BARNABAS",
        "second_vp_name": "MR KWAN YEW MENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3086925,
        "lng": 103.9163287
    },
    {
        "school_name": "ST. STEPHEN'S SCHOOL",
        "url_address": "http://www.ststephens.moe.edu.sg",
        "address": "20 SIGLAP VIEW",
        "postal_code": 455789,
        "telephone_no": 62419513,
        "telephone_no_2": 64441645,
        "fax_no": 64422576,
        "fax_no_2": "na",
        "email_address": "STSTEPHENSCH@MOE.EDU.SG",
        "mrt_desc": "Kembangan MRT Station",
        "bus_desc": "2,7,24,25,26,28,30,32,33,67,854",
        "principal_name": "MR GOH HENG LIANG TIMOTHY",
        "first_vp_name": "MR EDWIN HENG TOW YANG",
        "second_vp_name": "MR CHEW SOO KWANG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3188293,
        "lng": 103.9175685
    },
    {
        "school_name": "SWISS COTTAGE SECONDARY SCHOOL",
        "url_address": "http://www.swisscottagesec.moe.edu.sg",
        "address": "3 BUKIT BATOK STREET 34",
        "postal_code": 659322,
        "telephone_no": 65637173,
        "telephone_no_2": "na",
        "fax_no": 65693028,
        "fax_no_2": "na",
        "email_address": "SCSS@MOE.EDU.SG",
        "mrt_desc": "BUKIT GOMBAK MRT",
        "bus_desc": "187, 188, 985, 945",
        "principal_name": "MDM MANDY CHENG MUN YI",
        "first_vp_name": "MR TAN BOON PIANG",
        "second_vp_name": "na",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT BATOK",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3646741,
        "lng": 103.7506408
    },
    {
        "school_name": "TAMPINES MERIDIAN JUNIOR COLLEGE",
        "url_address": "http://www.tmjc.moe.edu.sg",
        "address": "21 Pasir Ris Street 71",
        "postal_code": 518799,
        "telephone_no": 63493660,
        "telephone_no_2": "na",
        "fax_no": 63493667,
        "fax_no_2": "na",
        "email_address": "tmjc@moe.edu.sg",
        "mrt_desc": "Pasir Ris MRT Station",
        "bus_desc": "3, 39, 53, 68, 81, 89, 109, 358, 359, 518, 518A",
        "principal_name": "MR SIN KIM HO",
        "first_vp_name": "MADAM TOH LAY HAR",
        "second_vp_name": "MR ANG YEOU PENG",
        "third_vp_name": "MDM YASMINE D/O KAMALUDHEEN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3766538,
        "lng": 103.9372656
    },
    {
        "school_name": "TAMPINES NORTH PRIMARY SCHOOL",
        "url_address": "http://www.tampinesnorthpri.moe.edu.sg",
        "address": "30 TAMPINES AVENUE 9",
        "postal_code": 529565,
        "telephone_no": 67854329,
        "telephone_no_2": "na",
        "fax_no": 67863117,
        "fax_no_2": "na",
        "email_address": "TNPS@MOE.EDU.SG",
        "mrt_desc": "Tampines MRT",
        "bus_desc": "SBS Transit 28, 29, 293",
        "principal_name": "MADAM RATNA KUMARI D/O R RAMACHANDRA",
        "first_vp_name": "MR MOHAMED YUSUFF MOHAMED ALLIE",
        "second_vp_name": "MISS CHARMAINE TAY",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.360298,
        "lng": 103.948581
    },
    {
        "school_name": "TAMPINES PRIMARY SCHOOL",
        "url_address": "http://www.tampinespri.moe.edu.sg",
        "address": "250 TAMPINES STREET 12",
        "postal_code": 529426,
        "telephone_no": 67831190,
        "telephone_no_2": "na",
        "fax_no": 67843521,
        "fax_no_2": "na",
        "email_address": "TPPS@MOE.EDU.SG",
        "mrt_desc": "Tampines MRT",
        "bus_desc": "8, 10, 17,18, 27, 31, 65, 292, 293, or any bus going into Tampines Interchange",
        "principal_name": "MADAM LEE LAY SEE/ MRS LAY SEE NEUFELD",
        "first_vp_name": "MADAM ARIKEN CHARMAINE CARRIE",
        "second_vp_name": "MR HO WEE MIN  KELVIN",
        "third_vp_name": "MR TIN CHEE KUANG EDMUND",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3501832,
        "lng": 103.9444396
    },
    {
        "school_name": "TAMPINES SECONDARY SCHOOL",
        "url_address": "https://www.tampinessec.moe.edu.sg",
        "address": "252 TAMPINES ST 12",
        "postal_code": 529427,
        "telephone_no": 67835423,
        "telephone_no_2": "na",
        "fax_no": 67843059,
        "fax_no_2": "na",
        "email_address": "TPSS@MOE.EDU.SG",
        "mrt_desc": "TAMPINES MRT",
        "bus_desc": "3,  8,  10,  15,  17,  18,  20,  21,  23,  27,  28,  31,  34,  39,  59,  65,  129,  168,  292,  298,  518",
        "principal_name": "MADAM TAN YANG FERN",
        "first_vp_name": "MR MOHAMED FAHIZEL S/O M EGUEYAMAREC",
        "second_vp_name": "MS LEE PECK WEN AMANDA (LI BIWEN)",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3496921,
        "lng": 103.9445596
    },
    {
        "school_name": "TANJONG KATONG GIRLS' SCHOOL",
        "url_address": "http://www.tkgs.moe.edu.sg",
        "address": "20 Dunman Lane",
        "postal_code": 439272,
        "telephone_no": 63441593,
        "telephone_no_2": "na",
        "fax_no": 63451487,
        "fax_no_2": "64409187(from 2017)",
        "email_address": "TKGS@MOE.EDU.SG",
        "mrt_desc": "PAYA LEBAR MRT, DAKOTA MRT",
        "bus_desc": "10, 16, 31, 32, 33, 40, 43, 134, 135, 197",
        "principal_name": "MISS CHEW ING LIM",
        "first_vp_name": "MS XU WANJING",
        "second_vp_name": "MR CHAI CHI YANG MOSES",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "MARINE PARADE",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "GIRLS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3081616,
        "lng": 103.896462
    },
    {
        "school_name": "TANJONG KATONG PRIMARY SCHOOL",
        "url_address": "http://www.tanjongkatongpri.moe.edu.sg/",
        "address": "10 Seraya Road",
        "postal_code": 437259,
        "telephone_no": 63444728,
        "telephone_no_2": "na",
        "fax_no": 63445370,
        "fax_no_2": "na",
        "email_address": "TKPS@MOE.EDU.SG",
        "mrt_desc": "na",
        "bus_desc": "na",
        "principal_name": "MS TAN SEOK KUAN",
        "first_vp_name": "MISS ONG CHUXIAN",
        "second_vp_name": "MADAM TOH LENG LENG",
        "third_vp_name": "MRS VIJAYA GANESH",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "MARINE PARADE",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3053798,
        "lng": 103.9003358
    },
    {
        "school_name": "TANJONG KATONG SECONDARY SCHOOL",
        "url_address": "http://www.tanjongkatongsec.moe.edu.sg",
        "address": "130 HAIG ROAD",
        "postal_code": 438796,
        "telephone_no": 63443471,
        "telephone_no_2": "na",
        "fax_no": 64409624,
        "fax_no_2": "na",
        "email_address": "TKSS@MOE.EDU.SG",
        "mrt_desc": "PAYA LEBAR MRT, DAKOTA MRT",
        "bus_desc": "10, 16, 31, 32, 33, 40, 76, 135, 197",
        "principal_name": "MADAM TAN YOK CHING RUBY",
        "first_vp_name": "MADAM NG SIEW CHIN",
        "second_vp_name": "MR ARUUMUGAM SAMIKKANNU",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "MARINE PARADE",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3083557,
        "lng": 103.897532
    },
    {
        "school_name": "TAO NAN SCHOOL",
        "url_address": "http://www.taonan.moe.edu.sg",
        "address": "49 MARINE CRESCENT",
        "postal_code": 449761,
        "telephone_no": 64428307,
        "telephone_no_2": "na",
        "fax_no": 64435973,
        "fax_no_2": "na",
        "email_address": "TAONAN_SCH@MOE.EDU.SG",
        "mrt_desc": "Marine Parade, Marine Terrace",
        "bus_desc": "13, 16, 31, 36, 43, 48, 55, 134, 196, 197",
        "principal_name": "MADAM POH QINYU",
        "first_vp_name": "MS NG HUI MIN",
        "second_vp_name": "MR CHAN TUCK CHEONG",
        "third_vp_name": "MADAM FOO MEI PING",
        "fourth_vp_name": "MRS TEO CHAI HIAH",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "MARINE PARADE",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "Yes",
        "autonomous_ind": "No",
        "gifted_ind": "Yes",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "na",
        "mothertongue3_code": "na",
        "lat": 1.3049059,
        "lng": 103.911434
    },
    {
        "school_name": "TECK GHEE PRIMARY SCHOOL",
        "url_address": "http://www.teckgheepri.moe.edu.sg",
        "address": "1 ANG MO KIO STREET 32",
        "postal_code": 569299,
        "telephone_no": 64548769,
        "telephone_no_2": "na",
        "fax_no": 64589886,
        "fax_no_2": "na",
        "email_address": "TGPS@MOE.EDU.SG",
        "mrt_desc": "Ang Mo Kio & Bishan",
        "bus_desc": "22,24,135,853,162,262,159",
        "principal_name": "MISS REZIA RAHUMATHULLAH",
        "first_vp_name": "MADAM CHOH THIAN JENG CELIA",
        "second_vp_name": "MR TAN CHUAN YANG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3654149,
        "lng": 103.8506386
    },
    {
        "school_name": "TECK WHYE PRIMARY SCHOOL",
        "url_address": "http://www.teckwhyepri.moe.edu.sg",
        "address": "11 TECK WHYE WALK",
        "postal_code": 688261,
        "telephone_no": 67691025,
        "telephone_no_2": "na",
        "fax_no": 67635191,
        "fax_no_2": "na",
        "email_address": "TWPS@MOE.EDU.SG",
        "mrt_desc": "Choa Chu Kang MRT & LRT",
        "bus_desc": "975, 190 & 985",
        "principal_name": "MADAM WONG SU MAY",
        "first_vp_name": "MRS LIM GEK NOI",
        "second_vp_name": "MR MURALIDHARAN S/O NARAYANAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3837636,
        "lng": 103.7537174
    },
    {
        "school_name": "TELOK KURAU PRIMARY SCHOOL",
        "url_address": "http://www.telokkuraupri.moe.edu.sg",
        "address": "50 BEDOK RESERVOIR RD",
        "postal_code": 479239,
        "telephone_no": 62441600,
        "telephone_no_2": "na",
        "fax_no": 62442182,
        "fax_no_2": "na",
        "email_address": "TELOKKRAU_PS@MOE.EDU.SG",
        "mrt_desc": "Kaki Bukit MRT (nearest)",
        "bus_desc": "8, 21, 60 & 65",
        "principal_name": "MADAM GRACE HO LI JUN",
        "first_vp_name": "MDM SHANTHI D/O VEERASWAMY",
        "second_vp_name": "MADAM TAN KIM YAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3308237,
        "lng": 103.911406
    },
    {
        "school_name": "TEMASEK JUNIOR COLLEGE",
        "url_address": "http://www.temasekjc.moe.edu.sg",
        "address": "2 Tampines Avenue 9   Temasek Junior College",
        "postal_code": 529564,
        "telephone_no": 64428066,
        "telephone_no_2": "na",
        "fax_no": 64428762,
        "fax_no_2": "na",
        "email_address": "TEMASEK_JC@MOE.EDU.SG",
        "mrt_desc": "TAMPINES EAST MRT",
        "bus_desc": "Bus Service along Tampines Ave 9: 18, 29 and 29A; Bus Service along Tampines Ave 7: 3, 3A, 4, 9, 9A, 12, 12e, 17, 18, 19, 21, 29, 29A, 34, 34B, 37, 39, 59, 81, 293 and 518.",
        "principal_name": "MR LIU EARNLER",
        "first_vp_name": "MRS WENDY GOH",
        "second_vp_name": "MR QUEK POH BENG, KENNETH",
        "third_vp_name": "MR CHAN KOK YEW MARK",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "MIXED LEVEL (S1-JC2)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3572944,
        "lng": 103.9561855
    },
    {
        "school_name": "TEMASEK PRIMARY SCHOOL",
        "url_address": "http://www.temasekpri.moe.edu.sg",
        "address": "501 BEDOK SOUTH AVE 3",
        "postal_code": 469300,
        "telephone_no": 64438134,
        "telephone_no_2": "na",
        "fax_no": 64495871,
        "fax_no_2": "na",
        "email_address": "TEMASEK_PS@MOE.EDU.SG",
        "mrt_desc": "Tanah Merah MRT",
        "bus_desc": "25,46, 48, 229",
        "principal_name": "MADAM ANG GEK LENG ALISON AMANDA",
        "first_vp_name": "MADAM ONG SEOW PENG",
        "second_vp_name": "MADAM HASLINDAH BTE BAHROM",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3175255,
        "lng": 103.9455521
    },
    {
        "school_name": "TEMASEK SECONDARY SCHOOL",
        "url_address": "https://temaseksec.moe.edu.sg",
        "address": "600 UPPER EAST COAST ROAD",
        "postal_code": 465561,
        "telephone_no": 64495020,
        "telephone_no_2": "na",
        "fax_no": 64491450,
        "fax_no_2": "na",
        "email_address": "TEMASEK_SS@MOE.EDU.SG",
        "mrt_desc": "BEDOK MRT, TANAH MERAH MRT",
        "bus_desc": "10, 10E, 13, 14, 25, 43, 46, 55, 137, 229, 506, 531, 853",
        "principal_name": "MR TAN SHUN LOONG",
        "first_vp_name": "MR PONG WEN LONG",
        "second_vp_name": "MR CHANDRASEKARAN S/O AMMIAPPAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3160282,
        "lng": 103.9472248
    },
    {
        "school_name": "TOWNSVILLE PRIMARY SCHOOL",
        "url_address": "http://www.townsvillepri.moe.edu.sg/",
        "address": "3 ANG MO KIO AVE 10",
        "postal_code": 569730,
        "telephone_no": 64574345,
        "telephone_no_2": "na",
        "fax_no": 64570141,
        "fax_no_2": "na",
        "email_address": "TOWNSVILLEPS@MOE.EDU.SG",
        "mrt_desc": "Bishan MRT, Ang Mo Kio MRT Stations",
        "bus_desc": "45, 50, 55, 261, 548, 22, 24, 128, 135, 159, 162, 162M, 262, 853",
        "principal_name": "MR EDDIE FOO CHIT CHEONG",
        "first_vp_name": "MR HO SENG TAT SUNNY",
        "second_vp_name": "MADAM LYNETTE FERNANDEZ",
        "third_vp_name": "MR MARTIN VELAN ANTHONY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3601828,
        "lng": 103.8541038
    },
    {
        "school_name": "VICTORIA JUNIOR COLLEGE",
        "url_address": "https://www.victoriajc.moe.edu.sg/",
        "address": "20 MARINE VISTA",
        "postal_code": 449035,
        "telephone_no": 64485011,
        "telephone_no_2": "na",
        "fax_no": 64438337,
        "fax_no_2": "na",
        "email_address": "VICTORIA_JC@MOE.EDU.SG",
        "mrt_desc": "Nearest MRT Stations:  Marine Terrace, Kembangan, Eunos",
        "bus_desc": "13, 16, 16M, 31, 36, 36A, 36B, 43, 47, 48, 55, 196, 196A, 196e, 197, 853M",
        "principal_name": "MR LOW SWEE HENG JEFFREY",
        "first_vp_name": "MR KOH WEINING",
        "second_vp_name": "MS LEE YUN YUN GRACE",
        "third_vp_name": "MRS KAREN TAY",
        "fourth_vp_name": "MR LIM KWEE HONG KYLE",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3060699,
        "lng": 103.9198719
    },
    {
        "school_name": "VICTORIA SCHOOL",
        "url_address": "http://www.victoria.moe.edu.sg",
        "address": "2 SIGLAP LINK",
        "postal_code": 448880,
        "telephone_no": 62912965,
        "telephone_no_2": "na",
        "fax_no": 64452609,
        "fax_no_2": "na",
        "email_address": "VICTORIA_SCH@MOE.EDU.SG",
        "mrt_desc": "SIGLAP, BEDOK MRT, PAYA LEBAR MRT",
        "bus_desc": "31, 36, 43, 47, 48, 55, 155, 196, 196E, 197, 401, 853M",
        "principal_name": "MR LOW CHUN MENG",
        "first_vp_name": "MR LIM WEI ZHONG CLARENCE",
        "second_vp_name": "MR WU BIWEI, IVAN",
        "third_vp_name": "MR ANG JOHNNY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "BOYS' SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S4)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "Yes",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3087386,
        "lng": 103.9281936
    },
    {
        "school_name": "WATERWAY PRIMARY SCHOOL",
        "url_address": "https://waterwaypri.moe.edu.sg",
        "address": "70 Punggol Drive",
        "postal_code": 828802,
        "telephone_no": "6636 6880",
        "telephone_no_2": "na",
        "fax_no": "6315 3451",
        "fax_no_2": "na",
        "email_address": "waterway_ps@moe.edu.sg",
        "mrt_desc": "Kadaloor LRT Station",
        "bus_desc": "50, 381",
        "principal_name": "MR WONG KENG YUIN WILBUR",
        "first_vp_name": "MADAM TAN GEK SIM MAGELLA",
        "second_vp_name": "MADAM CHUA KIM LAN JUDY",
        "third_vp_name": "MADAM SHARIFAH MASTURAH BTE S OSMAN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3992126,
        "lng": 103.9186292
    },
    {
        "school_name": "WELLINGTON PRIMARY SCHOOL",
        "url_address": "http://www.wellingtonpri.moe.edu.sg",
        "address": "10 WELLINGTON CIRCLE",
        "postal_code": 757702,
        "telephone_no": 67533319,
        "telephone_no_2": "na",
        "fax_no": 67533765,
        "fax_no_2": "na",
        "email_address": "WELLINGTONPS@MOE.EDU.SG",
        "mrt_desc": "Sembawang MRT",
        "bus_desc": "980, 856, 859",
        "principal_name": "MR ALCANTARA ALBERT ALFRED",
        "first_vp_name": "MADAM HOONG WHEE SIEN",
        "second_vp_name": "MADAM SHAHRULHANA BTE MOHAMED",
        "third_vp_name": "MR NG WEE MING DENNIS",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SEMBAWANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4521597,
        "lng": 103.8224459
    },
    {
        "school_name": "WEST GROVE PRIMARY SCHOOL",
        "url_address": "http://www.westgrovepri.moe.edu.sg/",
        "address": "1 JURONG WEST ST 72",
        "postal_code": 649223,
        "telephone_no": 62679234,
        "telephone_no_2": "na",
        "fax_no": 62679235,
        "fax_no_2": "na",
        "email_address": "WGPS@MOE.EDU.SG",
        "mrt_desc": "Boon Lay MRT",
        "bus_desc": "Bus 99, 242",
        "principal_name": "MISS MABEL GOH",
        "first_vp_name": "MADAM GOH XUEMIN CHERMAINE",
        "second_vp_name": "MADAM TAY SOOK HIAN, AUDREY",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.344983,
        "lng": 103.6992347
    },
    {
        "school_name": "WEST SPRING PRIMARY SCHOOL",
        "url_address": "http://www.westspringpri.moe.edu.sg",
        "address": "60 Bukit Panjang Ring Road",
        "postal_code": 679946,
        "telephone_no": 63144192,
        "telephone_no_2": "na",
        "fax_no": "na",
        "fax_no_2": 63140648,
        "email_address": "westspring_ps@moe.edu.sg",
        "mrt_desc": "Jelapang LRT",
        "bus_desc": "920, 922",
        "principal_name": "MR WILLY TAN",
        "first_vp_name": "MR WILLY TAN NGUAN PENG",
        "second_vp_name": "MADAM KUM LAI MENG",
        "third_vp_name": "MR SIM KOOI SUEN",
        "fourth_vp_name": "MR CHIN HONG FAI HUMPHREY",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3896611,
        "lng": 103.7665176
    },
    {
        "school_name": "WEST SPRING SECONDARY SCHOOL",
        "url_address": "http://www.westspringsec.moe.edu.sg",
        "address": "61 SENJA  ROAD",
        "postal_code": 677737,
        "telephone_no": 68920369,
        "telephone_no_2": "na",
        "fax_no": 68929468,
        "fax_no_2": "na",
        "email_address": "WESTSPRINGSS@MOE.EDU.SG",
        "mrt_desc": "BUKIT PANJANG MRT, JELAPANG LRT, SENJA LRT",
        "bus_desc": "920, 972, 976",
        "principal_name": "MADAM YONG LI LING BELINDA",
        "first_vp_name": "MR MALVIN CHAN HUAN JIAN",
        "second_vp_name": "MADAM SIM BEE LIAN (SHEN MEILIAN)",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3877121,
        "lng": 103.7600409
    },
    {
        "school_name": "WEST VIEW PRIMARY SCHOOL",
        "url_address": "http://www.westviewpri.moe.edu.sg",
        "address": "31 SENJA ROAD",
        "postal_code": 677742,
        "telephone_no": 67600178,
        "telephone_no_2": "na",
        "fax_no": 67600147,
        "fax_no_2": "na",
        "email_address": "WVPS@MOE.EDU.SG",
        "mrt_desc": "Bukit Panjang MRT, SENJA LRT (A13)",
        "bus_desc": "170,171,176,178,180,000,000,000,000,000",
        "principal_name": "MR LEE FOOK LOONG EUGENE",
        "first_vp_name": "MADAM ONG POH CHOO DORIS",
        "second_vp_name": "MADAM SITI SUHAILA BTE SAPIHE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3837275,
        "lng": 103.7601419
    },
    {
        "school_name": "WESTWOOD PRIMARY SCHOOL",
        "url_address": "http://www.westwoodpri.moe.edu.sg",
        "address": "1 Jurong West Street 73",
        "postal_code": 649188,
        "telephone_no": 64121690,
        "telephone_no_2": "na",
        "fax_no": 67945084,
        "fax_no_2": "na",
        "email_address": "westwood_ps@moe.edu.sg",
        "mrt_desc": "Boon Lay MRT Station",
        "bus_desc": "181, 502 & 243",
        "principal_name": "MR MAH SENG THONG ANDREW",
        "first_vp_name": "MR CHEE CHIT YENG",
        "second_vp_name": "MR LOW MIN CHYE",
        "third_vp_name": "MISS CHONG HUAY LENG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3472361,
        "lng": 103.7004708
    },
    {
        "school_name": "WESTWOOD SECONDARY SCHOOL",
        "url_address": "https://www.westwoodsec.moe.edu.sg",
        "address": "11 JURONG WEST STREET 25",
        "postal_code": 648350,
        "telephone_no": 67929737,
        "telephone_no_2": "na",
        "fax_no": 67929738,
        "fax_no_2": "na",
        "email_address": "WESTWOOD_SS@MOE.EDU.SG",
        "mrt_desc": "BOON LAY MRT",
        "bus_desc": "172, 181, 181M, 185, 199, 405, 974, 974A",
        "principal_name": "MR ABDUL HARRIS B SUMARDI",
        "first_vp_name": "MR HOI WENG KIT DERRICK",
        "second_vp_name": "MISS THEODORA HUANG XINYI",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3537847,
        "lng": 103.7017948
    },
    {
        "school_name": "WHITE SANDS PRIMARY SCHOOL",
        "url_address": "http://www.whitesandspri.moe.edu.sg",
        "address": "2 PASIR RIS ST 11",
        "postal_code": 519075,
        "telephone_no": 69229100,
        "telephone_no_2": "na",
        "fax_no": 65815013,
        "fax_no_2": "na",
        "email_address": "WSPS@MOE.EDU.SG",
        "mrt_desc": "Pasir Ris MRT Station",
        "bus_desc": "12, 17, 21, 39, 53, 81, 518, 109",
        "principal_name": "MADAM WONG LIN LIN AUDREY",
        "first_vp_name": "MS REZINA KHAN D/O ABDUL RAHIM",
        "second_vp_name": "MISS TIONG LINA",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PASIR RIS",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3654493,
        "lng": 103.9610714
    },
    {
        "school_name": "WHITLEY SECONDARY SCHOOL",
        "url_address": "http://www.whitleysec.moe.edu.sg",
        "address": "30 BISHAN STREET 24",
        "postal_code": 579747,
        "telephone_no": 64561336,
        "telephone_no_2": "na",
        "fax_no": 64591330,
        "fax_no_2": "na",
        "email_address": "WHITLEY_SS@MOE.EDU.SG",
        "mrt_desc": "BISHAN MRT, MARYMOUNT MRT",
        "bus_desc": "13, 52, 54, 74, 74E, 88, 162, 162M,  588, 410, 851, 852",
        "principal_name": "MISS KOH LIN LYNN",
        "first_vp_name": "MR TAN YIT KEE",
        "second_vp_name": "MR TAY KIM SENG",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BISHAN",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3555261,
        "lng": 103.8429226
    },
    {
        "school_name": "WOODGROVE PRIMARY SCHOOL",
        "url_address": "http://www.woodgrovepri.moe.edu.sg/",
        "address": "2 WOODLANDS DRIVE 14",
        "postal_code": 738079,
        "telephone_no": 68943371,
        "telephone_no_2": "na",
        "fax_no": 68943372,
        "fax_no_2": "na",
        "email_address": "WOODGROVE_PS@MOE.EDU.SG",
        "mrt_desc": "Woodlands MRT Station",
        "bus_desc": 901,
        "principal_name": "MS ADELINE TAN WEE KIAW",
        "first_vp_name": "MR PHANG TECK HOW",
        "second_vp_name": "MR SIM YONG MING",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4334662,
        "lng": 103.7905304
    },
    {
        "school_name": "WOODGROVE SECONDARY SCHOOL",
        "url_address": "https://www.woodgrovesec.moe.edu.sg",
        "address": "3 WOODLANDS AVENUE 6",
        "postal_code": 738990,
        "telephone_no": 68932564,
        "telephone_no_2": "na",
        "fax_no": 68934458,
        "fax_no_2": "na",
        "email_address": "WOODGROVE_SS@MOE.EDU.SG",
        "mrt_desc": "WOODLANDS MRT, WOODLANDS SOUTH MRT",
        "bus_desc": "901, 901M",
        "principal_name": "MR CHUA CHOR HUAT",
        "first_vp_name": "MADAM TAN PHAIK HOON (CHEN BIHONG)",
        "second_vp_name": "MRS VENKATRAMAN CHITHRA",
        "third_vp_name": "MR LOKE KOK LEONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.428889,
        "lng": 103.7963256
    },
    {
        "school_name": "WOODLANDS PRIMARY SCHOOL",
        "url_address": "http://www.woodlandspri.moe.edu.sg",
        "address": "10 WOODLANDS DRIVE 50",
        "postal_code": 738853,
        "telephone_no": 62697410,
        "telephone_no_2": "na",
        "fax_no": 63671165,
        "fax_no_2": "na",
        "email_address": "WPS@MOE.EDU.SG",
        "mrt_desc": "Woodlands",
        "bus_desc": "912 & 912E",
        "principal_name": "MISS KUCK LI LIAN LILLIAN",
        "first_vp_name": "MR RAZALI B SENIN",
        "second_vp_name": "MISS SUSANNA CHAU",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4367469,
        "lng": 103.7915951
    },
    {
        "school_name": "WOODLANDS RING PRIMARY SCHOOL",
        "url_address": "HTTP://www.woodlandsringpri.moe.edu.sg",
        "address": "11 WOODLANDS RING ROAD",
        "postal_code": 738240,
        "telephone_no": 63643679,
        "telephone_no_2": "na",
        "fax_no": 63643490,
        "fax_no_2": "na",
        "email_address": "WRPS@MOE.EDU.SG",
        "mrt_desc": "Admiralty MRT Station",
        "bus_desc": 912,
        "principal_name": "MISS GEETHA D/O DORAISAMY",
        "first_vp_name": "MR LIM KIM THYE",
        "second_vp_name": "MR CHEW CHIN MING",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4345519,
        "lng": 103.7978994
    },
    {
        "school_name": "WOODLANDS RING SECONDARY SCHOOL",
        "url_address": "http://www.woodlandsringsec.moe.edu.sg",
        "address": "21 WOODLANDS AVENUE 1",
        "postal_code": 739062,
        "telephone_no": 63643712,
        "telephone_no_2": "na",
        "fax_no": "na",
        "fax_no_2": "na",
        "email_address": "WRSS@MOE.EDU.SG",
        "mrt_desc": "ADMIRALTY MRT",
        "bus_desc": 912,
        "principal_name": "MR LAM YUI- P'NG",
        "first_vp_name": "MR TAY YONG SEAH MELVIN",
        "second_vp_name": "MR SIM KOK HIAN, KENNETH",
        "third_vp_name": "MR HEE JUAY AY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4306596,
        "lng": 103.7773275
    },
    {
        "school_name": "WOODLANDS SECONDARY SCHOOL",
        "url_address": "http://www.woodlandssec.moe.edu.sg",
        "address": "11 MARSILING ROAD",
        "postal_code": 739111,
        "telephone_no": 68494400,
        "telephone_no_2": "na",
        "fax_no": 62691774,
        "fax_no_2": "na",
        "email_address": "WSS@MOE.EDU.SG",
        "mrt_desc": "MARSILING MRT, WOODLANDS MRT",
        "bus_desc": "913, 913M, 913, 913T, 178, 856, 903",
        "principal_name": "MISS MOH CUI RONG REBECCA",
        "first_vp_name": "MADAM MASAYU BINTE MAHMUD",
        "second_vp_name": "MR TAY HONG JOO STEVEN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "WOODLANDS",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4400304,
        "lng": 103.7744535
    },
    {
        "school_name": "XINGHUA PRIMARY SCHOOL",
        "url_address": "http://www.xinghuapri.moe.edu.sg",
        "address": "45 HOUGANG AVENUE 1",
        "postal_code": 538882,
        "telephone_no": 62889121,
        "telephone_no_2": "na",
        "fax_no": 62838831,
        "fax_no_2": "na",
        "email_address": "XINGHUA_PS@MOE.EDU.SG",
        "mrt_desc": "Kovan MRT Station",
        "bus_desc": "Bus services 53, 62, 112, 113, 115",
        "principal_name": "MR LEOW YEN MIN",
        "first_vp_name": "MISS PHUA AI LEI",
        "second_vp_name": "MS TAN BEE YIN (CHEN MEIYING)",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.357958,
        "lng": 103.8901418
    },
    {
        "school_name": "XINGNAN PRIMARY SCHOOL",
        "url_address": "http://www.xingnanpri.moe.edu.sg",
        "address": "5 JURONG WEST STREET 91",
        "postal_code": 649036,
        "telephone_no": 67913679,
        "telephone_no_2": "na",
        "fax_no": 67921493,
        "fax_no_2": "na",
        "email_address": "XINGNAN_PS@MOE.EDU.SG",
        "mrt_desc": "Pioneer MRT Station",
        "bus_desc": "Bus 99 & 241",
        "principal_name": "MADAM CHAN SIN LI, CINDY",
        "first_vp_name": "MDM ANG HWEE LOO",
        "second_vp_name": "MADAM S ANITHA",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3427136,
        "lng": 103.6875523
    },
    {
        "school_name": "XINMIN PRIMARY SCHOOL",
        "url_address": "https://xinminpri.moe.edu.sg/",
        "address": "9 HOUGANG AVENUE 8",
        "postal_code": 538784,
        "telephone_no": 62835479,
        "telephone_no_2": "na",
        "fax_no": 62880334,
        "fax_no_2": "na",
        "email_address": "XINMIN_PS@MOE.EDU.SG",
        "mrt_desc": "Nil",
        "bus_desc": "74, 147, 165, 112",
        "principal_name": "MADAM TAN KAY LING",
        "first_vp_name": "MRS AHKEELA JULIA BEE D/O HANIFAH",
        "second_vp_name": "MR LIM BOON TECK",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.371371,
        "lng": 103.883074
    },
    {
        "school_name": "XINMIN SECONDARY SCHOOL",
        "url_address": "http://www.xinminsec.moe.edu.sg",
        "address": "11 HOUGANG AVENUE 8",
        "postal_code": 538789,
        "telephone_no": 62889382,
        "telephone_no_2": "na",
        "fax_no": 63851068,
        "fax_no_2": "na",
        "email_address": "XINMIN_SS@MOE.EDU.SG",
        "mrt_desc": "HOUGANG MRT",
        "bus_desc": "25, 43, 43M, 55, 70, 70A, 70B, 70M, 72, 72A, 73, 73A, 74, 88, 88A, 103, 109, 109A, 112, 116, 132, 147, 159, 159A, 161, 165, 329, 660, 854, 854E",
        "principal_name": "MR TAN SOON HUI",
        "first_vp_name": "MR GOH KAR WHEE",
        "second_vp_name": "MADAM KOMATHI D/O P KESAVAN",
        "third_vp_name": "MR TAN KOK KWANG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3720807,
        "lng": 103.8828692
    },
    {
        "school_name": "XISHAN PRIMARY SCHOOL",
        "url_address": "https://www.xishanpri.moe.edu.sg/",
        "address": "8 YISHUN STREET 21",
        "postal_code": 768611,
        "telephone_no": 67588837,
        "telephone_no_2": "na",
        "fax_no": 67588361,
        "fax_no_2": "na",
        "email_address": "XISHAN_PS@MOE.EDU.SG",
        "mrt_desc": "Alight at Yishun MRT Station; Take Exit C; Walk towards Yishun Street 21",
        "bus_desc": "Along Yishun Ave 2,take Bus Service 117, 169, 804, 812, 965. Alight at Blk 220. Along Yishun Ring Road,take Bus Service 1N, 800, 804, NR1. Alight at Blk 227 or 236.",
        "principal_name": "MADAM NGOH YING LI, JANE",
        "first_vp_name": "MISS LATHA D/O SINASAMY",
        "second_vp_name": "MADAM LEE WEE LING (LI WEILIN)",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4334915,
        "lng": 103.8374838
    },
    {
        "school_name": "YANGZHENG PRIMARY SCHOOL",
        "url_address": "http://www.yangzhengpri.moe.edu.sg/",
        "address": "15 SERANGOON AVENUE 3",
        "postal_code": 556108,
        "telephone_no": 62846298,
        "telephone_no_2": "na",
        "fax_no": 62879778,
        "fax_no_2": "na",
        "email_address": "YZPS@MOE.EDU.SG",
        "mrt_desc": "Serangoon Station",
        "bus_desc": "58 & 105 (Outside the school, Serangoon Ave 3); 133 & 135(Serangoon Ave 2)",
        "principal_name": "MRS LIM- FOO BOON CHING",
        "first_vp_name": "MR ERIC LEE WEI TAT",
        "second_vp_name": "MISS MICHELLE HUANG",
        "third_vp_name": "MADAM TAN ENG ENG JENNY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.349218,
        "lng": 103.8685545
    },
    {
        "school_name": "YEW TEE PRIMARY SCHOOL",
        "url_address": "http://www.yewteepri.moe.edu.sg",
        "address": "10 CHOA CHU KANG ST 64",
        "postal_code": 689100,
        "telephone_no": 67670027,
        "telephone_no_2": "na",
        "fax_no": 67675450,
        "fax_no_2": "na",
        "email_address": "YTPS@MOE.EDU.SG",
        "mrt_desc": "Yew Tee MRT Station",
        "bus_desc": 307,
        "principal_name": "MADAM NUR SABARIAH BTE MOHD IBRAHIM",
        "first_vp_name": "MR NG SIOK KWANG ANDREW",
        "second_vp_name": "MADAM TOH GUAT HWA PAULINE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "CHOA CHU KANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.396978,
        "lng": 103.7511849
    },
    {
        "school_name": "YIO CHU KANG PRIMARY SCHOOL",
        "url_address": "http://www.yiochukangpri.moe.edu.sg",
        "address": "1 HOUGANG STREET 51",
        "postal_code": 538720,
        "telephone_no": 63851365,
        "telephone_no_2": "na",
        "fax_no": 63855915,
        "fax_no_2": "na",
        "email_address": "YCKPS@MOE.EDU.SG",
        "mrt_desc": "Hougang MRT Station; Yio Chu Kang MRT Station",
        "bus_desc": "88,101,109,159,161 and 325",
        "principal_name": "MS POH HWEE THING",
        "first_vp_name": "MADAM RAMACHANDRA SUGUNA",
        "second_vp_name": "MR TAN TECK MING",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.377996,
        "lng": 103.8855816
    },
    {
        "school_name": "YIO CHU KANG SECONDARY SCHOOL",
        "url_address": "http://www.yiochukangsec.moe.edu.sg",
        "address": "3063 ANG MO KIO AVENUE 5",
        "postal_code": 569868,
        "telephone_no": 64560669,
        "telephone_no_2": "na",
        "fax_no": 65522927,
        "fax_no_2": "na",
        "email_address": "YCKSS@MOE.EDU.SG",
        "mrt_desc": "YIO CHU KANG MRT",
        "bus_desc": "13, 45, 86, 138, 162, 269, 851, 852, 853",
        "principal_name": "MADAM BETTY CHANG",
        "first_vp_name": "MR LIM HOCK CHYE KEVIN",
        "second_vp_name": "MR PEK XU HAO, ALVIN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "ANG MO KIO",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3783445,
        "lng": 103.8420058
    },
    {
        "school_name": "YISHUN INNOVA JUNIOR COLLEGE",
        "url_address": "https://yijc.moe.edu.sg/",
        "address": "3 YISHUN RING ROAD",
        "postal_code": 768675,
        "telephone_no": 62579873,
        "telephone_no_2": "na",
        "fax_no": 62574373,
        "fax_no_2": "na",
        "email_address": "yijc@moe.edu.sg",
        "mrt_desc": "Yishun, Khatib",
        "bus_desc": "167, 169, 171, 800, 812",
        "principal_name": "MR MICHAEL DE SILVA",
        "first_vp_name": "MRS LEE HUI XIN",
        "second_vp_name": "MR LOI GUANG YOU",
        "third_vp_name": "MISS CHOY WEN JU JULIEANNE",
        "fourth_vp_name": "MR LONG TIEN HO",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "FULL DAY",
        "mainlevel_code": "JUNIOR COLLEGE",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4252209,
        "lng": 103.8311055
    },
    {
        "school_name": "YISHUN PRIMARY SCHOOL",
        "url_address": "http://www.yishunpri.moe.edu.sg",
        "address": "500 YISHUN RING ROAD",
        "postal_code": 768679,
        "telephone_no": 62577461,
        "telephone_no_2": "na",
        "fax_no": 67554198,
        "fax_no_2": "na",
        "email_address": "YPS@MOE.EDU.SG",
        "mrt_desc": "Yishun",
        "bus_desc": "Translink Feeder Service 800 & 812",
        "principal_name": "MR CHAN WENG YEW MARVIN",
        "first_vp_name": "MADAM FARLINAH SUPAAH",
        "second_vp_name": "MISS WONG PEI LI, PAMELA",
        "third_vp_name": "MR LEE HAN KEONG",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4334926,
        "lng": 103.8338127
    },
    {
        "school_name": "YISHUN SECONDARY SCHOOL",
        "url_address": "http://www.yishunsec.moe.edu.sg",
        "address": "4 YISHUN STREET 71",
        "postal_code": 768516,
        "telephone_no": 68767129,
        "telephone_no_2": "na",
        "fax_no": 67557748,
        "fax_no_2": "na",
        "email_address": "YISHUN_SS@MOE.EDU.SG",
        "mrt_desc": "YISHUN MRT, KHATIB MRT",
        "bus_desc": "167,  169,  171,  800,  807, 811, 812,  856,  858,  859,  860,  969, 980",
        "principal_name": "MRS REGINA LEE",
        "first_vp_name": "MRS CHAN WEE MING",
        "second_vp_name": "MR TAY HIANG SOON",
        "third_vp_name": "MR JAYAKUMAR S/O NAVARETNAM",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.428129,
        "lng": 103.828833
    },
    {
        "school_name": "YISHUN TOWN SECONDARY SCHOOL",
        "url_address": "http://www.yishuntownsec.moe.edu.sg",
        "address": "6 YISHUN STREET 21",
        "postal_code": 768610,
        "telephone_no": 67587219,
        "telephone_no_2": "na",
        "fax_no": 67559112,
        "fax_no_2": "na",
        "email_address": "YTSS@MOE.EDU.SG",
        "mrt_desc": "YISHUN MRT",
        "bus_desc": "39, 85, 171, 800, 803, 804, 806, 811, 812, 851, 852, 853, 853C, 854, 854E, 855, 856, 857, 859, 860",
        "principal_name": "MR NG TEO HENG",
        "first_vp_name": "MADAM CH'NG YUEN PING",
        "second_vp_name": "MR GOH YINGLUN ALLAN",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "YISHUN",
        "zone_code": "NORTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4326229,
        "lng": 103.8379391
    },
    {
        "school_name": "YU NENG PRIMARY SCHOOL",
        "url_address": "http://www.ynps.moe.edu.sg/",
        "address": "56 BEDOK NORTH ST 3",
        "postal_code": 469623,
        "telephone_no": 64490121,
        "telephone_no_2": "na",
        "fax_no": 64498564,
        "fax_no_2": "na",
        "email_address": "YNPS@MOE.EDU.SG",
        "mrt_desc": "Bedok MRT Station (East-West Line), Bedok Reservoir MRT STation (Downtown line)",
        "bus_desc": "14, 17, 18, 28, 66, 67, 69, 225",
        "principal_name": "MR NG YEOW LING",
        "first_vp_name": "MISS ONG PEI FEN JAMIE",
        "second_vp_name": "MR EDWIN ONG YOKE YAM",
        "third_vp_name": "MR SATIISH SATHASILVAM",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BEDOK",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3338292,
        "lng": 103.9318969
    },
    {
        "school_name": "YUAN CHING SECONDARY SCHOOL",
        "url_address": "https://yuanchingsec.moe.edu.sg/",
        "address": "103 YUAN CHING ROAD",
        "postal_code": 618654,
        "telephone_no": 62612489,
        "telephone_no_2": "na",
        "fax_no": 62616275,
        "fax_no_2": "na",
        "email_address": "YCSS@MOE.EDU.SG",
        "mrt_desc": "LAKESIDE MRT",
        "bus_desc": "49, 98, 98M, 154, 180, 187, 240, 240M, 246",
        "principal_name": "MR SHAWAL BIN HUSSIN",
        "first_vp_name": "MR TANG HSIN WEI",
        "second_vp_name": "MISS TANG SHIEN YIN",
        "third_vp_name": "MR TEO HUI YAO, JULIUS",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.34168,
        "lng": 103.7200992
    },
    {
        "school_name": "YUHUA PRIMARY SCHOOL",
        "url_address": "http://www.yuhuapri.moe.edu.sg",
        "address": "158 JURONG EAST STREET 24",
        "postal_code": 609558,
        "telephone_no": 65605062,
        "telephone_no_2": "na",
        "fax_no": 65648278,
        "fax_no_2": "na",
        "email_address": "YUHUA_PS@MOE.EDU.SG",
        "mrt_desc": "Jurong East, Bukit Batok",
        "bus_desc": "98,98A,187,333,502,507,NR5",
        "principal_name": "MRS RUTH TAI MEI FEN",
        "first_vp_name": "MADAM ZOEY LIM CHING SIA",
        "second_vp_name": "na",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG EAST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3429774,
        "lng": 103.7409109
    },
    {
        "school_name": "YUHUA SECONDARY SCHOOL",
        "url_address": "http://www.yuhuasec.moe.edu.sg",
        "address": "35 JURONG WEST STREET 41",
        "postal_code": 649406,
        "telephone_no": 65661985,
        "telephone_no_2": "na",
        "fax_no": 65696689,
        "fax_no_2": "na",
        "email_address": "YUHUA_SS@MOE.EDU.SG",
        "mrt_desc": "LAKESIDE MRT",
        "bus_desc": "49, 98, 99, 157, 180, 185, 187, 198, 334, 335, 502",
        "principal_name": "MR PANG CHIN KEAT, KEVIN",
        "first_vp_name": "MR TAN CHIN GUAN",
        "second_vp_name": "MISS CHIA KEL- LI",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "JURONG WEST",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.347026,
        "lng": 103.722405
    },
    {
        "school_name": "YUMIN PRIMARY SCHOOL",
        "url_address": "http://www.yuminpri.moe.edu.sg",
        "address": "3 TAMPINES STREET 21",
        "postal_code": 529393,
        "telephone_no": 67811262,
        "telephone_no_2": "na",
        "fax_no": 67845554,
        "fax_no_2": "na",
        "email_address": "YUMIN_PS@MOE.EDU.SG",
        "mrt_desc": "Tampines MRT Station",
        "bus_desc": 3,
        "principal_name": "MRS NG- TEO SOCK HUA",
        "first_vp_name": "MR ABDUL MUTALIB B MOHAMMED AMIN",
        "second_vp_name": "MADAM TAN BETTY",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "TAMPINES",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3516199,
        "lng": 103.9511251
    },
    {
        "school_name": "YUSOF ISHAK SECONDARY SCHOOL",
        "url_address": "http://www.yusofishaksec.moe.edu.sg",
        "address": "8 SUMANG WALK",
        "postal_code": 828676,
        "telephone_no": 65009800,
        "telephone_no_2": "na",
        "fax_no": 65675502,
        "fax_no_2": "na",
        "email_address": "YISS@MOE.EDU.SG",
        "mrt_desc": "PUNGGOL MRT",
        "bus_desc": "117, 382W, 43",
        "principal_name": "MR CHEN ZIYANG",
        "first_vp_name": "MISS LOH SEIN LING",
        "second_vp_name": "MR CHEONG TIEN BENG",
        "third_vp_name": "LIN ZHEN JIANG, TEDDY",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "PUNGGOL",
        "zone_code": "EAST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.4073296,
        "lng": 103.8959493
    },
    {
        "school_name": "YUYING SECONDARY SCHOOL",
        "url_address": "http://www.yuyingsec.moe.edu.sg",
        "address": "47 HOUGANG AVENUE 1",
        "postal_code": 538884,
        "telephone_no": 62827968,
        "telephone_no_2": "na",
        "fax_no": 62871607,
        "fax_no_2": "na",
        "email_address": "YUYING_SS@MOE.EDU.SG",
        "mrt_desc": "KOVAN MRT, SERANGOON MRT, HOUGANG MRT",
        "bus_desc": "25, 51, 53, 53M, 55, 62, 87, 113, 119, 151, 854",
        "principal_name": "MR CHONG JACK SHENG",
        "first_vp_name": "MR CHAN IVIN",
        "second_vp_name": "MR CHEONG KAH KAY GABRIEL",
        "third_vp_name": "MADAM TAN HUI LING",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "HOUGANG",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT-AIDED SCH",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.356753,
        "lng": 103.8900604
    },
    {
        "school_name": "ZHANGDE PRIMARY SCHOOL",
        "url_address": "http://www.zhangdepri.moe.edu.sg/",
        "address": "51 Jalan Membina",
        "postal_code": 169485,
        "telephone_no": 62740357,
        "telephone_no_2": "na",
        "fax_no": 62763042,
        "fax_no_2": "na",
        "email_address": "ZHANGDE_PS@MOE.EDU.SG",
        "mrt_desc": "Tiong Bahru MRT Station",
        "bus_desc": "16,33,63,123,195,605,851,14,65,147,167,196,197,961",
        "principal_name": "MADAM RITA RAJ LAL",
        "first_vp_name": "MRS LIM PEGGY",
        "second_vp_name": "MR CHAN CHEONG CHEONG",
        "third_vp_name": "MADAM WOO LI SAN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT MERAH",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.2842268,
        "lng": 103.8267059
    },
    {
        "school_name": "ZHENGHUA PRIMARY SCHOOL",
        "url_address": "http://www.zhenghuapri.moe.edu.sg",
        "address": "9 Fajar Road",
        "postal_code": 679002,
        "telephone_no": 67697478,
        "telephone_no_2": "na",
        "fax_no": 67636459,
        "fax_no_2": "na",
        "email_address": "ZHENGHUA_PS@MOE.EDU.SG",
        "mrt_desc": "LRT: Fajar Station",
        "bus_desc": "190, 184, 187, 700, 700A, 921",
        "principal_name": "MADAM WONG HIAN HWEE CONSTANCE",
        "first_vp_name": "MR YANG PECK CHIONG TOMMY",
        "second_vp_name": "MISS SANTHANA MARY D/O POOBALAN",
        "third_vp_name": "MADAM SNG YEE YEE",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3796697,
        "lng": 103.7692818
    },
    {
        "school_name": "ZHENGHUA SECONDARY SCHOOL",
        "url_address": "http://www.zhenghuasec.moe.edu.sg",
        "address": "62 Bukit Panjang Ring Road",
        "postal_code": 679962,
        "telephone_no": 67639455,
        "telephone_no_2": "na",
        "fax_no": 67633577,
        "fax_no_2": "na",
        "email_address": "ZHENGHUA_SS@MOE.EDU.SG",
        "mrt_desc": "JELAPANG LRT",
        "bus_desc": "920, 922, 976",
        "principal_name": "MR NG HOCK SOON",
        "first_vp_name": "MADAM TAN PEI LEE ELAINE",
        "second_vp_name": "MR SAMUEL LIM KOK BOON",
        "third_vp_name": "MISS HE AIFEN",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "BUKIT PANJANG",
        "zone_code": "WEST",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.388986,
        "lng": 103.7652978
    },
    {
        "school_name": "ZHONGHUA PRIMARY SCHOOL",
        "url_address": "http://www.zhonghuapri.moe.edu.sg",
        "address": "12 SERANGOON AVENUE 4",
        "postal_code": 556095,
        "telephone_no": 62835413,
        "telephone_no_2": "na",
        "fax_no": 62823882,
        "fax_no_2": "na",
        "email_address": "ZHONGHUA_PS@MOE.EDU.SG",
        "mrt_desc": "Ang Mo Kio MRT, Bishan MRT, Serangoon MRT",
        "bus_desc": "Boundary Road: 22,24,53,105,156,315,853,501,502; Yio Chu Kang Road: 70,76,103,147,156,501,502",
        "principal_name": "MRS CHAN LE CHIN",
        "first_vp_name": "MADAM THAM SIEW LENG MRS TAN SIEW LENG",
        "second_vp_name": "MRS TRINA POOK SIM NAR",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "PRIMARY",
        "sap_ind": "No",
        "autonomous_ind": "No",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "TAMIL",
        "lat": 1.3598531,
        "lng": 103.8695741
    },
    {
        "school_name": "ZHONGHUA SECONDARY SCHOOL",
        "url_address": "https://www.zhonghuasec.moe.edu.sg",
        "address": "13 SERANGOON AVENUE 3",
        "postal_code": 556123,
        "telephone_no": 62824339,
        "telephone_no_2": "na",
        "fax_no": 62823472,
        "fax_no_2": "na",
        "email_address": "ZHONGHUA_SS@MOE.EDU.SG",
        "mrt_desc": "SERANGOON MRT",
        "bus_desc": "22, 43, 45, 53, 58, 70, 81, 82, 100, 101, 103, 105, 107, 109, 133, 135, 147, 153, 158, 315, 317, 853",
        "principal_name": "MR TAN KIM KOON",
        "first_vp_name": "MR SHAHUL HAMEED S/O KUTHUBUDEEN",
        "second_vp_name": "MS TEO CELINE",
        "third_vp_name": "na",
        "fourth_vp_name": "na",
        "fifth_vp_name": "na",
        "sixth_vp_name": "na",
        "dgp_code": "SERANGOON",
        "zone_code": "SOUTH",
        "type_code": "GOVERNMENT SCHOOL",
        "nature_code": "CO-ED SCHOOL",
        "session_code": "SINGLE SESSION",
        "mainlevel_code": "SECONDARY (S1-S5)",
        "sap_ind": "No",
        "autonomous_ind": "Yes",
        "gifted_ind": "No",
        "ip_ind": "No",
        "mothertongue1_code": "CHINESE",
        "mothertongue2_code": "MALAY",
        "mothertongue3_code": "na",
        "lat": 1.3496094,
        "lng": 103.8693356
    }
]